
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire82b7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire82b7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hARba", function(module, exports) {
"use strict";
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/master/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol("Symbol.dispose"),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol("Symbol.asyncDispose"),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("23YUm", function(module, exports) {
"use strict";

var $4mEhT = parcelRequire("4mEhT");

var $hARba = parcelRequire("hARba");
var $180b1ba48de36d74$require$kResistStopPropagation = $hARba.kResistStopPropagation;
var $180b1ba48de36d74$require$SymbolDispose = $hARba.SymbolDispose;

const $180b1ba48de36d74$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("lOmHN")).AbortSignal;

const $180b1ba48de36d74$var$AbortController = globalThis.AbortController || (parcelRequire("lOmHN")).AbortController;
const $180b1ba48de36d74$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $180b1ba48de36d74$var$Blob = globalThis.Blob || $4mEhT.Blob;
/* eslint-disable indent */ const $180b1ba48de36d74$var$isBlob = typeof $180b1ba48de36d74$var$Blob !== "undefined" ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $180b1ba48de36d74$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $180b1ba48de36d74$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== "object" || !("aborted" in signal))) throw new ERR_INVALID_ARG_TYPE(name, "AbortSignal", signal);
};
const $180b1ba48de36d74$var$validateFunction = (value, name)=>{
    if (typeof value !== "function") throw new ERR_INVALID_ARG_TYPE(name, "Function", value);
};
// This is a simplified version of AggregateError
class $180b1ba48de36d74$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = "";
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = "AggregateError";
        this.errors = errors;
    }
}

module.exports = {
    AggregateError: $180b1ba48de36d74$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === "f") return replacement.toFixed(6);
            else if (type === "j") return JSON.stringify(replacement);
            else if (type === "s" && typeof replacement === "object") {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : "";
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case "string":
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes("`") && !value.includes("${")) return `\`${value}\``;
                }
                return `'${value}'`;
            case "number":
                if (isNaN(value)) return "NaN";
                else if (Object.is(value, -0)) return String(value);
                return value;
            case "bigint":
                return `${String(value)}n`;
            case "boolean":
            case "undefined":
                return String(value);
            case "object":
                return "{}";
        }
    },
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $180b1ba48de36d74$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $180b1ba48de36d74$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("al3fM")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new ERR_INVALID_ARG_TYPE("signal", "AbortSignal", signal);
        $180b1ba48de36d74$var$validateAbortSignal(signal, "signal");
        $180b1ba48de36d74$var$validateFunction(listener, "listener");
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener("abort", listener, {
                __proto__: null,
                once: true,
                [$180b1ba48de36d74$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener("abort", listener);
            };
        }
        return {
            __proto__: null,
            [$180b1ba48de36d74$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $180b1ba48de36d74$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $180b1ba48de36d74$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $180b1ba48de36d74$var$validateAbortSignal(signal, "signals");
            signal.addEventListener("abort", abort, {
                once: true
            });
        });
        ac.signal.addEventListener("abort", ()=>{
            signals.forEach((signal)=>signal.removeEventListener("abort", abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for("nodejs.util.promisify.custom");

});
parcelRegister("4mEhT", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $32d877ccc272da62$export$a143d493d941bafc, (v) => $32d877ccc272da62$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $32d877ccc272da62$export$e4cf37d7f6fb9e0a, (v) => $32d877ccc272da62$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $32d877ccc272da62$export$f99ded8fe4b79145, (v) => $32d877ccc272da62$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $32d877ccc272da62$export$599f31c3813fae4d, (v) => $32d877ccc272da62$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $32d877ccc272da62$export$a143d493d941bafc;
var $32d877ccc272da62$export$e4cf37d7f6fb9e0a;
var $32d877ccc272da62$export$f99ded8fe4b79145;
var $32d877ccc272da62$export$599f31c3813fae4d;
"use strict";

var $6cSDn = parcelRequire("6cSDn");

var $94uYi = parcelRequire("94uYi");
const $32d877ccc272da62$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$32d877ccc272da62$export$a143d493d941bafc = $32d877ccc272da62$var$Buffer;
$32d877ccc272da62$export$e4cf37d7f6fb9e0a = $32d877ccc272da62$var$SlowBuffer;
$32d877ccc272da62$export$f99ded8fe4b79145 = 50;
const $32d877ccc272da62$var$K_MAX_LENGTH = 0x7fffffff;
$32d877ccc272da62$export$599f31c3813fae4d = $32d877ccc272da62$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $32d877ccc272da62$var$Buffer.TYPED_ARRAY_SUPPORT = $32d877ccc272da62$var$typedArraySupport();
if (!$32d877ccc272da62$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $32d877ccc272da62$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($32d877ccc272da62$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$32d877ccc272da62$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($32d877ccc272da62$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$32d877ccc272da62$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $32d877ccc272da62$var$createBuffer(length) {
    if (length > $32d877ccc272da62$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $32d877ccc272da62$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $32d877ccc272da62$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $32d877ccc272da62$var$allocUnsafe(arg);
    }
    return $32d877ccc272da62$var$from(arg, encodingOrOffset, length);
}
$32d877ccc272da62$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $32d877ccc272da62$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $32d877ccc272da62$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $32d877ccc272da62$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($32d877ccc272da62$var$isInstance(value, ArrayBuffer) || value && $32d877ccc272da62$var$isInstance(value.buffer, ArrayBuffer)) return $32d877ccc272da62$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($32d877ccc272da62$var$isInstance(value, SharedArrayBuffer) || value && $32d877ccc272da62$var$isInstance(value.buffer, SharedArrayBuffer))) return $32d877ccc272da62$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $32d877ccc272da62$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $32d877ccc272da62$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $32d877ccc272da62$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $32d877ccc272da62$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $32d877ccc272da62$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($32d877ccc272da62$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($32d877ccc272da62$var$Buffer, Uint8Array);
function $32d877ccc272da62$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $32d877ccc272da62$var$alloc(size, fill, encoding) {
    $32d877ccc272da62$var$assertSize(size);
    if (size <= 0) return $32d877ccc272da62$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $32d877ccc272da62$var$createBuffer(size).fill(fill, encoding) : $32d877ccc272da62$var$createBuffer(size).fill(fill);
    return $32d877ccc272da62$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $32d877ccc272da62$var$Buffer.alloc = function(size, fill, encoding) {
    return $32d877ccc272da62$var$alloc(size, fill, encoding);
};
function $32d877ccc272da62$var$allocUnsafe(size) {
    $32d877ccc272da62$var$assertSize(size);
    return $32d877ccc272da62$var$createBuffer(size < 0 ? 0 : $32d877ccc272da62$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $32d877ccc272da62$var$Buffer.allocUnsafe = function(size) {
    return $32d877ccc272da62$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $32d877ccc272da62$var$Buffer.allocUnsafeSlow = function(size) {
    return $32d877ccc272da62$var$allocUnsafe(size);
};
function $32d877ccc272da62$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$32d877ccc272da62$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $32d877ccc272da62$var$byteLength(string, encoding) | 0;
    let buf = $32d877ccc272da62$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $32d877ccc272da62$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $32d877ccc272da62$var$checked(array.length) | 0;
    const buf = $32d877ccc272da62$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $32d877ccc272da62$var$fromArrayView(arrayView) {
    if ($32d877ccc272da62$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $32d877ccc272da62$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $32d877ccc272da62$var$fromArrayLike(arrayView);
}
function $32d877ccc272da62$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $32d877ccc272da62$var$Buffer.prototype);
    return buf;
}
function $32d877ccc272da62$var$fromObject(obj) {
    if ($32d877ccc272da62$var$Buffer.isBuffer(obj)) {
        const len = $32d877ccc272da62$var$checked(obj.length) | 0;
        const buf = $32d877ccc272da62$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $32d877ccc272da62$var$numberIsNaN(obj.length)) return $32d877ccc272da62$var$createBuffer(0);
        return $32d877ccc272da62$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $32d877ccc272da62$var$fromArrayLike(obj.data);
}
function $32d877ccc272da62$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $32d877ccc272da62$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $32d877ccc272da62$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $32d877ccc272da62$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $32d877ccc272da62$var$Buffer.alloc(+length);
}
$32d877ccc272da62$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $32d877ccc272da62$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$32d877ccc272da62$var$Buffer.compare = function compare(a, b) {
    if ($32d877ccc272da62$var$isInstance(a, Uint8Array)) a = $32d877ccc272da62$var$Buffer.from(a, a.offset, a.byteLength);
    if ($32d877ccc272da62$var$isInstance(b, Uint8Array)) b = $32d877ccc272da62$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$32d877ccc272da62$var$Buffer.isBuffer(a) || !$32d877ccc272da62$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$32d877ccc272da62$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$32d877ccc272da62$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $32d877ccc272da62$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $32d877ccc272da62$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($32d877ccc272da62$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$32d877ccc272da62$var$Buffer.isBuffer(buf)) buf = $32d877ccc272da62$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$32d877ccc272da62$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $32d877ccc272da62$var$byteLength(string, encoding) {
    if ($32d877ccc272da62$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $32d877ccc272da62$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $32d877ccc272da62$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $32d877ccc272da62$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $32d877ccc272da62$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$32d877ccc272da62$var$Buffer.byteLength = $32d877ccc272da62$var$byteLength;
function $32d877ccc272da62$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $32d877ccc272da62$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $32d877ccc272da62$var$utf8Slice(this, start, end);
        case "ascii":
            return $32d877ccc272da62$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $32d877ccc272da62$var$latin1Slice(this, start, end);
        case "base64":
            return $32d877ccc272da62$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $32d877ccc272da62$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$32d877ccc272da62$var$Buffer.prototype._isBuffer = true;
function $32d877ccc272da62$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$32d877ccc272da62$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$32d877ccc272da62$var$swap(this, i, i + 1);
    return this;
};
$32d877ccc272da62$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $32d877ccc272da62$var$swap(this, i, i + 3);
        $32d877ccc272da62$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$32d877ccc272da62$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $32d877ccc272da62$var$swap(this, i, i + 7);
        $32d877ccc272da62$var$swap(this, i + 1, i + 6);
        $32d877ccc272da62$var$swap(this, i + 2, i + 5);
        $32d877ccc272da62$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$32d877ccc272da62$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $32d877ccc272da62$var$utf8Slice(this, 0, length);
    return $32d877ccc272da62$var$slowToString.apply(this, arguments);
};
$32d877ccc272da62$var$Buffer.prototype.toLocaleString = $32d877ccc272da62$var$Buffer.prototype.toString;
$32d877ccc272da62$var$Buffer.prototype.equals = function equals(b) {
    if (!$32d877ccc272da62$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $32d877ccc272da62$var$Buffer.compare(this, b) === 0;
};
$32d877ccc272da62$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $32d877ccc272da62$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($32d877ccc272da62$var$customInspectSymbol) $32d877ccc272da62$var$Buffer.prototype[$32d877ccc272da62$var$customInspectSymbol] = $32d877ccc272da62$var$Buffer.prototype.inspect;
$32d877ccc272da62$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($32d877ccc272da62$var$isInstance(target, Uint8Array)) target = $32d877ccc272da62$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$32d877ccc272da62$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $32d877ccc272da62$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($32d877ccc272da62$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $32d877ccc272da62$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($32d877ccc272da62$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $32d877ccc272da62$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $32d877ccc272da62$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $32d877ccc272da62$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$32d877ccc272da62$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$32d877ccc272da62$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $32d877ccc272da62$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$32d877ccc272da62$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $32d877ccc272da62$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $32d877ccc272da62$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($32d877ccc272da62$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $32d877ccc272da62$var$utf8Write(buf, string, offset, length) {
    return $32d877ccc272da62$var$blitBuffer($32d877ccc272da62$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $32d877ccc272da62$var$asciiWrite(buf, string, offset, length) {
    return $32d877ccc272da62$var$blitBuffer($32d877ccc272da62$var$asciiToBytes(string), buf, offset, length);
}
function $32d877ccc272da62$var$base64Write(buf, string, offset, length) {
    return $32d877ccc272da62$var$blitBuffer($32d877ccc272da62$var$base64ToBytes(string), buf, offset, length);
}
function $32d877ccc272da62$var$ucs2Write(buf, string, offset, length) {
    return $32d877ccc272da62$var$blitBuffer($32d877ccc272da62$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$32d877ccc272da62$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $32d877ccc272da62$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $32d877ccc272da62$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $32d877ccc272da62$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $32d877ccc272da62$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $32d877ccc272da62$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$32d877ccc272da62$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $32d877ccc272da62$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6cSDn.fromByteArray(buf);
    else return $6cSDn.fromByteArray(buf.slice(start, end));
}
function $32d877ccc272da62$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $32d877ccc272da62$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $32d877ccc272da62$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $32d877ccc272da62$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $32d877ccc272da62$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $32d877ccc272da62$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $32d877ccc272da62$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $32d877ccc272da62$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $32d877ccc272da62$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $32d877ccc272da62$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $32d877ccc272da62$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$32d877ccc272da62$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $32d877ccc272da62$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $32d877ccc272da62$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$32d877ccc272da62$var$Buffer.prototype.readUintLE = $32d877ccc272da62$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$32d877ccc272da62$var$Buffer.prototype.readUintBE = $32d877ccc272da62$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$32d877ccc272da62$var$Buffer.prototype.readUint8 = $32d877ccc272da62$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$32d877ccc272da62$var$Buffer.prototype.readUint16LE = $32d877ccc272da62$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$32d877ccc272da62$var$Buffer.prototype.readUint16BE = $32d877ccc272da62$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$32d877ccc272da62$var$Buffer.prototype.readUint32LE = $32d877ccc272da62$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$32d877ccc272da62$var$Buffer.prototype.readUint32BE = $32d877ccc272da62$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$32d877ccc272da62$var$Buffer.prototype.readBigUInt64LE = $32d877ccc272da62$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $32d877ccc272da62$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $32d877ccc272da62$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$32d877ccc272da62$var$Buffer.prototype.readBigUInt64BE = $32d877ccc272da62$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $32d877ccc272da62$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $32d877ccc272da62$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$32d877ccc272da62$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$32d877ccc272da62$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$32d877ccc272da62$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$32d877ccc272da62$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$32d877ccc272da62$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$32d877ccc272da62$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$32d877ccc272da62$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$32d877ccc272da62$var$Buffer.prototype.readBigInt64LE = $32d877ccc272da62$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $32d877ccc272da62$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $32d877ccc272da62$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$32d877ccc272da62$var$Buffer.prototype.readBigInt64BE = $32d877ccc272da62$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $32d877ccc272da62$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $32d877ccc272da62$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$32d877ccc272da62$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, 4, this.length);
    return $94uYi.read(this, offset, true, 23, 4);
};
$32d877ccc272da62$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, 4, this.length);
    return $94uYi.read(this, offset, false, 23, 4);
};
$32d877ccc272da62$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, 8, this.length);
    return $94uYi.read(this, offset, true, 52, 8);
};
$32d877ccc272da62$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkOffset(offset, 8, this.length);
    return $94uYi.read(this, offset, false, 52, 8);
};
function $32d877ccc272da62$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$32d877ccc272da62$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$32d877ccc272da62$var$Buffer.prototype.writeUintLE = $32d877ccc272da62$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $32d877ccc272da62$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$32d877ccc272da62$var$Buffer.prototype.writeUintBE = $32d877ccc272da62$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $32d877ccc272da62$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$32d877ccc272da62$var$Buffer.prototype.writeUint8 = $32d877ccc272da62$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$32d877ccc272da62$var$Buffer.prototype.writeUint16LE = $32d877ccc272da62$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$32d877ccc272da62$var$Buffer.prototype.writeUint16BE = $32d877ccc272da62$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$32d877ccc272da62$var$Buffer.prototype.writeUint32LE = $32d877ccc272da62$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$32d877ccc272da62$var$Buffer.prototype.writeUint32BE = $32d877ccc272da62$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $32d877ccc272da62$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $32d877ccc272da62$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $32d877ccc272da62$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $32d877ccc272da62$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$32d877ccc272da62$var$Buffer.prototype.writeBigUInt64LE = $32d877ccc272da62$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $32d877ccc272da62$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$32d877ccc272da62$var$Buffer.prototype.writeBigUInt64BE = $32d877ccc272da62$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $32d877ccc272da62$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$32d877ccc272da62$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $32d877ccc272da62$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$32d877ccc272da62$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $32d877ccc272da62$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$32d877ccc272da62$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$32d877ccc272da62$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$32d877ccc272da62$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$32d877ccc272da62$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$32d877ccc272da62$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$32d877ccc272da62$var$Buffer.prototype.writeBigInt64LE = $32d877ccc272da62$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $32d877ccc272da62$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$32d877ccc272da62$var$Buffer.prototype.writeBigInt64BE = $32d877ccc272da62$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $32d877ccc272da62$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $32d877ccc272da62$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $32d877ccc272da62$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $94uYi.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$32d877ccc272da62$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $32d877ccc272da62$var$writeFloat(this, value, offset, true, noAssert);
};
$32d877ccc272da62$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $32d877ccc272da62$var$writeFloat(this, value, offset, false, noAssert);
};
function $32d877ccc272da62$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32d877ccc272da62$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $94uYi.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$32d877ccc272da62$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $32d877ccc272da62$var$writeDouble(this, value, offset, true, noAssert);
};
$32d877ccc272da62$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $32d877ccc272da62$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$32d877ccc272da62$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$32d877ccc272da62$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$32d877ccc272da62$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$32d877ccc272da62$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $32d877ccc272da62$var$Buffer.isBuffer(val) ? val : $32d877ccc272da62$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $32d877ccc272da62$var$errors = {};
function $32d877ccc272da62$var$E(sym, getMessage, Base) {
    $32d877ccc272da62$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$32d877ccc272da62$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$32d877ccc272da62$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$32d877ccc272da62$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $32d877ccc272da62$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $32d877ccc272da62$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $32d877ccc272da62$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $32d877ccc272da62$var$checkBounds(buf, offset, byteLength) {
    $32d877ccc272da62$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $32d877ccc272da62$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $32d877ccc272da62$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $32d877ccc272da62$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $32d877ccc272da62$var$checkBounds(buf, offset, byteLength);
}
function $32d877ccc272da62$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $32d877ccc272da62$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $32d877ccc272da62$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $32d877ccc272da62$var$validateNumber(value, type);
        throw new $32d877ccc272da62$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $32d877ccc272da62$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $32d877ccc272da62$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $32d877ccc272da62$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $32d877ccc272da62$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($32d877ccc272da62$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $32d877ccc272da62$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $32d877ccc272da62$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $32d877ccc272da62$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $32d877ccc272da62$var$base64ToBytes(str) {
    return $6cSDn.toByteArray($32d877ccc272da62$var$base64clean(str));
}
function $32d877ccc272da62$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $32d877ccc272da62$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $32d877ccc272da62$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $32d877ccc272da62$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $32d877ccc272da62$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $32d877ccc272da62$var$BufferBigIntNotDefined : fn;
}
function $32d877ccc272da62$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("6cSDn", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $484e3e41e8935f4a$export$d622b2ad8d90c771, (v) => $484e3e41e8935f4a$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $484e3e41e8935f4a$export$6100ba28696e12de, (v) => $484e3e41e8935f4a$export$6100ba28696e12de = v);
var $484e3e41e8935f4a$export$a48f0734ac7c2329;
var $484e3e41e8935f4a$export$d622b2ad8d90c771;
var $484e3e41e8935f4a$export$6100ba28696e12de;
"use strict";
$484e3e41e8935f4a$export$a48f0734ac7c2329 = $484e3e41e8935f4a$var$byteLength;
$484e3e41e8935f4a$export$d622b2ad8d90c771 = $484e3e41e8935f4a$var$toByteArray;
$484e3e41e8935f4a$export$6100ba28696e12de = $484e3e41e8935f4a$var$fromByteArray;
var $484e3e41e8935f4a$var$lookup = [];
var $484e3e41e8935f4a$var$revLookup = [];
var $484e3e41e8935f4a$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $484e3e41e8935f4a$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $484e3e41e8935f4a$var$i = 0, $484e3e41e8935f4a$var$len = $484e3e41e8935f4a$var$code.length; $484e3e41e8935f4a$var$i < $484e3e41e8935f4a$var$len; ++$484e3e41e8935f4a$var$i){
    $484e3e41e8935f4a$var$lookup[$484e3e41e8935f4a$var$i] = $484e3e41e8935f4a$var$code[$484e3e41e8935f4a$var$i];
    $484e3e41e8935f4a$var$revLookup[$484e3e41e8935f4a$var$code.charCodeAt($484e3e41e8935f4a$var$i)] = $484e3e41e8935f4a$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$484e3e41e8935f4a$var$revLookup["-".charCodeAt(0)] = 62;
$484e3e41e8935f4a$var$revLookup["_".charCodeAt(0)] = 63;
function $484e3e41e8935f4a$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $484e3e41e8935f4a$var$byteLength(b64) {
    var lens = $484e3e41e8935f4a$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $484e3e41e8935f4a$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $484e3e41e8935f4a$var$toByteArray(b64) {
    var tmp;
    var lens = $484e3e41e8935f4a$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $484e3e41e8935f4a$var$Arr($484e3e41e8935f4a$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $484e3e41e8935f4a$var$revLookup[b64.charCodeAt(i)] << 18 | $484e3e41e8935f4a$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $484e3e41e8935f4a$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $484e3e41e8935f4a$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $484e3e41e8935f4a$var$revLookup[b64.charCodeAt(i)] << 2 | $484e3e41e8935f4a$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $484e3e41e8935f4a$var$revLookup[b64.charCodeAt(i)] << 10 | $484e3e41e8935f4a$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $484e3e41e8935f4a$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $484e3e41e8935f4a$var$tripletToBase64(num) {
    return $484e3e41e8935f4a$var$lookup[num >> 18 & 0x3F] + $484e3e41e8935f4a$var$lookup[num >> 12 & 0x3F] + $484e3e41e8935f4a$var$lookup[num >> 6 & 0x3F] + $484e3e41e8935f4a$var$lookup[num & 0x3F];
}
function $484e3e41e8935f4a$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($484e3e41e8935f4a$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $484e3e41e8935f4a$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($484e3e41e8935f4a$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($484e3e41e8935f4a$var$lookup[tmp >> 2] + $484e3e41e8935f4a$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($484e3e41e8935f4a$var$lookup[tmp >> 10] + $484e3e41e8935f4a$var$lookup[tmp >> 4 & 0x3F] + $484e3e41e8935f4a$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("94uYi", function(module, exports) {

$parcel$export(module.exports, "read", () => $69ac8318a68ec33c$export$aafa59e2e03f2942, (v) => $69ac8318a68ec33c$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $69ac8318a68ec33c$export$68d8715fc104d294, (v) => $69ac8318a68ec33c$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $69ac8318a68ec33c$export$aafa59e2e03f2942;
var $69ac8318a68ec33c$export$68d8715fc104d294;
$69ac8318a68ec33c$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$69ac8318a68ec33c$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("lOmHN", function(module, exports) {
/*globals self, window */ "use strict";
/*eslint-disable @mysticatea/prettier */ const { AbortController: $fe0fe1475c40d1c7$var$AbortController, AbortSignal: $fe0fe1475c40d1c7$var$AbortSignal } = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : /* otherwise */ undefined;
/*eslint-enable @mysticatea/prettier */ module.exports = $fe0fe1475c40d1c7$var$AbortController;
module.exports.AbortSignal = $fe0fe1475c40d1c7$var$AbortSignal;
module.exports.default = $fe0fe1475c40d1c7$var$AbortController;

});

parcelRegister("al3fM", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $786e639d99c859a8$var$R = typeof Reflect === "object" ? Reflect : null;
var $786e639d99c859a8$var$ReflectApply = $786e639d99c859a8$var$R && typeof $786e639d99c859a8$var$R.apply === "function" ? $786e639d99c859a8$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $786e639d99c859a8$var$ReflectOwnKeys;
if ($786e639d99c859a8$var$R && typeof $786e639d99c859a8$var$R.ownKeys === "function") $786e639d99c859a8$var$ReflectOwnKeys = $786e639d99c859a8$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $786e639d99c859a8$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $786e639d99c859a8$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $786e639d99c859a8$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $786e639d99c859a8$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $786e639d99c859a8$var$EventEmitter() {
    $786e639d99c859a8$var$EventEmitter.init.call(this);
}
module.exports = $786e639d99c859a8$var$EventEmitter;
module.exports.once = $786e639d99c859a8$var$once;
// Backwards-compat with node 0.10.x
$786e639d99c859a8$var$EventEmitter.EventEmitter = $786e639d99c859a8$var$EventEmitter;
$786e639d99c859a8$var$EventEmitter.prototype._events = undefined;
$786e639d99c859a8$var$EventEmitter.prototype._eventsCount = 0;
$786e639d99c859a8$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $786e639d99c859a8$var$defaultMaxListeners = 10;
function $786e639d99c859a8$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($786e639d99c859a8$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $786e639d99c859a8$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $786e639d99c859a8$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $786e639d99c859a8$var$defaultMaxListeners = arg;
    }
});
$786e639d99c859a8$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$786e639d99c859a8$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $786e639d99c859a8$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $786e639d99c859a8$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $786e639d99c859a8$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$786e639d99c859a8$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $786e639d99c859a8$var$_getMaxListeners(this);
};
$786e639d99c859a8$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $786e639d99c859a8$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $786e639d99c859a8$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$786e639d99c859a8$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $786e639d99c859a8$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $786e639d99c859a8$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $786e639d99c859a8$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $786e639d99c859a8$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$786e639d99c859a8$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $786e639d99c859a8$var$_addListener(this, type, listener, false);
};
$786e639d99c859a8$var$EventEmitter.prototype.on = $786e639d99c859a8$var$EventEmitter.prototype.addListener;
$786e639d99c859a8$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $786e639d99c859a8$var$_addListener(this, type, listener, true);
};
function $786e639d99c859a8$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $786e639d99c859a8$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $786e639d99c859a8$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$786e639d99c859a8$var$EventEmitter.prototype.once = function once(type, listener) {
    $786e639d99c859a8$var$checkListener(listener);
    this.on(type, $786e639d99c859a8$var$_onceWrap(this, type, listener));
    return this;
};
$786e639d99c859a8$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $786e639d99c859a8$var$checkListener(listener);
    this.prependListener(type, $786e639d99c859a8$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$786e639d99c859a8$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $786e639d99c859a8$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $786e639d99c859a8$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$786e639d99c859a8$var$EventEmitter.prototype.off = $786e639d99c859a8$var$EventEmitter.prototype.removeListener;
$786e639d99c859a8$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $786e639d99c859a8$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $786e639d99c859a8$var$unwrapListeners(evlistener) : $786e639d99c859a8$var$arrayClone(evlistener, evlistener.length);
}
$786e639d99c859a8$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $786e639d99c859a8$var$_listeners(this, type, true);
};
$786e639d99c859a8$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $786e639d99c859a8$var$_listeners(this, type, false);
};
$786e639d99c859a8$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $786e639d99c859a8$var$listenerCount.call(emitter, type);
};
$786e639d99c859a8$var$EventEmitter.prototype.listenerCount = $786e639d99c859a8$var$listenerCount;
function $786e639d99c859a8$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$786e639d99c859a8$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $786e639d99c859a8$var$ReflectOwnKeys(this._events) : [];
};
function $786e639d99c859a8$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $786e639d99c859a8$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $786e639d99c859a8$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $786e639d99c859a8$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $786e639d99c859a8$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $786e639d99c859a8$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $786e639d99c859a8$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $786e639d99c859a8$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $786e639d99c859a8$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRegister("1DMM6", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.
"use strict";

var $hARba = parcelRequire("hARba");
var $131f44a2e19fd0f0$require$ObjectDefineProperties = $hARba.ObjectDefineProperties;
var $131f44a2e19fd0f0$require$ObjectGetOwnPropertyDescriptor = $hARba.ObjectGetOwnPropertyDescriptor;
var $131f44a2e19fd0f0$require$ObjectKeys = $hARba.ObjectKeys;
var $131f44a2e19fd0f0$require$ObjectSetPrototypeOf = $hARba.ObjectSetPrototypeOf;
module.exports = $131f44a2e19fd0f0$var$Duplex;

var $6t7Uw = parcelRequire("6t7Uw");

var $bhyec = parcelRequire("bhyec");
$131f44a2e19fd0f0$require$ObjectSetPrototypeOf($131f44a2e19fd0f0$var$Duplex.prototype, $6t7Uw.prototype);
$131f44a2e19fd0f0$require$ObjectSetPrototypeOf($131f44a2e19fd0f0$var$Duplex, $6t7Uw);
{
    const keys = $131f44a2e19fd0f0$require$ObjectKeys($bhyec.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$131f44a2e19fd0f0$var$Duplex.prototype[method]) $131f44a2e19fd0f0$var$Duplex.prototype[method] = $bhyec.prototype[method];
    }
}function $131f44a2e19fd0f0$var$Duplex(options) {
    if (!(this instanceof $131f44a2e19fd0f0$var$Duplex)) return new $131f44a2e19fd0f0$var$Duplex(options);
    $6t7Uw.call(this, options);
    $bhyec.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$131f44a2e19fd0f0$require$ObjectDefineProperties($131f44a2e19fd0f0$var$Duplex.prototype, {
    writable: {
        __proto__: null,
        ...$131f44a2e19fd0f0$require$ObjectGetOwnPropertyDescriptor($bhyec.prototype, "writable")
    },
    writableHighWaterMark: {
        __proto__: null,
        ...$131f44a2e19fd0f0$require$ObjectGetOwnPropertyDescriptor($bhyec.prototype, "writableHighWaterMark")
    },
    writableObjectMode: {
        __proto__: null,
        ...$131f44a2e19fd0f0$require$ObjectGetOwnPropertyDescriptor($bhyec.prototype, "writableObjectMode")
    },
    writableBuffer: {
        __proto__: null,
        ...$131f44a2e19fd0f0$require$ObjectGetOwnPropertyDescriptor($bhyec.prototype, "writableBuffer")
    },
    writableLength: {
        __proto__: null,
        ...$131f44a2e19fd0f0$require$ObjectGetOwnPropertyDescriptor($bhyec.prototype, "writableLength")
    },
    writableFinished: {
        __proto__: null,
        ...$131f44a2e19fd0f0$require$ObjectGetOwnPropertyDescriptor($bhyec.prototype, "writableFinished")
    },
    writableCorked: {
        __proto__: null,
        ...$131f44a2e19fd0f0$require$ObjectGetOwnPropertyDescriptor($bhyec.prototype, "writableCorked")
    },
    writableEnded: {
        __proto__: null,
        ...$131f44a2e19fd0f0$require$ObjectGetOwnPropertyDescriptor($bhyec.prototype, "writableEnded")
    },
    writableNeedDrain: {
        __proto__: null,
        ...$131f44a2e19fd0f0$require$ObjectGetOwnPropertyDescriptor($bhyec.prototype, "writableNeedDrain")
    },
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $131f44a2e19fd0f0$var$webStreamsAdapters;
// Lazy to avoid circular references
function $131f44a2e19fd0f0$var$lazyWebStreams() {
    if ($131f44a2e19fd0f0$var$webStreamsAdapters === undefined) $131f44a2e19fd0f0$var$webStreamsAdapters = {};
    return $131f44a2e19fd0f0$var$webStreamsAdapters;
}
$131f44a2e19fd0f0$var$Duplex.fromWeb = function(pair, options) {
    return $131f44a2e19fd0f0$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$131f44a2e19fd0f0$var$Duplex.toWeb = function(duplex) {
    return $131f44a2e19fd0f0$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $131f44a2e19fd0f0$var$duplexify;

$131f44a2e19fd0f0$var$Duplex.from = function(body) {
    if (!$131f44a2e19fd0f0$var$duplexify) $131f44a2e19fd0f0$var$duplexify = (parcelRequire("fYnfs"));
    return $131f44a2e19fd0f0$var$duplexify(body, "body");
};

});
parcelRegister("6t7Uw", function(module, exports) {
/* replacement start */ 
var $6Q1U4 = parcelRequire("6Q1U4");
"use strict";

var $hARba = parcelRequire("hARba");
var $4b5b9664f08cdb0c$require$ArrayPrototypeIndexOf = $hARba.ArrayPrototypeIndexOf;
var $4b5b9664f08cdb0c$require$NumberIsInteger = $hARba.NumberIsInteger;
var $4b5b9664f08cdb0c$require$NumberIsNaN = $hARba.NumberIsNaN;
var $4b5b9664f08cdb0c$require$NumberParseInt = $hARba.NumberParseInt;
var $4b5b9664f08cdb0c$require$ObjectDefineProperties = $hARba.ObjectDefineProperties;
var $4b5b9664f08cdb0c$require$ObjectKeys = $hARba.ObjectKeys;
var $4b5b9664f08cdb0c$require$ObjectSetPrototypeOf = $hARba.ObjectSetPrototypeOf;
var $4b5b9664f08cdb0c$require$Promise = $hARba.Promise;
var $4b5b9664f08cdb0c$require$SafeSet = $hARba.SafeSet;
var $4b5b9664f08cdb0c$require$SymbolAsyncDispose = $hARba.SymbolAsyncDispose;
var $4b5b9664f08cdb0c$require$SymbolAsyncIterator = $hARba.SymbolAsyncIterator;
var $4b5b9664f08cdb0c$require$Symbol = $hARba.Symbol;
module.exports = $4b5b9664f08cdb0c$var$Readable;
$4b5b9664f08cdb0c$var$Readable.ReadableState = $4b5b9664f08cdb0c$var$ReadableState;

var $al3fM = parcelRequire("al3fM");
var $4b5b9664f08cdb0c$require$EE = $al3fM.EventEmitter;

var $8tftx = parcelRequire("8tftx");
var $4b5b9664f08cdb0c$require$Stream = $8tftx.Stream;
var $4b5b9664f08cdb0c$require$prependListener = $8tftx.prependListener;

var $4mEhT = parcelRequire("4mEhT");
var $4b5b9664f08cdb0c$require$Buffer = $4mEhT.Buffer;

var $5VHEs = parcelRequire("5VHEs");
var $4b5b9664f08cdb0c$require$addAbortSignal = $5VHEs.addAbortSignal;

var $2GdZi = parcelRequire("2GdZi");

let $4b5b9664f08cdb0c$var$debug = (parcelRequire("23YUm")).debuglog("stream", (fn)=>{
    $4b5b9664f08cdb0c$var$debug = fn;
});

var $ccXJ1 = parcelRequire("ccXJ1");

var $eDzoI = parcelRequire("eDzoI");

var $2yl2j = parcelRequire("2yl2j");
var $4b5b9664f08cdb0c$require$getHighWaterMark = $2yl2j.getHighWaterMark;
var $4b5b9664f08cdb0c$require$getDefaultHighWaterMark = $2yl2j.getDefaultHighWaterMark;

var $fDejL = parcelRequire("fDejL");
const { aggregateTwoErrors: $4b5b9664f08cdb0c$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $4b5b9664f08cdb0c$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $4b5b9664f08cdb0c$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $4b5b9664f08cdb0c$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $4b5b9664f08cdb0c$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $4b5b9664f08cdb0c$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $4b5b9664f08cdb0c$var$AbortError } = $fDejL;

var $dJ6QP = parcelRequire("dJ6QP");
var $4b5b9664f08cdb0c$require$validateObject = $dJ6QP.validateObject;
const $4b5b9664f08cdb0c$var$kPaused = $4b5b9664f08cdb0c$require$Symbol("kPaused");

var $96pIe = parcelRequire("96pIe");
var $4b5b9664f08cdb0c$require$StringDecoder = $96pIe.StringDecoder;

var $lPnyY = parcelRequire("lPnyY");
$4b5b9664f08cdb0c$require$ObjectSetPrototypeOf($4b5b9664f08cdb0c$var$Readable.prototype, $4b5b9664f08cdb0c$require$Stream.prototype);
$4b5b9664f08cdb0c$require$ObjectSetPrototypeOf($4b5b9664f08cdb0c$var$Readable, $4b5b9664f08cdb0c$require$Stream);
const $4b5b9664f08cdb0c$var$nop = ()=>{};
const { errorOrDestroy: $4b5b9664f08cdb0c$var$errorOrDestroy } = $eDzoI;
const $4b5b9664f08cdb0c$var$kObjectMode = 1;
const $4b5b9664f08cdb0c$var$kEnded = 2;
const $4b5b9664f08cdb0c$var$kEndEmitted = 4;
const $4b5b9664f08cdb0c$var$kReading = 8;
const $4b5b9664f08cdb0c$var$kConstructed = 16;
const $4b5b9664f08cdb0c$var$kSync = 32;
const $4b5b9664f08cdb0c$var$kNeedReadable = 64;
const $4b5b9664f08cdb0c$var$kEmittedReadable = 128;
const $4b5b9664f08cdb0c$var$kReadableListening = 256;
const $4b5b9664f08cdb0c$var$kResumeScheduled = 512;
const $4b5b9664f08cdb0c$var$kErrorEmitted = 1024;
const $4b5b9664f08cdb0c$var$kEmitClose = 2048;
const $4b5b9664f08cdb0c$var$kAutoDestroy = 4096;
const $4b5b9664f08cdb0c$var$kDestroyed = 8192;
const $4b5b9664f08cdb0c$var$kClosed = 16384;
const $4b5b9664f08cdb0c$var$kCloseEmitted = 32768;
const $4b5b9664f08cdb0c$var$kMultiAwaitDrain = 65536;
const $4b5b9664f08cdb0c$var$kReadingMore = 131072;
const $4b5b9664f08cdb0c$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $4b5b9664f08cdb0c$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$4b5b9664f08cdb0c$require$ObjectDefineProperties($4b5b9664f08cdb0c$var$ReadableState.prototype, {
    objectMode: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kObjectMode),
    ended: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kEnded),
    endEmitted: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kEndEmitted),
    reading: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kNeedReadable),
    emittedReadable: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kEmittedReadable),
    readableListening: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kReadableListening),
    resumeScheduled: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kErrorEmitted),
    emitClose: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kEmitClose),
    autoDestroy: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kCloseEmitted),
    multiAwaitDrain: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kReadingMore),
    dataEmitted: $4b5b9664f08cdb0c$var$makeBitMapDescriptor($4b5b9664f08cdb0c$var$kDataEmitted)
});

function $4b5b9664f08cdb0c$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof (parcelRequire("1DMM6"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $4b5b9664f08cdb0c$var$kEmitClose | $4b5b9664f08cdb0c$var$kAutoDestroy | $4b5b9664f08cdb0c$var$kConstructed | $4b5b9664f08cdb0c$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $4b5b9664f08cdb0c$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $4b5b9664f08cdb0c$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $4b5b9664f08cdb0c$require$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex) : $4b5b9664f08cdb0c$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $ccXJ1();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$4b5b9664f08cdb0c$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$4b5b9664f08cdb0c$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$4b5b9664f08cdb0c$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || "utf8";
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $4b5b9664f08cdb0c$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $4b5b9664f08cdb0c$var$Readable(options) {
    if (!(this instanceof $4b5b9664f08cdb0c$var$Readable)) return new $4b5b9664f08cdb0c$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("1DMM6"));
    this._readableState = new $4b5b9664f08cdb0c$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.construct === "function") this._construct = options.construct;
        if (options.signal && !isDuplex) $4b5b9664f08cdb0c$require$addAbortSignal(options.signal, this);
    }
    $4b5b9664f08cdb0c$require$Stream.call(this, options);
    $eDzoI.construct(this, ()=>{
        if (this._readableState.needReadable) $4b5b9664f08cdb0c$var$maybeReadMore(this, this._readableState);
    });
}
$4b5b9664f08cdb0c$var$Readable.prototype.destroy = $eDzoI.destroy;
$4b5b9664f08cdb0c$var$Readable.prototype._undestroy = $eDzoI.undestroy;
$4b5b9664f08cdb0c$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$4b5b9664f08cdb0c$var$Readable.prototype[$4b5b9664f08cdb0c$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$4b5b9664f08cdb0c$var$Readable.prototype[$4b5b9664f08cdb0c$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $4b5b9664f08cdb0c$var$AbortError();
        this.destroy(error);
    }
    return new $4b5b9664f08cdb0c$require$Promise((resolve, reject)=>$2GdZi(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$4b5b9664f08cdb0c$var$Readable.prototype.push = function(chunk, encoding) {
    return $4b5b9664f08cdb0c$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$4b5b9664f08cdb0c$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $4b5b9664f08cdb0c$var$readableAddChunk(this, chunk, encoding, true);
};
function $4b5b9664f08cdb0c$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $4b5b9664f08cdb0c$var$debug("readableAddChunk", chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $4b5b9664f08cdb0c$var$kObjectMode) === 0) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $4b5b9664f08cdb0c$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $4b5b9664f08cdb0c$require$Buffer.from(chunk, encoding);
                    encoding = "";
                }
            }
        } else if (chunk instanceof $4b5b9664f08cdb0c$require$Buffer) encoding = "";
        else if ($4b5b9664f08cdb0c$require$Stream._isUint8Array(chunk)) {
            chunk = $4b5b9664f08cdb0c$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = "";
        } else if (chunk != null) err = new $4b5b9664f08cdb0c$var$ERR_INVALID_ARG_TYPE("chunk", [
            "string",
            "Buffer",
            "Uint8Array"
        ], chunk);
    }
    if (err) $4b5b9664f08cdb0c$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$4b5b9664f08cdb0c$var$kReading;
        $4b5b9664f08cdb0c$var$onEofChunk(stream, state);
    } else if ((state.state & $4b5b9664f08cdb0c$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $4b5b9664f08cdb0c$var$kEndEmitted) !== 0) $4b5b9664f08cdb0c$var$errorOrDestroy(stream, new $4b5b9664f08cdb0c$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $4b5b9664f08cdb0c$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $4b5b9664f08cdb0c$var$errorOrDestroy(stream, new $4b5b9664f08cdb0c$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$4b5b9664f08cdb0c$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $4b5b9664f08cdb0c$var$addChunk(stream, state, chunk, false);
                else $4b5b9664f08cdb0c$var$maybeReadMore(stream, state);
            } else $4b5b9664f08cdb0c$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$4b5b9664f08cdb0c$var$kReading;
        $4b5b9664f08cdb0c$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $4b5b9664f08cdb0c$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount("data") > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $4b5b9664f08cdb0c$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit("data", chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $4b5b9664f08cdb0c$var$kNeedReadable) !== 0) $4b5b9664f08cdb0c$var$emitReadable(stream);
    }
    $4b5b9664f08cdb0c$var$maybeReadMore(stream, state);
}
$4b5b9664f08cdb0c$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$4b5b9664f08cdb0c$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$4b5b9664f08cdb0c$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $4b5b9664f08cdb0c$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = "";
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== "") buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $4b5b9664f08cdb0c$var$MAX_HWM = 0x40000000;
function $4b5b9664f08cdb0c$var$computeNewHighWaterMark(n) {
    if (n > $4b5b9664f08cdb0c$var$MAX_HWM) throw new $4b5b9664f08cdb0c$var$ERR_OUT_OF_RANGE("size", "<= 1GiB", n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $4b5b9664f08cdb0c$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $4b5b9664f08cdb0c$var$kObjectMode) !== 0) return 1;
    if ($4b5b9664f08cdb0c$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$4b5b9664f08cdb0c$var$Readable.prototype.read = function(n) {
    $4b5b9664f08cdb0c$var$debug("read", n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$4b5b9664f08cdb0c$require$NumberIsInteger(n)) n = $4b5b9664f08cdb0c$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $4b5b9664f08cdb0c$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$4b5b9664f08cdb0c$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $4b5b9664f08cdb0c$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $4b5b9664f08cdb0c$var$endReadable(this);
        else $4b5b9664f08cdb0c$var$emitReadable(this);
        return null;
    }
    n = $4b5b9664f08cdb0c$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $4b5b9664f08cdb0c$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $4b5b9664f08cdb0c$var$kNeedReadable) !== 0;
    $4b5b9664f08cdb0c$var$debug("need readable", doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $4b5b9664f08cdb0c$var$debug("length less than watermark", doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $4b5b9664f08cdb0c$var$debug("reading, ended or constructing", doRead);
    } else if (doRead) {
        $4b5b9664f08cdb0c$var$debug("do read");
        state.state |= $4b5b9664f08cdb0c$var$kReading | $4b5b9664f08cdb0c$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $4b5b9664f08cdb0c$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $4b5b9664f08cdb0c$var$errorOrDestroy(this, err);
        }
        state.state &= ~$4b5b9664f08cdb0c$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $4b5b9664f08cdb0c$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $4b5b9664f08cdb0c$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $4b5b9664f08cdb0c$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit("data", ret);
    }
    return ret;
};
function $4b5b9664f08cdb0c$var$onEofChunk(stream, state) {
    $4b5b9664f08cdb0c$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $4b5b9664f08cdb0c$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $4b5b9664f08cdb0c$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $4b5b9664f08cdb0c$var$emitReadable(stream) {
    const state = stream._readableState;
    $4b5b9664f08cdb0c$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $4b5b9664f08cdb0c$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $6Q1U4.nextTick($4b5b9664f08cdb0c$var$emitReadable_, stream);
    }
}
function $4b5b9664f08cdb0c$var$emitReadable_(stream) {
    const state = stream._readableState;
    $4b5b9664f08cdb0c$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $4b5b9664f08cdb0c$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $4b5b9664f08cdb0c$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $6Q1U4.nextTick($4b5b9664f08cdb0c$var$maybeReadMore_, stream, state);
    }
}
function $4b5b9664f08cdb0c$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $4b5b9664f08cdb0c$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$4b5b9664f08cdb0c$var$Readable.prototype._read = function(n) {
    throw new $4b5b9664f08cdb0c$var$ERR_METHOD_NOT_IMPLEMENTED("_read()");
};
$4b5b9664f08cdb0c$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $4b5b9664f08cdb0c$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $4b5b9664f08cdb0c$var$debug("pipe count=%d opts=%j", state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $6Q1U4.stdout && dest !== $6Q1U4.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $6Q1U4.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $4b5b9664f08cdb0c$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $4b5b9664f08cdb0c$var$debug("onend");
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $4b5b9664f08cdb0c$var$debug("cleanup");
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        if (ondrain) dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $4b5b9664f08cdb0c$var$debug("false write response, pause", 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $4b5b9664f08cdb0c$var$debug("false write response, pause", state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $4b5b9664f08cdb0c$var$pipeOnDrain(src, dest);
            dest.on("drain", ondrain);
        }
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $4b5b9664f08cdb0c$var$debug("ondata");
        const ret = dest.write(chunk);
        $4b5b9664f08cdb0c$var$debug("dest.write", ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $4b5b9664f08cdb0c$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if (dest.listenerCount("error") === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $4b5b9664f08cdb0c$var$errorOrDestroy(dest, er);
            else dest.emit("error", er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $4b5b9664f08cdb0c$require$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $4b5b9664f08cdb0c$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $4b5b9664f08cdb0c$var$debug("unpipe");
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit("pipe", src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $4b5b9664f08cdb0c$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $4b5b9664f08cdb0c$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $4b5b9664f08cdb0c$var$debug("pipeOnDrain", 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $4b5b9664f08cdb0c$var$debug("pipeOnDrain", state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount("data")) src.resume();
    };
}
$4b5b9664f08cdb0c$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $4b5b9664f08cdb0c$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$4b5b9664f08cdb0c$var$Readable.prototype.on = function(ev, fn) {
    const res = $4b5b9664f08cdb0c$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === "data") {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $4b5b9664f08cdb0c$var$debug("on readable", state.length, state.reading);
            if (state.length) $4b5b9664f08cdb0c$var$emitReadable(this);
            else if (!state.reading) $6Q1U4.nextTick($4b5b9664f08cdb0c$var$nReadingNextTick, this);
        }
    }
    return res;
};
$4b5b9664f08cdb0c$var$Readable.prototype.addListener = $4b5b9664f08cdb0c$var$Readable.prototype.on;
$4b5b9664f08cdb0c$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $4b5b9664f08cdb0c$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $6Q1U4.nextTick($4b5b9664f08cdb0c$var$updateReadableListening, this);
    return res;
};
$4b5b9664f08cdb0c$var$Readable.prototype.off = $4b5b9664f08cdb0c$var$Readable.prototype.removeListener;
$4b5b9664f08cdb0c$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $4b5b9664f08cdb0c$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $6Q1U4.nextTick($4b5b9664f08cdb0c$var$updateReadableListening, this);
    return res;
};
function $4b5b9664f08cdb0c$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount("readable") > 0;
    if (state.resumeScheduled && state[$4b5b9664f08cdb0c$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount("data") > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $4b5b9664f08cdb0c$var$nReadingNextTick(self) {
    $4b5b9664f08cdb0c$var$debug("readable nexttick read 0");
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$4b5b9664f08cdb0c$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $4b5b9664f08cdb0c$var$debug("resume");
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $4b5b9664f08cdb0c$var$resume(this, state);
    }
    state[$4b5b9664f08cdb0c$var$kPaused] = false;
    return this;
};
function $4b5b9664f08cdb0c$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $6Q1U4.nextTick($4b5b9664f08cdb0c$var$resume_, stream, state);
    }
}
function $4b5b9664f08cdb0c$var$resume_(stream, state) {
    $4b5b9664f08cdb0c$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $4b5b9664f08cdb0c$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$4b5b9664f08cdb0c$var$Readable.prototype.pause = function() {
    $4b5b9664f08cdb0c$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $4b5b9664f08cdb0c$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState[$4b5b9664f08cdb0c$var$kPaused] = true;
    return this;
};
function $4b5b9664f08cdb0c$var$flow(stream) {
    const state = stream._readableState;
    $4b5b9664f08cdb0c$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$4b5b9664f08cdb0c$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on("data", (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on("end", ()=>{
        this.push(null);
    });
    stream.on("error", (err)=>{
        $4b5b9664f08cdb0c$var$errorOrDestroy(this, err);
    });
    stream.on("close", ()=>{
        this.destroy();
    });
    stream.on("destroy", ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $4b5b9664f08cdb0c$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === "function") this[i] = stream[i].bind(stream);
    }
    return this;
};
$4b5b9664f08cdb0c$var$Readable.prototype[$4b5b9664f08cdb0c$require$SymbolAsyncIterator] = function() {
    return $4b5b9664f08cdb0c$var$streamToAsyncIterator(this);
};
$4b5b9664f08cdb0c$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $4b5b9664f08cdb0c$require$validateObject(options, "options");
    return $4b5b9664f08cdb0c$var$streamToAsyncIterator(this, options);
};
function $4b5b9664f08cdb0c$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== "function") stream = $4b5b9664f08cdb0c$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $4b5b9664f08cdb0c$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $4b5b9664f08cdb0c$var$createAsyncIterator(stream, options) {
    let callback = $4b5b9664f08cdb0c$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $4b5b9664f08cdb0c$var$nop;
        } else callback = resolve;
    }
    stream.on("readable", next);
    let error;
    const cleanup = $2GdZi(stream, {
        writable: false
    }, (err)=>{
        error = err ? $4b5b9664f08cdb0c$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $4b5b9664f08cdb0c$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $4b5b9664f08cdb0c$require$Promise(next);
        }
    } catch (err) {
        error = $4b5b9664f08cdb0c$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $eDzoI.destroyer(stream, null);
        else {
            stream.off("readable", next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$4b5b9664f08cdb0c$require$ObjectDefineProperties($4b5b9664f08cdb0c$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$4b5b9664f08cdb0c$require$ObjectDefineProperties($4b5b9664f08cdb0c$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$4b5b9664f08cdb0c$var$kPaused] !== false;
        },
        set (value) {
            this[$4b5b9664f08cdb0c$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$4b5b9664f08cdb0c$var$Readable._fromList = $4b5b9664f08cdb0c$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $4b5b9664f08cdb0c$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $4b5b9664f08cdb0c$var$endReadable(stream) {
    const state = stream._readableState;
    $4b5b9664f08cdb0c$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $6Q1U4.nextTick($4b5b9664f08cdb0c$var$endReadableNT, state, stream);
    }
}
function $4b5b9664f08cdb0c$var$endReadableNT(state, stream) {
    $4b5b9664f08cdb0c$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit("end");
        if (stream.writable && stream.allowHalfOpen === false) $6Q1U4.nextTick($4b5b9664f08cdb0c$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $4b5b9664f08cdb0c$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$4b5b9664f08cdb0c$var$Readable.from = function(iterable, opts) {
    return $lPnyY($4b5b9664f08cdb0c$var$Readable, iterable, opts);
};
let $4b5b9664f08cdb0c$var$webStreamsAdapters;
// Lazy to avoid circular references
function $4b5b9664f08cdb0c$var$lazyWebStreams() {
    if ($4b5b9664f08cdb0c$var$webStreamsAdapters === undefined) $4b5b9664f08cdb0c$var$webStreamsAdapters = {};
    return $4b5b9664f08cdb0c$var$webStreamsAdapters;
}
$4b5b9664f08cdb0c$var$Readable.fromWeb = function(readableStream, options) {
    return $4b5b9664f08cdb0c$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$4b5b9664f08cdb0c$var$Readable.toWeb = function(streamReadable, options) {
    return $4b5b9664f08cdb0c$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$4b5b9664f08cdb0c$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $4b5b9664f08cdb0c$var$Readable({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true,
        ...options,
        destroy (err, callback) {
            $eDzoI.destroyer(src, err);
            callback(err);
        }
    }).wrap(src);
};

});
parcelRegister("6Q1U4", function(module, exports) {
// shim for using process in browser
var $4fa9135dd8da4826$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4fa9135dd8da4826$var$cachedSetTimeout;
var $4fa9135dd8da4826$var$cachedClearTimeout;
function $4fa9135dd8da4826$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4fa9135dd8da4826$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4fa9135dd8da4826$var$cachedSetTimeout = setTimeout;
        else $4fa9135dd8da4826$var$cachedSetTimeout = $4fa9135dd8da4826$var$defaultSetTimout;
    } catch (e) {
        $4fa9135dd8da4826$var$cachedSetTimeout = $4fa9135dd8da4826$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4fa9135dd8da4826$var$cachedClearTimeout = clearTimeout;
        else $4fa9135dd8da4826$var$cachedClearTimeout = $4fa9135dd8da4826$var$defaultClearTimeout;
    } catch (e) {
        $4fa9135dd8da4826$var$cachedClearTimeout = $4fa9135dd8da4826$var$defaultClearTimeout;
    }
})();
function $4fa9135dd8da4826$var$runTimeout(fun) {
    if ($4fa9135dd8da4826$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4fa9135dd8da4826$var$cachedSetTimeout === $4fa9135dd8da4826$var$defaultSetTimout || !$4fa9135dd8da4826$var$cachedSetTimeout) && setTimeout) {
        $4fa9135dd8da4826$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4fa9135dd8da4826$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4fa9135dd8da4826$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4fa9135dd8da4826$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4fa9135dd8da4826$var$runClearTimeout(marker) {
    if ($4fa9135dd8da4826$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4fa9135dd8da4826$var$cachedClearTimeout === $4fa9135dd8da4826$var$defaultClearTimeout || !$4fa9135dd8da4826$var$cachedClearTimeout) && clearTimeout) {
        $4fa9135dd8da4826$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4fa9135dd8da4826$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4fa9135dd8da4826$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4fa9135dd8da4826$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4fa9135dd8da4826$var$queue = [];
var $4fa9135dd8da4826$var$draining = false;
var $4fa9135dd8da4826$var$currentQueue;
var $4fa9135dd8da4826$var$queueIndex = -1;
function $4fa9135dd8da4826$var$cleanUpNextTick() {
    if (!$4fa9135dd8da4826$var$draining || !$4fa9135dd8da4826$var$currentQueue) return;
    $4fa9135dd8da4826$var$draining = false;
    if ($4fa9135dd8da4826$var$currentQueue.length) $4fa9135dd8da4826$var$queue = $4fa9135dd8da4826$var$currentQueue.concat($4fa9135dd8da4826$var$queue);
    else $4fa9135dd8da4826$var$queueIndex = -1;
    if ($4fa9135dd8da4826$var$queue.length) $4fa9135dd8da4826$var$drainQueue();
}
function $4fa9135dd8da4826$var$drainQueue() {
    if ($4fa9135dd8da4826$var$draining) return;
    var timeout = $4fa9135dd8da4826$var$runTimeout($4fa9135dd8da4826$var$cleanUpNextTick);
    $4fa9135dd8da4826$var$draining = true;
    var len = $4fa9135dd8da4826$var$queue.length;
    while(len){
        $4fa9135dd8da4826$var$currentQueue = $4fa9135dd8da4826$var$queue;
        $4fa9135dd8da4826$var$queue = [];
        while(++$4fa9135dd8da4826$var$queueIndex < len)if ($4fa9135dd8da4826$var$currentQueue) $4fa9135dd8da4826$var$currentQueue[$4fa9135dd8da4826$var$queueIndex].run();
        $4fa9135dd8da4826$var$queueIndex = -1;
        len = $4fa9135dd8da4826$var$queue.length;
    }
    $4fa9135dd8da4826$var$currentQueue = null;
    $4fa9135dd8da4826$var$draining = false;
    $4fa9135dd8da4826$var$runClearTimeout(timeout);
}
$4fa9135dd8da4826$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4fa9135dd8da4826$var$queue.push(new $4fa9135dd8da4826$var$Item(fun, args));
    if ($4fa9135dd8da4826$var$queue.length === 1 && !$4fa9135dd8da4826$var$draining) $4fa9135dd8da4826$var$runTimeout($4fa9135dd8da4826$var$drainQueue);
};
// v8 likes predictible objects
function $4fa9135dd8da4826$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4fa9135dd8da4826$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4fa9135dd8da4826$var$process.title = "browser";
$4fa9135dd8da4826$var$process.browser = true;
$4fa9135dd8da4826$var$process.env = {};
$4fa9135dd8da4826$var$process.argv = [];
$4fa9135dd8da4826$var$process.version = ""; // empty string to avoid regexp issues
$4fa9135dd8da4826$var$process.versions = {};
function $4fa9135dd8da4826$var$noop() {}
$4fa9135dd8da4826$var$process.on = $4fa9135dd8da4826$var$noop;
$4fa9135dd8da4826$var$process.addListener = $4fa9135dd8da4826$var$noop;
$4fa9135dd8da4826$var$process.once = $4fa9135dd8da4826$var$noop;
$4fa9135dd8da4826$var$process.off = $4fa9135dd8da4826$var$noop;
$4fa9135dd8da4826$var$process.removeListener = $4fa9135dd8da4826$var$noop;
$4fa9135dd8da4826$var$process.removeAllListeners = $4fa9135dd8da4826$var$noop;
$4fa9135dd8da4826$var$process.emit = $4fa9135dd8da4826$var$noop;
$4fa9135dd8da4826$var$process.prependListener = $4fa9135dd8da4826$var$noop;
$4fa9135dd8da4826$var$process.prependOnceListener = $4fa9135dd8da4826$var$noop;
$4fa9135dd8da4826$var$process.listeners = function(name) {
    return [];
};
$4fa9135dd8da4826$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4fa9135dd8da4826$var$process.cwd = function() {
    return "/";
};
$4fa9135dd8da4826$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4fa9135dd8da4826$var$process.umask = function() {
    return 0;
};

});

parcelRegister("8tftx", function(module, exports) {
"use strict";

var $hARba = parcelRequire("hARba");
var $62ad094696df2815$require$ArrayIsArray = $hARba.ArrayIsArray;
var $62ad094696df2815$require$ObjectSetPrototypeOf = $hARba.ObjectSetPrototypeOf;

var $al3fM = parcelRequire("al3fM");
var $62ad094696df2815$require$EE = $al3fM.EventEmitter;
function $62ad094696df2815$var$Stream(opts) {
    $62ad094696df2815$require$EE.call(this, opts);
}
$62ad094696df2815$require$ObjectSetPrototypeOf($62ad094696df2815$var$Stream.prototype, $62ad094696df2815$require$EE.prototype);
$62ad094696df2815$require$ObjectSetPrototypeOf($62ad094696df2815$var$Stream, $62ad094696df2815$require$EE);
$62ad094696df2815$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($62ad094696df2815$require$EE.listenerCount(this, "error") === 0) this.emit("error", er);
    }
    $62ad094696df2815$var$prependListener(source, "error", onerror);
    $62ad094696df2815$var$prependListener(dest, "error", onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $62ad094696df2815$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($62ad094696df2815$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $62ad094696df2815$var$Stream,
    prependListener: $62ad094696df2815$var$prependListener
};

});

parcelRegister("5VHEs", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", () => $451422e6658d8f5f$export$e2db56ee53255a0, (v) => $451422e6658d8f5f$export$e2db56ee53255a0 = v);
$parcel$export(module.exports, "addAbortSignalNoValidate", () => $451422e6658d8f5f$export$11956e9313f43de0, (v) => $451422e6658d8f5f$export$11956e9313f43de0 = v);
var $451422e6658d8f5f$export$e2db56ee53255a0;
var $451422e6658d8f5f$export$11956e9313f43de0;
"use strict";

var $hARba = parcelRequire("hARba");
var $451422e6658d8f5f$require$SymbolDispose = $hARba.SymbolDispose;

var $fDejL = parcelRequire("fDejL");
var $451422e6658d8f5f$require$AbortError = $fDejL.AbortError;
var $451422e6658d8f5f$require$codes = $fDejL.codes;

var $jTHeA = parcelRequire("jTHeA");
var $451422e6658d8f5f$require$isNodeStream = $jTHeA.isNodeStream;
var $451422e6658d8f5f$require$isWebStream = $jTHeA.isWebStream;
var $451422e6658d8f5f$require$kControllerErrorFunction = $jTHeA.kControllerErrorFunction;

var $2GdZi = parcelRequire("2GdZi");
const { ERR_INVALID_ARG_TYPE: $451422e6658d8f5f$var$ERR_INVALID_ARG_TYPE } = $451422e6658d8f5f$require$codes;
let $451422e6658d8f5f$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $451422e6658d8f5f$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== "object" || !("aborted" in signal)) throw new $451422e6658d8f5f$var$ERR_INVALID_ARG_TYPE(name, "AbortSignal", signal);
};
$451422e6658d8f5f$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $451422e6658d8f5f$var$validateAbortSignal(signal, "signal");
    if (!$451422e6658d8f5f$require$isNodeStream(stream) && !$451422e6658d8f5f$require$isWebStream(stream)) throw new $451422e6658d8f5f$var$ERR_INVALID_ARG_TYPE("stream", [
        "ReadableStream",
        "WritableStream",
        "Stream"
    ], stream);
    return $451422e6658d8f5f$export$11956e9313f43de0(signal, stream);
};

$451422e6658d8f5f$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== "object" || !("aborted" in signal)) return stream;
    const onAbort = $451422e6658d8f5f$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $451422e6658d8f5f$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$451422e6658d8f5f$require$kControllerErrorFunction](new $451422e6658d8f5f$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $451422e6658d8f5f$var$addAbortListener = $451422e6658d8f5f$var$addAbortListener || (parcelRequire("23YUm")).addAbortListener;
        const disposable = $451422e6658d8f5f$var$addAbortListener(signal, onAbort);
        $2GdZi(stream, disposable[$451422e6658d8f5f$require$SymbolDispose]);
    }
    return stream;
};

});
parcelRegister("fDejL", function(module, exports) {
"use strict";

var $23YUm = parcelRequire("23YUm");
var $b6159ab8e1ca8042$require$format = $23YUm.format;
var $b6159ab8e1ca8042$require$inspect = $23YUm.inspect;
var $b6159ab8e1ca8042$require$CustomAggregateError = $23YUm.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/master/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $b6159ab8e1ca8042$var$AggregateError = globalThis.AggregateError || $b6159ab8e1ca8042$require$CustomAggregateError;
const $b6159ab8e1ca8042$var$kIsNodeError = Symbol("kIsNodeError");
const $b6159ab8e1ca8042$var$kTypes = [
    "string",
    "function",
    "number",
    "object",
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    "Function",
    "Object",
    "boolean",
    "bigint",
    "symbol"
];
const $b6159ab8e1ca8042$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $b6159ab8e1ca8042$var$nodeInternalPrefix = "__node_internal_";
const $b6159ab8e1ca8042$var$codes = {};
function $b6159ab8e1ca8042$var$assert(value, message) {
    if (!value) throw new $b6159ab8e1ca8042$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $b6159ab8e1ca8042$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $b6159ab8e1ca8042$var$getMessage(key, msg, args) {
    if (typeof msg === "function") {
        $b6159ab8e1ca8042$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $b6159ab8e1ca8042$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $b6159ab8e1ca8042$require$format(msg, ...args);
}
function $b6159ab8e1ca8042$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        constructor(...args){
            super($b6159ab8e1ca8042$var$getMessage(code, message, args));
        }
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$b6159ab8e1ca8042$var$kIsNodeError] = true;
    $b6159ab8e1ca8042$var$codes[code] = NodeError;
}
function $b6159ab8e1ca8042$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $b6159ab8e1ca8042$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, "name", {
        value: hidden
    });
    return fn;
}
function $b6159ab8e1ca8042$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $b6159ab8e1ca8042$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $b6159ab8e1ca8042$var$AbortError extends Error {
    constructor(message = "The operation was aborted", options){
        if (options !== undefined && typeof options !== "object") throw new $b6159ab8e1ca8042$var$codes.ERR_INVALID_ARG_TYPE("options", "Object", options);
        super(message, options);
        this.code = "ABORT_ERR";
        this.name = "AbortError";
    }
}
$b6159ab8e1ca8042$var$E("ERR_ASSERTION", "%s", Error);
$b6159ab8e1ca8042$var$E("ERR_INVALID_ARG_TYPE", (name, expected, actual)=>{
    $b6159ab8e1ca8042$var$assert(typeof name === "string", "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = "The ";
    if (name.endsWith(" argument")) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes(".") ? "property" : "argument"} `;
    msg += "must be ";
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $b6159ab8e1ca8042$var$assert(typeof value === "string", "All expected entries have to be of type string");
        if ($b6159ab8e1ca8042$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($b6159ab8e1ca8042$var$classRegExp.test(value)) instances.push(value);
        else {
            $b6159ab8e1ca8042$var$assert(value !== "object", 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf("object");
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push("Object");
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(", ")}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += " or ";
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(", ")}, or ${last}`;
                }
        }
        if (other.length > 0) msg += " or ";
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += "an ";
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(", ")}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === "function" && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === "object") {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $b6159ab8e1ca8042$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $b6159ab8e1ca8042$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$b6159ab8e1ca8042$var$E("ERR_INVALID_ARG_VALUE", (name, value, reason = "is invalid")=>{
    let inspected = $b6159ab8e1ca8042$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + "...";
    const type = name.includes(".") ? "property" : "argument";
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$b6159ab8e1ca8042$var$E("ERR_INVALID_RETURN_VALUE", (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$b6159ab8e1ca8042$var$E("ERR_MISSING_ARGS", (...args)=>{
    $b6159ab8e1ca8042$var$assert(args.length > 0, "At least one arg needs to be specified");
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(" or ");
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(", ")}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$b6159ab8e1ca8042$var$E("ERR_OUT_OF_RANGE", (str, range, input)=>{
    $b6159ab8e1ca8042$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $b6159ab8e1ca8042$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > 2n ** 32n || input < -(2n ** 32n)) received = $b6159ab8e1ca8042$var$addNumericalSeparator(received);
        received += "n";
    } else received = $b6159ab8e1ca8042$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$b6159ab8e1ca8042$var$E("ERR_MULTIPLE_CALLBACK", "Callback called multiple times", Error);
$b6159ab8e1ca8042$var$E("ERR_METHOD_NOT_IMPLEMENTED", "The %s method is not implemented", Error);
$b6159ab8e1ca8042$var$E("ERR_STREAM_ALREADY_FINISHED", "Cannot call %s after a stream was finished", Error);
$b6159ab8e1ca8042$var$E("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable", Error);
$b6159ab8e1ca8042$var$E("ERR_STREAM_DESTROYED", "Cannot call %s after a stream was destroyed", Error);
$b6159ab8e1ca8042$var$E("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$b6159ab8e1ca8042$var$E("ERR_STREAM_PREMATURE_CLOSE", "Premature close", Error);
$b6159ab8e1ca8042$var$E("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF", Error);
$b6159ab8e1ca8042$var$E("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event", Error);
$b6159ab8e1ca8042$var$E("ERR_STREAM_WRITE_AFTER_END", "write after end", Error);
$b6159ab8e1ca8042$var$E("ERR_UNKNOWN_ENCODING", "Unknown encoding: %s", TypeError);
module.exports = {
    AbortError: $b6159ab8e1ca8042$var$AbortError,
    aggregateTwoErrors: $b6159ab8e1ca8042$var$hideStackFrames($b6159ab8e1ca8042$var$aggregateTwoErrors),
    hideStackFrames: $b6159ab8e1ca8042$var$hideStackFrames,
    codes: $b6159ab8e1ca8042$var$codes
};

});

parcelRegister("jTHeA", function(module, exports) {
"use strict";

var $hARba = parcelRequire("hARba");
var $e7c4b0cc2268d789$require$SymbolAsyncIterator = $hARba.SymbolAsyncIterator;
var $e7c4b0cc2268d789$require$SymbolIterator = $hARba.SymbolIterator;
var $e7c4b0cc2268d789$require$SymbolFor = $hARba.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $e7c4b0cc2268d789$var$kIsDestroyed = $e7c4b0cc2268d789$require$SymbolFor("nodejs.stream.destroyed");
const $e7c4b0cc2268d789$var$kIsErrored = $e7c4b0cc2268d789$require$SymbolFor("nodejs.stream.errored");
const $e7c4b0cc2268d789$var$kIsReadable = $e7c4b0cc2268d789$require$SymbolFor("nodejs.stream.readable");
const $e7c4b0cc2268d789$var$kIsWritable = $e7c4b0cc2268d789$require$SymbolFor("nodejs.stream.writable");
const $e7c4b0cc2268d789$var$kIsDisturbed = $e7c4b0cc2268d789$require$SymbolFor("nodejs.stream.disturbed");
const $e7c4b0cc2268d789$var$kIsClosedPromise = $e7c4b0cc2268d789$require$SymbolFor("nodejs.webstream.isClosedPromise");
const $e7c4b0cc2268d789$var$kControllerErrorFunction = $e7c4b0cc2268d789$require$SymbolFor("nodejs.webstream.controllerErrorFunction");
function $e7c4b0cc2268d789$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === "function" && typeof obj.on === "function" && (!strict || typeof obj.pause === "function" && typeof obj.resume === "function") && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $e7c4b0cc2268d789$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === "function" && typeof obj.on === "function" && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $e7c4b0cc2268d789$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === "function" && obj._readableState && typeof obj.on === "function" && typeof obj.write === "function");
}
function $e7c4b0cc2268d789$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === "function" && typeof obj.on === "function" || typeof obj.pipe === "function" && typeof obj.on === "function");
}
function $e7c4b0cc2268d789$var$isReadableStream(obj) {
    return !!(obj && !$e7c4b0cc2268d789$var$isNodeStream(obj) && typeof obj.pipeThrough === "function" && typeof obj.getReader === "function" && typeof obj.cancel === "function");
}
function $e7c4b0cc2268d789$var$isWritableStream(obj) {
    return !!(obj && !$e7c4b0cc2268d789$var$isNodeStream(obj) && typeof obj.getWriter === "function" && typeof obj.abort === "function");
}
function $e7c4b0cc2268d789$var$isTransformStream(obj) {
    return !!(obj && !$e7c4b0cc2268d789$var$isNodeStream(obj) && typeof obj.readable === "object" && typeof obj.writable === "object");
}
function $e7c4b0cc2268d789$var$isWebStream(obj) {
    return $e7c4b0cc2268d789$var$isReadableStream(obj) || $e7c4b0cc2268d789$var$isWritableStream(obj) || $e7c4b0cc2268d789$var$isTransformStream(obj);
}
function $e7c4b0cc2268d789$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$e7c4b0cc2268d789$require$SymbolAsyncIterator] === "function";
    if (isAsync === false) return typeof obj[$e7c4b0cc2268d789$require$SymbolIterator] === "function";
    return typeof obj[$e7c4b0cc2268d789$require$SymbolAsyncIterator] === "function" || typeof obj[$e7c4b0cc2268d789$require$SymbolIterator] === "function";
}
function $e7c4b0cc2268d789$var$isDestroyed(stream) {
    if (!$e7c4b0cc2268d789$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$e7c4b0cc2268d789$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $e7c4b0cc2268d789$var$isWritableEnded(stream) {
    if (!$e7c4b0cc2268d789$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== "boolean") return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $e7c4b0cc2268d789$var$isWritableFinished(stream, strict) {
    if (!$e7c4b0cc2268d789$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== "boolean") return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $e7c4b0cc2268d789$var$isReadableEnded(stream) {
    if (!$e7c4b0cc2268d789$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== "boolean") return null;
    return rState.ended;
}
// Have emitted 'end'.
function $e7c4b0cc2268d789$var$isReadableFinished(stream, strict) {
    if (!$e7c4b0cc2268d789$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== "boolean") return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $e7c4b0cc2268d789$var$isReadable(stream) {
    if (stream && stream[$e7c4b0cc2268d789$var$kIsReadable] != null) return stream[$e7c4b0cc2268d789$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== "boolean") return null;
    if ($e7c4b0cc2268d789$var$isDestroyed(stream)) return false;
    return $e7c4b0cc2268d789$var$isReadableNodeStream(stream) && stream.readable && !$e7c4b0cc2268d789$var$isReadableFinished(stream);
}
function $e7c4b0cc2268d789$var$isWritable(stream) {
    if (stream && stream[$e7c4b0cc2268d789$var$kIsWritable] != null) return stream[$e7c4b0cc2268d789$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== "boolean") return null;
    if ($e7c4b0cc2268d789$var$isDestroyed(stream)) return false;
    return $e7c4b0cc2268d789$var$isWritableNodeStream(stream) && stream.writable && !$e7c4b0cc2268d789$var$isWritableEnded(stream);
}
function $e7c4b0cc2268d789$var$isFinished(stream, opts) {
    if (!$e7c4b0cc2268d789$var$isNodeStream(stream)) return null;
    if ($e7c4b0cc2268d789$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $e7c4b0cc2268d789$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $e7c4b0cc2268d789$var$isWritable(stream)) return false;
    return true;
}
function $e7c4b0cc2268d789$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$e7c4b0cc2268d789$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $e7c4b0cc2268d789$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$e7c4b0cc2268d789$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $e7c4b0cc2268d789$var$isClosed(stream) {
    if (!$e7c4b0cc2268d789$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === "boolean") return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === "boolean" || typeof (rState === null || rState === undefined ? undefined : rState.closed) === "boolean") return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === "boolean" && $e7c4b0cc2268d789$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $e7c4b0cc2268d789$var$isOutgoingMessage(stream) {
    return typeof stream._closed === "boolean" && typeof stream._defaultKeepAlive === "boolean" && typeof stream._removedConnection === "boolean" && typeof stream._removedContLen === "boolean";
}
function $e7c4b0cc2268d789$var$isServerResponse(stream) {
    return typeof stream._sent100 === "boolean" && $e7c4b0cc2268d789$var$isOutgoingMessage(stream);
}
function $e7c4b0cc2268d789$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === "boolean" && typeof stream._dumped === "boolean" && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $e7c4b0cc2268d789$var$willEmitClose(stream) {
    if (!$e7c4b0cc2268d789$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $e7c4b0cc2268d789$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $e7c4b0cc2268d789$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$e7c4b0cc2268d789$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $e7c4b0cc2268d789$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$e7c4b0cc2268d789$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $e7c4b0cc2268d789$var$isDestroyed,
    kIsDestroyed: $e7c4b0cc2268d789$var$kIsDestroyed,
    isDisturbed: $e7c4b0cc2268d789$var$isDisturbed,
    kIsDisturbed: $e7c4b0cc2268d789$var$kIsDisturbed,
    isErrored: $e7c4b0cc2268d789$var$isErrored,
    kIsErrored: $e7c4b0cc2268d789$var$kIsErrored,
    isReadable: $e7c4b0cc2268d789$var$isReadable,
    kIsReadable: $e7c4b0cc2268d789$var$kIsReadable,
    kIsClosedPromise: $e7c4b0cc2268d789$var$kIsClosedPromise,
    kControllerErrorFunction: $e7c4b0cc2268d789$var$kControllerErrorFunction,
    kIsWritable: $e7c4b0cc2268d789$var$kIsWritable,
    isClosed: $e7c4b0cc2268d789$var$isClosed,
    isDuplexNodeStream: $e7c4b0cc2268d789$var$isDuplexNodeStream,
    isFinished: $e7c4b0cc2268d789$var$isFinished,
    isIterable: $e7c4b0cc2268d789$var$isIterable,
    isReadableNodeStream: $e7c4b0cc2268d789$var$isReadableNodeStream,
    isReadableStream: $e7c4b0cc2268d789$var$isReadableStream,
    isReadableEnded: $e7c4b0cc2268d789$var$isReadableEnded,
    isReadableFinished: $e7c4b0cc2268d789$var$isReadableFinished,
    isReadableErrored: $e7c4b0cc2268d789$var$isReadableErrored,
    isNodeStream: $e7c4b0cc2268d789$var$isNodeStream,
    isWebStream: $e7c4b0cc2268d789$var$isWebStream,
    isWritable: $e7c4b0cc2268d789$var$isWritable,
    isWritableNodeStream: $e7c4b0cc2268d789$var$isWritableNodeStream,
    isWritableStream: $e7c4b0cc2268d789$var$isWritableStream,
    isWritableEnded: $e7c4b0cc2268d789$var$isWritableEnded,
    isWritableFinished: $e7c4b0cc2268d789$var$isWritableFinished,
    isWritableErrored: $e7c4b0cc2268d789$var$isWritableErrored,
    isServerRequest: $e7c4b0cc2268d789$var$isServerRequest,
    isServerResponse: $e7c4b0cc2268d789$var$isServerResponse,
    willEmitClose: $e7c4b0cc2268d789$var$willEmitClose,
    isTransformStream: $e7c4b0cc2268d789$var$isTransformStream
};

});

parcelRegister("2GdZi", function(module, exports) {
/* replacement start */ 
var $6Q1U4 = parcelRequire("6Q1U4");
"use strict";

var $fDejL = parcelRequire("fDejL");
var $1f3a5aab2f2fd1d2$require$AbortError = $fDejL.AbortError;
var $1f3a5aab2f2fd1d2$require$codes = $fDejL.codes;
const { ERR_INVALID_ARG_TYPE: $1f3a5aab2f2fd1d2$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $1f3a5aab2f2fd1d2$var$ERR_STREAM_PREMATURE_CLOSE } = $1f3a5aab2f2fd1d2$require$codes;

var $1f3a5aab2f2fd1d2$require$kEmptyObject = (parcelRequire("23YUm")).kEmptyObject;
var $1f3a5aab2f2fd1d2$require$once = (parcelRequire("23YUm")).once;

var $dJ6QP = parcelRequire("dJ6QP");
var $1f3a5aab2f2fd1d2$require$validateAbortSignal = $dJ6QP.validateAbortSignal;
var $1f3a5aab2f2fd1d2$require$validateFunction = $dJ6QP.validateFunction;
var $1f3a5aab2f2fd1d2$require$validateObject = $dJ6QP.validateObject;
var $1f3a5aab2f2fd1d2$require$validateBoolean = $dJ6QP.validateBoolean;

var $hARba = parcelRequire("hARba");
var $1f3a5aab2f2fd1d2$require$Promise = $hARba.Promise;
var $1f3a5aab2f2fd1d2$require$PromisePrototypeThen = $hARba.PromisePrototypeThen;
var $1f3a5aab2f2fd1d2$require$SymbolDispose = $hARba.SymbolDispose;

var $jTHeA = parcelRequire("jTHeA");
var $1f3a5aab2f2fd1d2$require$isClosed = $jTHeA.isClosed;
var $1f3a5aab2f2fd1d2$require$isReadable = $jTHeA.isReadable;
var $1f3a5aab2f2fd1d2$require$isReadableNodeStream = $jTHeA.isReadableNodeStream;
var $1f3a5aab2f2fd1d2$require$isReadableStream = $jTHeA.isReadableStream;
var $1f3a5aab2f2fd1d2$require$isReadableFinished = $jTHeA.isReadableFinished;
var $1f3a5aab2f2fd1d2$require$isReadableErrored = $jTHeA.isReadableErrored;
var $1f3a5aab2f2fd1d2$require$isWritable = $jTHeA.isWritable;
var $1f3a5aab2f2fd1d2$require$isWritableNodeStream = $jTHeA.isWritableNodeStream;
var $1f3a5aab2f2fd1d2$require$isWritableStream = $jTHeA.isWritableStream;
var $1f3a5aab2f2fd1d2$require$isWritableFinished = $jTHeA.isWritableFinished;
var $1f3a5aab2f2fd1d2$require$isWritableErrored = $jTHeA.isWritableErrored;
var $1f3a5aab2f2fd1d2$require$isNodeStream = $jTHeA.isNodeStream;
var $1f3a5aab2f2fd1d2$require$_willEmitClose = $jTHeA.willEmitClose;
var $1f3a5aab2f2fd1d2$require$kIsClosedPromise = $jTHeA.kIsClosedPromise;
let $1f3a5aab2f2fd1d2$var$addAbortListener;
function $1f3a5aab2f2fd1d2$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
const $1f3a5aab2f2fd1d2$var$nop = ()=>{};

function $1f3a5aab2f2fd1d2$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $1f3a5aab2f2fd1d2$require$kEmptyObject;
    } else if (options == null) options = $1f3a5aab2f2fd1d2$require$kEmptyObject;
    else $1f3a5aab2f2fd1d2$require$validateObject(options, "options");
    $1f3a5aab2f2fd1d2$require$validateFunction(callback, "callback");
    $1f3a5aab2f2fd1d2$require$validateAbortSignal(options.signal, "options.signal");
    callback = $1f3a5aab2f2fd1d2$require$once(callback);
    if ($1f3a5aab2f2fd1d2$require$isReadableStream(stream) || $1f3a5aab2f2fd1d2$require$isWritableStream(stream)) return $1f3a5aab2f2fd1d2$var$eosWeb(stream, options, callback);
    if (!$1f3a5aab2f2fd1d2$require$isNodeStream(stream)) throw new $1f3a5aab2f2fd1d2$var$ERR_INVALID_ARG_TYPE("stream", [
        "ReadableStream",
        "WritableStream",
        "Stream"
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $1f3a5aab2f2fd1d2$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $1f3a5aab2f2fd1d2$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $1f3a5aab2f2fd1d2$require$_willEmitClose(stream) && $1f3a5aab2f2fd1d2$require$isReadableNodeStream(stream) === readable && $1f3a5aab2f2fd1d2$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $1f3a5aab2f2fd1d2$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $1f3a5aab2f2fd1d2$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $1f3a5aab2f2fd1d2$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $1f3a5aab2f2fd1d2$require$isWritableErrored(stream) || $1f3a5aab2f2fd1d2$require$isReadableErrored(stream);
        if (errored && typeof errored !== "boolean") return callback.call(stream, errored);
        if (readable && !readableFinished && $1f3a5aab2f2fd1d2$require$isReadableNodeStream(stream, true)) {
            if (!$1f3a5aab2f2fd1d2$require$isReadableFinished(stream, false)) return callback.call(stream, new $1f3a5aab2f2fd1d2$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$1f3a5aab2f2fd1d2$require$isWritableFinished(stream, false)) return callback.call(stream, new $1f3a5aab2f2fd1d2$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $1f3a5aab2f2fd1d2$require$isWritableErrored(stream) || $1f3a5aab2f2fd1d2$require$isReadableErrored(stream);
        if (errored && typeof errored !== "boolean") return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on("finish", onfinish);
    };
    if ($1f3a5aab2f2fd1d2$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        if (!willEmitClose) stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === "boolean") stream.on("aborted", onclose);
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (options.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    if (closed) $6Q1U4.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $6Q1U4.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $1f3a5aab2f2fd1d2$require$isReadable(stream)) && (writableFinished || $1f3a5aab2f2fd1d2$require$isWritable(stream) === false)) $6Q1U4.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $1f3a5aab2f2fd1d2$require$isWritable(stream)) && (readableFinished || $1f3a5aab2f2fd1d2$require$isReadable(stream) === false)) $6Q1U4.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $6Q1U4.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $1f3a5aab2f2fd1d2$var$nop;
        stream.removeListener("aborted", onclose);
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $1f3a5aab2f2fd1d2$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $6Q1U4.nextTick(abort);
        else {
            $1f3a5aab2f2fd1d2$var$addAbortListener = $1f3a5aab2f2fd1d2$var$addAbortListener || (parcelRequire("23YUm")).addAbortListener;
            const disposable = $1f3a5aab2f2fd1d2$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $1f3a5aab2f2fd1d2$require$once((...args)=>{
                disposable[$1f3a5aab2f2fd1d2$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $1f3a5aab2f2fd1d2$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $1f3a5aab2f2fd1d2$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $1f3a5aab2f2fd1d2$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $6Q1U4.nextTick(abort);
        else {
            $1f3a5aab2f2fd1d2$var$addAbortListener = $1f3a5aab2f2fd1d2$var$addAbortListener || (parcelRequire("23YUm")).addAbortListener;
            const disposable = $1f3a5aab2f2fd1d2$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $1f3a5aab2f2fd1d2$require$once((...args)=>{
                disposable[$1f3a5aab2f2fd1d2$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $6Q1U4.nextTick(()=>callback.apply(stream, args));
    };
    $1f3a5aab2f2fd1d2$require$PromisePrototypeThen(stream[$1f3a5aab2f2fd1d2$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $1f3a5aab2f2fd1d2$var$nop;
}
function $1f3a5aab2f2fd1d2$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $1f3a5aab2f2fd1d2$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $1f3a5aab2f2fd1d2$require$validateBoolean(opts.cleanup, "cleanup");
        autoCleanup = opts.cleanup;
    }
    return new $1f3a5aab2f2fd1d2$require$Promise((resolve, reject)=>{
        const cleanup = $1f3a5aab2f2fd1d2$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $1f3a5aab2f2fd1d2$var$eos;
module.exports.finished = $1f3a5aab2f2fd1d2$var$finished;

});
parcelRegister("dJ6QP", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ "use strict";

var $hARba = parcelRequire("hARba");
var $9fe4cad25f5d2697$require$ArrayIsArray = $hARba.ArrayIsArray;
var $9fe4cad25f5d2697$require$ArrayPrototypeIncludes = $hARba.ArrayPrototypeIncludes;
var $9fe4cad25f5d2697$require$ArrayPrototypeJoin = $hARba.ArrayPrototypeJoin;
var $9fe4cad25f5d2697$require$ArrayPrototypeMap = $hARba.ArrayPrototypeMap;
var $9fe4cad25f5d2697$require$NumberIsInteger = $hARba.NumberIsInteger;
var $9fe4cad25f5d2697$require$NumberIsNaN = $hARba.NumberIsNaN;
var $9fe4cad25f5d2697$require$NumberMAX_SAFE_INTEGER = $hARba.NumberMAX_SAFE_INTEGER;
var $9fe4cad25f5d2697$require$NumberMIN_SAFE_INTEGER = $hARba.NumberMIN_SAFE_INTEGER;
var $9fe4cad25f5d2697$require$NumberParseInt = $hARba.NumberParseInt;
var $9fe4cad25f5d2697$require$ObjectPrototypeHasOwnProperty = $hARba.ObjectPrototypeHasOwnProperty;
var $9fe4cad25f5d2697$require$RegExpPrototypeExec = $hARba.RegExpPrototypeExec;
var $9fe4cad25f5d2697$require$String = $hARba.String;
var $9fe4cad25f5d2697$require$StringPrototypeToUpperCase = $hARba.StringPrototypeToUpperCase;
var $9fe4cad25f5d2697$require$StringPrototypeTrim = $hARba.StringPrototypeTrim;

var $fDejL = parcelRequire("fDejL");
const { hideStackFrames: $9fe4cad25f5d2697$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $9fe4cad25f5d2697$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $9fe4cad25f5d2697$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $9fe4cad25f5d2697$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $9fe4cad25f5d2697$var$ERR_UNKNOWN_SIGNAL } } = $fDejL;

var $23YUm = parcelRequire("23YUm");
const { normalizeEncoding: $9fe4cad25f5d2697$var$normalizeEncoding } = $23YUm;

var $23YUm = parcelRequire("23YUm");
const { isAsyncFunction: $9fe4cad25f5d2697$var$isAsyncFunction, isArrayBufferView: $9fe4cad25f5d2697$var$isArrayBufferView } = $23YUm.types;
const $9fe4cad25f5d2697$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $9fe4cad25f5d2697$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $9fe4cad25f5d2697$var$isUint32(value) {
    return value === value >>> 0;
}
const $9fe4cad25f5d2697$var$octalReg = /^[0-7]+$/;
const $9fe4cad25f5d2697$var$modeDesc = "must be a 32-bit unsigned integer or an octal string";
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $9fe4cad25f5d2697$var$parseFileMode(value, name, def) {
    if (typeof value === "undefined") value = def;
    if (typeof value === "string") {
        if ($9fe4cad25f5d2697$require$RegExpPrototypeExec($9fe4cad25f5d2697$var$octalReg, value) === null) throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_VALUE(name, value, $9fe4cad25f5d2697$var$modeDesc);
        value = $9fe4cad25f5d2697$require$NumberParseInt(value, 8);
    }
    $9fe4cad25f5d2697$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $9fe4cad25f5d2697$var$validateInteger = $9fe4cad25f5d2697$var$hideStackFrames((value, name, min = $9fe4cad25f5d2697$require$NumberMIN_SAFE_INTEGER, max = $9fe4cad25f5d2697$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== "number") throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE(name, "number", value);
    if (!$9fe4cad25f5d2697$require$NumberIsInteger(value)) throw new $9fe4cad25f5d2697$var$ERR_OUT_OF_RANGE(name, "an integer", value);
    if (value < min || value > max) throw new $9fe4cad25f5d2697$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $9fe4cad25f5d2697$var$validateInt32 = $9fe4cad25f5d2697$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== "number") throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE(name, "number", value);
    if (!$9fe4cad25f5d2697$require$NumberIsInteger(value)) throw new $9fe4cad25f5d2697$var$ERR_OUT_OF_RANGE(name, "an integer", value);
    if (value < min || value > max) throw new $9fe4cad25f5d2697$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $9fe4cad25f5d2697$var$validateUint32 = $9fe4cad25f5d2697$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== "number") throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE(name, "number", value);
    if (!$9fe4cad25f5d2697$require$NumberIsInteger(value)) throw new $9fe4cad25f5d2697$var$ERR_OUT_OF_RANGE(name, "an integer", value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $9fe4cad25f5d2697$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $9fe4cad25f5d2697$var$validateString(value, name) {
    if (typeof value !== "string") throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE(name, "string", value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $9fe4cad25f5d2697$var$validateNumber(value, name, min, max) {
    if (typeof value !== "number") throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE(name, "number", value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $9fe4cad25f5d2697$require$NumberIsNaN(value)) throw new $9fe4cad25f5d2697$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ""}${min != null && max != null ? " && " : ""}${max != null ? `<= ${max}` : ""}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $9fe4cad25f5d2697$var$validateOneOf = $9fe4cad25f5d2697$var$hideStackFrames((value, name, oneOf)=>{
    if (!$9fe4cad25f5d2697$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $9fe4cad25f5d2697$require$ArrayPrototypeJoin($9fe4cad25f5d2697$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === "string" ? `'${v}'` : $9fe4cad25f5d2697$require$String(v)), ", ");
        const reason = "must be one of: " + allowed;
        throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $9fe4cad25f5d2697$var$validateBoolean(value, name) {
    if (typeof value !== "boolean") throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE(name, "boolean", value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $9fe4cad25f5d2697$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$9fe4cad25f5d2697$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $9fe4cad25f5d2697$var$validateObject = $9fe4cad25f5d2697$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $9fe4cad25f5d2697$var$getOwnPropertyValueOrDefault(options, "allowArray", false);
    const allowFunction = $9fe4cad25f5d2697$var$getOwnPropertyValueOrDefault(options, "allowFunction", false);
    const nullable = $9fe4cad25f5d2697$var$getOwnPropertyValueOrDefault(options, "nullable", false);
    if (!nullable && value === null || !allowArray && $9fe4cad25f5d2697$require$ArrayIsArray(value) || typeof value !== "object" && (!allowFunction || typeof value !== "function")) throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE(name, "Object", value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $9fe4cad25f5d2697$var$validateDictionary = $9fe4cad25f5d2697$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== "object" && typeof value !== "function") throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE(name, "a dictionary", value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $9fe4cad25f5d2697$var$validateArray = $9fe4cad25f5d2697$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$9fe4cad25f5d2697$require$ArrayIsArray(value)) throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE(name, "Array", value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $9fe4cad25f5d2697$var$validateStringArray(value, name) {
    $9fe4cad25f5d2697$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$9fe4cad25f5d2697$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $9fe4cad25f5d2697$var$validateBooleanArray(value, name) {
    $9fe4cad25f5d2697$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$9fe4cad25f5d2697$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $9fe4cad25f5d2697$var$validateAbortSignalArray(value, name) {
    $9fe4cad25f5d2697$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE(indexedName, "AbortSignal", signal);
        $9fe4cad25f5d2697$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $9fe4cad25f5d2697$var$validateSignalName(signal, name = "signal") {
    $9fe4cad25f5d2697$var$validateString(signal, name);
    if ($9fe4cad25f5d2697$var$signals[signal] === undefined) {
        if ($9fe4cad25f5d2697$var$signals[$9fe4cad25f5d2697$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $9fe4cad25f5d2697$var$ERR_UNKNOWN_SIGNAL(signal + " (signals must use all capital letters)");
        throw new $9fe4cad25f5d2697$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $9fe4cad25f5d2697$var$validateBuffer = $9fe4cad25f5d2697$var$hideStackFrames((buffer, name = "buffer")=>{
    if (!$9fe4cad25f5d2697$var$isArrayBufferView(buffer)) throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE(name, [
        "Buffer",
        "TypedArray",
        "DataView"
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $9fe4cad25f5d2697$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $9fe4cad25f5d2697$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === "hex" && length % 2 !== 0) throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_VALUE("encoding", encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $9fe4cad25f5d2697$var$validatePort(port, name = "Port", allowZero = true) {
    if (typeof port !== "number" && typeof port !== "string" || typeof port === "string" && $9fe4cad25f5d2697$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $9fe4cad25f5d2697$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $9fe4cad25f5d2697$var$validateAbortSignal = $9fe4cad25f5d2697$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== "object" || !("aborted" in signal))) throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE(name, "AbortSignal", signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $9fe4cad25f5d2697$var$validateFunction = $9fe4cad25f5d2697$var$hideStackFrames((value, name)=>{
    if (typeof value !== "function") throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE(name, "Function", value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $9fe4cad25f5d2697$var$validatePlainFunction = $9fe4cad25f5d2697$var$hideStackFrames((value, name)=>{
    if (typeof value !== "function" || $9fe4cad25f5d2697$var$isAsyncFunction(value)) throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE(name, "Function", value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $9fe4cad25f5d2697$var$validateUndefined = $9fe4cad25f5d2697$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE(name, "undefined", value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $9fe4cad25f5d2697$var$validateUnion(value, name, union) {
    if (!$9fe4cad25f5d2697$require$ArrayPrototypeIncludes(union, value)) throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_TYPE(name, `('${$9fe4cad25f5d2697$require$ArrayPrototypeJoin(union, "|")}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $9fe4cad25f5d2697$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $9fe4cad25f5d2697$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === "undefined" || !$9fe4cad25f5d2697$require$RegExpPrototypeExec($9fe4cad25f5d2697$var$linkValueRegExp, value)) throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $9fe4cad25f5d2697$var$validateLinkHeaderValue(hints) {
    if (typeof hints === "string") {
        $9fe4cad25f5d2697$var$validateLinkHeaderFormat(hints, "hints");
        return hints;
    } else if ($9fe4cad25f5d2697$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = "";
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $9fe4cad25f5d2697$var$validateLinkHeaderFormat(link, "hints");
            result += link;
            if (i !== hintsLength - 1) result += ", ";
        }
        return result;
    }
    throw new $9fe4cad25f5d2697$var$ERR_INVALID_ARG_VALUE("hints", hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $9fe4cad25f5d2697$var$isInt32,
    isUint32: $9fe4cad25f5d2697$var$isUint32,
    parseFileMode: $9fe4cad25f5d2697$var$parseFileMode,
    validateArray: $9fe4cad25f5d2697$var$validateArray,
    validateStringArray: $9fe4cad25f5d2697$var$validateStringArray,
    validateBooleanArray: $9fe4cad25f5d2697$var$validateBooleanArray,
    validateAbortSignalArray: $9fe4cad25f5d2697$var$validateAbortSignalArray,
    validateBoolean: $9fe4cad25f5d2697$var$validateBoolean,
    validateBuffer: $9fe4cad25f5d2697$var$validateBuffer,
    validateDictionary: $9fe4cad25f5d2697$var$validateDictionary,
    validateEncoding: $9fe4cad25f5d2697$var$validateEncoding,
    validateFunction: $9fe4cad25f5d2697$var$validateFunction,
    validateInt32: $9fe4cad25f5d2697$var$validateInt32,
    validateInteger: $9fe4cad25f5d2697$var$validateInteger,
    validateNumber: $9fe4cad25f5d2697$var$validateNumber,
    validateObject: $9fe4cad25f5d2697$var$validateObject,
    validateOneOf: $9fe4cad25f5d2697$var$validateOneOf,
    validatePlainFunction: $9fe4cad25f5d2697$var$validatePlainFunction,
    validatePort: $9fe4cad25f5d2697$var$validatePort,
    validateSignalName: $9fe4cad25f5d2697$var$validateSignalName,
    validateString: $9fe4cad25f5d2697$var$validateString,
    validateUint32: $9fe4cad25f5d2697$var$validateUint32,
    validateUndefined: $9fe4cad25f5d2697$var$validateUndefined,
    validateUnion: $9fe4cad25f5d2697$var$validateUnion,
    validateAbortSignal: $9fe4cad25f5d2697$var$validateAbortSignal,
    validateLinkHeaderValue: $9fe4cad25f5d2697$var$validateLinkHeaderValue
};

});



parcelRegister("ccXJ1", function(module, exports) {
"use strict";

var $hARba = parcelRequire("hARba");
var $8e34ef3712a15df7$require$StringPrototypeSlice = $hARba.StringPrototypeSlice;
var $8e34ef3712a15df7$require$SymbolIterator = $hARba.SymbolIterator;
var $8e34ef3712a15df7$require$TypedArrayPrototypeSet = $hARba.TypedArrayPrototypeSet;
var $8e34ef3712a15df7$require$Uint8Array = $hARba.Uint8Array;

var $4mEhT = parcelRequire("4mEhT");
var $8e34ef3712a15df7$require$Buffer = $4mEhT.Buffer;

var $23YUm = parcelRequire("23YUm");
var $8e34ef3712a15df7$require$inspect = $23YUm.inspect;
module.exports = class BufferList {
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return "";
        let p = this.head;
        let ret = "" + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $8e34ef3712a15df7$require$Buffer.alloc(0);
        const ret = $8e34ef3712a15df7$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $8e34ef3712a15df7$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$8e34ef3712a15df7$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = "";
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $8e34ef3712a15df7$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $8e34ef3712a15df7$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $8e34ef3712a15df7$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $8e34ef3712a15df7$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $8e34ef3712a15df7$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $8e34ef3712a15df7$require$TypedArrayPrototypeSet(ret, new $8e34ef3712a15df7$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for("nodejs.util.inspect.custom")](_, options) {
        return $8e34ef3712a15df7$require$inspect(this, {
            ...options,
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        });
    }
};

});

parcelRegister("eDzoI", function(module, exports) {
"use strict";

var $6Q1U4 = parcelRequire("6Q1U4");

var $fDejL = parcelRequire("fDejL");
/* replacement end */ const { aggregateTwoErrors: $aa802a6c53545d39$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $aa802a6c53545d39$var$ERR_MULTIPLE_CALLBACK }, AbortError: $aa802a6c53545d39$var$AbortError } = $fDejL;

var $hARba = parcelRequire("hARba");
var $aa802a6c53545d39$require$Symbol = $hARba.Symbol;

var $jTHeA = parcelRequire("jTHeA");
var $aa802a6c53545d39$require$kIsDestroyed = $jTHeA.kIsDestroyed;
var $aa802a6c53545d39$require$isDestroyed = $jTHeA.isDestroyed;
var $aa802a6c53545d39$require$isFinished = $jTHeA.isFinished;
var $aa802a6c53545d39$require$isServerRequest = $jTHeA.isServerRequest;
const $aa802a6c53545d39$var$kDestroy = $aa802a6c53545d39$require$Symbol("kDestroy");
const $aa802a6c53545d39$var$kConstruct = $aa802a6c53545d39$require$Symbol("kConstruct");
function $aa802a6c53545d39$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $aa802a6c53545d39$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === "function") cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $aa802a6c53545d39$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($aa802a6c53545d39$var$kDestroy, function(er) {
        $aa802a6c53545d39$var$_destroy(this, $aa802a6c53545d39$var$aggregateTwoErrors(er, err), cb);
    });
    else $aa802a6c53545d39$var$_destroy(this, err, cb);
    return this;
}
function $aa802a6c53545d39$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $aa802a6c53545d39$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === "function") cb(err);
        if (err) $6Q1U4.nextTick($aa802a6c53545d39$var$emitErrorCloseNT, self, err);
        else $6Q1U4.nextTick($aa802a6c53545d39$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $aa802a6c53545d39$var$emitErrorCloseNT(self, err) {
    $aa802a6c53545d39$var$emitErrorNT(self, err);
    $aa802a6c53545d39$var$emitCloseNT(self);
}
function $aa802a6c53545d39$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit("close");
}
function $aa802a6c53545d39$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit("error", err);
}
function $aa802a6c53545d39$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $aa802a6c53545d39$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $6Q1U4.nextTick($aa802a6c53545d39$var$emitErrorNT, stream, err);
        else $aa802a6c53545d39$var$emitErrorNT(stream, err);
    }
}
function $aa802a6c53545d39$var$construct(stream, cb) {
    if (typeof stream._construct !== "function") return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($aa802a6c53545d39$var$kConstruct, cb);
    if (stream.listenerCount($aa802a6c53545d39$var$kConstruct) > 1) // Duplex
    return;
    $6Q1U4.nextTick($aa802a6c53545d39$var$constructNT, stream);
}
function $aa802a6c53545d39$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $aa802a6c53545d39$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $aa802a6c53545d39$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($aa802a6c53545d39$var$kDestroy, err);
        else if (err) $aa802a6c53545d39$var$errorOrDestroy(stream, err, true);
        else $6Q1U4.nextTick($aa802a6c53545d39$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $6Q1U4.nextTick(onConstruct, err);
        });
    } catch (err) {
        $6Q1U4.nextTick(onConstruct, err);
    }
}
function $aa802a6c53545d39$var$emitConstructNT(stream) {
    stream.emit($aa802a6c53545d39$var$kConstruct);
}
function $aa802a6c53545d39$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === "function";
}
function $aa802a6c53545d39$var$emitCloseLegacy(stream) {
    stream.emit("close");
}
function $aa802a6c53545d39$var$emitErrorCloseLegacy(stream, err) {
    stream.emit("error", err);
    $6Q1U4.nextTick($aa802a6c53545d39$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $aa802a6c53545d39$var$destroyer(stream, err) {
    if (!stream || $aa802a6c53545d39$require$isDestroyed(stream)) return;
    if (!err && !$aa802a6c53545d39$require$isFinished(stream)) err = new $aa802a6c53545d39$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($aa802a6c53545d39$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($aa802a6c53545d39$var$isRequest(stream)) stream.abort();
    else if ($aa802a6c53545d39$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === "function") stream.destroy(err);
    else if (typeof stream.close === "function") // TODO: Don't lose err?
    stream.close();
    else if (err) $6Q1U4.nextTick($aa802a6c53545d39$var$emitErrorCloseLegacy, stream, err);
    else $6Q1U4.nextTick($aa802a6c53545d39$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$aa802a6c53545d39$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $aa802a6c53545d39$var$construct,
    destroyer: $aa802a6c53545d39$var$destroyer,
    destroy: $aa802a6c53545d39$var$destroy,
    undestroy: $aa802a6c53545d39$var$undestroy,
    errorOrDestroy: $aa802a6c53545d39$var$errorOrDestroy
};

});

parcelRegister("2yl2j", function(module, exports) {
"use strict";

var $hARba = parcelRequire("hARba");
var $1dbf131efb5ac223$require$MathFloor = $hARba.MathFloor;
var $1dbf131efb5ac223$require$NumberIsInteger = $hARba.NumberIsInteger;

var $dJ6QP = parcelRequire("dJ6QP");
var $1dbf131efb5ac223$require$validateInteger = $dJ6QP.validateInteger;

var $fDejL = parcelRequire("fDejL");
const { ERR_INVALID_ARG_VALUE: $1dbf131efb5ac223$var$ERR_INVALID_ARG_VALUE } = $fDejL.codes;
let $1dbf131efb5ac223$var$defaultHighWaterMarkBytes = 16384;
let $1dbf131efb5ac223$var$defaultHighWaterMarkObjectMode = 16;
function $1dbf131efb5ac223$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $1dbf131efb5ac223$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $1dbf131efb5ac223$var$defaultHighWaterMarkObjectMode : $1dbf131efb5ac223$var$defaultHighWaterMarkBytes;
}
function $1dbf131efb5ac223$var$setDefaultHighWaterMark(objectMode, value) {
    $1dbf131efb5ac223$require$validateInteger(value, "value", 0);
    if (objectMode) $1dbf131efb5ac223$var$defaultHighWaterMarkObjectMode = value;
    else $1dbf131efb5ac223$var$defaultHighWaterMarkBytes = value;
}
function $1dbf131efb5ac223$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $1dbf131efb5ac223$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$1dbf131efb5ac223$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : "options.highWaterMark";
            throw new $1dbf131efb5ac223$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $1dbf131efb5ac223$require$MathFloor(hwm);
    }
    // Default value
    return $1dbf131efb5ac223$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $1dbf131efb5ac223$var$getHighWaterMark,
    getDefaultHighWaterMark: $1dbf131efb5ac223$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $1dbf131efb5ac223$var$setDefaultHighWaterMark
};

});

parcelRegister("96pIe", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $6a089e88b712120d$export$63a7aa211a91ed69, (v) => $6a089e88b712120d$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $6a089e88b712120d$export$63a7aa211a91ed69;
"use strict";

var $9e9l9 = parcelRequire("9e9l9");
var $6a089e88b712120d$require$Buffer = $9e9l9.Buffer;
/*</replacement>*/ var $6a089e88b712120d$var$isEncoding = $6a089e88b712120d$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $6a089e88b712120d$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $6a089e88b712120d$var$normalizeEncoding(enc) {
    var nenc = $6a089e88b712120d$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($6a089e88b712120d$require$Buffer.isEncoding === $6a089e88b712120d$var$isEncoding || !$6a089e88b712120d$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$6a089e88b712120d$export$63a7aa211a91ed69 = $6a089e88b712120d$var$StringDecoder;
function $6a089e88b712120d$var$StringDecoder(encoding) {
    this.encoding = $6a089e88b712120d$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $6a089e88b712120d$var$utf16Text;
            this.end = $6a089e88b712120d$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $6a089e88b712120d$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $6a089e88b712120d$var$base64Text;
            this.end = $6a089e88b712120d$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $6a089e88b712120d$var$simpleWrite;
            this.end = $6a089e88b712120d$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $6a089e88b712120d$require$Buffer.allocUnsafe(nb);
}
$6a089e88b712120d$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$6a089e88b712120d$var$StringDecoder.prototype.end = $6a089e88b712120d$var$utf8End;
// Returns only complete characters in a Buffer
$6a089e88b712120d$var$StringDecoder.prototype.text = $6a089e88b712120d$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$6a089e88b712120d$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $6a089e88b712120d$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $6a089e88b712120d$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $6a089e88b712120d$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $6a089e88b712120d$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $6a089e88b712120d$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $6a089e88b712120d$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $6a089e88b712120d$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $6a089e88b712120d$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $6a089e88b712120d$var$utf8Text(buf, i) {
    var total = $6a089e88b712120d$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $6a089e88b712120d$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $6a089e88b712120d$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $6a089e88b712120d$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $6a089e88b712120d$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $6a089e88b712120d$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $6a089e88b712120d$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $6a089e88b712120d$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRegister("9e9l9", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $4mEhT = parcelRequire("4mEhT");
var $6b7caaa11fde8b13$var$Buffer = $4mEhT.Buffer;
// alternative to using Object.keys for old browsers
function $6b7caaa11fde8b13$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($6b7caaa11fde8b13$var$Buffer.from && $6b7caaa11fde8b13$var$Buffer.alloc && $6b7caaa11fde8b13$var$Buffer.allocUnsafe && $6b7caaa11fde8b13$var$Buffer.allocUnsafeSlow) module.exports = $4mEhT;
else {
    // Copy properties from require('buffer')
    $6b7caaa11fde8b13$var$copyProps($4mEhT, module.exports);
    module.exports.Buffer = $6b7caaa11fde8b13$var$SafeBuffer;
}
function $6b7caaa11fde8b13$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $6b7caaa11fde8b13$var$Buffer(arg, encodingOrOffset, length);
}
$6b7caaa11fde8b13$var$SafeBuffer.prototype = Object.create($6b7caaa11fde8b13$var$Buffer.prototype);
// Copy static methods from Buffer
$6b7caaa11fde8b13$var$copyProps($6b7caaa11fde8b13$var$Buffer, $6b7caaa11fde8b13$var$SafeBuffer);
$6b7caaa11fde8b13$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $6b7caaa11fde8b13$var$Buffer(arg, encodingOrOffset, length);
};
$6b7caaa11fde8b13$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $6b7caaa11fde8b13$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$6b7caaa11fde8b13$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6b7caaa11fde8b13$var$Buffer(size);
};
$6b7caaa11fde8b13$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $4mEhT.SlowBuffer(size);
};

});


parcelRegister("lPnyY", function(module, exports) {
"use strict";

var $6Q1U4 = parcelRequire("6Q1U4");

var $hARba = parcelRequire("hARba");
var $fe40a3847efda89a$require$PromisePrototypeThen = $hARba.PromisePrototypeThen;
var $fe40a3847efda89a$require$SymbolAsyncIterator = $hARba.SymbolAsyncIterator;
var $fe40a3847efda89a$require$SymbolIterator = $hARba.SymbolIterator;

var $4mEhT = parcelRequire("4mEhT");
var $fe40a3847efda89a$require$Buffer = $4mEhT.Buffer;

var $fDejL = parcelRequire("fDejL");
const { ERR_INVALID_ARG_TYPE: $fe40a3847efda89a$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $fe40a3847efda89a$var$ERR_STREAM_NULL_VALUES } = $fDejL.codes;
function $fe40a3847efda89a$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === "string" || iterable instanceof $fe40a3847efda89a$require$Buffer) return new Readable({
        objectMode: true,
        ...opts,
        read () {
            this.push(iterable);
            this.push(null);
        }
    });
    let isAsync;
    if (iterable && iterable[$fe40a3847efda89a$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$fe40a3847efda89a$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$fe40a3847efda89a$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$fe40a3847efda89a$require$SymbolIterator]();
    } else throw new $fe40a3847efda89a$var$ERR_INVALID_ARG_TYPE("iterable", [
        "Iterable"
    ], iterable);
    const readable = new Readable({
        objectMode: true,
        highWaterMark: 1,
        // TODO(ronag): What options should be allowed?
        ...opts
    });
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $fe40a3847efda89a$require$PromisePrototypeThen(close(error), ()=>$6Q1U4.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$6Q1U4.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === "function";
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === "function") {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === "function" ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $fe40a3847efda89a$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $fe40a3847efda89a$var$from;

});


parcelRegister("bhyec", function(module, exports) {
/* replacement start */ 
var $6Q1U4 = parcelRequire("6Q1U4");
"use strict";

var $hARba = parcelRequire("hARba");
var $836bd53043ea8c37$require$ArrayPrototypeSlice = $hARba.ArrayPrototypeSlice;
var $836bd53043ea8c37$require$Error = $hARba.Error;
var $836bd53043ea8c37$require$FunctionPrototypeSymbolHasInstance = $hARba.FunctionPrototypeSymbolHasInstance;
var $836bd53043ea8c37$require$ObjectDefineProperty = $hARba.ObjectDefineProperty;
var $836bd53043ea8c37$require$ObjectDefineProperties = $hARba.ObjectDefineProperties;
var $836bd53043ea8c37$require$ObjectSetPrototypeOf = $hARba.ObjectSetPrototypeOf;
var $836bd53043ea8c37$require$StringPrototypeToLowerCase = $hARba.StringPrototypeToLowerCase;
var $836bd53043ea8c37$require$Symbol = $hARba.Symbol;
var $836bd53043ea8c37$require$SymbolHasInstance = $hARba.SymbolHasInstance;
module.exports = $836bd53043ea8c37$var$Writable;
$836bd53043ea8c37$var$Writable.WritableState = $836bd53043ea8c37$var$WritableState;

var $al3fM = parcelRequire("al3fM");
var $836bd53043ea8c37$require$EE = $al3fM.EventEmitter;

var $8tftx = parcelRequire("8tftx");
var $836bd53043ea8c37$require$Stream = $8tftx.Stream;

var $4mEhT = parcelRequire("4mEhT");
var $836bd53043ea8c37$require$Buffer = $4mEhT.Buffer;

var $eDzoI = parcelRequire("eDzoI");

var $5VHEs = parcelRequire("5VHEs");
var $836bd53043ea8c37$require$addAbortSignal = $5VHEs.addAbortSignal;

var $2yl2j = parcelRequire("2yl2j");
var $836bd53043ea8c37$require$getHighWaterMark = $2yl2j.getHighWaterMark;
var $836bd53043ea8c37$require$getDefaultHighWaterMark = $2yl2j.getDefaultHighWaterMark;

var $fDejL = parcelRequire("fDejL");
const { ERR_INVALID_ARG_TYPE: $836bd53043ea8c37$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $836bd53043ea8c37$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $836bd53043ea8c37$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $836bd53043ea8c37$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $836bd53043ea8c37$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $836bd53043ea8c37$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $836bd53043ea8c37$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $836bd53043ea8c37$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $836bd53043ea8c37$var$ERR_UNKNOWN_ENCODING } = $fDejL.codes;
const { errorOrDestroy: $836bd53043ea8c37$var$errorOrDestroy } = $eDzoI;
$836bd53043ea8c37$require$ObjectSetPrototypeOf($836bd53043ea8c37$var$Writable.prototype, $836bd53043ea8c37$require$Stream.prototype);
$836bd53043ea8c37$require$ObjectSetPrototypeOf($836bd53043ea8c37$var$Writable, $836bd53043ea8c37$require$Stream);
function $836bd53043ea8c37$var$nop() {}
const $836bd53043ea8c37$var$kOnFinished = $836bd53043ea8c37$require$Symbol("kOnFinished");

function $836bd53043ea8c37$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof (parcelRequire("1DMM6"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $836bd53043ea8c37$require$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex) : $836bd53043ea8c37$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || "utf8";
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $836bd53043ea8c37$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $836bd53043ea8c37$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$836bd53043ea8c37$var$kOnFinished] = [];
}
function $836bd53043ea8c37$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$836bd53043ea8c37$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $836bd53043ea8c37$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$836bd53043ea8c37$require$ObjectDefineProperty($836bd53043ea8c37$var$WritableState.prototype, "bufferedRequestCount", {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $836bd53043ea8c37$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("1DMM6"));
    if (!isDuplex && !$836bd53043ea8c37$require$FunctionPrototypeSymbolHasInstance($836bd53043ea8c37$var$Writable, this)) return new $836bd53043ea8c37$var$Writable(options);
    this._writableState = new $836bd53043ea8c37$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
        if (typeof options.construct === "function") this._construct = options.construct;
        if (options.signal) $836bd53043ea8c37$require$addAbortSignal(options.signal, this);
    }
    $836bd53043ea8c37$require$Stream.call(this, options);
    $eDzoI.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $836bd53043ea8c37$var$clearBuffer(this, state);
        $836bd53043ea8c37$var$finishMaybe(this, state);
    });
}
$836bd53043ea8c37$require$ObjectDefineProperty($836bd53043ea8c37$var$Writable, $836bd53043ea8c37$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($836bd53043ea8c37$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $836bd53043ea8c37$var$Writable) return false;
        return object && object._writableState instanceof $836bd53043ea8c37$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$836bd53043ea8c37$var$Writable.prototype.pipe = function() {
    $836bd53043ea8c37$var$errorOrDestroy(this, new $836bd53043ea8c37$var$ERR_STREAM_CANNOT_PIPE());
};
function $836bd53043ea8c37$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== "buffer" && !$836bd53043ea8c37$require$Buffer.isEncoding(encoding)) throw new $836bd53043ea8c37$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== "function") cb = $836bd53043ea8c37$var$nop;
    }
    if (chunk === null) throw new $836bd53043ea8c37$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === "string") {
            if (state.decodeStrings !== false) {
                chunk = $836bd53043ea8c37$require$Buffer.from(chunk, encoding);
                encoding = "buffer";
            }
        } else if (chunk instanceof $836bd53043ea8c37$require$Buffer) encoding = "buffer";
        else if ($836bd53043ea8c37$require$Stream._isUint8Array(chunk)) {
            chunk = $836bd53043ea8c37$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = "buffer";
        } else throw new $836bd53043ea8c37$var$ERR_INVALID_ARG_TYPE("chunk", [
            "string",
            "Buffer",
            "Uint8Array"
        ], chunk);
    }
    let err;
    if (state.ending) err = new $836bd53043ea8c37$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $836bd53043ea8c37$var$ERR_STREAM_DESTROYED("write");
    if (err) {
        $6Q1U4.nextTick(cb, err);
        $836bd53043ea8c37$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $836bd53043ea8c37$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$836bd53043ea8c37$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $836bd53043ea8c37$var$_write(this, chunk, encoding, cb) === true;
};
$836bd53043ea8c37$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$836bd53043ea8c37$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $836bd53043ea8c37$var$clearBuffer(this, state);
    }
};
$836bd53043ea8c37$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = $836bd53043ea8c37$require$StringPrototypeToLowerCase(encoding);
    if (!$836bd53043ea8c37$require$Buffer.isEncoding(encoding)) throw new $836bd53043ea8c37$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $836bd53043ea8c37$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== "buffer") state.allBuffers = false;
        if (state.allNoop && callback !== $836bd53043ea8c37$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $836bd53043ea8c37$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $836bd53043ea8c37$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $836bd53043ea8c37$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $836bd53043ea8c37$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $836bd53043ea8c37$var$errorOrDestroy(stream, er);
}
function $836bd53043ea8c37$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== "function") {
        $836bd53043ea8c37$var$errorOrDestroy(stream, new $836bd53043ea8c37$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $6Q1U4.nextTick($836bd53043ea8c37$var$onwriteError, stream, state, er, cb);
        else $836bd53043ea8c37$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $836bd53043ea8c37$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $6Q1U4.nextTick($836bd53043ea8c37$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $836bd53043ea8c37$var$afterWrite(stream, state, 1, cb);
    }
}
function $836bd53043ea8c37$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $836bd53043ea8c37$var$afterWrite(stream, state, count, cb);
}
function $836bd53043ea8c37$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $836bd53043ea8c37$var$errorBuffer(state);
    $836bd53043ea8c37$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $836bd53043ea8c37$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $836bd53043ea8c37$var$ERR_STREAM_DESTROYED("write"));
    }
    const onfinishCallbacks = state[$836bd53043ea8c37$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $836bd53043ea8c37$var$ERR_STREAM_DESTROYED("end"));
    }
    $836bd53043ea8c37$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $836bd53043ea8c37$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $836bd53043ea8c37$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $836bd53043ea8c37$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $836bd53043ea8c37$var$doWrite(stream, state, true, state.length, chunks, "", callback);
        $836bd53043ea8c37$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $836bd53043ea8c37$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $836bd53043ea8c37$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$836bd53043ea8c37$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $836bd53043ea8c37$var$ERR_METHOD_NOT_IMPLEMENTED("_write()");
};
$836bd53043ea8c37$var$Writable.prototype._writev = null;
$836bd53043ea8c37$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $836bd53043ea8c37$var$_write(this, chunk, encoding);
        if (ret instanceof $836bd53043ea8c37$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $836bd53043ea8c37$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $836bd53043ea8c37$var$ERR_STREAM_ALREADY_FINISHED("end");
    else if (state.destroyed) err = new $836bd53043ea8c37$var$ERR_STREAM_DESTROYED("end");
    if (typeof cb === "function") {
        if (err || state.finished) $6Q1U4.nextTick(cb, err);
        else state[$836bd53043ea8c37$var$kOnFinished].push(cb);
    }
    return this;
};
function $836bd53043ea8c37$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $836bd53043ea8c37$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $836bd53043ea8c37$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $836bd53043ea8c37$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$836bd53043ea8c37$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $836bd53043ea8c37$var$errorOrDestroy(stream, err, state.sync);
        } else if ($836bd53043ea8c37$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit("prefinish");
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $6Q1U4.nextTick($836bd53043ea8c37$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $836bd53043ea8c37$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.finalCalled = true;
            $836bd53043ea8c37$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $836bd53043ea8c37$var$finishMaybe(stream, state, sync) {
    if ($836bd53043ea8c37$var$needFinish(state)) {
        $836bd53043ea8c37$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $6Q1U4.nextTick((stream, state)=>{
                    if ($836bd53043ea8c37$var$needFinish(state)) $836bd53043ea8c37$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($836bd53043ea8c37$var$needFinish(state)) {
                state.pendingcb++;
                $836bd53043ea8c37$var$finish(stream, state);
            }
        }
    }
}
function $836bd53043ea8c37$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$836bd53043ea8c37$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit("finish");
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$836bd53043ea8c37$require$ObjectDefineProperties($836bd53043ea8c37$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $836bd53043ea8c37$var$destroy = $eDzoI.destroy;
$836bd53043ea8c37$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$836bd53043ea8c37$var$kOnFinished].length)) $6Q1U4.nextTick($836bd53043ea8c37$var$errorBuffer, state);
    $836bd53043ea8c37$var$destroy.call(this, err, cb);
    return this;
};
$836bd53043ea8c37$var$Writable.prototype._undestroy = $eDzoI.undestroy;
$836bd53043ea8c37$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$836bd53043ea8c37$var$Writable.prototype[$836bd53043ea8c37$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $836bd53043ea8c37$var$webStreamsAdapters;
// Lazy to avoid circular references
function $836bd53043ea8c37$var$lazyWebStreams() {
    if ($836bd53043ea8c37$var$webStreamsAdapters === undefined) $836bd53043ea8c37$var$webStreamsAdapters = {};
    return $836bd53043ea8c37$var$webStreamsAdapters;
}
$836bd53043ea8c37$var$Writable.fromWeb = function(writableStream, options) {
    return $836bd53043ea8c37$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$836bd53043ea8c37$var$Writable.toWeb = function(streamWritable) {
    return $836bd53043ea8c37$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("fYnfs", function(module, exports) {
/* replacement start */ 
var $6Q1U4 = parcelRequire("6Q1U4");
"use strict";

var $4mEhT = parcelRequire("4mEhT");

var $jTHeA = parcelRequire("jTHeA");
var $ba0e7e39669c0af5$require$isReadable = $jTHeA.isReadable;
var $ba0e7e39669c0af5$require$isWritable = $jTHeA.isWritable;
var $ba0e7e39669c0af5$require$isIterable = $jTHeA.isIterable;
var $ba0e7e39669c0af5$require$isNodeStream = $jTHeA.isNodeStream;
var $ba0e7e39669c0af5$require$isReadableNodeStream = $jTHeA.isReadableNodeStream;
var $ba0e7e39669c0af5$require$isWritableNodeStream = $jTHeA.isWritableNodeStream;
var $ba0e7e39669c0af5$require$isDuplexNodeStream = $jTHeA.isDuplexNodeStream;
var $ba0e7e39669c0af5$require$isReadableStream = $jTHeA.isReadableStream;
var $ba0e7e39669c0af5$require$isWritableStream = $jTHeA.isWritableStream;

var $2GdZi = parcelRequire("2GdZi");

var $fDejL = parcelRequire("fDejL");
const { AbortError: $ba0e7e39669c0af5$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $ba0e7e39669c0af5$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $ba0e7e39669c0af5$var$ERR_INVALID_RETURN_VALUE } } = $fDejL;

var $eDzoI = parcelRequire("eDzoI");
var $ba0e7e39669c0af5$require$destroyer = $eDzoI.destroyer;

var $1DMM6 = parcelRequire("1DMM6");

var $6t7Uw = parcelRequire("6t7Uw");

var $bhyec = parcelRequire("bhyec");

var $23YUm = parcelRequire("23YUm");
var $ba0e7e39669c0af5$require$createDeferredPromise = $23YUm.createDeferredPromise;

var $lPnyY = parcelRequire("lPnyY");
const $ba0e7e39669c0af5$var$Blob = globalThis.Blob || $4mEhT.Blob;
const $ba0e7e39669c0af5$var$isBlob = typeof $ba0e7e39669c0af5$var$Blob !== "undefined" ? function isBlob(b) {
    return b instanceof $ba0e7e39669c0af5$var$Blob;
} : function isBlob(b) {
    return false;
};

const $ba0e7e39669c0af5$var$AbortController = globalThis.AbortController || (parcelRequire("lOmHN")).AbortController;

var $hARba = parcelRequire("hARba");
var $ba0e7e39669c0af5$require$FunctionPrototypeCall = $hARba.FunctionPrototypeCall;
// This is needed for pre node 17.
class $ba0e7e39669c0af5$var$Duplexify extends $1DMM6 {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($ba0e7e39669c0af5$require$isDuplexNodeStream(body)) return body;
    if ($ba0e7e39669c0af5$require$isReadableNodeStream(body)) return $ba0e7e39669c0af5$var$_duplexify({
        readable: body
    });
    if ($ba0e7e39669c0af5$require$isWritableNodeStream(body)) return $ba0e7e39669c0af5$var$_duplexify({
        writable: body
    });
    if ($ba0e7e39669c0af5$require$isNodeStream(body)) return $ba0e7e39669c0af5$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($ba0e7e39669c0af5$require$isReadableStream(body)) return $ba0e7e39669c0af5$var$_duplexify({
        readable: $6t7Uw.fromWeb(body)
    });
    if ($ba0e7e39669c0af5$require$isWritableStream(body)) return $ba0e7e39669c0af5$var$_duplexify({
        writable: $bhyec.fromWeb(body)
    });
    if (typeof body === "function") {
        const { value: value, write: write, final: final, destroy: destroy } = $ba0e7e39669c0af5$var$fromAsyncGen(body);
        if ($ba0e7e39669c0af5$require$isIterable(value)) return $lPnyY($ba0e7e39669c0af5$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === "function") {
            let d;
            const promise = $ba0e7e39669c0af5$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $ba0e7e39669c0af5$var$ERR_INVALID_RETURN_VALUE("nully", "body", val);
            }, (err)=>{
                $ba0e7e39669c0af5$require$destroyer(d, err);
            });
            return d = new $ba0e7e39669c0af5$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $6Q1U4.nextTick(cb, null);
                        } catch (err) {
                            $6Q1U4.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $ba0e7e39669c0af5$var$ERR_INVALID_RETURN_VALUE("Iterable, AsyncIterable or AsyncFunction", name, value);
    }
    if ($ba0e7e39669c0af5$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($ba0e7e39669c0af5$require$isIterable(body)) return $lPnyY($ba0e7e39669c0af5$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($ba0e7e39669c0af5$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $ba0e7e39669c0af5$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $ba0e7e39669c0af5$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === "object" || typeof (body === null || body === undefined ? undefined : body.readable) === "object") {
        const readable = body !== null && body !== undefined && body.readable ? $ba0e7e39669c0af5$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $ba0e7e39669c0af5$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $ba0e7e39669c0af5$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === "function") {
        let d;
        $ba0e7e39669c0af5$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $ba0e7e39669c0af5$require$destroyer(d, err);
        });
        return d = new $ba0e7e39669c0af5$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $ba0e7e39669c0af5$var$ERR_INVALID_ARG_TYPE(name, [
        "Blob",
        "ReadableStream",
        "WritableStream",
        "Stream",
        "Iterable",
        "AsyncIterable",
        "Function",
        "{ readable, writable } pair",
        "Promise"
    ], body);
};
function $ba0e7e39669c0af5$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $ba0e7e39669c0af5$require$createDeferredPromise();
    const ac = new $ba0e7e39669c0af5$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $6Q1U4.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $ba0e7e39669c0af5$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $ba0e7e39669c0af5$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $ba0e7e39669c0af5$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== "function" ? $6t7Uw.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$ba0e7e39669c0af5$require$isReadable(r);
    let writable = !!$ba0e7e39669c0af5$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $ba0e7e39669c0af5$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $2GdZi(w, (err)=>{
            writable = false;
            if (err) $ba0e7e39669c0af5$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on("drain", function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on("finish", function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $2GdZi(r, (err)=>{
            readable = false;
            if (err) $ba0e7e39669c0af5$require$destroyer(r, err);
            onfinished(err);
        });
        r.on("readable", function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on("end", function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $ba0e7e39669c0af5$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $ba0e7e39669c0af5$require$destroyer(w, err);
            $ba0e7e39669c0af5$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("a9qV7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";

var $hARba = parcelRequire("hARba");
var $763fa07954d1dc11$require$ObjectSetPrototypeOf = $hARba.ObjectSetPrototypeOf;
module.exports = $763fa07954d1dc11$var$PassThrough;

var $6ch13 = parcelRequire("6ch13");
$763fa07954d1dc11$require$ObjectSetPrototypeOf($763fa07954d1dc11$var$PassThrough.prototype, $6ch13.prototype);
$763fa07954d1dc11$require$ObjectSetPrototypeOf($763fa07954d1dc11$var$PassThrough, $6ch13);
function $763fa07954d1dc11$var$PassThrough(options) {
    if (!(this instanceof $763fa07954d1dc11$var$PassThrough)) return new $763fa07954d1dc11$var$PassThrough(options);
    $6ch13.call(this, options);
}
$763fa07954d1dc11$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("6ch13", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";

var $hARba = parcelRequire("hARba");
var $48311011d89cff46$require$ObjectSetPrototypeOf = $hARba.ObjectSetPrototypeOf;
var $48311011d89cff46$require$Symbol = $hARba.Symbol;
module.exports = $48311011d89cff46$var$Transform;

var $fDejL = parcelRequire("fDejL");
const { ERR_METHOD_NOT_IMPLEMENTED: $48311011d89cff46$var$ERR_METHOD_NOT_IMPLEMENTED } = $fDejL.codes;

var $1DMM6 = parcelRequire("1DMM6");

var $2yl2j = parcelRequire("2yl2j");
var $48311011d89cff46$require$getHighWaterMark = $2yl2j.getHighWaterMark;
$48311011d89cff46$require$ObjectSetPrototypeOf($48311011d89cff46$var$Transform.prototype, $1DMM6.prototype);
$48311011d89cff46$require$ObjectSetPrototypeOf($48311011d89cff46$var$Transform, $1DMM6);
const $48311011d89cff46$var$kCallback = $48311011d89cff46$require$Symbol("kCallback");
function $48311011d89cff46$var$Transform(options) {
    if (!(this instanceof $48311011d89cff46$var$Transform)) return new $48311011d89cff46$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $48311011d89cff46$require$getHighWaterMark(this, options, "readableHighWaterMark", true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = {
        ...options,
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    };
    $1DMM6.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$48311011d89cff46$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on("prefinish", $48311011d89cff46$var$prefinish);
}
function $48311011d89cff46$var$final(cb) {
    if (typeof this._flush === "function" && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $48311011d89cff46$var$prefinish() {
    if (this._final !== $48311011d89cff46$var$final) $48311011d89cff46$var$final.call(this);
}
$48311011d89cff46$var$Transform.prototype._final = $48311011d89cff46$var$final;
$48311011d89cff46$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $48311011d89cff46$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()");
};
$48311011d89cff46$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$48311011d89cff46$var$kCallback] = callback;
    });
};
$48311011d89cff46$var$Transform.prototype._read = function() {
    if (this[$48311011d89cff46$var$kCallback]) {
        const callback = this[$48311011d89cff46$var$kCallback];
        this[$48311011d89cff46$var$kCallback] = null;
        callback();
    }
};

});


parcelRegister("3T6tc", function(module, exports) {
/** @license React v16.12.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $fve7V = parcelRequire("fve7V");
var $2d4b86f016b21118$var$n = "function" === typeof Symbol && Symbol.for, $2d4b86f016b21118$var$p = $2d4b86f016b21118$var$n ? Symbol.for("react.element") : 60103, $2d4b86f016b21118$var$q = $2d4b86f016b21118$var$n ? Symbol.for("react.portal") : 60106, $2d4b86f016b21118$var$r = $2d4b86f016b21118$var$n ? Symbol.for("react.fragment") : 60107, $2d4b86f016b21118$var$t = $2d4b86f016b21118$var$n ? Symbol.for("react.strict_mode") : 60108, $2d4b86f016b21118$var$u = $2d4b86f016b21118$var$n ? Symbol.for("react.profiler") : 60114, $2d4b86f016b21118$var$v = $2d4b86f016b21118$var$n ? Symbol.for("react.provider") : 60109, $2d4b86f016b21118$var$w = $2d4b86f016b21118$var$n ? Symbol.for("react.context") : 60110, $2d4b86f016b21118$var$x = $2d4b86f016b21118$var$n ? Symbol.for("react.forward_ref") : 60112, $2d4b86f016b21118$var$y = $2d4b86f016b21118$var$n ? Symbol.for("react.suspense") : 60113;
$2d4b86f016b21118$var$n && Symbol.for("react.suspense_list");
var $2d4b86f016b21118$var$z = $2d4b86f016b21118$var$n ? Symbol.for("react.memo") : 60115, $2d4b86f016b21118$var$aa = $2d4b86f016b21118$var$n ? Symbol.for("react.lazy") : 60116;
$2d4b86f016b21118$var$n && Symbol.for("react.fundamental");
$2d4b86f016b21118$var$n && Symbol.for("react.responder");
$2d4b86f016b21118$var$n && Symbol.for("react.scope");
var $2d4b86f016b21118$var$A = "function" === typeof Symbol && Symbol.iterator;
function $2d4b86f016b21118$var$B(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $2d4b86f016b21118$var$C = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $2d4b86f016b21118$var$D = {};
function $2d4b86f016b21118$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $2d4b86f016b21118$var$D;
    this.updater = c || $2d4b86f016b21118$var$C;
}
$2d4b86f016b21118$var$E.prototype.isReactComponent = {};
$2d4b86f016b21118$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($2d4b86f016b21118$var$B(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$2d4b86f016b21118$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $2d4b86f016b21118$var$F() {}
$2d4b86f016b21118$var$F.prototype = $2d4b86f016b21118$var$E.prototype;
function $2d4b86f016b21118$var$G(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $2d4b86f016b21118$var$D;
    this.updater = c || $2d4b86f016b21118$var$C;
}
var $2d4b86f016b21118$var$H = $2d4b86f016b21118$var$G.prototype = new $2d4b86f016b21118$var$F;
$2d4b86f016b21118$var$H.constructor = $2d4b86f016b21118$var$G;
$fve7V($2d4b86f016b21118$var$H, $2d4b86f016b21118$var$E.prototype);
$2d4b86f016b21118$var$H.isPureReactComponent = !0;
var $2d4b86f016b21118$var$I = {
    current: null
}, $2d4b86f016b21118$var$J = {
    current: null
}, $2d4b86f016b21118$var$K = Object.prototype.hasOwnProperty, $2d4b86f016b21118$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $2d4b86f016b21118$var$M(a, b, c) {
    var e, d = {}, g = null, l = null;
    if (null != b) for(e in void 0 !== b.ref && (l = b.ref), void 0 !== b.key && (g = "" + b.key), b)$2d4b86f016b21118$var$K.call(b, e) && !$2d4b86f016b21118$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var k = Array(f), m = 0; m < f; m++)k[m] = arguments[m + 2];
        d.children = k;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $2d4b86f016b21118$var$p,
        type: a,
        key: g,
        ref: l,
        props: d,
        _owner: $2d4b86f016b21118$var$J.current
    };
}
function $2d4b86f016b21118$var$ba(a, b) {
    return {
        $$typeof: $2d4b86f016b21118$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $2d4b86f016b21118$var$N(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2d4b86f016b21118$var$p;
}
function $2d4b86f016b21118$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $2d4b86f016b21118$var$O = /\/+/g, $2d4b86f016b21118$var$P = [];
function $2d4b86f016b21118$var$Q(a, b, c, e) {
    if ($2d4b86f016b21118$var$P.length) {
        var d = $2d4b86f016b21118$var$P.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $2d4b86f016b21118$var$R(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $2d4b86f016b21118$var$P.length && $2d4b86f016b21118$var$P.push(a);
}
function $2d4b86f016b21118$var$S(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $2d4b86f016b21118$var$p:
                case $2d4b86f016b21118$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $2d4b86f016b21118$var$T(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var l = 0; l < a.length; l++){
        d = a[l];
        var f = b + $2d4b86f016b21118$var$T(d, l);
        g += $2d4b86f016b21118$var$S(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $2d4b86f016b21118$var$A && a[$2d4b86f016b21118$var$A] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), l = 0; !(d = a.next()).done;)d = d.value, f = b + $2d4b86f016b21118$var$T(d, l++), g += $2d4b86f016b21118$var$S(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($2d4b86f016b21118$var$B(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $2d4b86f016b21118$var$U(a, b, c) {
    return null == a ? 0 : $2d4b86f016b21118$var$S(a, "", b, c);
}
function $2d4b86f016b21118$var$T(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $2d4b86f016b21118$var$escape(a.key) : b.toString(36);
}
function $2d4b86f016b21118$var$ca(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $2d4b86f016b21118$var$da(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $2d4b86f016b21118$var$V(a, e, c, function(a) {
        return a;
    }) : null != a && ($2d4b86f016b21118$var$N(a) && (a = $2d4b86f016b21118$var$ba(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($2d4b86f016b21118$var$O, "$&/") + "/") + c)), e.push(a));
}
function $2d4b86f016b21118$var$V(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($2d4b86f016b21118$var$O, "$&/") + "/");
    b = $2d4b86f016b21118$var$Q(b, g, e, d);
    $2d4b86f016b21118$var$U(a, $2d4b86f016b21118$var$da, b);
    $2d4b86f016b21118$var$R(b);
}
function $2d4b86f016b21118$var$W() {
    var a = $2d4b86f016b21118$var$I.current;
    if (null === a) throw Error($2d4b86f016b21118$var$B(321));
    return a;
}
var $2d4b86f016b21118$var$X = {
    Children: {
        map: function(a, b, c) {
            if (null == a) return a;
            var e = [];
            $2d4b86f016b21118$var$V(a, e, null, b, c);
            return e;
        },
        forEach: function(a, b, c) {
            if (null == a) return a;
            b = $2d4b86f016b21118$var$Q(null, null, b, c);
            $2d4b86f016b21118$var$U(a, $2d4b86f016b21118$var$ca, b);
            $2d4b86f016b21118$var$R(b);
        },
        count: function(a) {
            return $2d4b86f016b21118$var$U(a, function() {
                return null;
            }, null);
        },
        toArray: function(a) {
            var b = [];
            $2d4b86f016b21118$var$V(a, b, null, function(a) {
                return a;
            });
            return b;
        },
        only: function(a) {
            if (!$2d4b86f016b21118$var$N(a)) throw Error($2d4b86f016b21118$var$B(143));
            return a;
        }
    },
    createRef: function() {
        return {
            current: null
        };
    },
    Component: $2d4b86f016b21118$var$E,
    PureComponent: $2d4b86f016b21118$var$G,
    createContext: function(a, b) {
        void 0 === b && (b = null);
        a = {
            $$typeof: $2d4b86f016b21118$var$w,
            _calculateChangedBits: b,
            _currentValue: a,
            _currentValue2: a,
            _threadCount: 0,
            Provider: null,
            Consumer: null
        };
        a.Provider = {
            $$typeof: $2d4b86f016b21118$var$v,
            _context: a
        };
        return a.Consumer = a;
    },
    forwardRef: function(a) {
        return {
            $$typeof: $2d4b86f016b21118$var$x,
            render: a
        };
    },
    lazy: function(a) {
        return {
            $$typeof: $2d4b86f016b21118$var$aa,
            _ctor: a,
            _status: -1,
            _result: null
        };
    },
    memo: function(a, b) {
        return {
            $$typeof: $2d4b86f016b21118$var$z,
            type: a,
            compare: void 0 === b ? null : b
        };
    },
    useCallback: function(a, b) {
        return $2d4b86f016b21118$var$W().useCallback(a, b);
    },
    useContext: function(a, b) {
        return $2d4b86f016b21118$var$W().useContext(a, b);
    },
    useEffect: function(a, b) {
        return $2d4b86f016b21118$var$W().useEffect(a, b);
    },
    useImperativeHandle: function(a, b, c) {
        return $2d4b86f016b21118$var$W().useImperativeHandle(a, b, c);
    },
    useDebugValue: function() {},
    useLayoutEffect: function(a, b) {
        return $2d4b86f016b21118$var$W().useLayoutEffect(a, b);
    },
    useMemo: function(a, b) {
        return $2d4b86f016b21118$var$W().useMemo(a, b);
    },
    useReducer: function(a, b, c) {
        return $2d4b86f016b21118$var$W().useReducer(a, b, c);
    },
    useRef: function(a) {
        return $2d4b86f016b21118$var$W().useRef(a);
    },
    useState: function(a) {
        return $2d4b86f016b21118$var$W().useState(a);
    },
    Fragment: $2d4b86f016b21118$var$r,
    Profiler: $2d4b86f016b21118$var$u,
    StrictMode: $2d4b86f016b21118$var$t,
    Suspense: $2d4b86f016b21118$var$y,
    createElement: $2d4b86f016b21118$var$M,
    cloneElement: function(a, b, c) {
        if (null === a || void 0 === a) throw Error($2d4b86f016b21118$var$B(267, a));
        var e = $fve7V({}, a.props), d = a.key, g = a.ref, l = a._owner;
        if (null != b) {
            void 0 !== b.ref && (g = b.ref, l = $2d4b86f016b21118$var$J.current);
            void 0 !== b.key && (d = "" + b.key);
            if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
            for(k in b)$2d4b86f016b21118$var$K.call(b, k) && !$2d4b86f016b21118$var$L.hasOwnProperty(k) && (e[k] = void 0 === b[k] && void 0 !== f ? f[k] : b[k]);
        }
        var k = arguments.length - 2;
        if (1 === k) e.children = c;
        else if (1 < k) {
            f = Array(k);
            for(var m = 0; m < k; m++)f[m] = arguments[m + 2];
            e.children = f;
        }
        return {
            $$typeof: $2d4b86f016b21118$var$p,
            type: a.type,
            key: d,
            ref: g,
            props: e,
            _owner: l
        };
    },
    createFactory: function(a) {
        var b = $2d4b86f016b21118$var$M.bind(null, a);
        b.type = a;
        return b;
    },
    isValidElement: $2d4b86f016b21118$var$N,
    version: "16.12.0",
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
        ReactCurrentDispatcher: $2d4b86f016b21118$var$I,
        ReactCurrentBatchConfig: {
            suspense: null
        },
        ReactCurrentOwner: $2d4b86f016b21118$var$J,
        IsSomeRendererActing: {
            current: !1
        },
        assign: $fve7V
    }
}, $2d4b86f016b21118$var$Y = {
    default: $2d4b86f016b21118$var$X
}, $2d4b86f016b21118$var$Z = $2d4b86f016b21118$var$Y && $2d4b86f016b21118$var$X || $2d4b86f016b21118$var$Y;
module.exports = $2d4b86f016b21118$var$Z.default || $2d4b86f016b21118$var$Z;

});
parcelRegister("fve7V", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $b494b58c584d7e6a$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $b494b58c584d7e6a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $b494b58c584d7e6a$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $b494b58c584d7e6a$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $b494b58c584d7e6a$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $b494b58c584d7e6a$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $b494b58c584d7e6a$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($b494b58c584d7e6a$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($b494b58c584d7e6a$var$getOwnPropertySymbols) {
            symbols = $b494b58c584d7e6a$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($b494b58c584d7e6a$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("giKfk", function(module, exports) {
/** @license React v16.12.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $jTfnt = parcelRequire("jTfnt");

var $fve7V = parcelRequire("fve7V");

var $6ynyd = parcelRequire("6ynyd");
function $bde2334e73da0799$var$u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$jTfnt) throw Error($bde2334e73da0799$var$u(227));
var $bde2334e73da0799$var$ba = null, $bde2334e73da0799$var$ca = {};
function $bde2334e73da0799$var$da() {
    if ($bde2334e73da0799$var$ba) for(var a in $bde2334e73da0799$var$ca){
        var b = $bde2334e73da0799$var$ca[a], c = $bde2334e73da0799$var$ba.indexOf(a);
        if (!(-1 < c)) throw Error($bde2334e73da0799$var$u(96, a));
        if (!$bde2334e73da0799$var$ea[c]) {
            if (!b.extractEvents) throw Error($bde2334e73da0799$var$u(97, a));
            $bde2334e73da0799$var$ea[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if ($bde2334e73da0799$var$fa.hasOwnProperty(h)) throw Error($bde2334e73da0799$var$u(99, h));
                $bde2334e73da0799$var$fa[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && $bde2334e73da0799$var$ha(k[e], g, h);
                    e = !0;
                } else f.registrationName ? ($bde2334e73da0799$var$ha(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error($bde2334e73da0799$var$u(98, d, a));
            }
        }
    }
}
function $bde2334e73da0799$var$ha(a, b, c) {
    if ($bde2334e73da0799$var$ia[a]) throw Error($bde2334e73da0799$var$u(100, a));
    $bde2334e73da0799$var$ia[a] = b;
    $bde2334e73da0799$var$ja[a] = b.eventTypes[c].dependencies;
}
var $bde2334e73da0799$var$ea = [], $bde2334e73da0799$var$fa = {}, $bde2334e73da0799$var$ia = {}, $bde2334e73da0799$var$ja = {};
function $bde2334e73da0799$var$ka(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $bde2334e73da0799$var$la = !1, $bde2334e73da0799$var$ma = null, $bde2334e73da0799$var$na = !1, $bde2334e73da0799$var$oa = null, $bde2334e73da0799$var$pa = {
    onError: function(a) {
        $bde2334e73da0799$var$la = !0;
        $bde2334e73da0799$var$ma = a;
    }
};
function $bde2334e73da0799$var$qa(a, b, c, d, e, f, g, h, k) {
    $bde2334e73da0799$var$la = !1;
    $bde2334e73da0799$var$ma = null;
    $bde2334e73da0799$var$ka.apply($bde2334e73da0799$var$pa, arguments);
}
function $bde2334e73da0799$var$ra(a, b, c, d, e, f, g, h, k) {
    $bde2334e73da0799$var$qa.apply(this, arguments);
    if ($bde2334e73da0799$var$la) {
        if ($bde2334e73da0799$var$la) {
            var l = $bde2334e73da0799$var$ma;
            $bde2334e73da0799$var$la = !1;
            $bde2334e73da0799$var$ma = null;
        } else throw Error($bde2334e73da0799$var$u(198));
        $bde2334e73da0799$var$na || ($bde2334e73da0799$var$na = !0, $bde2334e73da0799$var$oa = l);
    }
}
var $bde2334e73da0799$var$sa = null, $bde2334e73da0799$var$ua = null, $bde2334e73da0799$var$va = null;
function $bde2334e73da0799$var$wa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = $bde2334e73da0799$var$va(c);
    $bde2334e73da0799$var$ra(d, b, void 0, a);
    a.currentTarget = null;
}
function $bde2334e73da0799$var$xa(a, b) {
    if (null == b) throw Error($bde2334e73da0799$var$u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function $bde2334e73da0799$var$ya(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var $bde2334e73da0799$var$za = null;
function $bde2334e73da0799$var$Aa(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)$bde2334e73da0799$var$wa(a, b[d], c[d]);
        else b && $bde2334e73da0799$var$wa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function $bde2334e73da0799$var$Ba(a) {
    null !== a && ($bde2334e73da0799$var$za = $bde2334e73da0799$var$xa($bde2334e73da0799$var$za, a));
    a = $bde2334e73da0799$var$za;
    $bde2334e73da0799$var$za = null;
    if (a) {
        $bde2334e73da0799$var$ya(a, $bde2334e73da0799$var$Aa);
        if ($bde2334e73da0799$var$za) throw Error($bde2334e73da0799$var$u(95));
        if ($bde2334e73da0799$var$na) throw a = $bde2334e73da0799$var$oa, $bde2334e73da0799$var$na = !1, $bde2334e73da0799$var$oa = null, a;
    }
}
var $bde2334e73da0799$var$Ca = {
    injectEventPluginOrder: function(a) {
        if ($bde2334e73da0799$var$ba) throw Error($bde2334e73da0799$var$u(101));
        $bde2334e73da0799$var$ba = Array.prototype.slice.call(a);
        $bde2334e73da0799$var$da();
    },
    injectEventPluginsByName: function(a) {
        var b = !1, c;
        for(c in a)if (a.hasOwnProperty(c)) {
            var d = a[c];
            if (!$bde2334e73da0799$var$ca.hasOwnProperty(c) || $bde2334e73da0799$var$ca[c] !== d) {
                if ($bde2334e73da0799$var$ca[c]) throw Error($bde2334e73da0799$var$u(102, c));
                $bde2334e73da0799$var$ca[c] = d;
                b = !0;
            }
        }
        b && $bde2334e73da0799$var$da();
    }
};
function $bde2334e73da0799$var$Da(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = $bde2334e73da0799$var$sa(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($bde2334e73da0799$var$u(231, b, typeof c));
    return c;
}
var $bde2334e73da0799$var$Ea = $jTfnt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$bde2334e73da0799$var$Ea.hasOwnProperty("ReactCurrentDispatcher") || ($bde2334e73da0799$var$Ea.ReactCurrentDispatcher = {
    current: null
});
$bde2334e73da0799$var$Ea.hasOwnProperty("ReactCurrentBatchConfig") || ($bde2334e73da0799$var$Ea.ReactCurrentBatchConfig = {
    suspense: null
});
var $bde2334e73da0799$var$Fa = /^(.*)[\\\/]/, $bde2334e73da0799$var$w = "function" === typeof Symbol && Symbol.for, $bde2334e73da0799$var$Ga = $bde2334e73da0799$var$w ? Symbol.for("react.element") : 60103, $bde2334e73da0799$var$Ha = $bde2334e73da0799$var$w ? Symbol.for("react.portal") : 60106, $bde2334e73da0799$var$Ia = $bde2334e73da0799$var$w ? Symbol.for("react.fragment") : 60107, $bde2334e73da0799$var$Ja = $bde2334e73da0799$var$w ? Symbol.for("react.strict_mode") : 60108, $bde2334e73da0799$var$Ka = $bde2334e73da0799$var$w ? Symbol.for("react.profiler") : 60114, $bde2334e73da0799$var$La = $bde2334e73da0799$var$w ? Symbol.for("react.provider") : 60109, $bde2334e73da0799$var$Ma = $bde2334e73da0799$var$w ? Symbol.for("react.context") : 60110, $bde2334e73da0799$var$Na = $bde2334e73da0799$var$w ? Symbol.for("react.concurrent_mode") : 60111, $bde2334e73da0799$var$Oa = $bde2334e73da0799$var$w ? Symbol.for("react.forward_ref") : 60112, $bde2334e73da0799$var$Pa = $bde2334e73da0799$var$w ? Symbol.for("react.suspense") : 60113, $bde2334e73da0799$var$Qa = $bde2334e73da0799$var$w ? Symbol.for("react.suspense_list") : 60120, $bde2334e73da0799$var$Ra = $bde2334e73da0799$var$w ? Symbol.for("react.memo") : 60115, $bde2334e73da0799$var$Sa = $bde2334e73da0799$var$w ? Symbol.for("react.lazy") : 60116;
$bde2334e73da0799$var$w && Symbol.for("react.fundamental");
$bde2334e73da0799$var$w && Symbol.for("react.responder");
$bde2334e73da0799$var$w && Symbol.for("react.scope");
var $bde2334e73da0799$var$Ta = "function" === typeof Symbol && Symbol.iterator;
function $bde2334e73da0799$var$Ua(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $bde2334e73da0799$var$Ta && a[$bde2334e73da0799$var$Ta] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $bde2334e73da0799$var$Va(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function $bde2334e73da0799$var$Wa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $bde2334e73da0799$var$Ia:
            return "Fragment";
        case $bde2334e73da0799$var$Ha:
            return "Portal";
        case $bde2334e73da0799$var$Ka:
            return "Profiler";
        case $bde2334e73da0799$var$Ja:
            return "StrictMode";
        case $bde2334e73da0799$var$Pa:
            return "Suspense";
        case $bde2334e73da0799$var$Qa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $bde2334e73da0799$var$Ma:
            return "Context.Consumer";
        case $bde2334e73da0799$var$La:
            return "Context.Provider";
        case $bde2334e73da0799$var$Oa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $bde2334e73da0799$var$Ra:
            return $bde2334e73da0799$var$Wa(a.type);
        case $bde2334e73da0799$var$Sa:
            if (a = 1 === a._status ? a._result : null) return $bde2334e73da0799$var$Wa(a);
    }
    return null;
}
function $bde2334e73da0799$var$Xa(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = $bde2334e73da0799$var$Wa(a.type);
                c = null;
                d && (c = $bde2334e73da0799$var$Wa(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace($bde2334e73da0799$var$Fa, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
var $bde2334e73da0799$var$Ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $bde2334e73da0799$var$Za = null, $bde2334e73da0799$var$$a = null, $bde2334e73da0799$var$ab = null;
function $bde2334e73da0799$var$bb(a) {
    if (a = $bde2334e73da0799$var$ua(a)) {
        if ("function" !== typeof $bde2334e73da0799$var$Za) throw Error($bde2334e73da0799$var$u(280));
        var b = $bde2334e73da0799$var$sa(a.stateNode);
        $bde2334e73da0799$var$Za(a.stateNode, a.type, b);
    }
}
function $bde2334e73da0799$var$cb(a) {
    $bde2334e73da0799$var$$a ? $bde2334e73da0799$var$ab ? $bde2334e73da0799$var$ab.push(a) : $bde2334e73da0799$var$ab = [
        a
    ] : $bde2334e73da0799$var$$a = a;
}
function $bde2334e73da0799$var$db() {
    if ($bde2334e73da0799$var$$a) {
        var a = $bde2334e73da0799$var$$a, b = $bde2334e73da0799$var$ab;
        $bde2334e73da0799$var$ab = $bde2334e73da0799$var$$a = null;
        $bde2334e73da0799$var$bb(a);
        if (b) for(a = 0; a < b.length; a++)$bde2334e73da0799$var$bb(b[a]);
    }
}
function $bde2334e73da0799$var$eb(a, b) {
    return a(b);
}
function $bde2334e73da0799$var$fb(a, b, c, d) {
    return a(b, c, d);
}
function $bde2334e73da0799$var$gb() {}
var $bde2334e73da0799$var$hb = $bde2334e73da0799$var$eb, $bde2334e73da0799$var$ib = !1, $bde2334e73da0799$var$jb = !1;
function $bde2334e73da0799$var$kb() {
    if (null !== $bde2334e73da0799$var$$a || null !== $bde2334e73da0799$var$ab) $bde2334e73da0799$var$gb(), $bde2334e73da0799$var$db();
}
new Map;
var $bde2334e73da0799$var$lb = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $bde2334e73da0799$var$mb = Object.prototype.hasOwnProperty, $bde2334e73da0799$var$nb = {}, $bde2334e73da0799$var$ob = {};
function $bde2334e73da0799$var$pb(a) {
    if ($bde2334e73da0799$var$mb.call($bde2334e73da0799$var$ob, a)) return !0;
    if ($bde2334e73da0799$var$mb.call($bde2334e73da0799$var$nb, a)) return !1;
    if ($bde2334e73da0799$var$lb.test(a)) return $bde2334e73da0799$var$ob[a] = !0;
    $bde2334e73da0799$var$nb[a] = !0;
    return !1;
}
function $bde2334e73da0799$var$qb(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $bde2334e73da0799$var$rb(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $bde2334e73da0799$var$qb(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $bde2334e73da0799$var$B(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var $bde2334e73da0799$var$D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $bde2334e73da0799$var$D[a] = new $bde2334e73da0799$var$B(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $bde2334e73da0799$var$D[b] = new $bde2334e73da0799$var$B(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $bde2334e73da0799$var$D[a] = new $bde2334e73da0799$var$B(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $bde2334e73da0799$var$D[a] = new $bde2334e73da0799$var$B(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $bde2334e73da0799$var$D[a] = new $bde2334e73da0799$var$B(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $bde2334e73da0799$var$D[a] = new $bde2334e73da0799$var$B(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $bde2334e73da0799$var$D[a] = new $bde2334e73da0799$var$B(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $bde2334e73da0799$var$D[a] = new $bde2334e73da0799$var$B(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $bde2334e73da0799$var$D[a] = new $bde2334e73da0799$var$B(a, 5, !1, a.toLowerCase(), null, !1);
});
var $bde2334e73da0799$var$sb = /[\-:]([a-z])/g;
function $bde2334e73da0799$var$tb(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($bde2334e73da0799$var$sb, $bde2334e73da0799$var$tb);
    $bde2334e73da0799$var$D[b] = new $bde2334e73da0799$var$B(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($bde2334e73da0799$var$sb, $bde2334e73da0799$var$tb);
    $bde2334e73da0799$var$D[b] = new $bde2334e73da0799$var$B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($bde2334e73da0799$var$sb, $bde2334e73da0799$var$tb);
    $bde2334e73da0799$var$D[b] = new $bde2334e73da0799$var$B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $bde2334e73da0799$var$D[a] = new $bde2334e73da0799$var$B(a, 1, !1, a.toLowerCase(), null, !1);
});
$bde2334e73da0799$var$D.xlinkHref = new $bde2334e73da0799$var$B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $bde2334e73da0799$var$D[a] = new $bde2334e73da0799$var$B(a, 1, !1, a.toLowerCase(), null, !0);
});
function $bde2334e73da0799$var$ub(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function $bde2334e73da0799$var$vb(a, b, c, d) {
    var e = $bde2334e73da0799$var$D.hasOwnProperty(b) ? $bde2334e73da0799$var$D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || ($bde2334e73da0799$var$rb(b, c, e, d) && (c = null), d || null === e ? $bde2334e73da0799$var$pb(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
function $bde2334e73da0799$var$wb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $bde2334e73da0799$var$xb(a) {
    var b = $bde2334e73da0799$var$wb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $bde2334e73da0799$var$yb(a) {
    a._valueTracker || (a._valueTracker = $bde2334e73da0799$var$xb(a));
}
function $bde2334e73da0799$var$zb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $bde2334e73da0799$var$wb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $bde2334e73da0799$var$Ab(a, b) {
    var c = b.checked;
    return $fve7V({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $bde2334e73da0799$var$Bb(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $bde2334e73da0799$var$ub(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $bde2334e73da0799$var$Cb(a, b) {
    b = b.checked;
    null != b && $bde2334e73da0799$var$vb(a, "checked", b, !1);
}
function $bde2334e73da0799$var$Eb(a, b) {
    $bde2334e73da0799$var$Cb(a, b);
    var c = $bde2334e73da0799$var$ub(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $bde2334e73da0799$var$Fb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $bde2334e73da0799$var$Fb(a, b.type, $bde2334e73da0799$var$ub(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $bde2334e73da0799$var$Gb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !a.defaultChecked;
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $bde2334e73da0799$var$Fb(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function $bde2334e73da0799$var$Hb(a) {
    var b = "";
    $jTfnt.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $bde2334e73da0799$var$Ib(a, b) {
    a = $fve7V({
        children: void 0
    }, b);
    if (b = $bde2334e73da0799$var$Hb(b.children)) a.children = b;
    return a;
}
function $bde2334e73da0799$var$Jb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $bde2334e73da0799$var$ub(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $bde2334e73da0799$var$Kb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($bde2334e73da0799$var$u(91));
    return $fve7V({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $bde2334e73da0799$var$Lb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.defaultValue;
        b = b.children;
        if (null != b) {
            if (null != c) throw Error($bde2334e73da0799$var$u(92));
            if (Array.isArray(b)) {
                if (!(1 >= b.length)) throw Error($bde2334e73da0799$var$u(93));
                b = b[0];
            }
            c = b;
        }
        null == c && (c = "");
    }
    a._wrapperState = {
        initialValue: $bde2334e73da0799$var$ub(c)
    };
}
function $bde2334e73da0799$var$Mb(a, b) {
    var c = $bde2334e73da0799$var$ub(b.value), d = $bde2334e73da0799$var$ub(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $bde2334e73da0799$var$Nb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var $bde2334e73da0799$var$Ob = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $bde2334e73da0799$var$Pb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $bde2334e73da0799$var$Qb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $bde2334e73da0799$var$Pb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $bde2334e73da0799$var$Rb, $bde2334e73da0799$var$Sb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== $bde2334e73da0799$var$Ob.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        $bde2334e73da0799$var$Rb = $bde2334e73da0799$var$Rb || document.createElement("div");
        $bde2334e73da0799$var$Rb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $bde2334e73da0799$var$Rb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $bde2334e73da0799$var$Tb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function $bde2334e73da0799$var$Ub(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $bde2334e73da0799$var$Vb = {
    animationend: $bde2334e73da0799$var$Ub("Animation", "AnimationEnd"),
    animationiteration: $bde2334e73da0799$var$Ub("Animation", "AnimationIteration"),
    animationstart: $bde2334e73da0799$var$Ub("Animation", "AnimationStart"),
    transitionend: $bde2334e73da0799$var$Ub("Transition", "TransitionEnd")
}, $bde2334e73da0799$var$Wb = {}, $bde2334e73da0799$var$Xb = {};
$bde2334e73da0799$var$Ya && ($bde2334e73da0799$var$Xb = document.createElement("div").style, "AnimationEvent" in window || (delete $bde2334e73da0799$var$Vb.animationend.animation, delete $bde2334e73da0799$var$Vb.animationiteration.animation, delete $bde2334e73da0799$var$Vb.animationstart.animation), "TransitionEvent" in window || delete $bde2334e73da0799$var$Vb.transitionend.transition);
function $bde2334e73da0799$var$Yb(a) {
    if ($bde2334e73da0799$var$Wb[a]) return $bde2334e73da0799$var$Wb[a];
    if (!$bde2334e73da0799$var$Vb[a]) return a;
    var b = $bde2334e73da0799$var$Vb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $bde2334e73da0799$var$Xb) return $bde2334e73da0799$var$Wb[a] = b[c];
    return a;
}
var $bde2334e73da0799$var$Zb = $bde2334e73da0799$var$Yb("animationend"), $bde2334e73da0799$var$$b = $bde2334e73da0799$var$Yb("animationiteration"), $bde2334e73da0799$var$ac = $bde2334e73da0799$var$Yb("animationstart"), $bde2334e73da0799$var$bc = $bde2334e73da0799$var$Yb("transitionend"), $bde2334e73da0799$var$cc = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
function $bde2334e73da0799$var$ec(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $bde2334e73da0799$var$fc(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $bde2334e73da0799$var$gc(a) {
    if ($bde2334e73da0799$var$ec(a) !== a) throw Error($bde2334e73da0799$var$u(188));
}
function $bde2334e73da0799$var$hc(a) {
    var b = a.alternate;
    if (!b) {
        b = $bde2334e73da0799$var$ec(a);
        if (null === b) throw Error($bde2334e73da0799$var$u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $bde2334e73da0799$var$gc(e), a;
                if (f === d) return $bde2334e73da0799$var$gc(e), b;
                f = f.sibling;
            }
            throw Error($bde2334e73da0799$var$u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($bde2334e73da0799$var$u(189));
            }
        }
        if (c.alternate !== d) throw Error($bde2334e73da0799$var$u(190));
    }
    if (3 !== c.tag) throw Error($bde2334e73da0799$var$u(188));
    return c.stateNode.current === c ? a : b;
}
function $bde2334e73da0799$var$ic(a) {
    a = $bde2334e73da0799$var$hc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
var $bde2334e73da0799$var$jc, $bde2334e73da0799$var$kc, $bde2334e73da0799$var$lc, $bde2334e73da0799$var$mc = !1, $bde2334e73da0799$var$nc = [], $bde2334e73da0799$var$oc = null, $bde2334e73da0799$var$pc = null, $bde2334e73da0799$var$qc = null, $bde2334e73da0799$var$rc = new Map, $bde2334e73da0799$var$sc = new Map, $bde2334e73da0799$var$tc = [], $bde2334e73da0799$var$uc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), $bde2334e73da0799$var$vc = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function $bde2334e73da0799$var$wc(a) {
    var b = $bde2334e73da0799$var$xc(a);
    $bde2334e73da0799$var$uc.forEach(function(c) {
        $bde2334e73da0799$var$yc(c, a, b);
    });
    $bde2334e73da0799$var$vc.forEach(function(c) {
        $bde2334e73da0799$var$yc(c, a, b);
    });
}
function $bde2334e73da0799$var$zc(a, b, c, d) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: d
    };
}
function $bde2334e73da0799$var$Ac(a, b) {
    switch(a){
        case "focus":
        case "blur":
            $bde2334e73da0799$var$oc = null;
            break;
        case "dragenter":
        case "dragleave":
            $bde2334e73da0799$var$pc = null;
            break;
        case "mouseover":
        case "mouseout":
            $bde2334e73da0799$var$qc = null;
            break;
        case "pointerover":
        case "pointerout":
            $bde2334e73da0799$var$rc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $bde2334e73da0799$var$sc.delete(b.pointerId);
    }
}
function $bde2334e73da0799$var$Bc(a, b, c, d, e) {
    if (null === a || a.nativeEvent !== e) return a = $bde2334e73da0799$var$zc(b, c, d, e), null !== b && (b = $bde2334e73da0799$var$Cc(b), null !== b && $bde2334e73da0799$var$kc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function $bde2334e73da0799$var$Dc(a, b, c, d) {
    switch(b){
        case "focus":
            return $bde2334e73da0799$var$oc = $bde2334e73da0799$var$Bc($bde2334e73da0799$var$oc, a, b, c, d), !0;
        case "dragenter":
            return $bde2334e73da0799$var$pc = $bde2334e73da0799$var$Bc($bde2334e73da0799$var$pc, a, b, c, d), !0;
        case "mouseover":
            return $bde2334e73da0799$var$qc = $bde2334e73da0799$var$Bc($bde2334e73da0799$var$qc, a, b, c, d), !0;
        case "pointerover":
            var e = d.pointerId;
            $bde2334e73da0799$var$rc.set(e, $bde2334e73da0799$var$Bc($bde2334e73da0799$var$rc.get(e) || null, a, b, c, d));
            return !0;
        case "gotpointercapture":
            return e = d.pointerId, $bde2334e73da0799$var$sc.set(e, $bde2334e73da0799$var$Bc($bde2334e73da0799$var$sc.get(e) || null, a, b, c, d)), !0;
    }
    return !1;
}
function $bde2334e73da0799$var$Ec(a) {
    var b = $bde2334e73da0799$var$Fc(a.target);
    if (null !== b) {
        var c = $bde2334e73da0799$var$ec(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $bde2334e73da0799$var$fc(c), null !== b) {
                    a.blockedOn = b;
                    $6ynyd.unstable_runWithPriority(a.priority, function() {
                        $bde2334e73da0799$var$lc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $bde2334e73da0799$var$Gc(a) {
    if (null !== a.blockedOn) return !1;
    var b = $bde2334e73da0799$var$Hc(a.topLevelType, a.eventSystemFlags, a.nativeEvent);
    if (null !== b) {
        var c = $bde2334e73da0799$var$Cc(b);
        null !== c && $bde2334e73da0799$var$kc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function $bde2334e73da0799$var$Ic(a, b, c) {
    $bde2334e73da0799$var$Gc(a) && c.delete(b);
}
function $bde2334e73da0799$var$Jc() {
    for($bde2334e73da0799$var$mc = !1; 0 < $bde2334e73da0799$var$nc.length;){
        var a = $bde2334e73da0799$var$nc[0];
        if (null !== a.blockedOn) {
            a = $bde2334e73da0799$var$Cc(a.blockedOn);
            null !== a && $bde2334e73da0799$var$jc(a);
            break;
        }
        var b = $bde2334e73da0799$var$Hc(a.topLevelType, a.eventSystemFlags, a.nativeEvent);
        null !== b ? a.blockedOn = b : $bde2334e73da0799$var$nc.shift();
    }
    null !== $bde2334e73da0799$var$oc && $bde2334e73da0799$var$Gc($bde2334e73da0799$var$oc) && ($bde2334e73da0799$var$oc = null);
    null !== $bde2334e73da0799$var$pc && $bde2334e73da0799$var$Gc($bde2334e73da0799$var$pc) && ($bde2334e73da0799$var$pc = null);
    null !== $bde2334e73da0799$var$qc && $bde2334e73da0799$var$Gc($bde2334e73da0799$var$qc) && ($bde2334e73da0799$var$qc = null);
    $bde2334e73da0799$var$rc.forEach($bde2334e73da0799$var$Ic);
    $bde2334e73da0799$var$sc.forEach($bde2334e73da0799$var$Ic);
}
function $bde2334e73da0799$var$Kc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $bde2334e73da0799$var$mc || ($bde2334e73da0799$var$mc = !0, $6ynyd.unstable_scheduleCallback($6ynyd.unstable_NormalPriority, $bde2334e73da0799$var$Jc)));
}
function $bde2334e73da0799$var$Lc(a) {
    function b(b) {
        return $bde2334e73da0799$var$Kc(b, a);
    }
    if (0 < $bde2334e73da0799$var$nc.length) {
        $bde2334e73da0799$var$Kc($bde2334e73da0799$var$nc[0], a);
        for(var c = 1; c < $bde2334e73da0799$var$nc.length; c++){
            var d = $bde2334e73da0799$var$nc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $bde2334e73da0799$var$oc && $bde2334e73da0799$var$Kc($bde2334e73da0799$var$oc, a);
    null !== $bde2334e73da0799$var$pc && $bde2334e73da0799$var$Kc($bde2334e73da0799$var$pc, a);
    null !== $bde2334e73da0799$var$qc && $bde2334e73da0799$var$Kc($bde2334e73da0799$var$qc, a);
    $bde2334e73da0799$var$rc.forEach(b);
    $bde2334e73da0799$var$sc.forEach(b);
    for(c = 0; c < $bde2334e73da0799$var$tc.length; c++)d = $bde2334e73da0799$var$tc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $bde2334e73da0799$var$tc.length && (c = $bde2334e73da0799$var$tc[0], null === c.blockedOn);)$bde2334e73da0799$var$Ec(c), null === c.blockedOn && $bde2334e73da0799$var$tc.shift();
}
function $bde2334e73da0799$var$Mc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function $bde2334e73da0799$var$Nc(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $bde2334e73da0799$var$Oc(a, b, c) {
    if (b = $bde2334e73da0799$var$Da(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = $bde2334e73da0799$var$xa(c._dispatchListeners, b), c._dispatchInstances = $bde2334e73da0799$var$xa(c._dispatchInstances, a);
}
function $bde2334e73da0799$var$Pc(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = $bde2334e73da0799$var$Nc(b);
        for(b = c.length; 0 < b--;)$bde2334e73da0799$var$Oc(c[b], "captured", a);
        for(b = 0; b < c.length; b++)$bde2334e73da0799$var$Oc(c[b], "bubbled", a);
    }
}
function $bde2334e73da0799$var$Qc(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = $bde2334e73da0799$var$Da(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = $bde2334e73da0799$var$xa(c._dispatchListeners, b), c._dispatchInstances = $bde2334e73da0799$var$xa(c._dispatchInstances, a));
}
function $bde2334e73da0799$var$Rc(a) {
    a && a.dispatchConfig.registrationName && $bde2334e73da0799$var$Qc(a._targetInst, null, a);
}
function $bde2334e73da0799$var$Sc(a) {
    $bde2334e73da0799$var$ya(a, $bde2334e73da0799$var$Pc);
}
function $bde2334e73da0799$var$Tc() {
    return !0;
}
function $bde2334e73da0799$var$Uc() {
    return !1;
}
function $bde2334e73da0799$var$E(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? $bde2334e73da0799$var$Tc : $bde2334e73da0799$var$Uc;
    this.isPropagationStopped = $bde2334e73da0799$var$Uc;
    return this;
}
$fve7V($bde2334e73da0799$var$E.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $bde2334e73da0799$var$Tc);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $bde2334e73da0799$var$Tc);
    },
    persist: function() {
        this.isPersistent = $bde2334e73da0799$var$Tc;
    },
    isPersistent: $bde2334e73da0799$var$Uc,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = $bde2334e73da0799$var$Uc;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
$bde2334e73da0799$var$E.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
$bde2334e73da0799$var$E.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $fve7V(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $fve7V({}, d.Interface, a);
    c.extend = d.extend;
    $bde2334e73da0799$var$Vc(c);
    return c;
};
$bde2334e73da0799$var$Vc($bde2334e73da0799$var$E);
function $bde2334e73da0799$var$Wc(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function $bde2334e73da0799$var$Xc(a) {
    if (!(a instanceof this)) throw Error($bde2334e73da0799$var$u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function $bde2334e73da0799$var$Vc(a) {
    a.eventPool = [];
    a.getPooled = $bde2334e73da0799$var$Wc;
    a.release = $bde2334e73da0799$var$Xc;
}
var $bde2334e73da0799$var$Yc = $bde2334e73da0799$var$E.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), $bde2334e73da0799$var$Zc = $bde2334e73da0799$var$E.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $bde2334e73da0799$var$$c = $bde2334e73da0799$var$E.extend({
    view: null,
    detail: null
}), $bde2334e73da0799$var$ad = $bde2334e73da0799$var$$c.extend({
    relatedTarget: null
});
function $bde2334e73da0799$var$bd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var $bde2334e73da0799$var$cd = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $bde2334e73da0799$var$dd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $bde2334e73da0799$var$ed = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $bde2334e73da0799$var$gd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $bde2334e73da0799$var$ed[a]) ? !!b[a] : !1;
}
function $bde2334e73da0799$var$hd() {
    return $bde2334e73da0799$var$gd;
}
var $bde2334e73da0799$var$id = $bde2334e73da0799$var$$c.extend({
    key: function(a) {
        if (a.key) {
            var b = $bde2334e73da0799$var$cd[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $bde2334e73da0799$var$bd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $bde2334e73da0799$var$dd[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: $bde2334e73da0799$var$hd,
    charCode: function(a) {
        return "keypress" === a.type ? $bde2334e73da0799$var$bd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $bde2334e73da0799$var$bd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $bde2334e73da0799$var$jd = 0, $bde2334e73da0799$var$kd = 0, $bde2334e73da0799$var$ld = !1, $bde2334e73da0799$var$md = !1, $bde2334e73da0799$var$nd = $bde2334e73da0799$var$$c.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: $bde2334e73da0799$var$hd,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = $bde2334e73da0799$var$jd;
        $bde2334e73da0799$var$jd = a.screenX;
        return $bde2334e73da0799$var$ld ? "mousemove" === a.type ? a.screenX - b : 0 : ($bde2334e73da0799$var$ld = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = $bde2334e73da0799$var$kd;
        $bde2334e73da0799$var$kd = a.screenY;
        return $bde2334e73da0799$var$md ? "mousemove" === a.type ? a.screenY - b : 0 : ($bde2334e73da0799$var$md = !0, 0);
    }
}), $bde2334e73da0799$var$od = $bde2334e73da0799$var$nd.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), $bde2334e73da0799$var$pd = $bde2334e73da0799$var$nd.extend({
    dataTransfer: null
}), $bde2334e73da0799$var$qd = $bde2334e73da0799$var$$c.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: $bde2334e73da0799$var$hd
}), $bde2334e73da0799$var$rd = $bde2334e73da0799$var$E.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), $bde2334e73da0799$var$sd = $bde2334e73da0799$var$nd.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), $bde2334e73da0799$var$td = [
    [
        "blur",
        "blur",
        0
    ],
    [
        "cancel",
        "cancel",
        0
    ],
    [
        "click",
        "click",
        0
    ],
    [
        "close",
        "close",
        0
    ],
    [
        "contextmenu",
        "contextMenu",
        0
    ],
    [
        "copy",
        "copy",
        0
    ],
    [
        "cut",
        "cut",
        0
    ],
    [
        "auxclick",
        "auxClick",
        0
    ],
    [
        "dblclick",
        "doubleClick",
        0
    ],
    [
        "dragend",
        "dragEnd",
        0
    ],
    [
        "dragstart",
        "dragStart",
        0
    ],
    [
        "drop",
        "drop",
        0
    ],
    [
        "focus",
        "focus",
        0
    ],
    [
        "input",
        "input",
        0
    ],
    [
        "invalid",
        "invalid",
        0
    ],
    [
        "keydown",
        "keyDown",
        0
    ],
    [
        "keypress",
        "keyPress",
        0
    ],
    [
        "keyup",
        "keyUp",
        0
    ],
    [
        "mousedown",
        "mouseDown",
        0
    ],
    [
        "mouseup",
        "mouseUp",
        0
    ],
    [
        "paste",
        "paste",
        0
    ],
    [
        "pause",
        "pause",
        0
    ],
    [
        "play",
        "play",
        0
    ],
    [
        "pointercancel",
        "pointerCancel",
        0
    ],
    [
        "pointerdown",
        "pointerDown",
        0
    ],
    [
        "pointerup",
        "pointerUp",
        0
    ],
    [
        "ratechange",
        "rateChange",
        0
    ],
    [
        "reset",
        "reset",
        0
    ],
    [
        "seeked",
        "seeked",
        0
    ],
    [
        "submit",
        "submit",
        0
    ],
    [
        "touchcancel",
        "touchCancel",
        0
    ],
    [
        "touchend",
        "touchEnd",
        0
    ],
    [
        "touchstart",
        "touchStart",
        0
    ],
    [
        "volumechange",
        "volumeChange",
        0
    ],
    [
        "drag",
        "drag",
        1
    ],
    [
        "dragenter",
        "dragEnter",
        1
    ],
    [
        "dragexit",
        "dragExit",
        1
    ],
    [
        "dragleave",
        "dragLeave",
        1
    ],
    [
        "dragover",
        "dragOver",
        1
    ],
    [
        "mousemove",
        "mouseMove",
        1
    ],
    [
        "mouseout",
        "mouseOut",
        1
    ],
    [
        "mouseover",
        "mouseOver",
        1
    ],
    [
        "pointermove",
        "pointerMove",
        1
    ],
    [
        "pointerout",
        "pointerOut",
        1
    ],
    [
        "pointerover",
        "pointerOver",
        1
    ],
    [
        "scroll",
        "scroll",
        1
    ],
    [
        "toggle",
        "toggle",
        1
    ],
    [
        "touchmove",
        "touchMove",
        1
    ],
    [
        "wheel",
        "wheel",
        1
    ],
    [
        "abort",
        "abort",
        2
    ],
    [
        $bde2334e73da0799$var$Zb,
        "animationEnd",
        2
    ],
    [
        $bde2334e73da0799$var$$b,
        "animationIteration",
        2
    ],
    [
        $bde2334e73da0799$var$ac,
        "animationStart",
        2
    ],
    [
        "canplay",
        "canPlay",
        2
    ],
    [
        "canplaythrough",
        "canPlayThrough",
        2
    ],
    [
        "durationchange",
        "durationChange",
        2
    ],
    [
        "emptied",
        "emptied",
        2
    ],
    [
        "encrypted",
        "encrypted",
        2
    ],
    [
        "ended",
        "ended",
        2
    ],
    [
        "error",
        "error",
        2
    ],
    [
        "gotpointercapture",
        "gotPointerCapture",
        2
    ],
    [
        "load",
        "load",
        2
    ],
    [
        "loadeddata",
        "loadedData",
        2
    ],
    [
        "loadedmetadata",
        "loadedMetadata",
        2
    ],
    [
        "loadstart",
        "loadStart",
        2
    ],
    [
        "lostpointercapture",
        "lostPointerCapture",
        2
    ],
    [
        "playing",
        "playing",
        2
    ],
    [
        "progress",
        "progress",
        2
    ],
    [
        "seeking",
        "seeking",
        2
    ],
    [
        "stalled",
        "stalled",
        2
    ],
    [
        "suspend",
        "suspend",
        2
    ],
    [
        "timeupdate",
        "timeUpdate",
        2
    ],
    [
        $bde2334e73da0799$var$bc,
        "transitionEnd",
        2
    ],
    [
        "waiting",
        "waiting",
        2
    ]
], $bde2334e73da0799$var$ud = {}, $bde2334e73da0799$var$vd = {}, $bde2334e73da0799$var$wd = 0;
for(; $bde2334e73da0799$var$wd < $bde2334e73da0799$var$td.length; $bde2334e73da0799$var$wd++){
    var $bde2334e73da0799$var$yd = $bde2334e73da0799$var$td[$bde2334e73da0799$var$wd], $bde2334e73da0799$var$zd = $bde2334e73da0799$var$yd[0], $bde2334e73da0799$var$Ad = $bde2334e73da0799$var$yd[1], $bde2334e73da0799$var$Bd = $bde2334e73da0799$var$yd[2], $bde2334e73da0799$var$Cd = "on" + ($bde2334e73da0799$var$Ad[0].toUpperCase() + $bde2334e73da0799$var$Ad.slice(1)), $bde2334e73da0799$var$Dd = {
        phasedRegistrationNames: {
            bubbled: $bde2334e73da0799$var$Cd,
            captured: $bde2334e73da0799$var$Cd + "Capture"
        },
        dependencies: [
            $bde2334e73da0799$var$zd
        ],
        eventPriority: $bde2334e73da0799$var$Bd
    };
    $bde2334e73da0799$var$ud[$bde2334e73da0799$var$Ad] = $bde2334e73da0799$var$Dd;
    $bde2334e73da0799$var$vd[$bde2334e73da0799$var$zd] = $bde2334e73da0799$var$Dd;
}
var $bde2334e73da0799$var$Ed = {
    eventTypes: $bde2334e73da0799$var$ud,
    getEventPriority: function(a) {
        a = $bde2334e73da0799$var$vd[a];
        return void 0 !== a ? a.eventPriority : 2;
    },
    extractEvents: function(a, b, c, d) {
        var e = $bde2334e73da0799$var$vd[a];
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === $bde2334e73da0799$var$bd(c)) return null;
            case "keydown":
            case "keyup":
                a = $bde2334e73da0799$var$id;
                break;
            case "blur":
            case "focus":
                a = $bde2334e73da0799$var$ad;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = $bde2334e73da0799$var$nd;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = $bde2334e73da0799$var$pd;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = $bde2334e73da0799$var$qd;
                break;
            case $bde2334e73da0799$var$Zb:
            case $bde2334e73da0799$var$$b:
            case $bde2334e73da0799$var$ac:
                a = $bde2334e73da0799$var$Yc;
                break;
            case $bde2334e73da0799$var$bc:
                a = $bde2334e73da0799$var$rd;
                break;
            case "scroll":
                a = $bde2334e73da0799$var$$c;
                break;
            case "wheel":
                a = $bde2334e73da0799$var$sd;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = $bde2334e73da0799$var$Zc;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = $bde2334e73da0799$var$od;
                break;
            default:
                a = $bde2334e73da0799$var$E;
        }
        b = a.getPooled(e, b, c, d);
        $bde2334e73da0799$var$Sc(b);
        return b;
    }
}, $bde2334e73da0799$var$Fd = $6ynyd.unstable_UserBlockingPriority, $bde2334e73da0799$var$Gd = $6ynyd.unstable_runWithPriority, $bde2334e73da0799$var$Hd = $bde2334e73da0799$var$Ed.getEventPriority, $bde2334e73da0799$var$Id = 10, $bde2334e73da0799$var$Jd = [];
function $bde2334e73da0799$var$Kd(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = $bde2334e73da0799$var$Fc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = $bde2334e73da0799$var$Mc(a.nativeEvent);
        d = a.topLevelType;
        for(var f = a.nativeEvent, g = a.eventSystemFlags, h = null, k = 0; k < $bde2334e73da0799$var$ea.length; k++){
            var l = $bde2334e73da0799$var$ea[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = $bde2334e73da0799$var$xa(h, l));
        }
        $bde2334e73da0799$var$Ba(h);
    }
}
var $bde2334e73da0799$var$Ld = !0;
function $bde2334e73da0799$var$F(a, b) {
    $bde2334e73da0799$var$Md(b, a, !1);
}
function $bde2334e73da0799$var$Md(a, b, c) {
    switch($bde2334e73da0799$var$Hd(b)){
        case 0:
            var d = $bde2334e73da0799$var$Nd.bind(null, b, 1);
            break;
        case 1:
            d = $bde2334e73da0799$var$Od.bind(null, b, 1);
            break;
        default:
            d = $bde2334e73da0799$var$Pd.bind(null, b, 1);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function $bde2334e73da0799$var$Nd(a, b, c) {
    $bde2334e73da0799$var$ib || $bde2334e73da0799$var$gb();
    var d = $bde2334e73da0799$var$Pd, e = $bde2334e73da0799$var$ib;
    $bde2334e73da0799$var$ib = !0;
    try {
        $bde2334e73da0799$var$fb(d, a, b, c);
    } finally{
        ($bde2334e73da0799$var$ib = e) || $bde2334e73da0799$var$kb();
    }
}
function $bde2334e73da0799$var$Od(a, b, c) {
    $bde2334e73da0799$var$Gd($bde2334e73da0799$var$Fd, $bde2334e73da0799$var$Pd.bind(null, a, b, c));
}
function $bde2334e73da0799$var$Qd(a, b, c, d) {
    if ($bde2334e73da0799$var$Jd.length) {
        var e = $bde2334e73da0799$var$Jd.pop();
        e.topLevelType = a;
        e.eventSystemFlags = b;
        e.nativeEvent = c;
        e.targetInst = d;
        a = e;
    } else a = {
        topLevelType: a,
        eventSystemFlags: b,
        nativeEvent: c,
        targetInst: d,
        ancestors: []
    };
    try {
        if (b = $bde2334e73da0799$var$Kd, c = a, $bde2334e73da0799$var$jb) b(c, void 0);
        else {
            $bde2334e73da0799$var$jb = !0;
            try {
                $bde2334e73da0799$var$hb(b, c, void 0);
            } finally{
                $bde2334e73da0799$var$jb = !1, $bde2334e73da0799$var$kb();
            }
        }
    } finally{
        a.topLevelType = null, a.nativeEvent = null, a.targetInst = null, a.ancestors.length = 0, $bde2334e73da0799$var$Jd.length < $bde2334e73da0799$var$Id && $bde2334e73da0799$var$Jd.push(a);
    }
}
function $bde2334e73da0799$var$Pd(a, b, c) {
    if ($bde2334e73da0799$var$Ld) {
        if (0 < $bde2334e73da0799$var$nc.length && -1 < $bde2334e73da0799$var$uc.indexOf(a)) a = $bde2334e73da0799$var$zc(null, a, b, c), $bde2334e73da0799$var$nc.push(a);
        else {
            var d = $bde2334e73da0799$var$Hc(a, b, c);
            null === d ? $bde2334e73da0799$var$Ac(a, c) : -1 < $bde2334e73da0799$var$uc.indexOf(a) ? (a = $bde2334e73da0799$var$zc(d, a, b, c), $bde2334e73da0799$var$nc.push(a)) : $bde2334e73da0799$var$Dc(d, a, b, c) || ($bde2334e73da0799$var$Ac(a, c), $bde2334e73da0799$var$Qd(a, b, c, null));
        }
    }
}
function $bde2334e73da0799$var$Hc(a, b, c) {
    var d = $bde2334e73da0799$var$Mc(c);
    d = $bde2334e73da0799$var$Fc(d);
    if (null !== d) {
        var e = $bde2334e73da0799$var$ec(d);
        if (null === e) d = null;
        else {
            var f = e.tag;
            if (13 === f) {
                d = $bde2334e73da0799$var$fc(e);
                if (null !== d) return d;
                d = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                d = null;
            } else e !== d && (d = null);
        }
    }
    $bde2334e73da0799$var$Qd(a, b, c, d);
    return null;
}
function $bde2334e73da0799$var$Rd(a) {
    if (!$bde2334e73da0799$var$Ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var $bde2334e73da0799$var$Sd = new ("function" === typeof WeakMap ? WeakMap : Map);
function $bde2334e73da0799$var$xc(a) {
    var b = $bde2334e73da0799$var$Sd.get(a);
    void 0 === b && (b = new Set, $bde2334e73da0799$var$Sd.set(a, b));
    return b;
}
function $bde2334e73da0799$var$yc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                $bde2334e73da0799$var$Md(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                $bde2334e73da0799$var$Md(b, "focus", !0);
                $bde2334e73da0799$var$Md(b, "blur", !0);
                c.add("blur");
                c.add("focus");
                break;
            case "cancel":
            case "close":
                $bde2334e73da0799$var$Rd(a) && $bde2334e73da0799$var$Md(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === $bde2334e73da0799$var$cc.indexOf(a) && $bde2334e73da0799$var$F(a, b);
        }
        c.add(a);
    }
}
var $bde2334e73da0799$var$Td = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $bde2334e73da0799$var$Ud = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($bde2334e73da0799$var$Td).forEach(function(a) {
    $bde2334e73da0799$var$Ud.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $bde2334e73da0799$var$Td[b] = $bde2334e73da0799$var$Td[a];
    });
});
function $bde2334e73da0799$var$Vd(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $bde2334e73da0799$var$Td.hasOwnProperty(a) && $bde2334e73da0799$var$Td[a] ? ("" + b).trim() : b + "px";
}
function $bde2334e73da0799$var$Wd(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $bde2334e73da0799$var$Vd(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $bde2334e73da0799$var$Xd = $fve7V({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $bde2334e73da0799$var$Yd(a, b) {
    if (b) {
        if ($bde2334e73da0799$var$Xd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($bde2334e73da0799$var$u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($bde2334e73da0799$var$u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error($bde2334e73da0799$var$u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($bde2334e73da0799$var$u(62, ""));
    }
}
function $bde2334e73da0799$var$Zd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function $bde2334e73da0799$var$$d(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = $bde2334e73da0799$var$xc(a);
    b = $bde2334e73da0799$var$ja[b];
    for(var d = 0; d < b.length; d++)$bde2334e73da0799$var$yc(b[d], a, c);
}
function $bde2334e73da0799$var$ae() {}
function $bde2334e73da0799$var$be(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $bde2334e73da0799$var$ce(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $bde2334e73da0799$var$de(a, b) {
    var c = $bde2334e73da0799$var$ce(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $bde2334e73da0799$var$ce(c);
    }
}
function $bde2334e73da0799$var$ee(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $bde2334e73da0799$var$ee(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $bde2334e73da0799$var$fe() {
    for(var a = window, b = $bde2334e73da0799$var$be(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $bde2334e73da0799$var$be(a.document);
    }
    return b;
}
function $bde2334e73da0799$var$ge(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var $bde2334e73da0799$var$he = "$", $bde2334e73da0799$var$ie = "/$", $bde2334e73da0799$var$je = "$?", $bde2334e73da0799$var$ke = "$!", $bde2334e73da0799$var$le = null, $bde2334e73da0799$var$me = null;
function $bde2334e73da0799$var$ne(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function $bde2334e73da0799$var$oe(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $bde2334e73da0799$var$pe = "function" === typeof setTimeout ? setTimeout : void 0, $bde2334e73da0799$var$qe = "function" === typeof clearTimeout ? clearTimeout : void 0;
function $bde2334e73da0799$var$re(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function $bde2334e73da0799$var$se(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === $bde2334e73da0799$var$he || c === $bde2334e73da0799$var$ke || c === $bde2334e73da0799$var$je) {
                if (0 === b) return a;
                b--;
            } else c === $bde2334e73da0799$var$ie && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $bde2334e73da0799$var$te = Math.random().toString(36).slice(2), $bde2334e73da0799$var$ue = "__reactInternalInstance$" + $bde2334e73da0799$var$te, $bde2334e73da0799$var$ve = "__reactEventHandlers$" + $bde2334e73da0799$var$te, $bde2334e73da0799$var$we = "__reactContainere$" + $bde2334e73da0799$var$te;
function $bde2334e73da0799$var$Fc(a) {
    var b = a[$bde2334e73da0799$var$ue];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$bde2334e73da0799$var$we] || c[$bde2334e73da0799$var$ue]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $bde2334e73da0799$var$se(a); null !== a;){
                if (c = a[$bde2334e73da0799$var$ue]) return c;
                a = $bde2334e73da0799$var$se(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $bde2334e73da0799$var$Cc(a) {
    a = a[$bde2334e73da0799$var$ue] || a[$bde2334e73da0799$var$we];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $bde2334e73da0799$var$xe(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($bde2334e73da0799$var$u(33));
}
function $bde2334e73da0799$var$ye(a) {
    return a[$bde2334e73da0799$var$ve] || null;
}
var $bde2334e73da0799$var$ze = null, $bde2334e73da0799$var$Ae = null, $bde2334e73da0799$var$Be = null;
function $bde2334e73da0799$var$Ce() {
    if ($bde2334e73da0799$var$Be) return $bde2334e73da0799$var$Be;
    var a, b = $bde2334e73da0799$var$Ae, c = b.length, d, e = "value" in $bde2334e73da0799$var$ze ? $bde2334e73da0799$var$ze.value : $bde2334e73da0799$var$ze.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $bde2334e73da0799$var$Be = e.slice(a, 1 < d ? 1 - d : void 0);
}
var $bde2334e73da0799$var$De = $bde2334e73da0799$var$E.extend({
    data: null
}), $bde2334e73da0799$var$Ee = $bde2334e73da0799$var$E.extend({
    data: null
}), $bde2334e73da0799$var$Fe = [
    9,
    13,
    27,
    32
], $bde2334e73da0799$var$Ge = $bde2334e73da0799$var$Ya && "CompositionEvent" in window, $bde2334e73da0799$var$He = null;
$bde2334e73da0799$var$Ya && "documentMode" in document && ($bde2334e73da0799$var$He = document.documentMode);
var $bde2334e73da0799$var$Ie = $bde2334e73da0799$var$Ya && "TextEvent" in window && !$bde2334e73da0799$var$He, $bde2334e73da0799$var$Je = $bde2334e73da0799$var$Ya && (!$bde2334e73da0799$var$Ge || $bde2334e73da0799$var$He && 8 < $bde2334e73da0799$var$He && 11 >= $bde2334e73da0799$var$He), $bde2334e73da0799$var$Ke = String.fromCharCode(32), $bde2334e73da0799$var$Le = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, $bde2334e73da0799$var$Me = !1;
function $bde2334e73da0799$var$Ne(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $bde2334e73da0799$var$Fe.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function $bde2334e73da0799$var$Oe(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $bde2334e73da0799$var$Pe = !1;
function $bde2334e73da0799$var$Qe(a, b) {
    switch(a){
        case "compositionend":
            return $bde2334e73da0799$var$Oe(b);
        case "keypress":
            if (32 !== b.which) return null;
            $bde2334e73da0799$var$Me = !0;
            return $bde2334e73da0799$var$Ke;
        case "textInput":
            return a = b.data, a === $bde2334e73da0799$var$Ke && $bde2334e73da0799$var$Me ? null : a;
        default:
            return null;
    }
}
function $bde2334e73da0799$var$Re(a, b) {
    if ($bde2334e73da0799$var$Pe) return "compositionend" === a || !$bde2334e73da0799$var$Ge && $bde2334e73da0799$var$Ne(a, b) ? (a = $bde2334e73da0799$var$Ce(), $bde2334e73da0799$var$Be = $bde2334e73da0799$var$Ae = $bde2334e73da0799$var$ze = null, $bde2334e73da0799$var$Pe = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $bde2334e73da0799$var$Je && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $bde2334e73da0799$var$Se = {
    eventTypes: $bde2334e73da0799$var$Le,
    extractEvents: function(a, b, c, d) {
        var e;
        if ($bde2334e73da0799$var$Ge) b: {
            switch(a){
                case "compositionstart":
                    var f = $bde2334e73da0799$var$Le.compositionStart;
                    break b;
                case "compositionend":
                    f = $bde2334e73da0799$var$Le.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = $bde2334e73da0799$var$Le.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else $bde2334e73da0799$var$Pe ? $bde2334e73da0799$var$Ne(a, c) && (f = $bde2334e73da0799$var$Le.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = $bde2334e73da0799$var$Le.compositionStart);
        f ? ($bde2334e73da0799$var$Je && "ko" !== c.locale && ($bde2334e73da0799$var$Pe || f !== $bde2334e73da0799$var$Le.compositionStart ? f === $bde2334e73da0799$var$Le.compositionEnd && $bde2334e73da0799$var$Pe && (e = $bde2334e73da0799$var$Ce()) : ($bde2334e73da0799$var$ze = d, $bde2334e73da0799$var$Ae = "value" in $bde2334e73da0799$var$ze ? $bde2334e73da0799$var$ze.value : $bde2334e73da0799$var$ze.textContent, $bde2334e73da0799$var$Pe = !0)), f = $bde2334e73da0799$var$De.getPooled(f, b, c, d), e ? f.data = e : (e = $bde2334e73da0799$var$Oe(c), null !== e && (f.data = e)), $bde2334e73da0799$var$Sc(f), e = f) : e = null;
        (a = $bde2334e73da0799$var$Ie ? $bde2334e73da0799$var$Qe(a, c) : $bde2334e73da0799$var$Re(a, c)) ? (b = $bde2334e73da0799$var$Ee.getPooled($bde2334e73da0799$var$Le.beforeInput, b, c, d), b.data = a, $bde2334e73da0799$var$Sc(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, $bde2334e73da0799$var$Te = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $bde2334e73da0799$var$Ue(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$bde2334e73da0799$var$Te[a.type] : "textarea" === b ? !0 : !1;
}
var $bde2334e73da0799$var$Ve = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function $bde2334e73da0799$var$We(a, b, c) {
    a = $bde2334e73da0799$var$E.getPooled($bde2334e73da0799$var$Ve.change, a, b, c);
    a.type = "change";
    $bde2334e73da0799$var$cb(c);
    $bde2334e73da0799$var$Sc(a);
    return a;
}
var $bde2334e73da0799$var$Xe = null, $bde2334e73da0799$var$Ye = null;
function $bde2334e73da0799$var$Ze(a) {
    $bde2334e73da0799$var$Ba(a);
}
function $bde2334e73da0799$var$$e(a) {
    var b = $bde2334e73da0799$var$xe(a);
    if ($bde2334e73da0799$var$zb(b)) return a;
}
function $bde2334e73da0799$var$af(a, b) {
    if ("change" === a) return b;
}
var $bde2334e73da0799$var$bf = !1;
$bde2334e73da0799$var$Ya && ($bde2334e73da0799$var$bf = $bde2334e73da0799$var$Rd("input") && (!document.documentMode || 9 < document.documentMode));
function $bde2334e73da0799$var$cf() {
    $bde2334e73da0799$var$Xe && ($bde2334e73da0799$var$Xe.detachEvent("onpropertychange", $bde2334e73da0799$var$df), $bde2334e73da0799$var$Ye = $bde2334e73da0799$var$Xe = null);
}
function $bde2334e73da0799$var$df(a) {
    if ("value" === a.propertyName && $bde2334e73da0799$var$$e($bde2334e73da0799$var$Ye)) {
        if (a = $bde2334e73da0799$var$We($bde2334e73da0799$var$Ye, a, $bde2334e73da0799$var$Mc(a)), $bde2334e73da0799$var$ib) $bde2334e73da0799$var$Ba(a);
        else {
            $bde2334e73da0799$var$ib = !0;
            try {
                $bde2334e73da0799$var$eb($bde2334e73da0799$var$Ze, a);
            } finally{
                $bde2334e73da0799$var$ib = !1, $bde2334e73da0799$var$kb();
            }
        }
    }
}
function $bde2334e73da0799$var$ef(a, b, c) {
    "focus" === a ? ($bde2334e73da0799$var$cf(), $bde2334e73da0799$var$Xe = b, $bde2334e73da0799$var$Ye = c, $bde2334e73da0799$var$Xe.attachEvent("onpropertychange", $bde2334e73da0799$var$df)) : "blur" === a && $bde2334e73da0799$var$cf();
}
function $bde2334e73da0799$var$ff(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $bde2334e73da0799$var$$e($bde2334e73da0799$var$Ye);
}
function $bde2334e73da0799$var$gf(a, b) {
    if ("click" === a) return $bde2334e73da0799$var$$e(b);
}
function $bde2334e73da0799$var$hf(a, b) {
    if ("input" === a || "change" === a) return $bde2334e73da0799$var$$e(b);
}
var $bde2334e73da0799$var$jf = {
    eventTypes: $bde2334e73da0799$var$Ve,
    _isInputEventSupported: $bde2334e73da0799$var$bf,
    extractEvents: function(a, b, c, d) {
        var e = b ? $bde2334e73da0799$var$xe(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = $bde2334e73da0799$var$af;
        else if ($bde2334e73da0799$var$Ue(e)) {
            if ($bde2334e73da0799$var$bf) g = $bde2334e73da0799$var$hf;
            else {
                g = $bde2334e73da0799$var$ff;
                var h = $bde2334e73da0799$var$ef;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = $bde2334e73da0799$var$gf);
        if (g && (g = g(a, b))) return $bde2334e73da0799$var$We(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && $bde2334e73da0799$var$Fb(e, "number", e.value);
    }
}, $bde2334e73da0799$var$kf = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, $bde2334e73da0799$var$lf, $bde2334e73da0799$var$mf = {
    eventTypes: $bde2334e73da0799$var$kf,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        e = d.window === d ? d : (e = d.ownerDocument) ? e.defaultView || e.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? $bde2334e73da0799$var$Fc(b) : null, null !== b && (f = $bde2334e73da0799$var$ec(b), b !== f || 5 !== b.tag && 6 !== b.tag)) b = null;
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var h = $bde2334e73da0799$var$nd;
            var k = $bde2334e73da0799$var$kf.mouseLeave;
            var l = $bde2334e73da0799$var$kf.mouseEnter;
            var m = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) h = $bde2334e73da0799$var$od, k = $bde2334e73da0799$var$kf.pointerLeave, l = $bde2334e73da0799$var$kf.pointerEnter, m = "pointer";
        a = null == g ? e : $bde2334e73da0799$var$xe(g);
        e = null == b ? e : $bde2334e73da0799$var$xe(b);
        k = h.getPooled(k, g, c, d);
        k.type = m + "leave";
        k.target = a;
        k.relatedTarget = e;
        d = h.getPooled(l, b, c, d);
        d.type = m + "enter";
        d.target = e;
        d.relatedTarget = a;
        h = g;
        m = b;
        if (h && m) a: {
            l = h;
            a = m;
            g = 0;
            for(b = l; b; b = $bde2334e73da0799$var$Nc(b))g++;
            b = 0;
            for(e = a; e; e = $bde2334e73da0799$var$Nc(e))b++;
            for(; 0 < g - b;)l = $bde2334e73da0799$var$Nc(l), g--;
            for(; 0 < b - g;)a = $bde2334e73da0799$var$Nc(a), b--;
            for(; g--;){
                if (l === a || l === a.alternate) break a;
                l = $bde2334e73da0799$var$Nc(l);
                a = $bde2334e73da0799$var$Nc(a);
            }
            l = null;
        }
        else l = null;
        a = l;
        for(l = []; h && h !== a;){
            g = h.alternate;
            if (null !== g && g === a) break;
            l.push(h);
            h = $bde2334e73da0799$var$Nc(h);
        }
        for(h = []; m && m !== a;){
            g = m.alternate;
            if (null !== g && g === a) break;
            h.push(m);
            m = $bde2334e73da0799$var$Nc(m);
        }
        for(m = 0; m < l.length; m++)$bde2334e73da0799$var$Qc(l[m], "bubbled", k);
        for(m = h.length; 0 < m--;)$bde2334e73da0799$var$Qc(h[m], "captured", d);
        if (c === $bde2334e73da0799$var$lf) return $bde2334e73da0799$var$lf = null, [
            k
        ];
        $bde2334e73da0799$var$lf = c;
        return [
            k,
            d
        ];
    }
};
function $bde2334e73da0799$var$nf(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $bde2334e73da0799$var$of = "function" === typeof Object.is ? Object.is : $bde2334e73da0799$var$nf, $bde2334e73da0799$var$pf = Object.prototype.hasOwnProperty;
function $bde2334e73da0799$var$qf(a, b) {
    if ($bde2334e73da0799$var$of(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!$bde2334e73da0799$var$pf.call(b, c[d]) || !$bde2334e73da0799$var$of(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var $bde2334e73da0799$var$rf = $bde2334e73da0799$var$Ya && "documentMode" in document && 11 >= document.documentMode, $bde2334e73da0799$var$sf = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, $bde2334e73da0799$var$tf = null, $bde2334e73da0799$var$uf = null, $bde2334e73da0799$var$vf = null, $bde2334e73da0799$var$wf = !1;
function $bde2334e73da0799$var$xf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if ($bde2334e73da0799$var$wf || null == $bde2334e73da0799$var$tf || $bde2334e73da0799$var$tf !== $bde2334e73da0799$var$be(c)) return null;
    c = $bde2334e73da0799$var$tf;
    "selectionStart" in c && $bde2334e73da0799$var$ge(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return $bde2334e73da0799$var$vf && $bde2334e73da0799$var$qf($bde2334e73da0799$var$vf, c) ? null : ($bde2334e73da0799$var$vf = c, a = $bde2334e73da0799$var$E.getPooled($bde2334e73da0799$var$sf.select, $bde2334e73da0799$var$uf, a, b), a.type = "select", a.target = $bde2334e73da0799$var$tf, $bde2334e73da0799$var$Sc(a), a);
}
var $bde2334e73da0799$var$yf = {
    eventTypes: $bde2334e73da0799$var$sf,
    extractEvents: function(a, b, c, d) {
        var e = d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument, f;
        if (!(f = !e)) {
            a: {
                e = $bde2334e73da0799$var$xc(e);
                f = $bde2334e73da0799$var$ja.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? $bde2334e73da0799$var$xe(b) : window;
        switch(a){
            case "focus":
                if ($bde2334e73da0799$var$Ue(e) || "true" === e.contentEditable) $bde2334e73da0799$var$tf = e, $bde2334e73da0799$var$uf = b, $bde2334e73da0799$var$vf = null;
                break;
            case "blur":
                $bde2334e73da0799$var$vf = $bde2334e73da0799$var$uf = $bde2334e73da0799$var$tf = null;
                break;
            case "mousedown":
                $bde2334e73da0799$var$wf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return $bde2334e73da0799$var$wf = !1, $bde2334e73da0799$var$xf(c, d);
            case "selectionchange":
                if ($bde2334e73da0799$var$rf) break;
            case "keydown":
            case "keyup":
                return $bde2334e73da0799$var$xf(c, d);
        }
        return null;
    }
};
$bde2334e73da0799$var$Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
var $bde2334e73da0799$var$zf = $bde2334e73da0799$var$Cc;
$bde2334e73da0799$var$sa = $bde2334e73da0799$var$ye;
$bde2334e73da0799$var$ua = $bde2334e73da0799$var$zf;
$bde2334e73da0799$var$va = $bde2334e73da0799$var$xe;
$bde2334e73da0799$var$Ca.injectEventPluginsByName({
    SimpleEventPlugin: $bde2334e73da0799$var$Ed,
    EnterLeaveEventPlugin: $bde2334e73da0799$var$mf,
    ChangeEventPlugin: $bde2334e73da0799$var$jf,
    SelectEventPlugin: $bde2334e73da0799$var$yf,
    BeforeInputEventPlugin: $bde2334e73da0799$var$Se
});
new Set;
var $bde2334e73da0799$var$Af = [], $bde2334e73da0799$var$Bf = -1;
function $bde2334e73da0799$var$G(a) {
    0 > $bde2334e73da0799$var$Bf || (a.current = $bde2334e73da0799$var$Af[$bde2334e73da0799$var$Bf], $bde2334e73da0799$var$Af[$bde2334e73da0799$var$Bf] = null, $bde2334e73da0799$var$Bf--);
}
function $bde2334e73da0799$var$I(a, b) {
    $bde2334e73da0799$var$Bf++;
    $bde2334e73da0799$var$Af[$bde2334e73da0799$var$Bf] = a.current;
    a.current = b;
}
var $bde2334e73da0799$var$Cf = {}, $bde2334e73da0799$var$J = {
    current: $bde2334e73da0799$var$Cf
}, $bde2334e73da0799$var$K = {
    current: !1
}, $bde2334e73da0799$var$Df = $bde2334e73da0799$var$Cf;
function $bde2334e73da0799$var$Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $bde2334e73da0799$var$Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $bde2334e73da0799$var$L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $bde2334e73da0799$var$Ff(a) {
    $bde2334e73da0799$var$G($bde2334e73da0799$var$K, a);
    $bde2334e73da0799$var$G($bde2334e73da0799$var$J, a);
}
function $bde2334e73da0799$var$Gf(a) {
    $bde2334e73da0799$var$G($bde2334e73da0799$var$K, a);
    $bde2334e73da0799$var$G($bde2334e73da0799$var$J, a);
}
function $bde2334e73da0799$var$Hf(a, b, c) {
    if ($bde2334e73da0799$var$J.current !== $bde2334e73da0799$var$Cf) throw Error($bde2334e73da0799$var$u(168));
    $bde2334e73da0799$var$I($bde2334e73da0799$var$J, b, a);
    $bde2334e73da0799$var$I($bde2334e73da0799$var$K, c, a);
}
function $bde2334e73da0799$var$If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error($bde2334e73da0799$var$u(108, $bde2334e73da0799$var$Wa(b) || "Unknown", e));
    return $fve7V({}, c, {}, d);
}
function $bde2334e73da0799$var$Jf(a) {
    var b = a.stateNode;
    b = b && b.__reactInternalMemoizedMergedChildContext || $bde2334e73da0799$var$Cf;
    $bde2334e73da0799$var$Df = $bde2334e73da0799$var$J.current;
    $bde2334e73da0799$var$I($bde2334e73da0799$var$J, b, a);
    $bde2334e73da0799$var$I($bde2334e73da0799$var$K, $bde2334e73da0799$var$K.current, a);
    return !0;
}
function $bde2334e73da0799$var$Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($bde2334e73da0799$var$u(169));
    c ? (b = $bde2334e73da0799$var$If(a, b, $bde2334e73da0799$var$Df), d.__reactInternalMemoizedMergedChildContext = b, $bde2334e73da0799$var$G($bde2334e73da0799$var$K, a), $bde2334e73da0799$var$G($bde2334e73da0799$var$J, a), $bde2334e73da0799$var$I($bde2334e73da0799$var$J, b, a)) : $bde2334e73da0799$var$G($bde2334e73da0799$var$K, a);
    $bde2334e73da0799$var$I($bde2334e73da0799$var$K, c, a);
}
var $bde2334e73da0799$var$Lf = $6ynyd.unstable_runWithPriority, $bde2334e73da0799$var$Mf = $6ynyd.unstable_scheduleCallback, $bde2334e73da0799$var$Nf = $6ynyd.unstable_cancelCallback, $bde2334e73da0799$var$Of = $6ynyd.unstable_shouldYield, $bde2334e73da0799$var$Pf = $6ynyd.unstable_requestPaint, $bde2334e73da0799$var$Qf = $6ynyd.unstable_now, $bde2334e73da0799$var$Rf = $6ynyd.unstable_getCurrentPriorityLevel, $bde2334e73da0799$var$Sf = $6ynyd.unstable_ImmediatePriority, $bde2334e73da0799$var$Tf = $6ynyd.unstable_UserBlockingPriority, $bde2334e73da0799$var$Uf = $6ynyd.unstable_NormalPriority, $bde2334e73da0799$var$Vf = $6ynyd.unstable_LowPriority, $bde2334e73da0799$var$Wf = $6ynyd.unstable_IdlePriority, $bde2334e73da0799$var$Xf = {}, $bde2334e73da0799$var$Yf = void 0 !== $bde2334e73da0799$var$Pf ? $bde2334e73da0799$var$Pf : function() {}, $bde2334e73da0799$var$Zf = null, $bde2334e73da0799$var$$f = null, $bde2334e73da0799$var$ag = !1, $bde2334e73da0799$var$bg = $bde2334e73da0799$var$Qf(), $bde2334e73da0799$var$cg = 1E4 > $bde2334e73da0799$var$bg ? $bde2334e73da0799$var$Qf : function() {
    return $bde2334e73da0799$var$Qf() - $bde2334e73da0799$var$bg;
};
function $bde2334e73da0799$var$dg() {
    switch($bde2334e73da0799$var$Rf()){
        case $bde2334e73da0799$var$Sf:
            return 99;
        case $bde2334e73da0799$var$Tf:
            return 98;
        case $bde2334e73da0799$var$Uf:
            return 97;
        case $bde2334e73da0799$var$Vf:
            return 96;
        case $bde2334e73da0799$var$Wf:
            return 95;
        default:
            throw Error($bde2334e73da0799$var$u(332));
    }
}
function $bde2334e73da0799$var$eg(a) {
    switch(a){
        case 99:
            return $bde2334e73da0799$var$Sf;
        case 98:
            return $bde2334e73da0799$var$Tf;
        case 97:
            return $bde2334e73da0799$var$Uf;
        case 96:
            return $bde2334e73da0799$var$Vf;
        case 95:
            return $bde2334e73da0799$var$Wf;
        default:
            throw Error($bde2334e73da0799$var$u(332));
    }
}
function $bde2334e73da0799$var$fg(a, b) {
    a = $bde2334e73da0799$var$eg(a);
    return $bde2334e73da0799$var$Lf(a, b);
}
function $bde2334e73da0799$var$gg(a, b, c) {
    a = $bde2334e73da0799$var$eg(a);
    return $bde2334e73da0799$var$Mf(a, b, c);
}
function $bde2334e73da0799$var$hg(a) {
    null === $bde2334e73da0799$var$Zf ? ($bde2334e73da0799$var$Zf = [
        a
    ], $bde2334e73da0799$var$$f = $bde2334e73da0799$var$Mf($bde2334e73da0799$var$Sf, $bde2334e73da0799$var$ig)) : $bde2334e73da0799$var$Zf.push(a);
    return $bde2334e73da0799$var$Xf;
}
function $bde2334e73da0799$var$jg() {
    if (null !== $bde2334e73da0799$var$$f) {
        var a = $bde2334e73da0799$var$$f;
        $bde2334e73da0799$var$$f = null;
        $bde2334e73da0799$var$Nf(a);
    }
    $bde2334e73da0799$var$ig();
}
function $bde2334e73da0799$var$ig() {
    if (!$bde2334e73da0799$var$ag && null !== $bde2334e73da0799$var$Zf) {
        $bde2334e73da0799$var$ag = !0;
        var a = 0;
        try {
            var b = $bde2334e73da0799$var$Zf;
            $bde2334e73da0799$var$fg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            $bde2334e73da0799$var$Zf = null;
        } catch (c) {
            throw null !== $bde2334e73da0799$var$Zf && ($bde2334e73da0799$var$Zf = $bde2334e73da0799$var$Zf.slice(a + 1)), $bde2334e73da0799$var$Mf($bde2334e73da0799$var$Sf, $bde2334e73da0799$var$jg), c;
        } finally{
            $bde2334e73da0799$var$ag = !1;
        }
    }
}
var $bde2334e73da0799$var$kg = 3;
function $bde2334e73da0799$var$lg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function $bde2334e73da0799$var$mg(a, b) {
    if (a && a.defaultProps) {
        b = $fve7V({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var $bde2334e73da0799$var$ng = {
    current: null
}, $bde2334e73da0799$var$og = null, $bde2334e73da0799$var$pg = null, $bde2334e73da0799$var$qg = null;
function $bde2334e73da0799$var$rg() {
    $bde2334e73da0799$var$qg = $bde2334e73da0799$var$pg = $bde2334e73da0799$var$og = null;
}
function $bde2334e73da0799$var$sg(a, b) {
    var c = a.type._context;
    $bde2334e73da0799$var$I($bde2334e73da0799$var$ng, c._currentValue, a);
    c._currentValue = b;
}
function $bde2334e73da0799$var$tg(a) {
    var b = $bde2334e73da0799$var$ng.current;
    $bde2334e73da0799$var$G($bde2334e73da0799$var$ng, a);
    a.type._context._currentValue = b;
}
function $bde2334e73da0799$var$ug(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function $bde2334e73da0799$var$vg(a, b) {
    $bde2334e73da0799$var$og = a;
    $bde2334e73da0799$var$qg = $bde2334e73da0799$var$pg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && ($bde2334e73da0799$var$wg = !0), a.firstContext = null);
}
function $bde2334e73da0799$var$xg(a, b) {
    if ($bde2334e73da0799$var$qg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) $bde2334e73da0799$var$qg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === $bde2334e73da0799$var$pg) {
            if (null === $bde2334e73da0799$var$og) throw Error($bde2334e73da0799$var$u(308));
            $bde2334e73da0799$var$pg = b;
            $bde2334e73da0799$var$og.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else $bde2334e73da0799$var$pg = $bde2334e73da0799$var$pg.next = b;
    }
    return a._currentValue;
}
var $bde2334e73da0799$var$yg = !1;
function $bde2334e73da0799$var$zg(a) {
    return {
        baseState: a,
        firstUpdate: null,
        lastUpdate: null,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
    };
}
function $bde2334e73da0799$var$Ag(a) {
    return {
        baseState: a.baseState,
        firstUpdate: a.firstUpdate,
        lastUpdate: a.lastUpdate,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
    };
}
function $bde2334e73da0799$var$Bg(a, b) {
    return {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null,
        nextEffect: null
    };
}
function $bde2334e73da0799$var$Cg(a, b) {
    null === a.lastUpdate ? a.firstUpdate = a.lastUpdate = b : (a.lastUpdate.next = b, a.lastUpdate = b);
}
function $bde2334e73da0799$var$Dg(a, b) {
    var c = a.alternate;
    if (null === c) {
        var d = a.updateQueue;
        var e = null;
        null === d && (d = a.updateQueue = $bde2334e73da0799$var$zg(a.memoizedState));
    } else d = a.updateQueue, e = c.updateQueue, null === d ? null === e ? (d = a.updateQueue = $bde2334e73da0799$var$zg(a.memoizedState), e = c.updateQueue = $bde2334e73da0799$var$zg(c.memoizedState)) : d = a.updateQueue = $bde2334e73da0799$var$Ag(e) : null === e && (e = c.updateQueue = $bde2334e73da0799$var$Ag(d));
    null === e || d === e ? $bde2334e73da0799$var$Cg(d, b) : null === d.lastUpdate || null === e.lastUpdate ? ($bde2334e73da0799$var$Cg(d, b), $bde2334e73da0799$var$Cg(e, b)) : ($bde2334e73da0799$var$Cg(d, b), e.lastUpdate = b);
}
function $bde2334e73da0799$var$Eg(a, b) {
    var c = a.updateQueue;
    c = null === c ? a.updateQueue = $bde2334e73da0799$var$zg(a.memoizedState) : $bde2334e73da0799$var$Fg(a, c);
    null === c.lastCapturedUpdate ? c.firstCapturedUpdate = c.lastCapturedUpdate = b : (c.lastCapturedUpdate.next = b, c.lastCapturedUpdate = b);
}
function $bde2334e73da0799$var$Fg(a, b) {
    var c = a.alternate;
    null !== c && b === c.updateQueue && (b = a.updateQueue = $bde2334e73da0799$var$Ag(b));
    return b;
}
function $bde2334e73da0799$var$Gg(a, b, c, d, e, f) {
    switch(c.tag){
        case 1:
            return a = c.payload, "function" === typeof a ? a.call(f, d, e) : a;
        case 3:
            a.effectTag = a.effectTag & -4097 | 64;
        case 0:
            a = c.payload;
            e = "function" === typeof a ? a.call(f, d, e) : a;
            if (null === e || void 0 === e) break;
            return $fve7V({}, d, e);
        case 2:
            $bde2334e73da0799$var$yg = !0;
    }
    return d;
}
function $bde2334e73da0799$var$Hg(a, b, c, d, e) {
    $bde2334e73da0799$var$yg = !1;
    b = $bde2334e73da0799$var$Fg(a, b);
    for(var f = b.baseState, g = null, h = 0, k = b.firstUpdate, l = f; null !== k;){
        var m = k.expirationTime;
        m < e ? (null === g && (g = k, f = l), h < m && (h = m)) : ($bde2334e73da0799$var$Ig(m, k.suspenseConfig), l = $bde2334e73da0799$var$Gg(a, b, k, l, c, d), null !== k.callback && (a.effectTag |= 32, k.nextEffect = null, null === b.lastEffect ? b.firstEffect = b.lastEffect = k : (b.lastEffect.nextEffect = k, b.lastEffect = k)));
        k = k.next;
    }
    m = null;
    for(k = b.firstCapturedUpdate; null !== k;){
        var C = k.expirationTime;
        C < e ? (null === m && (m = k, null === g && (f = l)), h < C && (h = C)) : (l = $bde2334e73da0799$var$Gg(a, b, k, l, c, d), null !== k.callback && (a.effectTag |= 32, k.nextEffect = null, null === b.lastCapturedEffect ? b.firstCapturedEffect = b.lastCapturedEffect = k : (b.lastCapturedEffect.nextEffect = k, b.lastCapturedEffect = k)));
        k = k.next;
    }
    null === g && (b.lastUpdate = null);
    null === m ? b.lastCapturedUpdate = null : a.effectTag |= 32;
    null === g && null === m && (f = l);
    b.baseState = f;
    b.firstUpdate = g;
    b.firstCapturedUpdate = m;
    $bde2334e73da0799$var$Jg(h);
    a.expirationTime = h;
    a.memoizedState = l;
}
function $bde2334e73da0799$var$Kg(a, b, c) {
    null !== b.firstCapturedUpdate && (null !== b.lastUpdate && (b.lastUpdate.next = b.firstCapturedUpdate, b.lastUpdate = b.lastCapturedUpdate), b.firstCapturedUpdate = b.lastCapturedUpdate = null);
    $bde2334e73da0799$var$Lg(b.firstEffect, c);
    b.firstEffect = b.lastEffect = null;
    $bde2334e73da0799$var$Lg(b.firstCapturedEffect, c);
    b.firstCapturedEffect = b.lastCapturedEffect = null;
}
function $bde2334e73da0799$var$Lg(a, b) {
    for(; null !== a;){
        var c = a.callback;
        if (null !== c) {
            a.callback = null;
            var d = b;
            if ("function" !== typeof c) throw Error($bde2334e73da0799$var$u(191, c));
            c.call(d);
        }
        a = a.nextEffect;
    }
}
var $bde2334e73da0799$var$Mg = $bde2334e73da0799$var$Ea.ReactCurrentBatchConfig, $bde2334e73da0799$var$Ng = (new $jTfnt.Component).refs;
function $bde2334e73da0799$var$Og(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $fve7V({}, b, c);
    a.memoizedState = c;
    d = a.updateQueue;
    null !== d && 0 === a.expirationTime && (d.baseState = c);
}
var $bde2334e73da0799$var$Sg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? $bde2334e73da0799$var$ec(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $bde2334e73da0799$var$Pg(), e = $bde2334e73da0799$var$Mg.suspense;
        d = $bde2334e73da0799$var$Qg(d, a, e);
        e = $bde2334e73da0799$var$Bg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $bde2334e73da0799$var$Dg(a, e);
        $bde2334e73da0799$var$Rg(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $bde2334e73da0799$var$Pg(), e = $bde2334e73da0799$var$Mg.suspense;
        d = $bde2334e73da0799$var$Qg(d, a, e);
        e = $bde2334e73da0799$var$Bg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $bde2334e73da0799$var$Dg(a, e);
        $bde2334e73da0799$var$Rg(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = $bde2334e73da0799$var$Pg(), d = $bde2334e73da0799$var$Mg.suspense;
        c = $bde2334e73da0799$var$Qg(c, a, d);
        d = $bde2334e73da0799$var$Bg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        $bde2334e73da0799$var$Dg(a, d);
        $bde2334e73da0799$var$Rg(a, c);
    }
};
function $bde2334e73da0799$var$Tg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$bde2334e73da0799$var$qf(c, d) || !$bde2334e73da0799$var$qf(e, f) : !0;
}
function $bde2334e73da0799$var$Ug(a, b, c) {
    var d = !1, e = $bde2334e73da0799$var$Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $bde2334e73da0799$var$xg(f) : (e = $bde2334e73da0799$var$L(b) ? $bde2334e73da0799$var$Df : $bde2334e73da0799$var$J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $bde2334e73da0799$var$Ef(a, e) : $bde2334e73da0799$var$Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $bde2334e73da0799$var$Sg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $bde2334e73da0799$var$Vg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $bde2334e73da0799$var$Sg.enqueueReplaceState(b, b.state, null);
}
function $bde2334e73da0799$var$Wg(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $bde2334e73da0799$var$Ng;
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $bde2334e73da0799$var$xg(f) : (f = $bde2334e73da0799$var$L(b) ? $bde2334e73da0799$var$Df : $bde2334e73da0799$var$J.current, e.context = $bde2334e73da0799$var$Ef(a, f));
    f = a.updateQueue;
    null !== f && ($bde2334e73da0799$var$Hg(a, f, c, e, d), e.state = a.memoizedState);
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($bde2334e73da0799$var$Og(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $bde2334e73da0799$var$Sg.enqueueReplaceState(e, e.state, null), f = a.updateQueue, null !== f && ($bde2334e73da0799$var$Hg(a, f, c, e, d), e.state = a.memoizedState));
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var $bde2334e73da0799$var$Xg = Array.isArray;
function $bde2334e73da0799$var$Yg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($bde2334e73da0799$var$u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($bde2334e73da0799$var$u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === $bde2334e73da0799$var$Ng && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error($bde2334e73da0799$var$u(284));
        if (!c._owner) throw Error($bde2334e73da0799$var$u(290, a));
    }
    return a;
}
function $bde2334e73da0799$var$Zg(a, b) {
    if ("textarea" !== a.type) throw Error($bde2334e73da0799$var$u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function $bde2334e73da0799$var$$g(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b, c) {
        a = $bde2334e73da0799$var$ah(a, b, c);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $bde2334e73da0799$var$bh(c, a.mode, d), b.return = a, b;
        b = e(b, c, d);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props, d), d.ref = $bde2334e73da0799$var$Yg(a, b, c), d.return = a, d;
        d = $bde2334e73da0799$var$ch(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $bde2334e73da0799$var$Yg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $bde2334e73da0799$var$dh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || [], d);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $bde2334e73da0799$var$eh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c, d);
        b.return = a;
        return b;
    }
    function C(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = $bde2334e73da0799$var$bh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $bde2334e73da0799$var$Ga:
                    return c = $bde2334e73da0799$var$ch(b.type, b.key, b.props, null, a.mode, c), c.ref = $bde2334e73da0799$var$Yg(a, null, b), c.return = a, c;
                case $bde2334e73da0799$var$Ha:
                    return b = $bde2334e73da0799$var$dh(b, a.mode, c), b.return = a, b;
            }
            if ($bde2334e73da0799$var$Xg(b) || $bde2334e73da0799$var$Ua(b)) return b = $bde2334e73da0799$var$eh(b, a.mode, c, null), b.return = a, b;
            $bde2334e73da0799$var$Zg(a, b);
        }
        return null;
    }
    function y(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $bde2334e73da0799$var$Ga:
                    return c.key === e ? c.type === $bde2334e73da0799$var$Ia ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $bde2334e73da0799$var$Ha:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if ($bde2334e73da0799$var$Xg(c) || $bde2334e73da0799$var$Ua(c)) return null !== e ? null : m(a, b, c, d, null);
            $bde2334e73da0799$var$Zg(a, c);
        }
        return null;
    }
    function H(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $bde2334e73da0799$var$Ga:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === $bde2334e73da0799$var$Ia ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $bde2334e73da0799$var$Ha:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if ($bde2334e73da0799$var$Xg(d) || $bde2334e73da0799$var$Ua(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $bde2334e73da0799$var$Zg(b, d);
        }
        return null;
    }
    function z(e, g, h, k) {
        for(var l = null, m = null, r = g, x = g = 0, A = null; null !== r && x < h.length; x++){
            r.index > x ? (A = r, r = null) : A = r.sibling;
            var p = y(e, r, h[x], k);
            if (null === p) {
                null === r && (r = A);
                break;
            }
            a && r && null === p.alternate && b(e, r);
            g = f(p, g, x);
            null === m ? l = p : m.sibling = p;
            m = p;
            r = A;
        }
        if (x === h.length) return c(e, r), l;
        if (null === r) {
            for(; x < h.length; x++)r = C(e, h[x], k), null !== r && (g = f(r, g, x), null === m ? l = r : m.sibling = r, m = r);
            return l;
        }
        for(r = d(e, r); x < h.length; x++)A = H(r, e, x, h[x], k), null !== A && (a && null !== A.alternate && r.delete(null === A.key ? x : A.key), g = f(A, g, x), null === m ? l = A : m.sibling = A, m = A);
        a && r.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function ta(e, g, h, k) {
        var l = $bde2334e73da0799$var$Ua(h);
        if ("function" !== typeof l) throw Error($bde2334e73da0799$var$u(150));
        h = l.call(h);
        if (null == h) throw Error($bde2334e73da0799$var$u(151));
        for(var m = l = null, r = g, x = g = 0, A = null, p = h.next(); null !== r && !p.done; x++, p = h.next()){
            r.index > x ? (A = r, r = null) : A = r.sibling;
            var z = y(e, r, p.value, k);
            if (null === z) {
                null === r && (r = A);
                break;
            }
            a && r && null === z.alternate && b(e, r);
            g = f(z, g, x);
            null === m ? l = z : m.sibling = z;
            m = z;
            r = A;
        }
        if (p.done) return c(e, r), l;
        if (null === r) {
            for(; !p.done; x++, p = h.next())p = C(e, p.value, k), null !== p && (g = f(p, g, x), null === m ? l = p : m.sibling = p, m = p);
            return l;
        }
        for(r = d(e, r); !p.done; x++, p = h.next())p = H(r, e, x, p.value, k), null !== p && (a && null !== p.alternate && r.delete(null === p.key ? x : p.key), g = f(p, g, x), null === m ? l = p : m.sibling = p, m = p);
        a && r.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === $bde2334e73da0799$var$Ia && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case $bde2334e73da0799$var$Ga:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            if (7 === k.tag ? f.type === $bde2334e73da0799$var$Ia : k.elementType === f.type) {
                                c(a, k.sibling);
                                d = e(k, f.type === $bde2334e73da0799$var$Ia ? f.props.children : f.props, h);
                                d.ref = $bde2334e73da0799$var$Yg(a, k, f);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, k);
                                break;
                            }
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === $bde2334e73da0799$var$Ia ? (d = $bde2334e73da0799$var$eh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $bde2334e73da0799$var$ch(f.type, f.key, f.props, null, a.mode, h), h.ref = $bde2334e73da0799$var$Yg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $bde2334e73da0799$var$Ha:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || [], h);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = $bde2334e73da0799$var$dh(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f, h), d.return = a, a = d) : (c(a, d), d = $bde2334e73da0799$var$bh(f, a.mode, h), d.return = a, a = d), g(a);
        if ($bde2334e73da0799$var$Xg(f)) return z(a, d, f, h);
        if ($bde2334e73da0799$var$Ua(f)) return ta(a, d, f, h);
        l && $bde2334e73da0799$var$Zg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error($bde2334e73da0799$var$u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var $bde2334e73da0799$var$fh = $bde2334e73da0799$var$$g(!0), $bde2334e73da0799$var$gh = $bde2334e73da0799$var$$g(!1), $bde2334e73da0799$var$hh = {}, $bde2334e73da0799$var$ih = {
    current: $bde2334e73da0799$var$hh
}, $bde2334e73da0799$var$jh = {
    current: $bde2334e73da0799$var$hh
}, $bde2334e73da0799$var$kh = {
    current: $bde2334e73da0799$var$hh
};
function $bde2334e73da0799$var$lh(a) {
    if (a === $bde2334e73da0799$var$hh) throw Error($bde2334e73da0799$var$u(174));
    return a;
}
function $bde2334e73da0799$var$mh(a, b) {
    $bde2334e73da0799$var$I($bde2334e73da0799$var$kh, b, a);
    $bde2334e73da0799$var$I($bde2334e73da0799$var$jh, a, a);
    $bde2334e73da0799$var$I($bde2334e73da0799$var$ih, $bde2334e73da0799$var$hh, a);
    var c = b.nodeType;
    switch(c){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $bde2334e73da0799$var$Qb(null, "");
            break;
        default:
            c = 8 === c ? b.parentNode : b, b = c.namespaceURI || null, c = c.tagName, b = $bde2334e73da0799$var$Qb(b, c);
    }
    $bde2334e73da0799$var$G($bde2334e73da0799$var$ih, a);
    $bde2334e73da0799$var$I($bde2334e73da0799$var$ih, b, a);
}
function $bde2334e73da0799$var$nh(a) {
    $bde2334e73da0799$var$G($bde2334e73da0799$var$ih, a);
    $bde2334e73da0799$var$G($bde2334e73da0799$var$jh, a);
    $bde2334e73da0799$var$G($bde2334e73da0799$var$kh, a);
}
function $bde2334e73da0799$var$oh(a) {
    $bde2334e73da0799$var$lh($bde2334e73da0799$var$kh.current);
    var b = $bde2334e73da0799$var$lh($bde2334e73da0799$var$ih.current);
    var c = $bde2334e73da0799$var$Qb(b, a.type);
    b !== c && ($bde2334e73da0799$var$I($bde2334e73da0799$var$jh, a, a), $bde2334e73da0799$var$I($bde2334e73da0799$var$ih, c, a));
}
function $bde2334e73da0799$var$ph(a) {
    $bde2334e73da0799$var$jh.current === a && ($bde2334e73da0799$var$G($bde2334e73da0799$var$ih, a), $bde2334e73da0799$var$G($bde2334e73da0799$var$jh, a));
}
var $bde2334e73da0799$var$M = {
    current: 0
};
function $bde2334e73da0799$var$qh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === $bde2334e73da0799$var$je || c.data === $bde2334e73da0799$var$ke)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function $bde2334e73da0799$var$rh(a, b) {
    return {
        responder: a,
        props: b
    };
}
var $bde2334e73da0799$var$sh = $bde2334e73da0799$var$Ea.ReactCurrentDispatcher, $bde2334e73da0799$var$N = $bde2334e73da0799$var$Ea.ReactCurrentBatchConfig, $bde2334e73da0799$var$th = 0, $bde2334e73da0799$var$uh = null, $bde2334e73da0799$var$O = null, $bde2334e73da0799$var$vh = null, $bde2334e73da0799$var$wh = null, $bde2334e73da0799$var$P = null, $bde2334e73da0799$var$xh = null, $bde2334e73da0799$var$yh = 0, $bde2334e73da0799$var$zh = null, $bde2334e73da0799$var$Ah = 0, $bde2334e73da0799$var$Bh = !1, $bde2334e73da0799$var$Ch = null, $bde2334e73da0799$var$Gh = 0;
function $bde2334e73da0799$var$Q() {
    throw Error($bde2334e73da0799$var$u(321));
}
function $bde2334e73da0799$var$Hh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$bde2334e73da0799$var$of(a[c], b[c])) return !1;
    return !0;
}
function $bde2334e73da0799$var$Ih(a, b, c, d, e, f) {
    $bde2334e73da0799$var$th = f;
    $bde2334e73da0799$var$uh = b;
    $bde2334e73da0799$var$vh = null !== a ? a.memoizedState : null;
    $bde2334e73da0799$var$sh.current = null === $bde2334e73da0799$var$vh ? $bde2334e73da0799$var$Jh : $bde2334e73da0799$var$Kh;
    b = c(d, e);
    if ($bde2334e73da0799$var$Bh) {
        do $bde2334e73da0799$var$Bh = !1, $bde2334e73da0799$var$Gh += 1, $bde2334e73da0799$var$vh = null !== a ? a.memoizedState : null, $bde2334e73da0799$var$xh = $bde2334e73da0799$var$wh, $bde2334e73da0799$var$zh = $bde2334e73da0799$var$P = $bde2334e73da0799$var$O = null, $bde2334e73da0799$var$sh.current = $bde2334e73da0799$var$Kh, b = c(d, e);
        while ($bde2334e73da0799$var$Bh);
        $bde2334e73da0799$var$Ch = null;
        $bde2334e73da0799$var$Gh = 0;
    }
    $bde2334e73da0799$var$sh.current = $bde2334e73da0799$var$Lh;
    a = $bde2334e73da0799$var$uh;
    a.memoizedState = $bde2334e73da0799$var$wh;
    a.expirationTime = $bde2334e73da0799$var$yh;
    a.updateQueue = $bde2334e73da0799$var$zh;
    a.effectTag |= $bde2334e73da0799$var$Ah;
    a = null !== $bde2334e73da0799$var$O && null !== $bde2334e73da0799$var$O.next;
    $bde2334e73da0799$var$th = 0;
    $bde2334e73da0799$var$xh = $bde2334e73da0799$var$P = $bde2334e73da0799$var$wh = $bde2334e73da0799$var$vh = $bde2334e73da0799$var$O = $bde2334e73da0799$var$uh = null;
    $bde2334e73da0799$var$yh = 0;
    $bde2334e73da0799$var$zh = null;
    $bde2334e73da0799$var$Ah = 0;
    if (a) throw Error($bde2334e73da0799$var$u(300));
    return b;
}
function $bde2334e73da0799$var$Mh() {
    $bde2334e73da0799$var$sh.current = $bde2334e73da0799$var$Lh;
    $bde2334e73da0799$var$th = 0;
    $bde2334e73da0799$var$xh = $bde2334e73da0799$var$P = $bde2334e73da0799$var$wh = $bde2334e73da0799$var$vh = $bde2334e73da0799$var$O = $bde2334e73da0799$var$uh = null;
    $bde2334e73da0799$var$yh = 0;
    $bde2334e73da0799$var$zh = null;
    $bde2334e73da0799$var$Ah = 0;
    $bde2334e73da0799$var$Bh = !1;
    $bde2334e73da0799$var$Ch = null;
    $bde2334e73da0799$var$Gh = 0;
}
function $bde2334e73da0799$var$Nh() {
    var a = {
        memoizedState: null,
        baseState: null,
        queue: null,
        baseUpdate: null,
        next: null
    };
    null === $bde2334e73da0799$var$P ? $bde2334e73da0799$var$wh = $bde2334e73da0799$var$P = a : $bde2334e73da0799$var$P = $bde2334e73da0799$var$P.next = a;
    return $bde2334e73da0799$var$P;
}
function $bde2334e73da0799$var$Oh() {
    if (null !== $bde2334e73da0799$var$xh) $bde2334e73da0799$var$P = $bde2334e73da0799$var$xh, $bde2334e73da0799$var$xh = $bde2334e73da0799$var$P.next, $bde2334e73da0799$var$O = $bde2334e73da0799$var$vh, $bde2334e73da0799$var$vh = null !== $bde2334e73da0799$var$O ? $bde2334e73da0799$var$O.next : null;
    else {
        if (null === $bde2334e73da0799$var$vh) throw Error($bde2334e73da0799$var$u(310));
        $bde2334e73da0799$var$O = $bde2334e73da0799$var$vh;
        var a = {
            memoizedState: $bde2334e73da0799$var$O.memoizedState,
            baseState: $bde2334e73da0799$var$O.baseState,
            queue: $bde2334e73da0799$var$O.queue,
            baseUpdate: $bde2334e73da0799$var$O.baseUpdate,
            next: null
        };
        $bde2334e73da0799$var$P = null === $bde2334e73da0799$var$P ? $bde2334e73da0799$var$wh = a : $bde2334e73da0799$var$P.next = a;
        $bde2334e73da0799$var$vh = $bde2334e73da0799$var$O.next;
    }
    return $bde2334e73da0799$var$P;
}
function $bde2334e73da0799$var$Ph(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $bde2334e73da0799$var$Qh(a) {
    var b = $bde2334e73da0799$var$Oh(), c = b.queue;
    if (null === c) throw Error($bde2334e73da0799$var$u(311));
    c.lastRenderedReducer = a;
    if (0 < $bde2334e73da0799$var$Gh) {
        var d = c.dispatch;
        if (null !== $bde2334e73da0799$var$Ch) {
            var e = $bde2334e73da0799$var$Ch.get(c);
            if (void 0 !== e) {
                $bde2334e73da0799$var$Ch.delete(c);
                var f = b.memoizedState;
                do f = a(f, e.action), e = e.next;
                while (null !== e);
                $bde2334e73da0799$var$of(f, b.memoizedState) || ($bde2334e73da0799$var$wg = !0);
                b.memoizedState = f;
                b.baseUpdate === c.last && (b.baseState = f);
                c.lastRenderedState = f;
                return [
                    f,
                    d
                ];
            }
        }
        return [
            b.memoizedState,
            d
        ];
    }
    d = c.last;
    var g = b.baseUpdate;
    f = b.baseState;
    null !== g ? (null !== d && (d.next = null), d = g.next) : d = null !== d ? d.next : null;
    if (null !== d) {
        var h = e = null, k = d, l = !1;
        do {
            var m = k.expirationTime;
            m < $bde2334e73da0799$var$th ? (l || (l = !0, h = g, e = f), m > $bde2334e73da0799$var$yh && ($bde2334e73da0799$var$yh = m, $bde2334e73da0799$var$Jg($bde2334e73da0799$var$yh))) : ($bde2334e73da0799$var$Ig(m, k.suspenseConfig), f = k.eagerReducer === a ? k.eagerState : a(f, k.action));
            g = k;
            k = k.next;
        }while (null !== k && k !== d);
        l || (h = g, e = f);
        $bde2334e73da0799$var$of(f, b.memoizedState) || ($bde2334e73da0799$var$wg = !0);
        b.memoizedState = f;
        b.baseUpdate = h;
        b.baseState = e;
        c.lastRenderedState = f;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $bde2334e73da0799$var$Rh(a) {
    var b = $bde2334e73da0799$var$Nh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        last: null,
        dispatch: null,
        lastRenderedReducer: $bde2334e73da0799$var$Ph,
        lastRenderedState: a
    };
    a = a.dispatch = $bde2334e73da0799$var$Sh.bind(null, $bde2334e73da0799$var$uh, a);
    return [
        b.memoizedState,
        a
    ];
}
function $bde2334e73da0799$var$Th(a) {
    return $bde2334e73da0799$var$Qh($bde2334e73da0799$var$Ph, a);
}
function $bde2334e73da0799$var$Uh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    null === $bde2334e73da0799$var$zh ? ($bde2334e73da0799$var$zh = {
        lastEffect: null
    }, $bde2334e73da0799$var$zh.lastEffect = a.next = a) : (b = $bde2334e73da0799$var$zh.lastEffect, null === b ? $bde2334e73da0799$var$zh.lastEffect = a.next = a : (c = b.next, b.next = a, a.next = c, $bde2334e73da0799$var$zh.lastEffect = a));
    return a;
}
function $bde2334e73da0799$var$Vh(a, b, c, d) {
    var e = $bde2334e73da0799$var$Nh();
    $bde2334e73da0799$var$Ah |= a;
    e.memoizedState = $bde2334e73da0799$var$Uh(b, c, void 0, void 0 === d ? null : d);
}
function $bde2334e73da0799$var$Wh(a, b, c, d) {
    var e = $bde2334e73da0799$var$Oh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $bde2334e73da0799$var$O) {
        var g = $bde2334e73da0799$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $bde2334e73da0799$var$Hh(d, g.deps)) {
            $bde2334e73da0799$var$Uh(0, c, f, d);
            return;
        }
    }
    $bde2334e73da0799$var$Ah |= a;
    e.memoizedState = $bde2334e73da0799$var$Uh(b, c, f, d);
}
function $bde2334e73da0799$var$Xh(a, b) {
    return $bde2334e73da0799$var$Vh(516, 192, a, b);
}
function $bde2334e73da0799$var$Yh(a, b) {
    return $bde2334e73da0799$var$Wh(516, 192, a, b);
}
function $bde2334e73da0799$var$Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $bde2334e73da0799$var$$h() {}
function $bde2334e73da0799$var$ai(a, b) {
    $bde2334e73da0799$var$Nh().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function $bde2334e73da0799$var$bi(a, b) {
    var c = $bde2334e73da0799$var$Oh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $bde2334e73da0799$var$Hh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $bde2334e73da0799$var$Sh(a, b, c) {
    if (!(25 > $bde2334e73da0799$var$Gh)) throw Error($bde2334e73da0799$var$u(301));
    var d = a.alternate;
    if (a === $bde2334e73da0799$var$uh || null !== d && d === $bde2334e73da0799$var$uh) {
        if ($bde2334e73da0799$var$Bh = !0, a = {
            expirationTime: $bde2334e73da0799$var$th,
            suspenseConfig: null,
            action: c,
            eagerReducer: null,
            eagerState: null,
            next: null
        }, null === $bde2334e73da0799$var$Ch && ($bde2334e73da0799$var$Ch = new Map), c = $bde2334e73da0799$var$Ch.get(b), void 0 === c) $bde2334e73da0799$var$Ch.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    } else {
        var e = $bde2334e73da0799$var$Pg(), f = $bde2334e73da0799$var$Mg.suspense;
        e = $bde2334e73da0799$var$Qg(e, a, f);
        f = {
            expirationTime: e,
            suspenseConfig: f,
            action: c,
            eagerReducer: null,
            eagerState: null,
            next: null
        };
        var g = b.last;
        if (null === g) f.next = f;
        else {
            var h = g.next;
            null !== h && (f.next = h);
            g.next = f;
        }
        b.last = f;
        if (0 === a.expirationTime && (null === d || 0 === d.expirationTime) && (d = b.lastRenderedReducer, null !== d)) try {
            var k = b.lastRenderedState, l = d(k, c);
            f.eagerReducer = d;
            f.eagerState = l;
            if ($bde2334e73da0799$var$of(l, k)) return;
        } catch (m) {} finally{}
        $bde2334e73da0799$var$Rg(a, e);
    }
}
var $bde2334e73da0799$var$Lh = {
    readContext: $bde2334e73da0799$var$xg,
    useCallback: $bde2334e73da0799$var$Q,
    useContext: $bde2334e73da0799$var$Q,
    useEffect: $bde2334e73da0799$var$Q,
    useImperativeHandle: $bde2334e73da0799$var$Q,
    useLayoutEffect: $bde2334e73da0799$var$Q,
    useMemo: $bde2334e73da0799$var$Q,
    useReducer: $bde2334e73da0799$var$Q,
    useRef: $bde2334e73da0799$var$Q,
    useState: $bde2334e73da0799$var$Q,
    useDebugValue: $bde2334e73da0799$var$Q,
    useResponder: $bde2334e73da0799$var$Q,
    useDeferredValue: $bde2334e73da0799$var$Q,
    useTransition: $bde2334e73da0799$var$Q
}, $bde2334e73da0799$var$Jh = {
    readContext: $bde2334e73da0799$var$xg,
    useCallback: $bde2334e73da0799$var$ai,
    useContext: $bde2334e73da0799$var$xg,
    useEffect: $bde2334e73da0799$var$Xh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $bde2334e73da0799$var$Vh(4, 36, $bde2334e73da0799$var$Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $bde2334e73da0799$var$Vh(4, 36, a, b);
    },
    useMemo: function(a, b) {
        var c = $bde2334e73da0799$var$Nh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $bde2334e73da0799$var$Nh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            last: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = $bde2334e73da0799$var$Sh.bind(null, $bde2334e73da0799$var$uh, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $bde2334e73da0799$var$Nh();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $bde2334e73da0799$var$Rh,
    useDebugValue: $bde2334e73da0799$var$$h,
    useResponder: $bde2334e73da0799$var$rh,
    useDeferredValue: function(a, b) {
        var c = $bde2334e73da0799$var$Rh(a), d = c[0], e = c[1];
        $bde2334e73da0799$var$Xh(function() {
            $6ynyd.unstable_next(function() {
                var c = $bde2334e73da0799$var$N.suspense;
                $bde2334e73da0799$var$N.suspense = void 0 === b ? null : b;
                try {
                    e(a);
                } finally{
                    $bde2334e73da0799$var$N.suspense = c;
                }
            });
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = $bde2334e73da0799$var$Rh(!1), c = b[0], d = b[1];
        return [
            $bde2334e73da0799$var$ai(function(b) {
                d(!0);
                $6ynyd.unstable_next(function() {
                    var c = $bde2334e73da0799$var$N.suspense;
                    $bde2334e73da0799$var$N.suspense = void 0 === a ? null : a;
                    try {
                        d(!1), b();
                    } finally{
                        $bde2334e73da0799$var$N.suspense = c;
                    }
                });
            }, [
                a,
                c
            ]),
            c
        ];
    }
}, $bde2334e73da0799$var$Kh = {
    readContext: $bde2334e73da0799$var$xg,
    useCallback: $bde2334e73da0799$var$bi,
    useContext: $bde2334e73da0799$var$xg,
    useEffect: $bde2334e73da0799$var$Yh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $bde2334e73da0799$var$Wh(4, 36, $bde2334e73da0799$var$Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $bde2334e73da0799$var$Wh(4, 36, a, b);
    },
    useMemo: function(a, b) {
        var c = $bde2334e73da0799$var$Oh();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && $bde2334e73da0799$var$Hh(b, d[1])) return d[0];
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: $bde2334e73da0799$var$Qh,
    useRef: function() {
        return $bde2334e73da0799$var$Oh().memoizedState;
    },
    useState: $bde2334e73da0799$var$Th,
    useDebugValue: $bde2334e73da0799$var$$h,
    useResponder: $bde2334e73da0799$var$rh,
    useDeferredValue: function(a, b) {
        var c = $bde2334e73da0799$var$Th(a), d = c[0], e = c[1];
        $bde2334e73da0799$var$Yh(function() {
            $6ynyd.unstable_next(function() {
                var c = $bde2334e73da0799$var$N.suspense;
                $bde2334e73da0799$var$N.suspense = void 0 === b ? null : b;
                try {
                    e(a);
                } finally{
                    $bde2334e73da0799$var$N.suspense = c;
                }
            });
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = $bde2334e73da0799$var$Th(!1), c = b[0], d = b[1];
        return [
            $bde2334e73da0799$var$bi(function(b) {
                d(!0);
                $6ynyd.unstable_next(function() {
                    var c = $bde2334e73da0799$var$N.suspense;
                    $bde2334e73da0799$var$N.suspense = void 0 === a ? null : a;
                    try {
                        d(!1), b();
                    } finally{
                        $bde2334e73da0799$var$N.suspense = c;
                    }
                });
            }, [
                a,
                c
            ]),
            c
        ];
    }
}, $bde2334e73da0799$var$ci = null, $bde2334e73da0799$var$di = null, $bde2334e73da0799$var$ei = !1;
function $bde2334e73da0799$var$fi(a, b) {
    var c = $bde2334e73da0799$var$gi(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function $bde2334e73da0799$var$hi(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function $bde2334e73da0799$var$ii(a) {
    if ($bde2334e73da0799$var$ei) {
        var b = $bde2334e73da0799$var$di;
        if (b) {
            var c = b;
            if (!$bde2334e73da0799$var$hi(a, b)) {
                b = $bde2334e73da0799$var$re(c.nextSibling);
                if (!b || !$bde2334e73da0799$var$hi(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    $bde2334e73da0799$var$ei = !1;
                    $bde2334e73da0799$var$ci = a;
                    return;
                }
                $bde2334e73da0799$var$fi($bde2334e73da0799$var$ci, c);
            }
            $bde2334e73da0799$var$ci = a;
            $bde2334e73da0799$var$di = $bde2334e73da0799$var$re(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, $bde2334e73da0799$var$ei = !1, $bde2334e73da0799$var$ci = a;
    }
}
function $bde2334e73da0799$var$ji(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $bde2334e73da0799$var$ci = a;
}
function $bde2334e73da0799$var$ki(a) {
    if (a !== $bde2334e73da0799$var$ci) return !1;
    if (!$bde2334e73da0799$var$ei) return $bde2334e73da0799$var$ji(a), $bde2334e73da0799$var$ei = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$bde2334e73da0799$var$oe(b, a.memoizedProps)) for(b = $bde2334e73da0799$var$di; b;)$bde2334e73da0799$var$fi(a, b), b = $bde2334e73da0799$var$re(b.nextSibling);
    $bde2334e73da0799$var$ji(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($bde2334e73da0799$var$u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === $bde2334e73da0799$var$ie) {
                        if (0 === b) {
                            $bde2334e73da0799$var$di = $bde2334e73da0799$var$re(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== $bde2334e73da0799$var$he && c !== $bde2334e73da0799$var$ke && c !== $bde2334e73da0799$var$je || b++;
                }
                a = a.nextSibling;
            }
            $bde2334e73da0799$var$di = null;
        }
    } else $bde2334e73da0799$var$di = $bde2334e73da0799$var$ci ? $bde2334e73da0799$var$re(a.stateNode.nextSibling) : null;
    return !0;
}
function $bde2334e73da0799$var$li() {
    $bde2334e73da0799$var$di = $bde2334e73da0799$var$ci = null;
    $bde2334e73da0799$var$ei = !1;
}
var $bde2334e73da0799$var$mi = $bde2334e73da0799$var$Ea.ReactCurrentOwner, $bde2334e73da0799$var$wg = !1;
function $bde2334e73da0799$var$R(a, b, c, d) {
    b.child = null === a ? $bde2334e73da0799$var$gh(b, null, c, d) : $bde2334e73da0799$var$fh(b, a.child, c, d);
}
function $bde2334e73da0799$var$ni(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $bde2334e73da0799$var$vg(b, e);
    d = $bde2334e73da0799$var$Ih(a, b, c, d, f, e);
    if (null !== a && !$bde2334e73da0799$var$wg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $bde2334e73da0799$var$oi(a, b, e);
    b.effectTag |= 1;
    $bde2334e73da0799$var$R(a, b, d, e);
    return b.child;
}
function $bde2334e73da0799$var$pi(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !$bde2334e73da0799$var$qi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, $bde2334e73da0799$var$ri(a, b, g, d, e, f);
        a = $bde2334e73da0799$var$ch(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : $bde2334e73da0799$var$qf, c(e, d) && a.ref === b.ref)) return $bde2334e73da0799$var$oi(a, b, f);
    b.effectTag |= 1;
    a = $bde2334e73da0799$var$ah(g, d, f);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $bde2334e73da0799$var$ri(a, b, c, d, e, f) {
    return null !== a && $bde2334e73da0799$var$qf(a.memoizedProps, d) && a.ref === b.ref && ($bde2334e73da0799$var$wg = !1, e < f) ? $bde2334e73da0799$var$oi(a, b, f) : $bde2334e73da0799$var$si(a, b, c, d, f);
}
function $bde2334e73da0799$var$ti(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function $bde2334e73da0799$var$si(a, b, c, d, e) {
    var f = $bde2334e73da0799$var$L(c) ? $bde2334e73da0799$var$Df : $bde2334e73da0799$var$J.current;
    f = $bde2334e73da0799$var$Ef(b, f);
    $bde2334e73da0799$var$vg(b, e);
    c = $bde2334e73da0799$var$Ih(a, b, c, d, f, e);
    if (null !== a && !$bde2334e73da0799$var$wg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $bde2334e73da0799$var$oi(a, b, e);
    b.effectTag |= 1;
    $bde2334e73da0799$var$R(a, b, c, e);
    return b.child;
}
function $bde2334e73da0799$var$ui(a, b, c, d, e) {
    if ($bde2334e73da0799$var$L(c)) {
        var f = !0;
        $bde2334e73da0799$var$Jf(b);
    } else f = !1;
    $bde2334e73da0799$var$vg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), $bde2334e73da0799$var$Ug(b, c, d, e), $bde2334e73da0799$var$Wg(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $bde2334e73da0799$var$xg(l) : (l = $bde2334e73da0799$var$L(c) ? $bde2334e73da0799$var$Df : $bde2334e73da0799$var$J.current, l = $bde2334e73da0799$var$Ef(b, l));
        var m = c.getDerivedStateFromProps, C = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        C || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $bde2334e73da0799$var$Vg(b, g, d, l);
        $bde2334e73da0799$var$yg = !1;
        var y = b.memoizedState;
        k = g.state = y;
        var H = b.updateQueue;
        null !== H && ($bde2334e73da0799$var$Hg(b, H, d, g, e), k = b.memoizedState);
        h !== d || y !== k || $bde2334e73da0799$var$K.current || $bde2334e73da0799$var$yg ? ("function" === typeof m && ($bde2334e73da0799$var$Og(b, c, m, d), k = b.memoizedState), (h = $bde2334e73da0799$var$yg || $bde2334e73da0799$var$Tg(b, c, h, d, y, k, l)) ? (C || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, h = b.memoizedProps, g.props = b.type === b.elementType ? h : $bde2334e73da0799$var$mg(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = $bde2334e73da0799$var$xg(l) : (l = $bde2334e73da0799$var$L(c) ? $bde2334e73da0799$var$Df : $bde2334e73da0799$var$J.current, l = $bde2334e73da0799$var$Ef(b, l)), m = c.getDerivedStateFromProps, (C = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $bde2334e73da0799$var$Vg(b, g, d, l), $bde2334e73da0799$var$yg = !1, k = b.memoizedState, y = g.state = k, H = b.updateQueue, null !== H && ($bde2334e73da0799$var$Hg(b, H, d, g, e), y = b.memoizedState), h !== d || k !== y || $bde2334e73da0799$var$K.current || $bde2334e73da0799$var$yg ? ("function" === typeof m && ($bde2334e73da0799$var$Og(b, c, m, d), y = b.memoizedState), (m = $bde2334e73da0799$var$yg || $bde2334e73da0799$var$Tg(b, c, h, d, k, y, l)) ? (C || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, y, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, y, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = y), g.props = d, g.state = y, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return $bde2334e73da0799$var$vi(a, b, c, d, f, e);
}
function $bde2334e73da0799$var$vi(a, b, c, d, e, f) {
    $bde2334e73da0799$var$ti(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && $bde2334e73da0799$var$Kf(b, c, !1), $bde2334e73da0799$var$oi(a, b, f);
    d = b.stateNode;
    $bde2334e73da0799$var$mi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = $bde2334e73da0799$var$fh(b, a.child, null, f), b.child = $bde2334e73da0799$var$fh(b, null, h, f)) : $bde2334e73da0799$var$R(a, b, h, f);
    b.memoizedState = d.state;
    e && $bde2334e73da0799$var$Kf(b, c, !0);
    return b.child;
}
function $bde2334e73da0799$var$wi(a) {
    var b = a.stateNode;
    b.pendingContext ? $bde2334e73da0799$var$Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $bde2334e73da0799$var$Hf(a, b.context, !1);
    $bde2334e73da0799$var$mh(a, b.containerInfo);
}
var $bde2334e73da0799$var$xi = {
    dehydrated: null,
    retryTime: 0
};
function $bde2334e73da0799$var$yi(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = $bde2334e73da0799$var$M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    $bde2334e73da0799$var$I($bde2334e73da0799$var$M, f & 1, b);
    if (null === a) {
        void 0 !== e.fallback && $bde2334e73da0799$var$ii(b);
        if (g) {
            g = e.fallback;
            e = $bde2334e73da0799$var$eh(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = $bde2334e73da0799$var$eh(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = $bde2334e73da0799$var$xi;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = $bde2334e73da0799$var$gh(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = $bde2334e73da0799$var$ah(a, a.pendingProps, 0);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = $bde2334e73da0799$var$ah(d, e, d.expirationTime);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = $bde2334e73da0799$var$xi;
            b.child = c;
            return d;
        }
        c = $bde2334e73da0799$var$fh(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = $bde2334e73da0799$var$eh(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = $bde2334e73da0799$var$eh(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = $bde2334e73da0799$var$xi;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = $bde2334e73da0799$var$fh(b, a, e.children, c);
}
function $bde2334e73da0799$var$zi(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    $bde2334e73da0799$var$ug(a.return, b);
}
function $bde2334e73da0799$var$Ai(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function $bde2334e73da0799$var$Bi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $bde2334e73da0799$var$R(a, b, d.children, c);
    d = $bde2334e73da0799$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $bde2334e73da0799$var$zi(a, c);
            else if (19 === a.tag) $bde2334e73da0799$var$zi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $bde2334e73da0799$var$I($bde2334e73da0799$var$M, d, b);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $bde2334e73da0799$var$qh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $bde2334e73da0799$var$Ai(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $bde2334e73da0799$var$qh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $bde2334e73da0799$var$Ai(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            $bde2334e73da0799$var$Ai(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $bde2334e73da0799$var$oi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && $bde2334e73da0799$var$Jg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error($bde2334e73da0799$var$u(153));
    if (null !== b.child) {
        a = b.child;
        c = $bde2334e73da0799$var$ah(a, a.pendingProps, a.expirationTime);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $bde2334e73da0799$var$ah(a, a.pendingProps, a.expirationTime), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $bde2334e73da0799$var$Ci(a) {
    a.effectTag |= 4;
}
var $bde2334e73da0799$var$Hi, $bde2334e73da0799$var$Ii, $bde2334e73da0799$var$Ji, $bde2334e73da0799$var$Ki;
$bde2334e73da0799$var$Hi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$bde2334e73da0799$var$Ii = function() {};
$bde2334e73da0799$var$Ji = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        $bde2334e73da0799$var$lh($bde2334e73da0799$var$ih.current);
        a = null;
        switch(c){
            case "input":
                f = $bde2334e73da0799$var$Ab(g, f);
                d = $bde2334e73da0799$var$Ab(g, d);
                a = [];
                break;
            case "option":
                f = $bde2334e73da0799$var$Ib(g, f);
                d = $bde2334e73da0799$var$Ib(g, d);
                a = [];
                break;
            case "select":
                f = $fve7V({}, f, {
                    value: void 0
                });
                d = $fve7V({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = $bde2334e73da0799$var$Kb(g, f);
                d = $bde2334e73da0799$var$Kb(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = $bde2334e73da0799$var$ae);
        }
        $bde2334e73da0799$var$Yd(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && ($bde2334e73da0799$var$ia.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, "" + l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && ($bde2334e73da0799$var$ia.hasOwnProperty(h) ? (null != l && $bde2334e73da0799$var$$d(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        (b.updateQueue = e) && $bde2334e73da0799$var$Ci(b);
    }
};
$bde2334e73da0799$var$Ki = function(a, b, c, d) {
    c !== d && $bde2334e73da0799$var$Ci(b);
};
function $bde2334e73da0799$var$Li(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $bde2334e73da0799$var$Mi(a) {
    switch(a.tag){
        case 1:
            $bde2334e73da0799$var$L(a.type) && $bde2334e73da0799$var$Ff(a);
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            $bde2334e73da0799$var$nh(a);
            $bde2334e73da0799$var$Gf(a);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error($bde2334e73da0799$var$u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return $bde2334e73da0799$var$ph(a), null;
        case 13:
            return $bde2334e73da0799$var$G($bde2334e73da0799$var$M, a), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return $bde2334e73da0799$var$G($bde2334e73da0799$var$M, a), null;
        case 4:
            return $bde2334e73da0799$var$nh(a), null;
        case 10:
            return $bde2334e73da0799$var$tg(a), null;
        default:
            return null;
    }
}
function $bde2334e73da0799$var$Ni(a, b) {
    return {
        value: a,
        source: b,
        stack: $bde2334e73da0799$var$Xa(b)
    };
}
var $bde2334e73da0799$var$Oi = "function" === typeof WeakSet ? WeakSet : Set;
function $bde2334e73da0799$var$Pi(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = $bde2334e73da0799$var$Xa(c));
    null !== c && $bde2334e73da0799$var$Wa(c.type);
    b = b.value;
    null !== a && 1 === a.tag && $bde2334e73da0799$var$Wa(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function $bde2334e73da0799$var$Qi(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        $bde2334e73da0799$var$Ri(a, c);
    }
}
function $bde2334e73da0799$var$Si(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            $bde2334e73da0799$var$Ri(a, c);
        }
        else b.current = null;
    }
}
function $bde2334e73da0799$var$Ti(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
            $bde2334e73da0799$var$Ui(2, 0, b);
            break;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : $bde2334e73da0799$var$mg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            break;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            break;
        default:
            throw Error($bde2334e73da0799$var$u(163));
    }
}
function $bde2334e73da0799$var$Ui(a, b, c) {
    c = c.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if (0 !== (d.tag & a)) {
                var e = d.destroy;
                d.destroy = void 0;
                void 0 !== e && e();
            }
            0 !== (d.tag & b) && (e = d.create, d.destroy = e());
            d = d.next;
        }while (d !== c);
    }
}
function $bde2334e73da0799$var$Vi(a, b, c) {
    "function" === typeof $bde2334e73da0799$var$Wi && $bde2334e73da0799$var$Wi(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                $bde2334e73da0799$var$fg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                $bde2334e73da0799$var$Ri(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            $bde2334e73da0799$var$Si(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && $bde2334e73da0799$var$Qi(b, c);
            break;
        case 5:
            $bde2334e73da0799$var$Si(b);
            break;
        case 4:
            $bde2334e73da0799$var$Xi(a, b, c);
    }
}
function $bde2334e73da0799$var$Yi(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    null !== b && $bde2334e73da0799$var$Yi(b);
}
function $bde2334e73da0799$var$Zi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $bde2334e73da0799$var$$i(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($bde2334e73da0799$var$Zi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error($bde2334e73da0799$var$u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error($bde2334e73da0799$var$u(161));
    }
    c.effectTag & 16 && ($bde2334e73da0799$var$Tb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || $bde2334e73da0799$var$Zi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    for(var e = a;;){
        var f = 5 === e.tag || 6 === e.tag;
        if (f) {
            var g = f ? e.stateNode : e.stateNode.instance;
            if (c) {
                if (d) {
                    f = b;
                    var h = g;
                    g = c;
                    8 === f.nodeType ? f.parentNode.insertBefore(h, g) : f.insertBefore(h, g);
                } else b.insertBefore(g, c);
            } else d ? (h = b, 8 === h.nodeType ? (f = h.parentNode, f.insertBefore(g, h)) : (f = h, f.appendChild(g)), h = h._reactRootContainer, null !== h && void 0 !== h || null !== f.onclick || (f.onclick = $bde2334e73da0799$var$ae)) : b.appendChild(g);
        } else if (4 !== e.tag && null !== e.child) {
            e.child.return = e;
            e = e.child;
            continue;
        }
        if (e === a) break;
        for(; null === e.sibling;){
            if (null === e.return || e.return === a) return;
            e = e.return;
        }
        e.sibling.return = e.return;
        e = e.sibling;
    }
}
function $bde2334e73da0799$var$Xi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error($bde2334e73da0799$var$u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if ($bde2334e73da0799$var$Vi(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if ($bde2334e73da0799$var$Vi(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function $bde2334e73da0799$var$aj(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $bde2334e73da0799$var$Ui(4, 8, b);
            break;
        case 1:
            break;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[$bde2334e73da0799$var$ve] = d;
                    "input" === a && "radio" === d.type && null != d.name && $bde2334e73da0799$var$Cb(c, d);
                    $bde2334e73da0799$var$Zd(a, e);
                    b = $bde2334e73da0799$var$Zd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? $bde2334e73da0799$var$Wd(c, h) : "dangerouslySetInnerHTML" === g ? $bde2334e73da0799$var$Sb(c, h) : "children" === g ? $bde2334e73da0799$var$Tb(c, h) : $bde2334e73da0799$var$vb(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            $bde2334e73da0799$var$Eb(c, d);
                            break;
                        case "textarea":
                            $bde2334e73da0799$var$Mb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? $bde2334e73da0799$var$Jb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? $bde2334e73da0799$var$Jb(c, !!d.multiple, d.defaultValue, !0) : $bde2334e73da0799$var$Jb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            break;
        case 6:
            if (null === b.stateNode) throw Error($bde2334e73da0799$var$u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            break;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, $bde2334e73da0799$var$Lc(b.containerInfo));
            break;
        case 12:
            break;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, $bde2334e73da0799$var$bj = $bde2334e73da0799$var$cg());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = $bde2334e73da0799$var$Vd("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break a;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            $bde2334e73da0799$var$cj(b);
            break;
        case 19:
            $bde2334e73da0799$var$cj(b);
            break;
        case 17:
            break;
        case 20:
            break;
        case 21:
            break;
        default:
            throw Error($bde2334e73da0799$var$u(163));
    }
}
function $bde2334e73da0799$var$cj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $bde2334e73da0799$var$Oi);
        b.forEach(function(b) {
            var d = $bde2334e73da0799$var$dj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var $bde2334e73da0799$var$ej = "function" === typeof WeakMap ? WeakMap : Map;
function $bde2334e73da0799$var$fj(a, b, c) {
    c = $bde2334e73da0799$var$Bg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $bde2334e73da0799$var$gj || ($bde2334e73da0799$var$gj = !0, $bde2334e73da0799$var$hj = d);
        $bde2334e73da0799$var$Pi(a, b);
    };
    return c;
}
function $bde2334e73da0799$var$ij(a, b, c) {
    c = $bde2334e73da0799$var$Bg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            $bde2334e73da0799$var$Pi(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === $bde2334e73da0799$var$jj ? $bde2334e73da0799$var$jj = new Set([
            this
        ]) : $bde2334e73da0799$var$jj.add(this), $bde2334e73da0799$var$Pi(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var $bde2334e73da0799$var$kj = Math.ceil, $bde2334e73da0799$var$lj = $bde2334e73da0799$var$Ea.ReactCurrentDispatcher, $bde2334e73da0799$var$mj = $bde2334e73da0799$var$Ea.ReactCurrentOwner, $bde2334e73da0799$var$S = 0, $bde2334e73da0799$var$nj = 8, $bde2334e73da0799$var$oj = 16, $bde2334e73da0799$var$pj = 32, $bde2334e73da0799$var$qj = 0, $bde2334e73da0799$var$rj = 1, $bde2334e73da0799$var$sj = 2, $bde2334e73da0799$var$tj = 3, $bde2334e73da0799$var$uj = 4, $bde2334e73da0799$var$vj = 5, $bde2334e73da0799$var$T = $bde2334e73da0799$var$S, $bde2334e73da0799$var$U = null, $bde2334e73da0799$var$V = null, $bde2334e73da0799$var$W = 0, $bde2334e73da0799$var$X = $bde2334e73da0799$var$qj, $bde2334e73da0799$var$wj = null, $bde2334e73da0799$var$xj = 1073741823, $bde2334e73da0799$var$yj = 1073741823, $bde2334e73da0799$var$zj = null, $bde2334e73da0799$var$Aj = 0, $bde2334e73da0799$var$Bj = !1, $bde2334e73da0799$var$bj = 0, $bde2334e73da0799$var$Cj = 500, $bde2334e73da0799$var$Y = null, $bde2334e73da0799$var$gj = !1, $bde2334e73da0799$var$hj = null, $bde2334e73da0799$var$jj = null, $bde2334e73da0799$var$Dj = !1, $bde2334e73da0799$var$Ej = null, $bde2334e73da0799$var$Fj = 90, $bde2334e73da0799$var$Gj = null, $bde2334e73da0799$var$Hj = 0, $bde2334e73da0799$var$Ij = null, $bde2334e73da0799$var$Jj = 0;
function $bde2334e73da0799$var$Pg() {
    return ($bde2334e73da0799$var$T & ($bde2334e73da0799$var$oj | $bde2334e73da0799$var$pj)) !== $bde2334e73da0799$var$S ? 1073741821 - ($bde2334e73da0799$var$cg() / 10 | 0) : 0 !== $bde2334e73da0799$var$Jj ? $bde2334e73da0799$var$Jj : $bde2334e73da0799$var$Jj = 1073741821 - ($bde2334e73da0799$var$cg() / 10 | 0);
}
function $bde2334e73da0799$var$Qg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = $bde2334e73da0799$var$dg();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if (($bde2334e73da0799$var$T & $bde2334e73da0799$var$oj) !== $bde2334e73da0799$var$S) return $bde2334e73da0799$var$W;
    if (null !== c) a = $bde2334e73da0799$var$lg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = $bde2334e73da0799$var$lg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = $bde2334e73da0799$var$lg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error($bde2334e73da0799$var$u(326));
    }
    null !== $bde2334e73da0799$var$U && a === $bde2334e73da0799$var$W && --a;
    return a;
}
function $bde2334e73da0799$var$Rg(a, b) {
    if (50 < $bde2334e73da0799$var$Hj) throw $bde2334e73da0799$var$Hj = 0, $bde2334e73da0799$var$Ij = null, Error($bde2334e73da0799$var$u(185));
    a = $bde2334e73da0799$var$Kj(a, b);
    if (null !== a) {
        var c = $bde2334e73da0799$var$dg();
        1073741823 === b ? ($bde2334e73da0799$var$T & $bde2334e73da0799$var$nj) !== $bde2334e73da0799$var$S && ($bde2334e73da0799$var$T & ($bde2334e73da0799$var$oj | $bde2334e73da0799$var$pj)) === $bde2334e73da0799$var$S ? $bde2334e73da0799$var$Lj(a) : ($bde2334e73da0799$var$Z(a), $bde2334e73da0799$var$T === $bde2334e73da0799$var$S && $bde2334e73da0799$var$jg()) : $bde2334e73da0799$var$Z(a);
        ($bde2334e73da0799$var$T & 4) === $bde2334e73da0799$var$S || 98 !== c && 99 !== c || (null === $bde2334e73da0799$var$Gj ? $bde2334e73da0799$var$Gj = new Map([
            [
                a,
                b
            ]
        ]) : (c = $bde2334e73da0799$var$Gj.get(a), (void 0 === c || c > b) && $bde2334e73da0799$var$Gj.set(a, b)));
    }
}
function $bde2334e73da0799$var$Kj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && ($bde2334e73da0799$var$U === e && ($bde2334e73da0799$var$Jg(b), $bde2334e73da0799$var$X === $bde2334e73da0799$var$uj && $bde2334e73da0799$var$Mj(e, $bde2334e73da0799$var$W)), $bde2334e73da0799$var$Nj(e, b));
    return e;
}
function $bde2334e73da0799$var$Oj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!$bde2334e73da0799$var$Pj(a, b)) return b;
    b = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    return b > a ? b : a;
}
function $bde2334e73da0799$var$Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = $bde2334e73da0799$var$hg($bde2334e73da0799$var$Lj.bind(null, a));
    else {
        var b = $bde2334e73da0799$var$Oj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = $bde2334e73da0799$var$Pg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== $bde2334e73da0799$var$Xf && $bde2334e73da0799$var$Nf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? $bde2334e73da0799$var$hg($bde2334e73da0799$var$Lj.bind(null, a)) : $bde2334e73da0799$var$gg(d, $bde2334e73da0799$var$Qj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $bde2334e73da0799$var$cg()
            });
            a.callbackNode = b;
        }
    }
}
function $bde2334e73da0799$var$Qj(a, b) {
    $bde2334e73da0799$var$Jj = 0;
    if (b) return b = $bde2334e73da0799$var$Pg(), $bde2334e73da0799$var$Rj(a, b), $bde2334e73da0799$var$Z(a), null;
    var c = $bde2334e73da0799$var$Oj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if (($bde2334e73da0799$var$T & ($bde2334e73da0799$var$oj | $bde2334e73da0799$var$pj)) !== $bde2334e73da0799$var$S) throw Error($bde2334e73da0799$var$u(327));
        $bde2334e73da0799$var$Sj();
        a === $bde2334e73da0799$var$U && c === $bde2334e73da0799$var$W || $bde2334e73da0799$var$Tj(a, c);
        if (null !== $bde2334e73da0799$var$V) {
            var d = $bde2334e73da0799$var$T;
            $bde2334e73da0799$var$T |= $bde2334e73da0799$var$oj;
            var e = $bde2334e73da0799$var$Uj(a);
            for(;;)try {
                $bde2334e73da0799$var$Vj();
                break;
            } catch (h) {
                $bde2334e73da0799$var$Wj(a, h);
            }
            $bde2334e73da0799$var$rg();
            $bde2334e73da0799$var$T = d;
            $bde2334e73da0799$var$lj.current = e;
            if ($bde2334e73da0799$var$X === $bde2334e73da0799$var$rj) throw b = $bde2334e73da0799$var$wj, $bde2334e73da0799$var$Tj(a, c), $bde2334e73da0799$var$Mj(a, c), $bde2334e73da0799$var$Z(a), b;
            if (null === $bde2334e73da0799$var$V) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = $bde2334e73da0799$var$X, $bde2334e73da0799$var$U = null, d){
                case $bde2334e73da0799$var$qj:
                case $bde2334e73da0799$var$rj:
                    throw Error($bde2334e73da0799$var$u(345));
                case $bde2334e73da0799$var$sj:
                    $bde2334e73da0799$var$Rj(a, 2 < c ? 2 : c);
                    break;
                case $bde2334e73da0799$var$tj:
                    $bde2334e73da0799$var$Mj(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = $bde2334e73da0799$var$Xj(e));
                    if (1073741823 === $bde2334e73da0799$var$xj && (e = $bde2334e73da0799$var$bj + $bde2334e73da0799$var$Cj - $bde2334e73da0799$var$cg(), 10 < e)) {
                        if ($bde2334e73da0799$var$Bj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                $bde2334e73da0799$var$Tj(a, c);
                                break;
                            }
                        }
                        f = $bde2334e73da0799$var$Oj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = $bde2334e73da0799$var$pe($bde2334e73da0799$var$Yj.bind(null, a), e);
                        break;
                    }
                    $bde2334e73da0799$var$Yj(a);
                    break;
                case $bde2334e73da0799$var$uj:
                    $bde2334e73da0799$var$Mj(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = $bde2334e73da0799$var$Xj(e));
                    if ($bde2334e73da0799$var$Bj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        $bde2334e73da0799$var$Tj(a, c);
                        break;
                    }
                    e = $bde2334e73da0799$var$Oj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== $bde2334e73da0799$var$yj ? d = 10 * (1073741821 - $bde2334e73da0799$var$yj) - $bde2334e73da0799$var$cg() : 1073741823 === $bde2334e73da0799$var$xj ? d = 0 : (d = 10 * (1073741821 - $bde2334e73da0799$var$xj) - 5E3, e = $bde2334e73da0799$var$cg(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $bde2334e73da0799$var$kj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = $bde2334e73da0799$var$pe($bde2334e73da0799$var$Yj.bind(null, a), d);
                        break;
                    }
                    $bde2334e73da0799$var$Yj(a);
                    break;
                case $bde2334e73da0799$var$vj:
                    if (1073741823 !== $bde2334e73da0799$var$xj && null !== $bde2334e73da0799$var$zj) {
                        f = $bde2334e73da0799$var$xj;
                        var g = $bde2334e73da0799$var$zj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $bde2334e73da0799$var$cg() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            $bde2334e73da0799$var$Mj(a, c);
                            a.timeoutHandle = $bde2334e73da0799$var$pe($bde2334e73da0799$var$Yj.bind(null, a), d);
                            break;
                        }
                    }
                    $bde2334e73da0799$var$Yj(a);
                    break;
                default:
                    throw Error($bde2334e73da0799$var$u(329));
            }
            $bde2334e73da0799$var$Z(a);
            if (a.callbackNode === b) return $bde2334e73da0799$var$Qj.bind(null, a);
        }
    }
    return null;
}
function $bde2334e73da0799$var$Lj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if (a.finishedExpirationTime === b) $bde2334e73da0799$var$Yj(a);
    else {
        if (($bde2334e73da0799$var$T & ($bde2334e73da0799$var$oj | $bde2334e73da0799$var$pj)) !== $bde2334e73da0799$var$S) throw Error($bde2334e73da0799$var$u(327));
        $bde2334e73da0799$var$Sj();
        a === $bde2334e73da0799$var$U && b === $bde2334e73da0799$var$W || $bde2334e73da0799$var$Tj(a, b);
        if (null !== $bde2334e73da0799$var$V) {
            var c = $bde2334e73da0799$var$T;
            $bde2334e73da0799$var$T |= $bde2334e73da0799$var$oj;
            var d = $bde2334e73da0799$var$Uj(a);
            for(;;)try {
                $bde2334e73da0799$var$Zj();
                break;
            } catch (e) {
                $bde2334e73da0799$var$Wj(a, e);
            }
            $bde2334e73da0799$var$rg();
            $bde2334e73da0799$var$T = c;
            $bde2334e73da0799$var$lj.current = d;
            if ($bde2334e73da0799$var$X === $bde2334e73da0799$var$rj) throw c = $bde2334e73da0799$var$wj, $bde2334e73da0799$var$Tj(a, b), $bde2334e73da0799$var$Mj(a, b), $bde2334e73da0799$var$Z(a), c;
            if (null !== $bde2334e73da0799$var$V) throw Error($bde2334e73da0799$var$u(261));
            a.finishedWork = a.current.alternate;
            a.finishedExpirationTime = b;
            $bde2334e73da0799$var$U = null;
            $bde2334e73da0799$var$Yj(a);
            $bde2334e73da0799$var$Z(a);
        }
    }
    return null;
}
function $bde2334e73da0799$var$ak() {
    if (null !== $bde2334e73da0799$var$Gj) {
        var a = $bde2334e73da0799$var$Gj;
        $bde2334e73da0799$var$Gj = null;
        a.forEach(function(a, c) {
            $bde2334e73da0799$var$Rj(c, a);
            $bde2334e73da0799$var$Z(c);
        });
        $bde2334e73da0799$var$jg();
    }
}
function $bde2334e73da0799$var$bk(a, b) {
    var c = $bde2334e73da0799$var$T;
    $bde2334e73da0799$var$T |= 1;
    try {
        return a(b);
    } finally{
        $bde2334e73da0799$var$T = c, $bde2334e73da0799$var$T === $bde2334e73da0799$var$S && $bde2334e73da0799$var$jg();
    }
}
function $bde2334e73da0799$var$ck(a, b) {
    var c = $bde2334e73da0799$var$T;
    $bde2334e73da0799$var$T &= -2;
    $bde2334e73da0799$var$T |= $bde2334e73da0799$var$nj;
    try {
        return a(b);
    } finally{
        $bde2334e73da0799$var$T = c, $bde2334e73da0799$var$T === $bde2334e73da0799$var$S && $bde2334e73da0799$var$jg();
    }
}
function $bde2334e73da0799$var$Tj(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $bde2334e73da0799$var$qe(c));
    if (null !== $bde2334e73da0799$var$V) for(c = $bde2334e73da0799$var$V.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                var e = d.type.childContextTypes;
                null !== e && void 0 !== e && $bde2334e73da0799$var$Ff(d);
                break;
            case 3:
                $bde2334e73da0799$var$nh(d);
                $bde2334e73da0799$var$Gf(d);
                break;
            case 5:
                $bde2334e73da0799$var$ph(d);
                break;
            case 4:
                $bde2334e73da0799$var$nh(d);
                break;
            case 13:
                $bde2334e73da0799$var$G($bde2334e73da0799$var$M, d);
                break;
            case 19:
                $bde2334e73da0799$var$G($bde2334e73da0799$var$M, d);
                break;
            case 10:
                $bde2334e73da0799$var$tg(d);
        }
        c = c.return;
    }
    $bde2334e73da0799$var$U = a;
    $bde2334e73da0799$var$V = $bde2334e73da0799$var$ah(a.current, null, b);
    $bde2334e73da0799$var$W = b;
    $bde2334e73da0799$var$X = $bde2334e73da0799$var$qj;
    $bde2334e73da0799$var$wj = null;
    $bde2334e73da0799$var$yj = $bde2334e73da0799$var$xj = 1073741823;
    $bde2334e73da0799$var$zj = null;
    $bde2334e73da0799$var$Aj = 0;
    $bde2334e73da0799$var$Bj = !1;
}
function $bde2334e73da0799$var$Wj(a, b) {
    do {
        try {
            $bde2334e73da0799$var$rg();
            $bde2334e73da0799$var$Mh();
            if (null === $bde2334e73da0799$var$V || null === $bde2334e73da0799$var$V.return) return $bde2334e73da0799$var$X = $bde2334e73da0799$var$rj, $bde2334e73da0799$var$wj = b, null;
            a: {
                var c = a, d = $bde2334e73da0799$var$V.return, e = $bde2334e73da0799$var$V, f = b;
                b = $bde2334e73da0799$var$W;
                e.effectTag |= 2048;
                e.firstEffect = e.lastEffect = null;
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var g = f, h = 0 !== ($bde2334e73da0799$var$M.current & 1), k = d;
                    do {
                        var l;
                        if (l = 13 === k.tag) {
                            var m = k.memoizedState;
                            if (null !== m) l = null !== m.dehydrated ? !0 : !1;
                            else {
                                var C = k.memoizedProps;
                                l = void 0 === C.fallback ? !1 : !0 !== C.unstable_avoidThisFallback ? !0 : h ? !1 : !0;
                            }
                        }
                        if (l) {
                            var y = k.updateQueue;
                            if (null === y) {
                                var H = new Set;
                                H.add(g);
                                k.updateQueue = H;
                            } else y.add(g);
                            if (0 === (k.mode & 2)) {
                                k.effectTag |= 64;
                                e.effectTag &= -2981;
                                if (1 === e.tag) {
                                    if (null === e.alternate) e.tag = 17;
                                    else {
                                        var z = $bde2334e73da0799$var$Bg(1073741823, null);
                                        z.tag = 2;
                                        $bde2334e73da0799$var$Dg(e, z);
                                    }
                                }
                                e.expirationTime = 1073741823;
                                break a;
                            }
                            f = void 0;
                            e = b;
                            var ta = c.pingCache;
                            null === ta ? (ta = c.pingCache = new $bde2334e73da0799$var$ej, f = new Set, ta.set(g, f)) : (f = ta.get(g), void 0 === f && (f = new Set, ta.set(g, f)));
                            if (!f.has(e)) {
                                f.add(e);
                                var r = $bde2334e73da0799$var$dk.bind(null, c, g, e);
                                g.then(r, r);
                            }
                            k.effectTag |= 4096;
                            k.expirationTime = b;
                            break a;
                        }
                        k = k.return;
                    }while (null !== k);
                    f = Error(($bde2334e73da0799$var$Wa(e.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + $bde2334e73da0799$var$Xa(e));
                }
                $bde2334e73da0799$var$X !== $bde2334e73da0799$var$vj && ($bde2334e73da0799$var$X = $bde2334e73da0799$var$sj);
                f = $bde2334e73da0799$var$Ni(f, e);
                k = d;
                do {
                    switch(k.tag){
                        case 3:
                            g = f;
                            k.effectTag |= 4096;
                            k.expirationTime = b;
                            var x = $bde2334e73da0799$var$fj(k, g, b);
                            $bde2334e73da0799$var$Eg(k, x);
                            break a;
                        case 1:
                            g = f;
                            var A = k.type, p = k.stateNode;
                            if (0 === (k.effectTag & 64) && ("function" === typeof A.getDerivedStateFromError || null !== p && "function" === typeof p.componentDidCatch && (null === $bde2334e73da0799$var$jj || !$bde2334e73da0799$var$jj.has(p)))) {
                                k.effectTag |= 4096;
                                k.expirationTime = b;
                                var t = $bde2334e73da0799$var$ij(k, g, b);
                                $bde2334e73da0799$var$Eg(k, t);
                                break a;
                            }
                    }
                    k = k.return;
                }while (null !== k);
            }
            $bde2334e73da0799$var$V = $bde2334e73da0799$var$ek($bde2334e73da0799$var$V);
        } catch (v) {
            b = v;
            continue;
        }
        break;
    }while (1);
}
function $bde2334e73da0799$var$Uj() {
    var a = $bde2334e73da0799$var$lj.current;
    $bde2334e73da0799$var$lj.current = $bde2334e73da0799$var$Lh;
    return null === a ? $bde2334e73da0799$var$Lh : a;
}
function $bde2334e73da0799$var$Ig(a, b) {
    a < $bde2334e73da0799$var$xj && 2 < a && ($bde2334e73da0799$var$xj = a);
    null !== b && a < $bde2334e73da0799$var$yj && 2 < a && ($bde2334e73da0799$var$yj = a, $bde2334e73da0799$var$zj = b);
}
function $bde2334e73da0799$var$Jg(a) {
    a > $bde2334e73da0799$var$Aj && ($bde2334e73da0799$var$Aj = a);
}
function $bde2334e73da0799$var$Zj() {
    for(; null !== $bde2334e73da0799$var$V;)$bde2334e73da0799$var$V = $bde2334e73da0799$var$fk($bde2334e73da0799$var$V);
}
function $bde2334e73da0799$var$Vj() {
    for(; null !== $bde2334e73da0799$var$V && !$bde2334e73da0799$var$Of();)$bde2334e73da0799$var$V = $bde2334e73da0799$var$fk($bde2334e73da0799$var$V);
}
function $bde2334e73da0799$var$fk(a) {
    var b = $bde2334e73da0799$var$gk(a.alternate, a, $bde2334e73da0799$var$W);
    a.memoizedProps = a.pendingProps;
    null === b && (b = $bde2334e73da0799$var$ek(a));
    $bde2334e73da0799$var$mj.current = null;
    return b;
}
function $bde2334e73da0799$var$ek(a) {
    $bde2334e73da0799$var$V = a;
    do {
        var b = $bde2334e73da0799$var$V.alternate;
        a = $bde2334e73da0799$var$V.return;
        if (0 === ($bde2334e73da0799$var$V.effectTag & 2048)) {
            a: {
                var c = b;
                b = $bde2334e73da0799$var$V;
                var d = $bde2334e73da0799$var$W;
                var e = b.pendingProps;
                switch(b.tag){
                    case 2:
                        break;
                    case 16:
                        break;
                    case 15:
                    case 0:
                        break;
                    case 1:
                        $bde2334e73da0799$var$L(b.type) && $bde2334e73da0799$var$Ff(b);
                        break;
                    case 3:
                        $bde2334e73da0799$var$nh(b);
                        $bde2334e73da0799$var$Gf(b);
                        e = b.stateNode;
                        e.pendingContext && (e.context = e.pendingContext, e.pendingContext = null);
                        (null === c || null === c.child) && $bde2334e73da0799$var$ki(b) && $bde2334e73da0799$var$Ci(b);
                        $bde2334e73da0799$var$Ii(b);
                        break;
                    case 5:
                        $bde2334e73da0799$var$ph(b);
                        d = $bde2334e73da0799$var$lh($bde2334e73da0799$var$kh.current);
                        var f = b.type;
                        if (null !== c && null != b.stateNode) $bde2334e73da0799$var$Ji(c, b, f, e, d), c.ref !== b.ref && (b.effectTag |= 128);
                        else if (e) {
                            var g = $bde2334e73da0799$var$lh($bde2334e73da0799$var$ih.current);
                            if ($bde2334e73da0799$var$ki(b)) {
                                e = b;
                                var h = e.stateNode;
                                c = e.type;
                                var k = e.memoizedProps, l = d;
                                h[$bde2334e73da0799$var$ue] = e;
                                h[$bde2334e73da0799$var$ve] = k;
                                f = void 0;
                                d = h;
                                switch(c){
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        $bde2334e73da0799$var$F("load", d);
                                        break;
                                    case "video":
                                    case "audio":
                                        for(h = 0; h < $bde2334e73da0799$var$cc.length; h++)$bde2334e73da0799$var$F($bde2334e73da0799$var$cc[h], d);
                                        break;
                                    case "source":
                                        $bde2334e73da0799$var$F("error", d);
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        $bde2334e73da0799$var$F("error", d);
                                        $bde2334e73da0799$var$F("load", d);
                                        break;
                                    case "form":
                                        $bde2334e73da0799$var$F("reset", d);
                                        $bde2334e73da0799$var$F("submit", d);
                                        break;
                                    case "details":
                                        $bde2334e73da0799$var$F("toggle", d);
                                        break;
                                    case "input":
                                        $bde2334e73da0799$var$Bb(d, k);
                                        $bde2334e73da0799$var$F("invalid", d);
                                        $bde2334e73da0799$var$$d(l, "onChange");
                                        break;
                                    case "select":
                                        d._wrapperState = {
                                            wasMultiple: !!k.multiple
                                        };
                                        $bde2334e73da0799$var$F("invalid", d);
                                        $bde2334e73da0799$var$$d(l, "onChange");
                                        break;
                                    case "textarea":
                                        $bde2334e73da0799$var$Lb(d, k), $bde2334e73da0799$var$F("invalid", d), $bde2334e73da0799$var$$d(l, "onChange");
                                }
                                $bde2334e73da0799$var$Yd(c, k);
                                h = null;
                                for(f in k)k.hasOwnProperty(f) && (g = k[f], "children" === f ? "string" === typeof g ? d.textContent !== g && (h = [
                                    "children",
                                    g
                                ]) : "number" === typeof g && d.textContent !== "" + g && (h = [
                                    "children",
                                    "" + g
                                ]) : $bde2334e73da0799$var$ia.hasOwnProperty(f) && null != g && $bde2334e73da0799$var$$d(l, f));
                                switch(c){
                                    case "input":
                                        $bde2334e73da0799$var$yb(d);
                                        $bde2334e73da0799$var$Gb(d, k, !0);
                                        break;
                                    case "textarea":
                                        $bde2334e73da0799$var$yb(d);
                                        $bde2334e73da0799$var$Nb(d, k);
                                        break;
                                    case "select":
                                    case "option":
                                        break;
                                    default:
                                        "function" === typeof k.onClick && (d.onclick = $bde2334e73da0799$var$ae);
                                }
                                f = h;
                                e.updateQueue = f;
                                e = null !== f ? !0 : !1;
                                e && $bde2334e73da0799$var$Ci(b);
                            } else {
                                c = b;
                                l = f;
                                k = e;
                                h = 9 === d.nodeType ? d : d.ownerDocument;
                                g === $bde2334e73da0799$var$Ob.html && (g = $bde2334e73da0799$var$Pb(l));
                                g === $bde2334e73da0799$var$Ob.html ? "script" === l ? (k = h.createElement("div"), k.innerHTML = "<script></script>", h = k.removeChild(k.firstChild)) : "string" === typeof k.is ? h = h.createElement(l, {
                                    is: k.is
                                }) : (h = h.createElement(l), "select" === l && (l = h, k.multiple ? l.multiple = !0 : k.size && (l.size = k.size))) : h = h.createElementNS(g, l);
                                k = h;
                                k[$bde2334e73da0799$var$ue] = c;
                                k[$bde2334e73da0799$var$ve] = e;
                                $bde2334e73da0799$var$Hi(k, b, !1, !1);
                                b.stateNode = k;
                                l = f;
                                c = e;
                                var m = d, C = $bde2334e73da0799$var$Zd(l, c);
                                switch(l){
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        $bde2334e73da0799$var$F("load", k);
                                        d = c;
                                        break;
                                    case "video":
                                    case "audio":
                                        for(d = 0; d < $bde2334e73da0799$var$cc.length; d++)$bde2334e73da0799$var$F($bde2334e73da0799$var$cc[d], k);
                                        d = c;
                                        break;
                                    case "source":
                                        $bde2334e73da0799$var$F("error", k);
                                        d = c;
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        $bde2334e73da0799$var$F("error", k);
                                        $bde2334e73da0799$var$F("load", k);
                                        d = c;
                                        break;
                                    case "form":
                                        $bde2334e73da0799$var$F("reset", k);
                                        $bde2334e73da0799$var$F("submit", k);
                                        d = c;
                                        break;
                                    case "details":
                                        $bde2334e73da0799$var$F("toggle", k);
                                        d = c;
                                        break;
                                    case "input":
                                        $bde2334e73da0799$var$Bb(k, c);
                                        d = $bde2334e73da0799$var$Ab(k, c);
                                        $bde2334e73da0799$var$F("invalid", k);
                                        $bde2334e73da0799$var$$d(m, "onChange");
                                        break;
                                    case "option":
                                        d = $bde2334e73da0799$var$Ib(k, c);
                                        break;
                                    case "select":
                                        k._wrapperState = {
                                            wasMultiple: !!c.multiple
                                        };
                                        d = $fve7V({}, c, {
                                            value: void 0
                                        });
                                        $bde2334e73da0799$var$F("invalid", k);
                                        $bde2334e73da0799$var$$d(m, "onChange");
                                        break;
                                    case "textarea":
                                        $bde2334e73da0799$var$Lb(k, c);
                                        d = $bde2334e73da0799$var$Kb(k, c);
                                        $bde2334e73da0799$var$F("invalid", k);
                                        $bde2334e73da0799$var$$d(m, "onChange");
                                        break;
                                    default:
                                        d = c;
                                }
                                $bde2334e73da0799$var$Yd(l, d);
                                h = void 0;
                                g = l;
                                var y = k, H = d;
                                for(h in H)if (H.hasOwnProperty(h)) {
                                    var z = H[h];
                                    "style" === h ? $bde2334e73da0799$var$Wd(y, z) : "dangerouslySetInnerHTML" === h ? (z = z ? z.__html : void 0, null != z && $bde2334e73da0799$var$Sb(y, z)) : "children" === h ? "string" === typeof z ? ("textarea" !== g || "" !== z) && $bde2334e73da0799$var$Tb(y, z) : "number" === typeof z && $bde2334e73da0799$var$Tb(y, "" + z) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && ($bde2334e73da0799$var$ia.hasOwnProperty(h) ? null != z && $bde2334e73da0799$var$$d(m, h) : null != z && $bde2334e73da0799$var$vb(y, h, z, C));
                                }
                                switch(l){
                                    case "input":
                                        $bde2334e73da0799$var$yb(k);
                                        $bde2334e73da0799$var$Gb(k, c, !1);
                                        break;
                                    case "textarea":
                                        $bde2334e73da0799$var$yb(k);
                                        $bde2334e73da0799$var$Nb(k, c);
                                        break;
                                    case "option":
                                        null != c.value && k.setAttribute("value", "" + $bde2334e73da0799$var$ub(c.value));
                                        break;
                                    case "select":
                                        d = k;
                                        d.multiple = !!c.multiple;
                                        k = c.value;
                                        null != k ? $bde2334e73da0799$var$Jb(d, !!c.multiple, k, !1) : null != c.defaultValue && $bde2334e73da0799$var$Jb(d, !!c.multiple, c.defaultValue, !0);
                                        break;
                                    default:
                                        "function" === typeof d.onClick && (k.onclick = $bde2334e73da0799$var$ae);
                                }
                                (e = $bde2334e73da0799$var$ne(f, e)) && $bde2334e73da0799$var$Ci(b);
                            }
                            null !== b.ref && (b.effectTag |= 128);
                        } else if (null === b.stateNode) throw Error($bde2334e73da0799$var$u(166));
                        break;
                    case 6:
                        if (c && null != b.stateNode) $bde2334e73da0799$var$Ki(c, b, c.memoizedProps, e);
                        else {
                            if ("string" !== typeof e && null === b.stateNode) throw Error($bde2334e73da0799$var$u(166));
                            d = $bde2334e73da0799$var$lh($bde2334e73da0799$var$kh.current);
                            $bde2334e73da0799$var$lh($bde2334e73da0799$var$ih.current);
                            $bde2334e73da0799$var$ki(b) ? (e = b, f = e.stateNode, d = e.memoizedProps, f[$bde2334e73da0799$var$ue] = e, (e = f.nodeValue !== d) && $bde2334e73da0799$var$Ci(b)) : (f = b, e = (9 === d.nodeType ? d : d.ownerDocument).createTextNode(e), e[$bde2334e73da0799$var$ue] = f, b.stateNode = e);
                        }
                        break;
                    case 11:
                        break;
                    case 13:
                        $bde2334e73da0799$var$G($bde2334e73da0799$var$M, b);
                        e = b.memoizedState;
                        if (0 !== (b.effectTag & 64)) {
                            b.expirationTime = d;
                            break a;
                        }
                        e = null !== e;
                        f = !1;
                        null === c ? void 0 !== b.memoizedProps.fallback && $bde2334e73da0799$var$ki(b) : (d = c.memoizedState, f = null !== d, e || null === d || (d = c.child.sibling, null !== d && (k = b.firstEffect, null !== k ? (b.firstEffect = d, d.nextEffect = k) : (b.firstEffect = b.lastEffect = d, d.nextEffect = null), d.effectTag = 8)));
                        if (e && !f && 0 !== (b.mode & 2)) {
                            if (null === c && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== ($bde2334e73da0799$var$M.current & 1)) $bde2334e73da0799$var$X === $bde2334e73da0799$var$qj && ($bde2334e73da0799$var$X = $bde2334e73da0799$var$tj);
                            else {
                                if ($bde2334e73da0799$var$X === $bde2334e73da0799$var$qj || $bde2334e73da0799$var$X === $bde2334e73da0799$var$tj) $bde2334e73da0799$var$X = $bde2334e73da0799$var$uj;
                                0 !== $bde2334e73da0799$var$Aj && null !== $bde2334e73da0799$var$U && ($bde2334e73da0799$var$Mj($bde2334e73da0799$var$U, $bde2334e73da0799$var$W), $bde2334e73da0799$var$Nj($bde2334e73da0799$var$U, $bde2334e73da0799$var$Aj));
                            }
                        }
                        if (e || f) b.effectTag |= 4;
                        break;
                    case 7:
                        break;
                    case 8:
                        break;
                    case 12:
                        break;
                    case 4:
                        $bde2334e73da0799$var$nh(b);
                        $bde2334e73da0799$var$Ii(b);
                        break;
                    case 10:
                        $bde2334e73da0799$var$tg(b);
                        break;
                    case 9:
                        break;
                    case 14:
                        break;
                    case 17:
                        $bde2334e73da0799$var$L(b.type) && $bde2334e73da0799$var$Ff(b);
                        break;
                    case 19:
                        $bde2334e73da0799$var$G($bde2334e73da0799$var$M, b);
                        e = b.memoizedState;
                        if (null === e) break;
                        f = 0 !== (b.effectTag & 64);
                        k = e.rendering;
                        if (null === k) {
                            if (f) $bde2334e73da0799$var$Li(e, !1);
                            else {
                                if ($bde2334e73da0799$var$X !== $bde2334e73da0799$var$qj || null !== c && 0 !== (c.effectTag & 64)) for(c = b.child; null !== c;){
                                    k = $bde2334e73da0799$var$qh(c);
                                    if (null !== k) {
                                        b.effectTag |= 64;
                                        $bde2334e73da0799$var$Li(e, !1);
                                        f = k.updateQueue;
                                        null !== f && (b.updateQueue = f, b.effectTag |= 4);
                                        null === e.lastEffect && (b.firstEffect = null);
                                        b.lastEffect = e.lastEffect;
                                        e = d;
                                        for(f = b.child; null !== f;)d = f, c = e, d.effectTag &= 2, d.nextEffect = null, d.firstEffect = null, d.lastEffect = null, k = d.alternate, null === k ? (d.childExpirationTime = 0, d.expirationTime = c, d.child = null, d.memoizedProps = null, d.memoizedState = null, d.updateQueue = null, d.dependencies = null) : (d.childExpirationTime = k.childExpirationTime, d.expirationTime = k.expirationTime, d.child = k.child, d.memoizedProps = k.memoizedProps, d.memoizedState = k.memoizedState, d.updateQueue = k.updateQueue, c = k.dependencies, d.dependencies = null === c ? null : {
                                            expirationTime: c.expirationTime,
                                            firstContext: c.firstContext,
                                            responders: c.responders
                                        }), f = f.sibling;
                                        $bde2334e73da0799$var$I($bde2334e73da0799$var$M, $bde2334e73da0799$var$M.current & 1 | 2, b);
                                        b = b.child;
                                        break a;
                                    }
                                    c = c.sibling;
                                }
                            }
                        } else {
                            if (!f) {
                                if (c = $bde2334e73da0799$var$qh(k), null !== c) {
                                    if (b.effectTag |= 64, f = !0, d = c.updateQueue, null !== d && (b.updateQueue = d, b.effectTag |= 4), $bde2334e73da0799$var$Li(e, !0), null === e.tail && "hidden" === e.tailMode && !k.alternate) {
                                        b = b.lastEffect = e.lastEffect;
                                        null !== b && (b.nextEffect = null);
                                        break;
                                    }
                                } else $bde2334e73da0799$var$cg() > e.tailExpiration && 1 < d && (b.effectTag |= 64, f = !0, $bde2334e73da0799$var$Li(e, !1), b.expirationTime = b.childExpirationTime = d - 1);
                            }
                            e.isBackwards ? (k.sibling = b.child, b.child = k) : (d = e.last, null !== d ? d.sibling = k : b.child = k, e.last = k);
                        }
                        if (null !== e.tail) {
                            0 === e.tailExpiration && (e.tailExpiration = $bde2334e73da0799$var$cg() + 500);
                            d = e.tail;
                            e.rendering = d;
                            e.tail = d.sibling;
                            e.lastEffect = b.lastEffect;
                            d.sibling = null;
                            e = $bde2334e73da0799$var$M.current;
                            e = f ? e & 1 | 2 : e & 1;
                            $bde2334e73da0799$var$I($bde2334e73da0799$var$M, e, b);
                            b = d;
                            break a;
                        }
                        break;
                    case 20:
                        break;
                    case 21:
                        break;
                    default:
                        throw Error($bde2334e73da0799$var$u(156, b.tag));
                }
                b = null;
            }
            e = $bde2334e73da0799$var$V;
            if (1 === $bde2334e73da0799$var$W || 1 !== e.childExpirationTime) {
                f = 0;
                for(d = e.child; null !== d;)c = d.expirationTime, k = d.childExpirationTime, c > f && (f = c), k > f && (f = k), d = d.sibling;
                e.childExpirationTime = f;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = $bde2334e73da0799$var$V.firstEffect), null !== $bde2334e73da0799$var$V.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = $bde2334e73da0799$var$V.firstEffect), a.lastEffect = $bde2334e73da0799$var$V.lastEffect), 1 < $bde2334e73da0799$var$V.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = $bde2334e73da0799$var$V : a.firstEffect = $bde2334e73da0799$var$V, a.lastEffect = $bde2334e73da0799$var$V));
        } else {
            b = $bde2334e73da0799$var$Mi($bde2334e73da0799$var$V, $bde2334e73da0799$var$W);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = $bde2334e73da0799$var$V.sibling;
        if (null !== b) return b;
        $bde2334e73da0799$var$V = a;
    }while (null !== $bde2334e73da0799$var$V);
    $bde2334e73da0799$var$X === $bde2334e73da0799$var$qj && ($bde2334e73da0799$var$X = $bde2334e73da0799$var$vj);
    return null;
}
function $bde2334e73da0799$var$Xj(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function $bde2334e73da0799$var$Yj(a) {
    var b = $bde2334e73da0799$var$dg();
    $bde2334e73da0799$var$fg(99, $bde2334e73da0799$var$ik.bind(null, a, b));
    return null;
}
function $bde2334e73da0799$var$ik(a, b) {
    do $bde2334e73da0799$var$Sj();
    while (null !== $bde2334e73da0799$var$Ej);
    if (($bde2334e73da0799$var$T & ($bde2334e73da0799$var$oj | $bde2334e73da0799$var$pj)) !== $bde2334e73da0799$var$S) throw Error($bde2334e73da0799$var$u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error($bde2334e73da0799$var$u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = $bde2334e73da0799$var$Xj(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === $bde2334e73da0799$var$U && ($bde2334e73da0799$var$V = $bde2334e73da0799$var$U = null, $bde2334e73da0799$var$W = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = $bde2334e73da0799$var$T;
        $bde2334e73da0799$var$T |= $bde2334e73da0799$var$pj;
        $bde2334e73da0799$var$mj.current = null;
        $bde2334e73da0799$var$le = $bde2334e73da0799$var$Ld;
        var g = $bde2334e73da0799$var$fe();
        if ($bde2334e73da0799$var$ge(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (Db) {
                        h = null;
                        break a;
                    }
                    var C = 0, y = -1, H = -1, z = 0, ta = 0, r = g, x = null;
                    b: for(;;){
                        for(var A;;){
                            r !== h || 0 !== l && 3 !== r.nodeType || (y = C + l);
                            r !== m || 0 !== k && 3 !== r.nodeType || (H = C + k);
                            3 === r.nodeType && (C += r.nodeValue.length);
                            if (null === (A = r.firstChild)) break;
                            x = r;
                            r = A;
                        }
                        for(;;){
                            if (r === g) break b;
                            x === h && ++z === l && (y = C);
                            x === m && ++ta === k && (H = C);
                            if (null !== (A = r.nextSibling)) break;
                            r = x;
                            x = r.parentNode;
                        }
                        r = A;
                    }
                    h = -1 === y || -1 === H ? null : {
                        start: y,
                        end: H
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        $bde2334e73da0799$var$me = {
            focusedElem: g,
            selectionRange: h
        };
        $bde2334e73da0799$var$Ld = !1;
        $bde2334e73da0799$var$Y = e;
        do try {
            $bde2334e73da0799$var$jk();
        } catch (Db) {
            if (null === $bde2334e73da0799$var$Y) throw Error($bde2334e73da0799$var$u(330));
            $bde2334e73da0799$var$Ri($bde2334e73da0799$var$Y, Db);
            $bde2334e73da0799$var$Y = $bde2334e73da0799$var$Y.nextEffect;
        }
        while (null !== $bde2334e73da0799$var$Y);
        $bde2334e73da0799$var$Y = e;
        do try {
            for(g = a, h = b; null !== $bde2334e73da0799$var$Y;){
                var p = $bde2334e73da0799$var$Y.effectTag;
                p & 16 && $bde2334e73da0799$var$Tb($bde2334e73da0799$var$Y.stateNode, "");
                if (p & 128) {
                    var t = $bde2334e73da0799$var$Y.alternate;
                    if (null !== t) {
                        var v = t.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(p & 1038){
                    case 2:
                        $bde2334e73da0799$var$$i($bde2334e73da0799$var$Y);
                        $bde2334e73da0799$var$Y.effectTag &= -3;
                        break;
                    case 6:
                        $bde2334e73da0799$var$$i($bde2334e73da0799$var$Y);
                        $bde2334e73da0799$var$Y.effectTag &= -3;
                        $bde2334e73da0799$var$aj($bde2334e73da0799$var$Y.alternate, $bde2334e73da0799$var$Y);
                        break;
                    case 1024:
                        $bde2334e73da0799$var$Y.effectTag &= -1025;
                        break;
                    case 1028:
                        $bde2334e73da0799$var$Y.effectTag &= -1025;
                        $bde2334e73da0799$var$aj($bde2334e73da0799$var$Y.alternate, $bde2334e73da0799$var$Y);
                        break;
                    case 4:
                        $bde2334e73da0799$var$aj($bde2334e73da0799$var$Y.alternate, $bde2334e73da0799$var$Y);
                        break;
                    case 8:
                        l = $bde2334e73da0799$var$Y, $bde2334e73da0799$var$Xi(g, l, h), $bde2334e73da0799$var$Yi(l);
                }
                $bde2334e73da0799$var$Y = $bde2334e73da0799$var$Y.nextEffect;
            }
        } catch (Db) {
            if (null === $bde2334e73da0799$var$Y) throw Error($bde2334e73da0799$var$u(330));
            $bde2334e73da0799$var$Ri($bde2334e73da0799$var$Y, Db);
            $bde2334e73da0799$var$Y = $bde2334e73da0799$var$Y.nextEffect;
        }
        while (null !== $bde2334e73da0799$var$Y);
        v = $bde2334e73da0799$var$me;
        t = $bde2334e73da0799$var$fe();
        p = v.focusedElem;
        h = v.selectionRange;
        if (t !== p && p && p.ownerDocument && $bde2334e73da0799$var$ee(p.ownerDocument.documentElement, p)) {
            null !== h && $bde2334e73da0799$var$ge(p) && (t = h.start, v = h.end, void 0 === v && (v = t), "selectionStart" in p ? (p.selectionStart = t, p.selectionEnd = Math.min(v, p.value.length)) : (v = (t = p.ownerDocument || document) && t.defaultView || window, v.getSelection && (v = v.getSelection(), l = p.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !v.extend && g > h && (l = h, h = g, g = l), l = $bde2334e73da0799$var$de(p, g), m = $bde2334e73da0799$var$de(p, h), l && m && (1 !== v.rangeCount || v.anchorNode !== l.node || v.anchorOffset !== l.offset || v.focusNode !== m.node || v.focusOffset !== m.offset) && (t = t.createRange(), t.setStart(l.node, l.offset), v.removeAllRanges(), g > h ? (v.addRange(t), v.extend(m.node, m.offset)) : (t.setEnd(m.node, m.offset), v.addRange(t))))));
            t = [];
            for(v = p; v = v.parentNode;)1 === v.nodeType && t.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof p.focus && p.focus();
            for(p = 0; p < t.length; p++)v = t[p], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        $bde2334e73da0799$var$me = null;
        $bde2334e73da0799$var$Ld = !!$bde2334e73da0799$var$le;
        $bde2334e73da0799$var$le = null;
        a.current = c;
        $bde2334e73da0799$var$Y = e;
        do try {
            for(p = d; null !== $bde2334e73da0799$var$Y;){
                var Dh = $bde2334e73da0799$var$Y.effectTag;
                if (Dh & 36) {
                    var dc = $bde2334e73da0799$var$Y.alternate;
                    t = $bde2334e73da0799$var$Y;
                    v = p;
                    switch(t.tag){
                        case 0:
                        case 11:
                        case 15:
                            $bde2334e73da0799$var$Ui(16, 32, t);
                            break;
                        case 1:
                            var fd = t.stateNode;
                            if (t.effectTag & 4) {
                                if (null === dc) fd.componentDidMount();
                                else {
                                    var hk = t.elementType === t.type ? dc.memoizedProps : $bde2334e73da0799$var$mg(t.type, dc.memoizedProps);
                                    fd.componentDidUpdate(hk, dc.memoizedState, fd.__reactInternalSnapshotBeforeUpdate);
                                }
                            }
                            var Eh = t.updateQueue;
                            null !== Eh && $bde2334e73da0799$var$Kg(t, Eh, fd, v);
                            break;
                        case 3:
                            var Fh = t.updateQueue;
                            if (null !== Fh) {
                                g = null;
                                if (null !== t.child) switch(t.child.tag){
                                    case 5:
                                        g = t.child.stateNode;
                                        break;
                                    case 1:
                                        g = t.child.stateNode;
                                }
                                $bde2334e73da0799$var$Kg(t, Fh, g, v);
                            }
                            break;
                        case 5:
                            var xk = t.stateNode;
                            null === dc && t.effectTag & 4 && $bde2334e73da0799$var$ne(t.type, t.memoizedProps) && xk.focus();
                            break;
                        case 6:
                            break;
                        case 4:
                            break;
                        case 12:
                            break;
                        case 13:
                            if (null === t.memoizedState) {
                                var Di = t.alternate;
                                if (null !== Di) {
                                    var Ei = Di.memoizedState;
                                    if (null !== Ei) {
                                        var Fi = Ei.dehydrated;
                                        null !== Fi && $bde2334e73da0799$var$Lc(Fi);
                                    }
                                }
                            }
                            break;
                        case 19:
                        case 17:
                        case 20:
                        case 21:
                            break;
                        default:
                            throw Error($bde2334e73da0799$var$u(163));
                    }
                }
                if (Dh & 128) {
                    t = void 0;
                    var xd = $bde2334e73da0799$var$Y.ref;
                    if (null !== xd) {
                        var Gi = $bde2334e73da0799$var$Y.stateNode;
                        switch($bde2334e73da0799$var$Y.tag){
                            case 5:
                                t = Gi;
                                break;
                            default:
                                t = Gi;
                        }
                        "function" === typeof xd ? xd(t) : xd.current = t;
                    }
                }
                $bde2334e73da0799$var$Y = $bde2334e73da0799$var$Y.nextEffect;
            }
        } catch (Db) {
            if (null === $bde2334e73da0799$var$Y) throw Error($bde2334e73da0799$var$u(330));
            $bde2334e73da0799$var$Ri($bde2334e73da0799$var$Y, Db);
            $bde2334e73da0799$var$Y = $bde2334e73da0799$var$Y.nextEffect;
        }
        while (null !== $bde2334e73da0799$var$Y);
        $bde2334e73da0799$var$Y = null;
        $bde2334e73da0799$var$Yf();
        $bde2334e73da0799$var$T = f;
    } else a.current = c;
    if ($bde2334e73da0799$var$Dj) $bde2334e73da0799$var$Dj = !1, $bde2334e73da0799$var$Ej = a, $bde2334e73da0799$var$Fj = b;
    else for($bde2334e73da0799$var$Y = e; null !== $bde2334e73da0799$var$Y;)b = $bde2334e73da0799$var$Y.nextEffect, $bde2334e73da0799$var$Y.nextEffect = null, $bde2334e73da0799$var$Y = b;
    b = a.firstPendingTime;
    0 === b && ($bde2334e73da0799$var$jj = null);
    1073741823 === b ? a === $bde2334e73da0799$var$Ij ? $bde2334e73da0799$var$Hj++ : ($bde2334e73da0799$var$Hj = 0, $bde2334e73da0799$var$Ij = a) : $bde2334e73da0799$var$Hj = 0;
    "function" === typeof $bde2334e73da0799$var$kk && $bde2334e73da0799$var$kk(c.stateNode, d);
    $bde2334e73da0799$var$Z(a);
    if ($bde2334e73da0799$var$gj) throw $bde2334e73da0799$var$gj = !1, a = $bde2334e73da0799$var$hj, $bde2334e73da0799$var$hj = null, a;
    if (($bde2334e73da0799$var$T & $bde2334e73da0799$var$nj) !== $bde2334e73da0799$var$S) return null;
    $bde2334e73da0799$var$jg();
    return null;
}
function $bde2334e73da0799$var$jk() {
    for(; null !== $bde2334e73da0799$var$Y;){
        var a = $bde2334e73da0799$var$Y.effectTag;
        0 !== (a & 256) && $bde2334e73da0799$var$Ti($bde2334e73da0799$var$Y.alternate, $bde2334e73da0799$var$Y);
        0 === (a & 512) || $bde2334e73da0799$var$Dj || ($bde2334e73da0799$var$Dj = !0, $bde2334e73da0799$var$gg(97, function() {
            $bde2334e73da0799$var$Sj();
            return null;
        }));
        $bde2334e73da0799$var$Y = $bde2334e73da0799$var$Y.nextEffect;
    }
}
function $bde2334e73da0799$var$Sj() {
    if (90 !== $bde2334e73da0799$var$Fj) {
        var a = 97 < $bde2334e73da0799$var$Fj ? 97 : $bde2334e73da0799$var$Fj;
        $bde2334e73da0799$var$Fj = 90;
        return $bde2334e73da0799$var$fg(a, $bde2334e73da0799$var$lk);
    }
}
function $bde2334e73da0799$var$lk() {
    if (null === $bde2334e73da0799$var$Ej) return !1;
    var a = $bde2334e73da0799$var$Ej;
    $bde2334e73da0799$var$Ej = null;
    if (($bde2334e73da0799$var$T & ($bde2334e73da0799$var$oj | $bde2334e73da0799$var$pj)) !== $bde2334e73da0799$var$S) throw Error($bde2334e73da0799$var$u(331));
    var b = $bde2334e73da0799$var$T;
    $bde2334e73da0799$var$T |= $bde2334e73da0799$var$pj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                    $bde2334e73da0799$var$Ui(128, 0, c), $bde2334e73da0799$var$Ui(0, 64, c);
            }
        } catch (d) {
            if (null === a) throw Error($bde2334e73da0799$var$u(330));
            $bde2334e73da0799$var$Ri(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    $bde2334e73da0799$var$T = b;
    $bde2334e73da0799$var$jg();
    return !0;
}
function $bde2334e73da0799$var$mk(a, b, c) {
    b = $bde2334e73da0799$var$Ni(c, b);
    b = $bde2334e73da0799$var$fj(a, b, 1073741823);
    $bde2334e73da0799$var$Dg(a, b);
    a = $bde2334e73da0799$var$Kj(a, 1073741823);
    null !== a && $bde2334e73da0799$var$Z(a);
}
function $bde2334e73da0799$var$Ri(a, b) {
    if (3 === a.tag) $bde2334e73da0799$var$mk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            $bde2334e73da0799$var$mk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $bde2334e73da0799$var$jj || !$bde2334e73da0799$var$jj.has(d))) {
                a = $bde2334e73da0799$var$Ni(b, a);
                a = $bde2334e73da0799$var$ij(c, a, 1073741823);
                $bde2334e73da0799$var$Dg(c, a);
                c = $bde2334e73da0799$var$Kj(c, 1073741823);
                null !== c && $bde2334e73da0799$var$Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function $bde2334e73da0799$var$dk(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    $bde2334e73da0799$var$U === a && $bde2334e73da0799$var$W === c ? $bde2334e73da0799$var$X === $bde2334e73da0799$var$uj || $bde2334e73da0799$var$X === $bde2334e73da0799$var$tj && 1073741823 === $bde2334e73da0799$var$xj && $bde2334e73da0799$var$cg() - $bde2334e73da0799$var$bj < $bde2334e73da0799$var$Cj ? $bde2334e73da0799$var$Tj(a, $bde2334e73da0799$var$W) : $bde2334e73da0799$var$Bj = !0 : $bde2334e73da0799$var$Pj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, a.finishedExpirationTime === c && (a.finishedExpirationTime = 0, a.finishedWork = null), $bde2334e73da0799$var$Z(a)));
}
function $bde2334e73da0799$var$dj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = $bde2334e73da0799$var$Pg(), b = $bde2334e73da0799$var$Qg(b, a, null));
    a = $bde2334e73da0799$var$Kj(a, b);
    null !== a && $bde2334e73da0799$var$Z(a);
}
var $bde2334e73da0799$var$gk;
$bde2334e73da0799$var$gk = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || $bde2334e73da0799$var$K.current) $bde2334e73da0799$var$wg = !0;
        else {
            if (d < c) {
                $bde2334e73da0799$var$wg = !1;
                switch(b.tag){
                    case 3:
                        $bde2334e73da0799$var$wi(b);
                        $bde2334e73da0799$var$li();
                        break;
                    case 5:
                        $bde2334e73da0799$var$oh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        $bde2334e73da0799$var$L(b.type) && $bde2334e73da0799$var$Jf(b);
                        break;
                    case 4:
                        $bde2334e73da0799$var$mh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        $bde2334e73da0799$var$sg(b, b.memoizedProps.value);
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return $bde2334e73da0799$var$yi(a, b, c);
                            $bde2334e73da0799$var$I($bde2334e73da0799$var$M, $bde2334e73da0799$var$M.current & 1, b);
                            b = $bde2334e73da0799$var$oi(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        $bde2334e73da0799$var$I($bde2334e73da0799$var$M, $bde2334e73da0799$var$M.current & 1, b);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return $bde2334e73da0799$var$Bi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        $bde2334e73da0799$var$I($bde2334e73da0799$var$M, $bde2334e73da0799$var$M.current, b);
                        if (!d) return null;
                }
                return $bde2334e73da0799$var$oi(a, b, c);
            }
            $bde2334e73da0799$var$wg = !1;
        }
    } else $bde2334e73da0799$var$wg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = $bde2334e73da0799$var$Ef(b, $bde2334e73da0799$var$J.current);
            $bde2334e73da0799$var$vg(b, c);
            e = $bde2334e73da0799$var$Ih(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                $bde2334e73da0799$var$Mh();
                if ($bde2334e73da0799$var$L(d)) {
                    var f = !0;
                    $bde2334e73da0799$var$Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && $bde2334e73da0799$var$Og(b, d, g, a);
                e.updater = $bde2334e73da0799$var$Sg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                $bde2334e73da0799$var$Wg(b, d, a, c);
                b = $bde2334e73da0799$var$vi(null, b, d, !0, f, c);
            } else b.tag = 0, $bde2334e73da0799$var$R(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            $bde2334e73da0799$var$Va(e);
            if (1 !== e._status) throw e._result;
            e = e._result;
            b.type = e;
            f = b.tag = $bde2334e73da0799$var$nk(e);
            a = $bde2334e73da0799$var$mg(e, a);
            switch(f){
                case 0:
                    b = $bde2334e73da0799$var$si(null, b, e, a, c);
                    break;
                case 1:
                    b = $bde2334e73da0799$var$ui(null, b, e, a, c);
                    break;
                case 11:
                    b = $bde2334e73da0799$var$ni(null, b, e, a, c);
                    break;
                case 14:
                    b = $bde2334e73da0799$var$pi(null, b, e, $bde2334e73da0799$var$mg(e.type, a), d, c);
                    break;
                default:
                    throw Error($bde2334e73da0799$var$u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bde2334e73da0799$var$mg(d, e), $bde2334e73da0799$var$si(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bde2334e73da0799$var$mg(d, e), $bde2334e73da0799$var$ui(a, b, d, e, c);
        case 3:
            $bde2334e73da0799$var$wi(b);
            d = b.updateQueue;
            if (null === d) throw Error($bde2334e73da0799$var$u(282));
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            $bde2334e73da0799$var$Hg(b, d, b.pendingProps, null, c);
            d = b.memoizedState.element;
            if (d === e) $bde2334e73da0799$var$li(), b = $bde2334e73da0799$var$oi(a, b, c);
            else {
                if (e = b.stateNode.hydrate) $bde2334e73da0799$var$di = $bde2334e73da0799$var$re(b.stateNode.containerInfo.firstChild), $bde2334e73da0799$var$ci = b, e = $bde2334e73da0799$var$ei = !0;
                if (e) for(c = $bde2334e73da0799$var$gh(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else $bde2334e73da0799$var$R(a, b, d, c), $bde2334e73da0799$var$li();
                b = b.child;
            }
            return b;
        case 5:
            return $bde2334e73da0799$var$oh(b), null === a && $bde2334e73da0799$var$ii(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $bde2334e73da0799$var$oe(d, e) ? g = null : null !== f && $bde2334e73da0799$var$oe(d, f) && (b.effectTag |= 16), $bde2334e73da0799$var$ti(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : ($bde2334e73da0799$var$R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && $bde2334e73da0799$var$ii(b), null;
        case 13:
            return $bde2334e73da0799$var$yi(a, b, c);
        case 4:
            return $bde2334e73da0799$var$mh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $bde2334e73da0799$var$fh(b, null, d, c) : $bde2334e73da0799$var$R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bde2334e73da0799$var$mg(d, e), $bde2334e73da0799$var$ni(a, b, d, e, c);
        case 7:
            return $bde2334e73da0799$var$R(a, b, b.pendingProps, c), b.child;
        case 8:
            return $bde2334e73da0799$var$R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $bde2334e73da0799$var$R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                $bde2334e73da0799$var$sg(b, f);
                if (null !== g) {
                    var h = g.value;
                    f = $bde2334e73da0799$var$of(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0;
                    if (0 === f) {
                        if (g.children === e.children && !$bde2334e73da0799$var$K.current) {
                            b = $bde2334e73da0799$var$oi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = $bde2334e73da0799$var$Bg(c, null), l.tag = 2, $bde2334e73da0799$var$Dg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    $bde2334e73da0799$var$ug(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                $bde2334e73da0799$var$R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, $bde2334e73da0799$var$vg(b, c), e = $bde2334e73da0799$var$xg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, $bde2334e73da0799$var$R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = $bde2334e73da0799$var$mg(e, b.pendingProps), f = $bde2334e73da0799$var$mg(e.type, f), $bde2334e73da0799$var$pi(a, b, e, f, d, c);
        case 15:
            return $bde2334e73da0799$var$ri(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bde2334e73da0799$var$mg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, $bde2334e73da0799$var$L(d) ? (a = !0, $bde2334e73da0799$var$Jf(b)) : a = !1, $bde2334e73da0799$var$vg(b, c), $bde2334e73da0799$var$Ug(b, d, e, c), $bde2334e73da0799$var$Wg(b, d, e, c), $bde2334e73da0799$var$vi(null, b, d, !0, a, c);
        case 19:
            return $bde2334e73da0799$var$Bi(a, b, c);
    }
    throw Error($bde2334e73da0799$var$u(156, b.tag));
};
var $bde2334e73da0799$var$kk = null, $bde2334e73da0799$var$Wi = null;
function $bde2334e73da0799$var$ok(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        $bde2334e73da0799$var$kk = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        $bde2334e73da0799$var$Wi = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function $bde2334e73da0799$var$pk(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function $bde2334e73da0799$var$gi(a, b, c, d) {
    return new $bde2334e73da0799$var$pk(a, b, c, d);
}
function $bde2334e73da0799$var$qi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $bde2334e73da0799$var$nk(a) {
    if ("function" === typeof a) return $bde2334e73da0799$var$qi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $bde2334e73da0799$var$Oa) return 11;
        if (a === $bde2334e73da0799$var$Ra) return 14;
    }
    return 2;
}
function $bde2334e73da0799$var$ah(a, b) {
    var c = a.alternate;
    null === c ? (c = $bde2334e73da0799$var$gi(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $bde2334e73da0799$var$ch(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $bde2334e73da0799$var$qi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $bde2334e73da0799$var$Ia:
            return $bde2334e73da0799$var$eh(c.children, e, f, b);
        case $bde2334e73da0799$var$Na:
            g = 8;
            e |= 7;
            break;
        case $bde2334e73da0799$var$Ja:
            g = 8;
            e |= 1;
            break;
        case $bde2334e73da0799$var$Ka:
            return a = $bde2334e73da0799$var$gi(12, c, b, e | 8), a.elementType = $bde2334e73da0799$var$Ka, a.type = $bde2334e73da0799$var$Ka, a.expirationTime = f, a;
        case $bde2334e73da0799$var$Pa:
            return a = $bde2334e73da0799$var$gi(13, c, b, e), a.type = $bde2334e73da0799$var$Pa, a.elementType = $bde2334e73da0799$var$Pa, a.expirationTime = f, a;
        case $bde2334e73da0799$var$Qa:
            return a = $bde2334e73da0799$var$gi(19, c, b, e), a.elementType = $bde2334e73da0799$var$Qa, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $bde2334e73da0799$var$La:
                    g = 10;
                    break a;
                case $bde2334e73da0799$var$Ma:
                    g = 9;
                    break a;
                case $bde2334e73da0799$var$Oa:
                    g = 11;
                    break a;
                case $bde2334e73da0799$var$Ra:
                    g = 14;
                    break a;
                case $bde2334e73da0799$var$Sa:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($bde2334e73da0799$var$u(130, null == a ? a : typeof a, ""));
    }
    b = $bde2334e73da0799$var$gi(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function $bde2334e73da0799$var$eh(a, b, c, d) {
    a = $bde2334e73da0799$var$gi(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function $bde2334e73da0799$var$bh(a, b, c) {
    a = $bde2334e73da0799$var$gi(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function $bde2334e73da0799$var$dh(a, b, c) {
    b = $bde2334e73da0799$var$gi(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $bde2334e73da0799$var$qk(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function $bde2334e73da0799$var$Pj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function $bde2334e73da0799$var$Mj(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function $bde2334e73da0799$var$Nj(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function $bde2334e73da0799$var$Rj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function $bde2334e73da0799$var$rk(a, b, c, d) {
    var e = b.current, f = $bde2334e73da0799$var$Pg(), g = $bde2334e73da0799$var$Mg.suspense;
    f = $bde2334e73da0799$var$Qg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if ($bde2334e73da0799$var$ec(c) !== c || 1 !== c.tag) throw Error($bde2334e73da0799$var$u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if ($bde2334e73da0799$var$L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error($bde2334e73da0799$var$u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if ($bde2334e73da0799$var$L(k)) {
                c = $bde2334e73da0799$var$If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = $bde2334e73da0799$var$Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $bde2334e73da0799$var$Bg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    $bde2334e73da0799$var$Dg(e, b);
    $bde2334e73da0799$var$Rg(e, f);
    return f;
}
function $bde2334e73da0799$var$sk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $bde2334e73da0799$var$tk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function $bde2334e73da0799$var$uk(a, b) {
    $bde2334e73da0799$var$tk(a, b);
    (a = a.alternate) && $bde2334e73da0799$var$tk(a, b);
}
function $bde2334e73da0799$var$vk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new $bde2334e73da0799$var$qk(a, b, c), e = $bde2334e73da0799$var$gi(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    a[$bde2334e73da0799$var$we] = d.current;
    c && 0 !== b && $bde2334e73da0799$var$wc(9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
$bde2334e73da0799$var$vk.prototype.render = function(a, b) {
    $bde2334e73da0799$var$rk(a, this._internalRoot, null, void 0 === b ? null : b);
};
$bde2334e73da0799$var$vk.prototype.unmount = function(a) {
    var b = this._internalRoot, c = void 0 === a ? null : a, d = b.containerInfo;
    $bde2334e73da0799$var$rk(null, b, null, function() {
        d[$bde2334e73da0799$var$we] = null;
        null !== c && c();
    });
};
function $bde2334e73da0799$var$wk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $bde2334e73da0799$var$yk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new $bde2334e73da0799$var$vk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function $bde2334e73da0799$var$zk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $bde2334e73da0799$var$sk(g);
                h.call(a);
            };
        }
        $bde2334e73da0799$var$rk(b, g, a, e);
    } else {
        f = c._reactRootContainer = $bde2334e73da0799$var$yk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = $bde2334e73da0799$var$sk(g);
                k.call(a);
            };
        }
        $bde2334e73da0799$var$ck(function() {
            $bde2334e73da0799$var$rk(b, g, a, e);
        });
    }
    return $bde2334e73da0799$var$sk(g);
}
function $bde2334e73da0799$var$Ak(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $bde2334e73da0799$var$Ha,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
$bde2334e73da0799$var$jc = function(a) {
    if (13 === a.tag) {
        var b = $bde2334e73da0799$var$lg($bde2334e73da0799$var$Pg(), 150, 100);
        $bde2334e73da0799$var$Rg(a, b);
        $bde2334e73da0799$var$uk(a, b);
    }
};
$bde2334e73da0799$var$kc = function(a) {
    if (13 === a.tag) {
        $bde2334e73da0799$var$Pg();
        var b = $bde2334e73da0799$var$kg++;
        $bde2334e73da0799$var$Rg(a, b);
        $bde2334e73da0799$var$uk(a, b);
    }
};
$bde2334e73da0799$var$lc = function(a) {
    if (13 === a.tag) {
        var b = $bde2334e73da0799$var$Pg();
        b = $bde2334e73da0799$var$Qg(b, a, null);
        $bde2334e73da0799$var$Rg(a, b);
        $bde2334e73da0799$var$uk(a, b);
    }
};
$bde2334e73da0799$var$Za = function(a, b, c) {
    switch(b){
        case "input":
            $bde2334e73da0799$var$Eb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $bde2334e73da0799$var$ye(d);
                        if (!e) throw Error($bde2334e73da0799$var$u(90));
                        $bde2334e73da0799$var$zb(d);
                        $bde2334e73da0799$var$Eb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $bde2334e73da0799$var$Mb(a, c);
            break;
        case "select":
            b = c.value, null != b && $bde2334e73da0799$var$Jb(a, !!c.multiple, b, !1);
    }
};
$bde2334e73da0799$var$eb = $bde2334e73da0799$var$bk;
$bde2334e73da0799$var$fb = function(a, b, c, d) {
    var e = $bde2334e73da0799$var$T;
    $bde2334e73da0799$var$T |= 4;
    try {
        return $bde2334e73da0799$var$fg(98, a.bind(null, b, c, d));
    } finally{
        $bde2334e73da0799$var$T = e, $bde2334e73da0799$var$T === $bde2334e73da0799$var$S && $bde2334e73da0799$var$jg();
    }
};
$bde2334e73da0799$var$gb = function() {
    ($bde2334e73da0799$var$T & (1 | $bde2334e73da0799$var$oj | $bde2334e73da0799$var$pj)) === $bde2334e73da0799$var$S && ($bde2334e73da0799$var$ak(), $bde2334e73da0799$var$Sj());
};
$bde2334e73da0799$var$hb = function(a, b) {
    var c = $bde2334e73da0799$var$T;
    $bde2334e73da0799$var$T |= 2;
    try {
        return a(b);
    } finally{
        $bde2334e73da0799$var$T = c, $bde2334e73da0799$var$T === $bde2334e73da0799$var$S && $bde2334e73da0799$var$jg();
    }
};
function $bde2334e73da0799$var$Bk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$bde2334e73da0799$var$wk(b)) throw Error($bde2334e73da0799$var$u(200));
    return $bde2334e73da0799$var$Ak(a, b, null, c);
}
var $bde2334e73da0799$var$Ck = {
    createPortal: $bde2334e73da0799$var$Bk,
    findDOMNode: function(a) {
        if (null == a) return null;
        if (1 === a.nodeType) return a;
        var b = a._reactInternalFiber;
        if (void 0 === b) {
            if ("function" === typeof a.render) throw Error($bde2334e73da0799$var$u(188));
            throw Error($bde2334e73da0799$var$u(268, Object.keys(a)));
        }
        a = $bde2334e73da0799$var$ic(b);
        a = null === a ? null : a.stateNode;
        return a;
    },
    hydrate: function(a, b, c) {
        if (!$bde2334e73da0799$var$wk(b)) throw Error($bde2334e73da0799$var$u(200));
        return $bde2334e73da0799$var$zk(null, a, b, !0, c);
    },
    render: function(a, b, c) {
        if (!$bde2334e73da0799$var$wk(b)) throw Error($bde2334e73da0799$var$u(200));
        return $bde2334e73da0799$var$zk(null, a, b, !1, c);
    },
    unstable_renderSubtreeIntoContainer: function(a, b, c, d) {
        if (!$bde2334e73da0799$var$wk(c)) throw Error($bde2334e73da0799$var$u(200));
        if (null == a || void 0 === a._reactInternalFiber) throw Error($bde2334e73da0799$var$u(38));
        return $bde2334e73da0799$var$zk(a, b, c, !1, d);
    },
    unmountComponentAtNode: function(a) {
        if (!$bde2334e73da0799$var$wk(a)) throw Error($bde2334e73da0799$var$u(40));
        return a._reactRootContainer ? ($bde2334e73da0799$var$ck(function() {
            $bde2334e73da0799$var$zk(null, null, a, !1, function() {
                a._reactRootContainer = null;
                a[$bde2334e73da0799$var$we] = null;
            });
        }), !0) : !1;
    },
    unstable_createPortal: function() {
        return $bde2334e73da0799$var$Bk.apply(void 0, arguments);
    },
    unstable_batchedUpdates: $bde2334e73da0799$var$bk,
    flushSync: function(a, b) {
        if (($bde2334e73da0799$var$T & ($bde2334e73da0799$var$oj | $bde2334e73da0799$var$pj)) !== $bde2334e73da0799$var$S) throw Error($bde2334e73da0799$var$u(187));
        var c = $bde2334e73da0799$var$T;
        $bde2334e73da0799$var$T |= 1;
        try {
            return $bde2334e73da0799$var$fg(99, a.bind(null, b));
        } finally{
            $bde2334e73da0799$var$T = c, $bde2334e73da0799$var$jg();
        }
    },
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
        Events: [
            $bde2334e73da0799$var$Cc,
            $bde2334e73da0799$var$xe,
            $bde2334e73da0799$var$ye,
            $bde2334e73da0799$var$Ca.injectEventPluginsByName,
            $bde2334e73da0799$var$fa,
            $bde2334e73da0799$var$Sc,
            function(a) {
                $bde2334e73da0799$var$ya(a, $bde2334e73da0799$var$Rc);
            },
            $bde2334e73da0799$var$cb,
            $bde2334e73da0799$var$db,
            $bde2334e73da0799$var$Pd,
            $bde2334e73da0799$var$Ba,
            $bde2334e73da0799$var$Sj,
            {
                current: !1
            }
        ]
    }
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return $bde2334e73da0799$var$ok($fve7V({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: $bde2334e73da0799$var$Ea.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = $bde2334e73da0799$var$ic(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: $bde2334e73da0799$var$Fc,
    bundleType: 0,
    version: "16.12.0",
    rendererPackageName: "react-dom"
});
var $bde2334e73da0799$var$Dk = {
    default: $bde2334e73da0799$var$Ck
}, $bde2334e73da0799$var$Ek = $bde2334e73da0799$var$Dk && $bde2334e73da0799$var$Ck || $bde2334e73da0799$var$Dk;
module.exports = $bde2334e73da0799$var$Ek.default || $bde2334e73da0799$var$Ek;

});
parcelRegister("jTfnt", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3T6tc"));

});

parcelRegister("6ynyd", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jx8h3"));

});
parcelRegister("jx8h3", function(module, exports) {
/** @license React v0.18.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});
var $e387846ef7dd5541$var$f, $e387846ef7dd5541$var$g, $e387846ef7dd5541$var$h, $e387846ef7dd5541$var$k, $e387846ef7dd5541$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $e387846ef7dd5541$var$p = null, $e387846ef7dd5541$var$q = null, $e387846ef7dd5541$var$t = function() {
        if (null !== $e387846ef7dd5541$var$p) try {
            var a = module.exports.unstable_now();
            $e387846ef7dd5541$var$p(!0, a);
            $e387846ef7dd5541$var$p = null;
        } catch (b) {
            throw setTimeout($e387846ef7dd5541$var$t, 0), b;
        }
    }, $e387846ef7dd5541$var$u = Date.now();
    module.exports.unstable_now = function() {
        return Date.now() - $e387846ef7dd5541$var$u;
    };
    $e387846ef7dd5541$var$f = function(a) {
        null !== $e387846ef7dd5541$var$p ? setTimeout($e387846ef7dd5541$var$f, 0, a) : ($e387846ef7dd5541$var$p = a, setTimeout($e387846ef7dd5541$var$t, 0));
    };
    $e387846ef7dd5541$var$g = function(a, b) {
        $e387846ef7dd5541$var$q = setTimeout(a, b);
    };
    $e387846ef7dd5541$var$h = function() {
        clearTimeout($e387846ef7dd5541$var$q);
    };
    $e387846ef7dd5541$var$k = function() {
        return !1;
    };
    $e387846ef7dd5541$var$l = module.exports.unstable_forceFrameRate = function() {};
} else {
    var $e387846ef7dd5541$var$w = window.performance, $e387846ef7dd5541$var$x = window.Date, $e387846ef7dd5541$var$y = window.setTimeout, $e387846ef7dd5541$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $e387846ef7dd5541$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $e387846ef7dd5541$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $e387846ef7dd5541$var$w && "function" === typeof $e387846ef7dd5541$var$w.now) module.exports.unstable_now = function() {
        return $e387846ef7dd5541$var$w.now();
    };
    else {
        var $e387846ef7dd5541$var$B = $e387846ef7dd5541$var$x.now();
        module.exports.unstable_now = function() {
            return $e387846ef7dd5541$var$x.now() - $e387846ef7dd5541$var$B;
        };
    }
    var $e387846ef7dd5541$var$C = !1, $e387846ef7dd5541$var$D = null, $e387846ef7dd5541$var$E = -1, $e387846ef7dd5541$var$F = 5, $e387846ef7dd5541$var$G = 0;
    $e387846ef7dd5541$var$k = function() {
        return module.exports.unstable_now() >= $e387846ef7dd5541$var$G;
    };
    $e387846ef7dd5541$var$l = function() {};
    module.exports.unstable_forceFrameRate = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $e387846ef7dd5541$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $e387846ef7dd5541$var$H = new MessageChannel, $e387846ef7dd5541$var$I = $e387846ef7dd5541$var$H.port2;
    $e387846ef7dd5541$var$H.port1.onmessage = function() {
        if (null !== $e387846ef7dd5541$var$D) {
            var a = module.exports.unstable_now();
            $e387846ef7dd5541$var$G = a + $e387846ef7dd5541$var$F;
            try {
                $e387846ef7dd5541$var$D(!0, a) ? $e387846ef7dd5541$var$I.postMessage(null) : ($e387846ef7dd5541$var$C = !1, $e387846ef7dd5541$var$D = null);
            } catch (b) {
                throw $e387846ef7dd5541$var$I.postMessage(null), b;
            }
        } else $e387846ef7dd5541$var$C = !1;
    };
    $e387846ef7dd5541$var$f = function(a) {
        $e387846ef7dd5541$var$D = a;
        $e387846ef7dd5541$var$C || ($e387846ef7dd5541$var$C = !0, $e387846ef7dd5541$var$I.postMessage(null));
    };
    $e387846ef7dd5541$var$g = function(a, b) {
        $e387846ef7dd5541$var$E = $e387846ef7dd5541$var$y(function() {
            a(module.exports.unstable_now());
        }, b);
    };
    $e387846ef7dd5541$var$h = function() {
        $e387846ef7dd5541$var$z($e387846ef7dd5541$var$E);
        $e387846ef7dd5541$var$E = -1;
    };
}
function $e387846ef7dd5541$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = Math.floor((c - 1) / 2), e = a[d];
        if (void 0 !== e && 0 < $e387846ef7dd5541$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $e387846ef7dd5541$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $e387846ef7dd5541$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $e387846ef7dd5541$var$K(n, c)) void 0 !== r && 0 > $e387846ef7dd5541$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $e387846ef7dd5541$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $e387846ef7dd5541$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $e387846ef7dd5541$var$N = [], $e387846ef7dd5541$var$O = [], $e387846ef7dd5541$var$P = 1, $e387846ef7dd5541$var$Q = null, $e387846ef7dd5541$var$R = 3, $e387846ef7dd5541$var$S = !1, $e387846ef7dd5541$var$T = !1, $e387846ef7dd5541$var$U = !1;
function $e387846ef7dd5541$var$V(a) {
    for(var b = $e387846ef7dd5541$var$L($e387846ef7dd5541$var$O); null !== b;){
        if (null === b.callback) $e387846ef7dd5541$var$M($e387846ef7dd5541$var$O);
        else if (b.startTime <= a) $e387846ef7dd5541$var$M($e387846ef7dd5541$var$O), b.sortIndex = b.expirationTime, $e387846ef7dd5541$var$J($e387846ef7dd5541$var$N, b);
        else break;
        b = $e387846ef7dd5541$var$L($e387846ef7dd5541$var$O);
    }
}
function $e387846ef7dd5541$var$W(a) {
    $e387846ef7dd5541$var$U = !1;
    $e387846ef7dd5541$var$V(a);
    if (!$e387846ef7dd5541$var$T) {
        if (null !== $e387846ef7dd5541$var$L($e387846ef7dd5541$var$N)) $e387846ef7dd5541$var$T = !0, $e387846ef7dd5541$var$f($e387846ef7dd5541$var$X);
        else {
            var b = $e387846ef7dd5541$var$L($e387846ef7dd5541$var$O);
            null !== b && $e387846ef7dd5541$var$g($e387846ef7dd5541$var$W, b.startTime - a);
        }
    }
}
function $e387846ef7dd5541$var$X(a, b) {
    $e387846ef7dd5541$var$T = !1;
    $e387846ef7dd5541$var$U && ($e387846ef7dd5541$var$U = !1, $e387846ef7dd5541$var$h());
    $e387846ef7dd5541$var$S = !0;
    var c = $e387846ef7dd5541$var$R;
    try {
        $e387846ef7dd5541$var$V(b);
        for($e387846ef7dd5541$var$Q = $e387846ef7dd5541$var$L($e387846ef7dd5541$var$N); null !== $e387846ef7dd5541$var$Q && (!($e387846ef7dd5541$var$Q.expirationTime > b) || a && !$e387846ef7dd5541$var$k());){
            var d = $e387846ef7dd5541$var$Q.callback;
            if (null !== d) {
                $e387846ef7dd5541$var$Q.callback = null;
                $e387846ef7dd5541$var$R = $e387846ef7dd5541$var$Q.priorityLevel;
                var e = d($e387846ef7dd5541$var$Q.expirationTime <= b);
                b = module.exports.unstable_now();
                "function" === typeof e ? $e387846ef7dd5541$var$Q.callback = e : $e387846ef7dd5541$var$Q === $e387846ef7dd5541$var$L($e387846ef7dd5541$var$N) && $e387846ef7dd5541$var$M($e387846ef7dd5541$var$N);
                $e387846ef7dd5541$var$V(b);
            } else $e387846ef7dd5541$var$M($e387846ef7dd5541$var$N);
            $e387846ef7dd5541$var$Q = $e387846ef7dd5541$var$L($e387846ef7dd5541$var$N);
        }
        if (null !== $e387846ef7dd5541$var$Q) var m = !0;
        else {
            var n = $e387846ef7dd5541$var$L($e387846ef7dd5541$var$O);
            null !== n && $e387846ef7dd5541$var$g($e387846ef7dd5541$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $e387846ef7dd5541$var$Q = null, $e387846ef7dd5541$var$R = c, $e387846ef7dd5541$var$S = !1;
    }
}
function $e387846ef7dd5541$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $e387846ef7dd5541$var$Z = $e387846ef7dd5541$var$l;
module.exports.unstable_ImmediatePriority = 1;
module.exports.unstable_UserBlockingPriority = 2;
module.exports.unstable_NormalPriority = 3;
module.exports.unstable_IdlePriority = 5;
module.exports.unstable_LowPriority = 4;
module.exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $e387846ef7dd5541$var$R;
    $e387846ef7dd5541$var$R = a;
    try {
        return b();
    } finally{
        $e387846ef7dd5541$var$R = c;
    }
};
module.exports.unstable_next = function(a) {
    switch($e387846ef7dd5541$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $e387846ef7dd5541$var$R;
    }
    var c = $e387846ef7dd5541$var$R;
    $e387846ef7dd5541$var$R = b;
    try {
        return a();
    } finally{
        $e387846ef7dd5541$var$R = c;
    }
};
module.exports.unstable_scheduleCallback = function(a, b, c) {
    var d = module.exports.unstable_now();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $e387846ef7dd5541$var$Y(a);
    } else c = $e387846ef7dd5541$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $e387846ef7dd5541$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $e387846ef7dd5541$var$J($e387846ef7dd5541$var$O, a), null === $e387846ef7dd5541$var$L($e387846ef7dd5541$var$N) && a === $e387846ef7dd5541$var$L($e387846ef7dd5541$var$O) && ($e387846ef7dd5541$var$U ? $e387846ef7dd5541$var$h() : $e387846ef7dd5541$var$U = !0, $e387846ef7dd5541$var$g($e387846ef7dd5541$var$W, e - d))) : (a.sortIndex = c, $e387846ef7dd5541$var$J($e387846ef7dd5541$var$N, a), $e387846ef7dd5541$var$T || $e387846ef7dd5541$var$S || ($e387846ef7dd5541$var$T = !0, $e387846ef7dd5541$var$f($e387846ef7dd5541$var$X)));
    return a;
};
module.exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
module.exports.unstable_wrapCallback = function(a) {
    var b = $e387846ef7dd5541$var$R;
    return function() {
        var c = $e387846ef7dd5541$var$R;
        $e387846ef7dd5541$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $e387846ef7dd5541$var$R = c;
        }
    };
};
module.exports.unstable_getCurrentPriorityLevel = function() {
    return $e387846ef7dd5541$var$R;
};
module.exports.unstable_shouldYield = function() {
    var a = module.exports.unstable_now();
    $e387846ef7dd5541$var$V(a);
    var b = $e387846ef7dd5541$var$L($e387846ef7dd5541$var$N);
    return b !== $e387846ef7dd5541$var$Q && null !== $e387846ef7dd5541$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $e387846ef7dd5541$var$Q.expirationTime || $e387846ef7dd5541$var$k();
};
module.exports.unstable_requestPaint = $e387846ef7dd5541$var$Z;
module.exports.unstable_continueExecution = function() {
    $e387846ef7dd5541$var$T || $e387846ef7dd5541$var$S || ($e387846ef7dd5541$var$T = !0, $e387846ef7dd5541$var$f($e387846ef7dd5541$var$X));
};
module.exports.unstable_pauseExecution = function() {};
module.exports.unstable_getFirstCallbackNode = function() {
    return $e387846ef7dd5541$var$L($e387846ef7dd5541$var$N);
};
module.exports.unstable_Profiling = null;

});



// **N3Lexer** tokenizes N3 documents.
const $9b58994fe65d4758$var$RDF = "http://www.w3.org/1999/02/22-rdf-syntax-ns#", $9b58994fe65d4758$var$XSD = "http://www.w3.org/2001/XMLSchema#", $9b58994fe65d4758$var$SWAP = "http://www.w3.org/2000/10/swap/";
var $9b58994fe65d4758$export$2e2bcd8739ae039 = {
    xsd: {
        decimal: `${$9b58994fe65d4758$var$XSD}decimal`,
        boolean: `${$9b58994fe65d4758$var$XSD}boolean`,
        double: `${$9b58994fe65d4758$var$XSD}double`,
        integer: `${$9b58994fe65d4758$var$XSD}integer`,
        string: `${$9b58994fe65d4758$var$XSD}string`
    },
    rdf: {
        type: `${$9b58994fe65d4758$var$RDF}type`,
        nil: `${$9b58994fe65d4758$var$RDF}nil`,
        first: `${$9b58994fe65d4758$var$RDF}first`,
        rest: `${$9b58994fe65d4758$var$RDF}rest`,
        langString: `${$9b58994fe65d4758$var$RDF}langString`
    },
    owl: {
        sameAs: "http://www.w3.org/2002/07/owl#sameAs"
    },
    r: {
        forSome: `${$9b58994fe65d4758$var$SWAP}reify#forSome`,
        forAll: `${$9b58994fe65d4758$var$SWAP}reify#forAll`
    },
    log: {
        implies: `${$9b58994fe65d4758$var$SWAP}log#implies`
    }
};


var $b55cf5d9f088215c$exports = {};
/*! queue-microtask. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ let $b55cf5d9f088215c$var$promise;
$b55cf5d9f088215c$exports = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : $parcel$global) : (cb)=>($b55cf5d9f088215c$var$promise || ($b55cf5d9f088215c$var$promise = Promise.resolve())).then(cb).catch((err)=>setTimeout(()=>{
            throw err;
        }, 0));



var $4mEhT = parcelRequire("4mEhT");
var $06829f691c650db7$require$Buffer = $4mEhT.Buffer;
const { xsd: $06829f691c650db7$var$xsd } = (0, $9b58994fe65d4758$export$2e2bcd8739ae039);
// Regular expression and replacement string to escape N3 strings
const $06829f691c650db7$var$escapeSequence = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{8})|\\([^])/g;
const $06829f691c650db7$var$escapeReplacements = {
    "\\": "\\",
    "'": "'",
    '"': '"',
    "n": "\n",
    "r": "\r",
    "t": "	",
    "f": "\f",
    "b": "\b",
    "_": "_",
    "~": "~",
    ".": ".",
    "-": "-",
    "!": "!",
    "$": "$",
    "&": "&",
    "(": "(",
    ")": ")",
    "*": "*",
    "+": "+",
    ",": ",",
    ";": ";",
    "=": "=",
    "/": "/",
    "?": "?",
    "#": "#",
    "@": "@",
    "%": "%"
};
const $06829f691c650db7$var$illegalIriChars = /[\x00-\x20<>\\"\{\}\|\^\`]/;
const $06829f691c650db7$var$lineModeRegExps = {
    _iri: true,
    _unescapedIri: true,
    _simpleQuotedString: true,
    _langcode: true,
    _blank: true,
    _newline: true,
    _comment: true,
    _whitespace: true,
    _endOfFile: true
};
const $06829f691c650db7$var$invalidRegExp = /$0^/;
class $06829f691c650db7$export$2e2bcd8739ae039 {
    constructor(options){
        // ## Regular expressions
        // It's slightly faster to have these as properties than as in-scope variables
        this._iri = /^<((?:[^ <>{}\\]|\\[uU])+)>[ \t]*/; // IRI with escape sequences; needs sanity check after unescaping
        this._unescapedIri = /^<([^\x00-\x20<>\\"\{\}\|\^\`]*)>[ \t]*/; // IRI without escape sequences; no unescaping
        this._simpleQuotedString = /^"([^"\\\r\n]*)"(?=[^"])/; // string without escape sequences
        this._simpleApostropheString = /^'([^'\\\r\n]*)'(?=[^'])/;
        this._langcode = /^@([a-z]+(?:-[a-z0-9]+)*)(?=[^a-z0-9\-])/i;
        this._prefix = /^((?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)?:(?=[#\s<])/;
        this._prefixed = /^((?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)?:((?:(?:[0-:A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~])(?:(?:[\.\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~])*(?:[\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~]))?)?)(?:[ \t]+|(?=\.?[,;!\^\s#()\[\]\{\}"'<>]))/;
        this._variable = /^\?(?:(?:[A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:[\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)(?=[.,;!\^\s#()\[\]\{\}"'<>])/;
        this._blank = /^_:((?:[0-9A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)(?:[ \t]+|(?=\.?[,;:\s#()\[\]\{\}"'<>]))/;
        this._number = /^[\-+]?(?:(\d+\.\d*|\.?\d+)[eE][\-+]?|\d*(\.)?)\d+(?=\.?[,;:\s#()\[\]\{\}"'<>])/;
        this._boolean = /^(?:true|false)(?=[.,;\s#()\[\]\{\}"'<>])/;
        this._keyword = /^@[a-z]+(?=[\s#<:])/i;
        this._sparqlKeyword = /^(?:PREFIX|BASE|GRAPH)(?=[\s#<])/i;
        this._shortPredicates = /^a(?=[\s#()\[\]\{\}"'<>])/;
        this._newline = /^[ \t]*(?:#[^\n\r]*)?(?:\r\n|\n|\r)[ \t]*/;
        this._comment = /#([^\n\r]*)/;
        this._whitespace = /^[ \t]+/;
        this._endOfFile = /^(?:#[^\n\r]*)?$/;
        options = options || {};
        // In line mode (N-Triples or N-Quads), only simple features may be parsed
        if (this._lineMode = !!options.lineMode) {
            this._n3Mode = false;
            // Don't tokenize special literals
            for(const key in this)if (!(key in $06829f691c650db7$var$lineModeRegExps) && this[key] instanceof RegExp) this[key] = $06829f691c650db7$var$invalidRegExp;
        } else this._n3Mode = options.n3 !== false;
        // Don't output comment tokens by default
        this._comments = !!options.comments;
        // Cache the last tested closing position of long literals
        this._literalClosingPos = 0;
    }
    // ## Private methods
    // ### `_tokenizeToEnd` tokenizes as for as possible, emitting tokens through the callback
    _tokenizeToEnd(callback, inputFinished) {
        // Continue parsing as far as possible; the loop will return eventually
        let input = this._input;
        let currentLineLength = input.length;
        while(true){
            // Count and skip whitespace lines
            let whiteSpaceMatch, comment;
            while(whiteSpaceMatch = this._newline.exec(input)){
                // Try to find a comment
                if (this._comments && (comment = this._comment.exec(whiteSpaceMatch[0]))) emitToken("comment", comment[1], "", this._line, whiteSpaceMatch[0].length);
                // Advance the input
                input = input.substr(whiteSpaceMatch[0].length, input.length);
                currentLineLength = input.length;
                this._line++;
            }
            // Skip whitespace on current line
            if (!whiteSpaceMatch && (whiteSpaceMatch = this._whitespace.exec(input))) input = input.substr(whiteSpaceMatch[0].length, input.length);
            // Stop for now if we're at the end
            if (this._endOfFile.test(input)) {
                // If the input is finished, emit EOF
                if (inputFinished) {
                    // Try to find a final comment
                    if (this._comments && (comment = this._comment.exec(input))) emitToken("comment", comment[1], "", this._line, input.length);
                    input = null;
                    emitToken("eof", "", "", this._line, 0);
                }
                return this._input = input;
            }
            // Look for specific token types based on the first character
            const line = this._line, firstChar = input[0];
            let type = "", value = "", prefix = "", match = null, matchLength = 0, inconclusive = false;
            switch(firstChar){
                case "^":
                    // We need at least 3 tokens lookahead to distinguish ^^<IRI> and ^^pre:fixed
                    if (input.length < 3) break;
                    else if (input[1] === "^") {
                        this._previousMarker = "^^";
                        // Move to type IRI or prefixed name
                        input = input.substr(2);
                        if (input[0] !== "<") {
                            inconclusive = true;
                            break;
                        }
                    } else {
                        if (this._n3Mode) {
                            matchLength = 1;
                            type = "^";
                        }
                        break;
                    }
                // Fall through in case the type is an IRI
                case "<":
                    // Try to find a full IRI without escape sequences
                    if (match = this._unescapedIri.exec(input)) type = "IRI", value = match[1];
                    else if (match = this._iri.exec(input)) {
                        value = this._unescape(match[1]);
                        if (value === null || $06829f691c650db7$var$illegalIriChars.test(value)) return reportSyntaxError(this);
                        type = "IRI";
                    } else if (input.length > 1 && input[1] === "<") type = "<<", matchLength = 2;
                    else if (this._n3Mode && input.length > 1 && input[1] === "=") type = "inverse", matchLength = 2, value = ">";
                    break;
                case ">":
                    if (input.length > 1 && input[1] === ">") type = ">>", matchLength = 2;
                    break;
                case "_":
                    // Try to find a blank node. Since it can contain (but not end with) a dot,
                    // we always need a non-dot character before deciding it is a blank node.
                    // Therefore, try inserting a space if we're at the end of the input.
                    if ((match = this._blank.exec(input)) || inputFinished && (match = this._blank.exec(`${input} `))) type = "blank", prefix = "_", value = match[1];
                    break;
                case '"':
                    // Try to find a literal without escape sequences
                    if (match = this._simpleQuotedString.exec(input)) value = match[1];
                    else {
                        ({ value: value, matchLength: matchLength } = this._parseLiteral(input));
                        if (value === null) return reportSyntaxError(this);
                    }
                    if (match !== null || matchLength !== 0) {
                        type = "literal";
                        this._literalClosingPos = 0;
                    }
                    break;
                case "'":
                    if (!this._lineMode) {
                        // Try to find a literal without escape sequences
                        if (match = this._simpleApostropheString.exec(input)) value = match[1];
                        else {
                            ({ value: value, matchLength: matchLength } = this._parseLiteral(input));
                            if (value === null) return reportSyntaxError(this);
                        }
                        if (match !== null || matchLength !== 0) {
                            type = "literal";
                            this._literalClosingPos = 0;
                        }
                    }
                    break;
                case "?":
                    // Try to find a variable
                    if (this._n3Mode && (match = this._variable.exec(input))) type = "var", value = match[0];
                    break;
                case "@":
                    // Try to find a language code
                    if (this._previousMarker === "literal" && (match = this._langcode.exec(input))) type = "langcode", value = match[1];
                    else if (match = this._keyword.exec(input)) type = match[0];
                    break;
                case ".":
                    // Try to find a dot as punctuation
                    if (input.length === 1 ? inputFinished : input[1] < "0" || input[1] > "9") {
                        type = ".";
                        matchLength = 1;
                        break;
                    }
                // Fall through to numerical case (could be a decimal dot)
                case "0":
                case "1":
                case "2":
                case "3":
                case "4":
                case "5":
                case "6":
                case "7":
                case "8":
                case "9":
                case "+":
                case "-":
                    // Try to find a number. Since it can contain (but not end with) a dot,
                    // we always need a non-dot character before deciding it is a number.
                    // Therefore, try inserting a space if we're at the end of the input.
                    if (match = this._number.exec(input) || inputFinished && (match = this._number.exec(`${input} `))) {
                        type = "literal", value = match[0];
                        prefix = typeof match[1] === "string" ? $06829f691c650db7$var$xsd.double : typeof match[2] === "string" ? $06829f691c650db7$var$xsd.decimal : $06829f691c650db7$var$xsd.integer;
                    }
                    break;
                case "B":
                case "b":
                case "p":
                case "P":
                case "G":
                case "g":
                    // Try to find a SPARQL-style keyword
                    if (match = this._sparqlKeyword.exec(input)) type = match[0].toUpperCase();
                    else inconclusive = true;
                    break;
                case "f":
                case "t":
                    // Try to match a boolean
                    if (match = this._boolean.exec(input)) type = "literal", value = match[0], prefix = $06829f691c650db7$var$xsd.boolean;
                    else inconclusive = true;
                    break;
                case "a":
                    // Try to find an abbreviated predicate
                    if (match = this._shortPredicates.exec(input)) type = "abbreviation", value = "a";
                    else inconclusive = true;
                    break;
                case "=":
                    // Try to find an implication arrow or equals sign
                    if (this._n3Mode && input.length > 1) {
                        type = "abbreviation";
                        if (input[1] !== ">") matchLength = 1, value = "=";
                        else matchLength = 2, value = ">";
                    }
                    break;
                case "!":
                    if (!this._n3Mode) break;
                case ",":
                case ";":
                case "[":
                case "]":
                case "(":
                case ")":
                case "}":
                    if (!this._lineMode) {
                        matchLength = 1;
                        type = firstChar;
                    }
                    break;
                case "{":
                    // We need at least 2 tokens lookahead to distinguish "{|" and "{ "
                    if (!this._lineMode && input.length >= 2) {
                        // Try to find a quoted triple annotation start
                        if (input[1] === "|") type = "{|", matchLength = 2;
                        else type = firstChar, matchLength = 1;
                    }
                    break;
                case "|":
                    // We need 2 tokens lookahead to parse "|}"
                    // Try to find a quoted triple annotation end
                    if (input.length >= 2 && input[1] === "}") type = "|}", matchLength = 2;
                    break;
                default:
                    inconclusive = true;
            }
            // Some first characters do not allow an immediate decision, so inspect more
            if (inconclusive) {
                // Try to find a prefix
                if ((this._previousMarker === "@prefix" || this._previousMarker === "PREFIX") && (match = this._prefix.exec(input))) type = "prefix", value = match[1] || "";
                else if ((match = this._prefixed.exec(input)) || inputFinished && (match = this._prefixed.exec(`${input} `))) type = "prefixed", prefix = match[1] || "", value = this._unescape(match[2]);
            }
            // A type token is special: it can only be emitted after an IRI or prefixed name is read
            if (this._previousMarker === "^^") switch(type){
                case "prefixed":
                    type = "type";
                    break;
                case "IRI":
                    type = "typeIRI";
                    break;
                default:
                    type = "";
            }
            // What if nothing of the above was found?
            if (!type) {
                // We could be in streaming mode, and then we just wait for more input to arrive.
                // Otherwise, a syntax error has occurred in the input.
                // One exception: error on an unaccounted linebreak (= not inside a triple-quoted literal).
                if (inputFinished || !/^'''|^"""/.test(input) && /\n|\r/.test(input)) return reportSyntaxError(this);
                else return this._input = input;
            }
            // Emit the parsed token
            const length = matchLength || match[0].length;
            const token = emitToken(type, value, prefix, line, length);
            this.previousToken = token;
            this._previousMarker = type;
            // Advance to next part to tokenize
            input = input.substr(length, input.length);
        }
        // Emits the token through the callback
        function emitToken(type, value, prefix, line, length) {
            const start = input ? currentLineLength - input.length : currentLineLength;
            const end = start + length;
            const token = {
                type: type,
                value: value,
                prefix: prefix,
                line: line,
                start: start,
                end: end
            };
            callback(null, token);
            return token;
        }
        // Signals the syntax error through the callback
        function reportSyntaxError(self) {
            callback(self._syntaxError(/^\S*/.exec(input)[0]));
        }
    }
    // ### `_unescape` replaces N3 escape codes by their corresponding characters
    _unescape(item) {
        let invalid = false;
        const replaced = item.replace($06829f691c650db7$var$escapeSequence, (sequence, unicode4, unicode8, escapedChar)=>{
            // 4-digit unicode character
            if (typeof unicode4 === "string") return String.fromCharCode(Number.parseInt(unicode4, 16));
            // 8-digit unicode character
            if (typeof unicode8 === "string") {
                let charCode = Number.parseInt(unicode8, 16);
                return charCode <= 0xFFFF ? String.fromCharCode(Number.parseInt(unicode8, 16)) : String.fromCharCode(0xD800 + ((charCode -= 0x10000) >> 10), 0xDC00 + (charCode & 0x3FF));
            }
            // fixed escape sequence
            if (escapedChar in $06829f691c650db7$var$escapeReplacements) return $06829f691c650db7$var$escapeReplacements[escapedChar];
            // invalid escape sequence
            invalid = true;
            return "";
        });
        return invalid ? null : replaced;
    }
    // ### `_parseLiteral` parses a literal into an unescaped value
    _parseLiteral(input) {
        // Ensure we have enough lookahead to identify triple-quoted strings
        if (input.length >= 3) {
            // Identify the opening quote(s)
            const opening = input.match(/^(?:"""|"|'''|'|)/)[0];
            const openingLength = opening.length;
            // Find the next candidate closing quotes
            let closingPos = Math.max(this._literalClosingPos, openingLength);
            while((closingPos = input.indexOf(opening, closingPos)) > 0){
                // Count backslashes right before the closing quotes
                let backslashCount = 0;
                while(input[closingPos - backslashCount - 1] === "\\")backslashCount++;
                // An even number of backslashes (in particular 0)
                // means these are actual, non-escaped closing quotes
                if (backslashCount % 2 === 0) {
                    // Extract and unescape the value
                    const raw = input.substring(openingLength, closingPos);
                    const lines = raw.split(/\r\n|\r|\n/).length - 1;
                    const matchLength = closingPos + openingLength;
                    // Only triple-quoted strings can be multi-line
                    if (openingLength === 1 && lines !== 0 || openingLength === 3 && this._lineMode) break;
                    this._line += lines;
                    return {
                        value: this._unescape(raw),
                        matchLength: matchLength
                    };
                }
                closingPos++;
            }
            this._literalClosingPos = input.length - openingLength + 1;
        }
        return {
            value: "",
            matchLength: 0
        };
    }
    // ### `_syntaxError` creates a syntax error for the given issue
    _syntaxError(issue) {
        this._input = null;
        const err = new Error(`Unexpected "${issue}" on line ${this._line}.`);
        err.context = {
            token: undefined,
            line: this._line,
            previousToken: this.previousToken
        };
        return err;
    }
    // ### Strips off any starting UTF BOM mark.
    _readStartingBom(input) {
        return input.startsWith("\uFEFF") ? input.substr(1) : input;
    }
    // ## Public methods
    // ### `tokenize` starts the transformation of an N3 document into an array of tokens.
    // The input can be a string or a stream.
    tokenize(input, callback) {
        this._line = 1;
        // If the input is a string, continuously emit tokens through the callback until the end
        if (typeof input === "string") {
            this._input = this._readStartingBom(input);
            // If a callback was passed, asynchronously call it
            if (typeof callback === "function") (0, (/*@__PURE__*/$parcel$interopDefault($b55cf5d9f088215c$exports)))(()=>this._tokenizeToEnd(callback, true));
            else {
                const tokens = [];
                let error;
                this._tokenizeToEnd((e, t)=>e ? error = e : tokens.push(t), true);
                if (error) throw error;
                return tokens;
            }
        } else {
            this._pendingBuffer = null;
            if (typeof input.setEncoding === "function") input.setEncoding("utf8");
            // Adds the data chunk to the buffer and parses as far as possible
            input.on("data", (data)=>{
                if (this._input !== null && data.length !== 0) {
                    // Prepend any previous pending writes
                    if (this._pendingBuffer) {
                        data = $06829f691c650db7$require$Buffer.concat([
                            this._pendingBuffer,
                            data
                        ]);
                        this._pendingBuffer = null;
                    }
                    // Hold if the buffer ends in an incomplete unicode sequence
                    if (data[data.length - 1] & 0x80) this._pendingBuffer = data;
                    else {
                        // Only read a BOM at the start
                        if (typeof this._input === "undefined") this._input = this._readStartingBom(typeof data === "string" ? data : data.toString());
                        else this._input += data;
                        this._tokenizeToEnd(callback, false);
                    }
                }
            });
            // Parses until the end
            input.on("end", ()=>{
                if (typeof this._input === "string") this._tokenizeToEnd(callback, true);
            });
            input.on("error", callback);
        }
    }
}


// **N3Parser** parses N3 documents.

// N3.js implementations of the RDF/JS core data types
// See https://github.com/rdfjs/representation-task-force/blob/master/interface-spec.md

var $d6df86e8a0a82242$exports = {};

$parcel$export($d6df86e8a0a82242$exports, "isNamedNode", () => $d6df86e8a0a82242$export$10490ce738f72284);
$parcel$export($d6df86e8a0a82242$exports, "isBlankNode", () => $d6df86e8a0a82242$export$7b5b4967656acaac);
$parcel$export($d6df86e8a0a82242$exports, "isLiteral", () => $d6df86e8a0a82242$export$899158ea22bb4609);
$parcel$export($d6df86e8a0a82242$exports, "isVariable", () => $d6df86e8a0a82242$export$670a0c046e2ed227);
$parcel$export($d6df86e8a0a82242$exports, "isDefaultGraph", () => $d6df86e8a0a82242$export$1a29e0fa6b36b0c8);
$parcel$export($d6df86e8a0a82242$exports, "inDefaultGraph", () => $d6df86e8a0a82242$export$be8c4434e9c7c90b);
$parcel$export($d6df86e8a0a82242$exports, "prefix", () => $d6df86e8a0a82242$export$82e9f45cca5ba907);
$parcel$export($d6df86e8a0a82242$exports, "prefixes", () => $d6df86e8a0a82242$export$5d3c3f85c29a375);
// **N3Util** provides N3 utility functions.

function $d6df86e8a0a82242$export$10490ce738f72284(term) {
    return !!term && term.termType === "NamedNode";
}
function $d6df86e8a0a82242$export$7b5b4967656acaac(term) {
    return !!term && term.termType === "BlankNode";
}
function $d6df86e8a0a82242$export$899158ea22bb4609(term) {
    return !!term && term.termType === "Literal";
}
function $d6df86e8a0a82242$export$670a0c046e2ed227(term) {
    return !!term && term.termType === "Variable";
}
function $d6df86e8a0a82242$export$1a29e0fa6b36b0c8(term) {
    return !!term && term.termType === "DefaultGraph";
}
function $d6df86e8a0a82242$export$be8c4434e9c7c90b(quad) {
    return $d6df86e8a0a82242$export$1a29e0fa6b36b0c8(quad.graph);
}
function $d6df86e8a0a82242$export$82e9f45cca5ba907(iri, factory) {
    return $d6df86e8a0a82242$export$5d3c3f85c29a375({
        "": iri.value || iri
    }, factory)("");
}
function $d6df86e8a0a82242$export$5d3c3f85c29a375(defaultPrefixes, factory) {
    // Add all of the default prefixes
    const prefixes = Object.create(null);
    for(const prefix in defaultPrefixes)processPrefix(prefix, defaultPrefixes[prefix]);
    // Set the default factory if none was specified
    factory = factory || (0, $555d89d857a9ecd3$export$2e2bcd8739ae039);
    // Registers a new prefix (if an IRI was specified)
    // or retrieves a function that expands an existing prefix (if no IRI was specified)
    function processPrefix(prefix, iri) {
        // Create a new prefix if an IRI is specified or the prefix doesn't exist
        if (typeof iri === "string") {
            // Create a function that expands the prefix
            const cache = Object.create(null);
            prefixes[prefix] = (local)=>{
                return cache[local] || (cache[local] = factory.namedNode(iri + local));
            };
        } else if (!(prefix in prefixes)) throw new Error(`Unknown prefix: ${prefix}`);
        return prefixes[prefix];
    }
    return processPrefix;
}


const { rdf: $555d89d857a9ecd3$var$rdf, xsd: $555d89d857a9ecd3$var$xsd } = (0, $9b58994fe65d4758$export$2e2bcd8739ae039);
// eslint-disable-next-line prefer-const
let $555d89d857a9ecd3$var$DEFAULTGRAPH;
let $555d89d857a9ecd3$var$_blankNodeCounter = 0;
const $555d89d857a9ecd3$var$escapedLiteral = /^"(.*".*)(?="[^"]*$)/;
// ## DataFactory singleton
const $555d89d857a9ecd3$var$DataFactory = {
    namedNode: $555d89d857a9ecd3$var$namedNode,
    blankNode: $555d89d857a9ecd3$var$blankNode,
    variable: $555d89d857a9ecd3$var$variable,
    literal: $555d89d857a9ecd3$var$literal,
    defaultGraph: $555d89d857a9ecd3$var$defaultGraph,
    quad: $555d89d857a9ecd3$var$quad,
    triple: $555d89d857a9ecd3$var$quad
};
var $555d89d857a9ecd3$export$2e2bcd8739ae039 = $555d89d857a9ecd3$var$DataFactory;
class $555d89d857a9ecd3$export$656c1e606ad06131 {
    constructor(id){
        this.id = id;
    }
    // ### The value of this term
    get value() {
        return this.id;
    }
    // ### Returns whether this object represents the same term as the other
    equals(other) {
        // If both terms were created by this library,
        // equality can be computed through ids
        if (other instanceof $555d89d857a9ecd3$export$656c1e606ad06131) return this.id === other.id;
        // Otherwise, compare term type and value
        return !!other && this.termType === other.termType && this.value === other.value;
    }
    // ### Implement hashCode for Immutable.js, since we implement `equals`
    // https://immutable-js.com/docs/v4.0.0/ValueObject/#hashCode()
    hashCode() {
        return 0;
    }
    // ### Returns a plain object representation of this term
    toJSON() {
        return {
            termType: this.termType,
            value: this.value
        };
    }
}
class $555d89d857a9ecd3$export$e55689a56c4c92c2 extends $555d89d857a9ecd3$export$656c1e606ad06131 {
    // ### The term type of this term
    get termType() {
        return "NamedNode";
    }
}
class $555d89d857a9ecd3$export$e175ae9e414693bc extends $555d89d857a9ecd3$export$656c1e606ad06131 {
    // ### The term type of this term
    get termType() {
        return "Literal";
    }
    // ### The text value of this literal
    get value() {
        return this.id.substring(1, this.id.lastIndexOf('"'));
    }
    // ### The language of this literal
    get language() {
        // Find the last quotation mark (e.g., '"abc"@en-us')
        const id = this.id;
        let atPos = id.lastIndexOf('"') + 1;
        // If "@" it follows, return the remaining substring; empty otherwise
        return atPos < id.length && id[atPos++] === "@" ? id.substr(atPos).toLowerCase() : "";
    }
    // ### The datatype IRI of this literal
    get datatype() {
        return new $555d89d857a9ecd3$export$e55689a56c4c92c2(this.datatypeString);
    }
    // ### The datatype string of this literal
    get datatypeString() {
        // Find the last quotation mark (e.g., '"abc"^^http://ex.org/types#t')
        const id = this.id, dtPos = id.lastIndexOf('"') + 1;
        const char = dtPos < id.length ? id[dtPos] : "";
        // If "^" it follows, return the remaining substring
        return char === "^" ? id.substr(dtPos + 2) : // If "@" follows, return rdf:langString; xsd:string otherwise
        char !== "@" ? $555d89d857a9ecd3$var$xsd.string : $555d89d857a9ecd3$var$rdf.langString;
    }
    // ### Returns whether this object represents the same term as the other
    equals(other) {
        // If both literals were created by this library,
        // equality can be computed through ids
        if (other instanceof $555d89d857a9ecd3$export$e175ae9e414693bc) return this.id === other.id;
        // Otherwise, compare term type, value, language, and datatype
        return !!other && !!other.datatype && this.termType === other.termType && this.value === other.value && this.language === other.language && this.datatype.value === other.datatype.value;
    }
    toJSON() {
        return {
            termType: this.termType,
            value: this.value,
            language: this.language,
            datatype: {
                termType: "NamedNode",
                value: this.datatypeString
            }
        };
    }
}
class $555d89d857a9ecd3$export$1a8019c085269883 extends $555d89d857a9ecd3$export$656c1e606ad06131 {
    constructor(name){
        super(`_:${name}`);
    }
    // ### The term type of this term
    get termType() {
        return "BlankNode";
    }
    // ### The name of this blank node
    get value() {
        return this.id.substr(2);
    }
}
class $555d89d857a9ecd3$export$c867a5c9595a1350 extends $555d89d857a9ecd3$export$656c1e606ad06131 {
    constructor(name){
        super(`?${name}`);
    }
    // ### The term type of this term
    get termType() {
        return "Variable";
    }
    // ### The name of this variable
    get value() {
        return this.id.substr(1);
    }
}
class $555d89d857a9ecd3$export$4383f89a7161b240 extends $555d89d857a9ecd3$export$656c1e606ad06131 {
    constructor(){
        super("");
        return $555d89d857a9ecd3$var$DEFAULTGRAPH || this;
    }
    // ### The term type of this term
    get termType() {
        return "DefaultGraph";
    }
    // ### Returns whether this object represents the same term as the other
    equals(other) {
        // If both terms were created by this library,
        // equality can be computed through strict equality;
        // otherwise, compare term types.
        return this === other || !!other && this.termType === other.termType;
    }
}
// ## DefaultGraph singleton
$555d89d857a9ecd3$var$DEFAULTGRAPH = new $555d89d857a9ecd3$export$4383f89a7161b240();
function $555d89d857a9ecd3$export$85285e91bbd99cf(id, factory, nested) {
    factory = factory || $555d89d857a9ecd3$var$DataFactory;
    // Falsy value or empty string indicate the default graph
    if (!id) return factory.defaultGraph();
    // Identify the term type based on the first character
    switch(id[0]){
        case "?":
            return factory.variable(id.substr(1));
        case "_":
            return factory.blankNode(id.substr(2));
        case '"':
            // Shortcut for internal literals
            if (factory === $555d89d857a9ecd3$var$DataFactory) return new $555d89d857a9ecd3$export$e175ae9e414693bc(id);
            // Literal without datatype or language
            if (id[id.length - 1] === '"') return factory.literal(id.substr(1, id.length - 2));
            // Literal with datatype or language
            const endPos = id.lastIndexOf('"', id.length - 1);
            return factory.literal(id.substr(1, endPos - 1), id[endPos + 1] === "@" ? id.substr(endPos + 2) : factory.namedNode(id.substr(endPos + 3)));
        case "[":
            id = JSON.parse(id);
            break;
        default:
            if (!nested || !Array.isArray(id)) return factory.namedNode(id);
    }
    return factory.quad($555d89d857a9ecd3$export$85285e91bbd99cf(id[0], factory, true), $555d89d857a9ecd3$export$85285e91bbd99cf(id[1], factory, true), $555d89d857a9ecd3$export$85285e91bbd99cf(id[2], factory, true), id[3] && $555d89d857a9ecd3$export$85285e91bbd99cf(id[3], factory, true));
}
function $555d89d857a9ecd3$export$fbf03d1179c9227e(term, nested) {
    if (typeof term === "string") return term;
    if (term instanceof $555d89d857a9ecd3$export$656c1e606ad06131 && term.termType !== "Quad") return term.id;
    if (!term) return $555d89d857a9ecd3$var$DEFAULTGRAPH.id;
    // Term instantiated with another library
    switch(term.termType){
        case "NamedNode":
            return term.value;
        case "BlankNode":
            return `_:${term.value}`;
        case "Variable":
            return `?${term.value}`;
        case "DefaultGraph":
            return "";
        case "Literal":
            return `"${term.value}"${term.language ? `@${term.language}` : term.datatype && term.datatype.value !== $555d89d857a9ecd3$var$xsd.string ? `^^${term.datatype.value}` : ""}`;
        case "Quad":
            const res = [
                $555d89d857a9ecd3$export$fbf03d1179c9227e(term.subject, true),
                $555d89d857a9ecd3$export$fbf03d1179c9227e(term.predicate, true),
                $555d89d857a9ecd3$export$fbf03d1179c9227e(term.object, true)
            ];
            if (!(0, $d6df86e8a0a82242$export$1a29e0fa6b36b0c8)(term.graph)) res.push($555d89d857a9ecd3$export$fbf03d1179c9227e(term.graph, true));
            return nested ? res : JSON.stringify(res);
        default:
            throw new Error(`Unexpected termType: ${term.termType}`);
    }
}
class $555d89d857a9ecd3$export$7005c9eb6671414d extends $555d89d857a9ecd3$export$656c1e606ad06131 {
    constructor(subject, predicate, object, graph){
        super("");
        this._subject = subject;
        this._predicate = predicate;
        this._object = object;
        this._graph = graph || $555d89d857a9ecd3$var$DEFAULTGRAPH;
    }
    // ### The term type of this term
    get termType() {
        return "Quad";
    }
    get subject() {
        return this._subject;
    }
    get predicate() {
        return this._predicate;
    }
    get object() {
        return this._object;
    }
    get graph() {
        return this._graph;
    }
    // ### Returns a plain object representation of this quad
    toJSON() {
        return {
            termType: this.termType,
            subject: this._subject.toJSON(),
            predicate: this._predicate.toJSON(),
            object: this._object.toJSON(),
            graph: this._graph.toJSON()
        };
    }
    // ### Returns whether this object represents the same quad as the other
    equals(other) {
        return !!other && this._subject.equals(other.subject) && this._predicate.equals(other.predicate) && this._object.equals(other.object) && this._graph.equals(other.graph);
    }
}
function $555d89d857a9ecd3$export$3ff8cecf0aa87c28(id) {
    return id.replace($555d89d857a9ecd3$var$escapedLiteral, (_, quoted)=>`"${quoted.replace(/"/g, '""')}`);
}
function $555d89d857a9ecd3$export$7cedbcd33d1bf915(id) {
    return id.replace($555d89d857a9ecd3$var$escapedLiteral, (_, quoted)=>`"${quoted.replace(/""/g, '"')}`);
}
// ### Creates an IRI
function $555d89d857a9ecd3$var$namedNode(iri) {
    return new $555d89d857a9ecd3$export$e55689a56c4c92c2(iri);
}
// ### Creates a blank node
function $555d89d857a9ecd3$var$blankNode(name) {
    return new $555d89d857a9ecd3$export$1a8019c085269883(name || `n3-${$555d89d857a9ecd3$var$_blankNodeCounter++}`);
}
// ### Creates a literal
function $555d89d857a9ecd3$var$literal(value, languageOrDataType) {
    // Create a language-tagged string
    if (typeof languageOrDataType === "string") return new $555d89d857a9ecd3$export$e175ae9e414693bc(`"${value}"@${languageOrDataType.toLowerCase()}`);
    // Automatically determine datatype for booleans and numbers
    let datatype = languageOrDataType ? languageOrDataType.value : "";
    if (datatype === "") {
        // Convert a boolean
        if (typeof value === "boolean") datatype = $555d89d857a9ecd3$var$xsd.boolean;
        else if (typeof value === "number") {
            if (Number.isFinite(value)) datatype = Number.isInteger(value) ? $555d89d857a9ecd3$var$xsd.integer : $555d89d857a9ecd3$var$xsd.double;
            else {
                datatype = $555d89d857a9ecd3$var$xsd.double;
                if (!Number.isNaN(value)) value = value > 0 ? "INF" : "-INF";
            }
        }
    }
    // Create a datatyped literal
    return datatype === "" || datatype === $555d89d857a9ecd3$var$xsd.string ? new $555d89d857a9ecd3$export$e175ae9e414693bc(`"${value}"`) : new $555d89d857a9ecd3$export$e175ae9e414693bc(`"${value}"^^${datatype}`);
}
// ### Creates a variable
function $555d89d857a9ecd3$var$variable(name) {
    return new $555d89d857a9ecd3$export$c867a5c9595a1350(name);
}
// ### Returns the default graph
function $555d89d857a9ecd3$var$defaultGraph() {
    return $555d89d857a9ecd3$var$DEFAULTGRAPH;
}
// ### Creates a quad
function $555d89d857a9ecd3$var$quad(subject, predicate, object, graph) {
    return new $555d89d857a9ecd3$export$7005c9eb6671414d(subject, predicate, object, graph);
}



let $37274793fe7a5937$var$blankNodePrefix = 0;
class $37274793fe7a5937$export$2e2bcd8739ae039 {
    constructor(options){
        this._contextStack = [];
        this._graph = null;
        // Set the document IRI
        options = options || {};
        this._setBase(options.baseIRI);
        options.factory && $37274793fe7a5937$var$initDataFactory(this, options.factory);
        // Set supported features depending on the format
        const format = typeof options.format === "string" ? options.format.match(/\w*$/)[0].toLowerCase() : "", isTurtle = /turtle/.test(format), isTriG = /trig/.test(format), isNTriples = /triple/.test(format), isNQuads = /quad/.test(format), isN3 = this._n3Mode = /n3/.test(format), isLineMode = isNTriples || isNQuads;
        if (!(this._supportsNamedGraphs = !(isTurtle || isN3))) this._readPredicateOrNamedGraph = this._readPredicate;
        // Support triples in other graphs
        this._supportsQuads = !(isTurtle || isTriG || isNTriples || isN3);
        // Support nesting of triples
        this._supportsRDFStar = format === "" || /star|\*$/.test(format);
        // Disable relative IRIs in N-Triples or N-Quads mode
        if (isLineMode) this._resolveRelativeIRI = (iri)=>{
            return null;
        };
        this._blankNodePrefix = typeof options.blankNodePrefix !== "string" ? "" : options.blankNodePrefix.replace(/^(?!_:)/, "_:");
        this._lexer = options.lexer || new (0, $06829f691c650db7$export$2e2bcd8739ae039)({
            lineMode: isLineMode,
            n3: isN3
        });
        // Disable explicit quantifiers by default
        this._explicitQuantifiers = !!options.explicitQuantifiers;
    }
    // ## Static class methods
    // ### `_resetBlankNodePrefix` restarts blank node prefix identification
    static _resetBlankNodePrefix() {
        $37274793fe7a5937$var$blankNodePrefix = 0;
    }
    // ## Private methods
    // ### `_setBase` sets the base IRI to resolve relative IRIs
    _setBase(baseIRI) {
        if (!baseIRI) {
            this._base = "";
            this._basePath = "";
        } else {
            // Remove fragment if present
            const fragmentPos = baseIRI.indexOf("#");
            if (fragmentPos >= 0) baseIRI = baseIRI.substr(0, fragmentPos);
            // Set base IRI and its components
            this._base = baseIRI;
            this._basePath = baseIRI.indexOf("/") < 0 ? baseIRI : baseIRI.replace(/[^\/?]*(?:\?.*)?$/, "");
            baseIRI = baseIRI.match(/^(?:([a-z][a-z0-9+.-]*:))?(?:\/\/[^\/]*)?/i);
            this._baseRoot = baseIRI[0];
            this._baseScheme = baseIRI[1];
        }
    }
    // ### `_saveContext` stores the current parsing context
    // when entering a new scope (list, blank node, formula)
    _saveContext(type, graph, subject, predicate, object) {
        const n3Mode = this._n3Mode;
        this._contextStack.push({
            type: type,
            subject: subject,
            predicate: predicate,
            object: object,
            graph: graph,
            inverse: n3Mode ? this._inversePredicate : false,
            blankPrefix: n3Mode ? this._prefixes._ : "",
            quantified: n3Mode ? this._quantified : null
        });
        // The settings below only apply to N3 streams
        if (n3Mode) {
            // Every new scope resets the predicate direction
            this._inversePredicate = false;
            // In N3, blank nodes are scoped to a formula
            // (using a dot as separator, as a blank node label cannot start with it)
            this._prefixes._ = this._graph ? `${this._graph.value}.` : ".";
            // Quantifiers are scoped to a formula
            this._quantified = Object.create(this._quantified);
        }
    }
    // ### `_restoreContext` restores the parent context
    // when leaving a scope (list, blank node, formula)
    _restoreContext(type, token) {
        // Obtain the previous context
        const context = this._contextStack.pop();
        if (!context || context.type !== type) return this._error(`Unexpected ${token.type}`, token);
        // Restore the quad of the previous context
        this._subject = context.subject;
        this._predicate = context.predicate;
        this._object = context.object;
        this._graph = context.graph;
        // Restore N3 context settings
        if (this._n3Mode) {
            this._inversePredicate = context.inverse;
            this._prefixes._ = context.blankPrefix;
            this._quantified = context.quantified;
        }
    }
    // ### `_readInTopContext` reads a token when in the top context
    _readInTopContext(token) {
        switch(token.type){
            // If an EOF token arrives in the top context, signal that we're done
            case "eof":
                if (this._graph !== null) return this._error("Unclosed graph", token);
                delete this._prefixes._;
                return this._callback(null, null, this._prefixes);
            // It could be a prefix declaration
            case "PREFIX":
                this._sparqlStyle = true;
            case "@prefix":
                return this._readPrefix;
            // It could be a base declaration
            case "BASE":
                this._sparqlStyle = true;
            case "@base":
                return this._readBaseIRI;
            // It could be a graph
            case "{":
                if (this._supportsNamedGraphs) {
                    this._graph = "";
                    this._subject = null;
                    return this._readSubject;
                }
            case "GRAPH":
                if (this._supportsNamedGraphs) return this._readNamedGraphLabel;
            // Otherwise, the next token must be a subject
            default:
                return this._readSubject(token);
        }
    }
    // ### `_readEntity` reads an IRI, prefixed name, blank node, or variable
    _readEntity(token, quantifier) {
        let value;
        switch(token.type){
            // Read a relative or absolute IRI
            case "IRI":
            case "typeIRI":
                const iri = this._resolveIRI(token.value);
                if (iri === null) return this._error("Invalid IRI", token);
                value = this._namedNode(iri);
                break;
            // Read a prefixed name
            case "type":
            case "prefixed":
                const prefix = this._prefixes[token.prefix];
                if (prefix === undefined) return this._error(`Undefined prefix "${token.prefix}:"`, token);
                value = this._namedNode(prefix + token.value);
                break;
            // Read a blank node
            case "blank":
                value = this._blankNode(this._prefixes[token.prefix] + token.value);
                break;
            // Read a variable
            case "var":
                value = this._variable(token.value.substr(1));
                break;
            // Everything else is not an entity
            default:
                return this._error(`Expected entity but got ${token.type}`, token);
        }
        // In N3 mode, replace the entity if it is quantified
        if (!quantifier && this._n3Mode && value.id in this._quantified) value = this._quantified[value.id];
        return value;
    }
    // ### `_readSubject` reads a quad's subject
    _readSubject(token) {
        this._predicate = null;
        switch(token.type){
            case "[":
                // Start a new quad with a new blank node as subject
                this._saveContext("blank", this._graph, this._subject = this._blankNode(), null, null);
                return this._readBlankNodeHead;
            case "(":
                // Start a new list
                this._saveContext("list", this._graph, this.RDF_NIL, null, null);
                this._subject = null;
                return this._readListItem;
            case "{":
                // Start a new formula
                if (!this._n3Mode) return this._error("Unexpected graph", token);
                this._saveContext("formula", this._graph, this._graph = this._blankNode(), null, null);
                return this._readSubject;
            case "}":
                // No subject; the graph in which we are reading is closed instead
                return this._readPunctuation(token);
            case "@forSome":
                if (!this._n3Mode) return this._error('Unexpected "@forSome"', token);
                this._subject = null;
                this._predicate = this.N3_FORSOME;
                this._quantifier = this._blankNode;
                return this._readQuantifierList;
            case "@forAll":
                if (!this._n3Mode) return this._error('Unexpected "@forAll"', token);
                this._subject = null;
                this._predicate = this.N3_FORALL;
                this._quantifier = this._variable;
                return this._readQuantifierList;
            case "literal":
                if (!this._n3Mode) return this._error("Unexpected literal", token);
                if (token.prefix.length === 0) {
                    this._literalValue = token.value;
                    return this._completeSubjectLiteral;
                } else this._subject = this._literal(token.value, this._namedNode(token.prefix));
                break;
            case "<<":
                if (!this._supportsRDFStar) return this._error("Unexpected RDF* syntax", token);
                this._saveContext("<<", this._graph, null, null, null);
                this._graph = null;
                return this._readSubject;
            default:
                // Read the subject entity
                if ((this._subject = this._readEntity(token)) === undefined) return;
                // In N3 mode, the subject might be a path
                if (this._n3Mode) return this._getPathReader(this._readPredicateOrNamedGraph);
        }
        // The next token must be a predicate,
        // or, if the subject was actually a graph IRI, a named graph
        return this._readPredicateOrNamedGraph;
    }
    // ### `_readPredicate` reads a quad's predicate
    _readPredicate(token) {
        const type = token.type;
        switch(type){
            case "inverse":
                this._inversePredicate = true;
            case "abbreviation":
                this._predicate = this.ABBREVIATIONS[token.value];
                break;
            case ".":
            case "]":
            case "}":
                // Expected predicate didn't come, must have been trailing semicolon
                if (this._predicate === null) return this._error(`Unexpected ${type}`, token);
                this._subject = null;
                return type === "]" ? this._readBlankNodeTail(token) : this._readPunctuation(token);
            case ";":
                // Additional semicolons can be safely ignored
                return this._predicate !== null ? this._readPredicate : this._error("Expected predicate but got ;", token);
            case "[":
                if (this._n3Mode) {
                    // Start a new quad with a new blank node as subject
                    this._saveContext("blank", this._graph, this._subject, this._subject = this._blankNode(), null);
                    return this._readBlankNodeHead;
                }
            case "blank":
                if (!this._n3Mode) return this._error("Disallowed blank node as predicate", token);
            default:
                if ((this._predicate = this._readEntity(token)) === undefined) return;
        }
        // The next token must be an object
        return this._readObject;
    }
    // ### `_readObject` reads a quad's object
    _readObject(token) {
        switch(token.type){
            case "literal":
                // Regular literal, can still get a datatype or language
                if (token.prefix.length === 0) {
                    this._literalValue = token.value;
                    return this._readDataTypeOrLang;
                } else this._object = this._literal(token.value, this._namedNode(token.prefix));
                break;
            case "[":
                // Start a new quad with a new blank node as subject
                this._saveContext("blank", this._graph, this._subject, this._predicate, this._subject = this._blankNode());
                return this._readBlankNodeHead;
            case "(":
                // Start a new list
                this._saveContext("list", this._graph, this._subject, this._predicate, this.RDF_NIL);
                this._subject = null;
                return this._readListItem;
            case "{":
                // Start a new formula
                if (!this._n3Mode) return this._error("Unexpected graph", token);
                this._saveContext("formula", this._graph, this._subject, this._predicate, this._graph = this._blankNode());
                return this._readSubject;
            case "<<":
                if (!this._supportsRDFStar) return this._error("Unexpected RDF* syntax", token);
                this._saveContext("<<", this._graph, this._subject, this._predicate, null);
                this._graph = null;
                return this._readSubject;
            default:
                // Read the object entity
                if ((this._object = this._readEntity(token)) === undefined) return;
                // In N3 mode, the object might be a path
                if (this._n3Mode) return this._getPathReader(this._getContextEndReader());
        }
        return this._getContextEndReader();
    }
    // ### `_readPredicateOrNamedGraph` reads a quad's predicate, or a named graph
    _readPredicateOrNamedGraph(token) {
        return token.type === "{" ? this._readGraph(token) : this._readPredicate(token);
    }
    // ### `_readGraph` reads a graph
    _readGraph(token) {
        if (token.type !== "{") return this._error(`Expected graph but got ${token.type}`, token);
        // The "subject" we read is actually the GRAPH's label
        this._graph = this._subject, this._subject = null;
        return this._readSubject;
    }
    // ### `_readBlankNodeHead` reads the head of a blank node
    _readBlankNodeHead(token) {
        if (token.type === "]") {
            this._subject = null;
            return this._readBlankNodeTail(token);
        } else {
            this._predicate = null;
            return this._readPredicate(token);
        }
    }
    // ### `_readBlankNodeTail` reads the end of a blank node
    _readBlankNodeTail(token) {
        if (token.type !== "]") return this._readBlankNodePunctuation(token);
        // Store blank node quad
        if (this._subject !== null) this._emit(this._subject, this._predicate, this._object, this._graph);
        // Restore the parent context containing this blank node
        const empty = this._predicate === null;
        this._restoreContext("blank", token);
        // If the blank node was the object, restore previous context and read punctuation
        if (this._object !== null) return this._getContextEndReader();
        else if (this._predicate !== null) return this._readObject;
        else // If the blank node was empty, it could be a named graph label
        return empty ? this._readPredicateOrNamedGraph : this._readPredicateAfterBlank;
    }
    // ### `_readPredicateAfterBlank` reads a predicate after an anonymous blank node
    _readPredicateAfterBlank(token) {
        switch(token.type){
            case ".":
            case "}":
                // No predicate is coming if the triple is terminated here
                this._subject = null;
                return this._readPunctuation(token);
            default:
                return this._readPredicate(token);
        }
    }
    // ### `_readListItem` reads items from a list
    _readListItem(token) {
        let item = null, list = null, next = this._readListItem; // The next function to execute
        const previousList = this._subject, stack = this._contextStack, parent = stack[stack.length - 1]; // The parent containing the current list
        switch(token.type){
            case "[":
                // Stack the current list quad and start a new quad with a blank node as subject
                this._saveContext("blank", this._graph, list = this._blankNode(), this.RDF_FIRST, this._subject = item = this._blankNode());
                next = this._readBlankNodeHead;
                break;
            case "(":
                // Stack the current list quad and start a new list
                this._saveContext("list", this._graph, list = this._blankNode(), this.RDF_FIRST, this.RDF_NIL);
                this._subject = null;
                break;
            case ")":
                // Closing the list; restore the parent context
                this._restoreContext("list", token);
                // If this list is contained within a parent list, return the membership quad here.
                // This will be `<parent list element> rdf:first <this list>.`.
                if (stack.length !== 0 && stack[stack.length - 1].type === "list") this._emit(this._subject, this._predicate, this._object, this._graph);
                // Was this list the parent's subject?
                if (this._predicate === null) {
                    // The next token is the predicate
                    next = this._readPredicate;
                    // No list tail if this was an empty list
                    if (this._subject === this.RDF_NIL) return next;
                } else {
                    next = this._getContextEndReader();
                    // No list tail if this was an empty list
                    if (this._object === this.RDF_NIL) return next;
                }
                // Close the list by making the head nil
                list = this.RDF_NIL;
                break;
            case "literal":
                // Regular literal, can still get a datatype or language
                if (token.prefix.length === 0) {
                    this._literalValue = token.value;
                    next = this._readListItemDataTypeOrLang;
                } else {
                    item = this._literal(token.value, this._namedNode(token.prefix));
                    next = this._getContextEndReader();
                }
                break;
            case "{":
                // Start a new formula
                if (!this._n3Mode) return this._error("Unexpected graph", token);
                this._saveContext("formula", this._graph, this._subject, this._predicate, this._graph = this._blankNode());
                return this._readSubject;
            default:
                if ((item = this._readEntity(token)) === undefined) return;
        }
        // Create a new blank node if no item head was assigned yet
        if (list === null) this._subject = list = this._blankNode();
        // Is this the first element of the list?
        if (previousList === null) {
            // This list is either the subject or the object of its parent
            if (parent.predicate === null) parent.subject = list;
            else parent.object = list;
        } else // Continue the previous list with the current list
        this._emit(previousList, this.RDF_REST, list, this._graph);
        // If an item was read, add it to the list
        if (item !== null) {
            // In N3 mode, the item might be a path
            if (this._n3Mode && (token.type === "IRI" || token.type === "prefixed")) {
                // Create a new context to add the item's path
                this._saveContext("item", this._graph, list, this.RDF_FIRST, item);
                this._subject = item, this._predicate = null;
                // _readPath will restore the context and output the item
                return this._getPathReader(this._readListItem);
            }
            // Output the item
            this._emit(list, this.RDF_FIRST, item, this._graph);
        }
        return next;
    }
    // ### `_readDataTypeOrLang` reads an _optional_ datatype or language
    _readDataTypeOrLang(token) {
        return this._completeObjectLiteral(token, false);
    }
    // ### `_readListItemDataTypeOrLang` reads an _optional_ datatype or language in a list
    _readListItemDataTypeOrLang(token) {
        return this._completeObjectLiteral(token, true);
    }
    // ### `_completeLiteral` completes a literal with an optional datatype or language
    _completeLiteral(token) {
        // Create a simple string literal by default
        let literal = this._literal(this._literalValue);
        switch(token.type){
            // Create a datatyped literal
            case "type":
            case "typeIRI":
                const datatype = this._readEntity(token);
                if (datatype === undefined) return; // No datatype means an error occurred
                literal = this._literal(this._literalValue, datatype);
                token = null;
                break;
            // Create a language-tagged string
            case "langcode":
                literal = this._literal(this._literalValue, token.value);
                token = null;
                break;
        }
        return {
            token: token,
            literal: literal
        };
    }
    // Completes a literal in subject position
    _completeSubjectLiteral(token) {
        this._subject = this._completeLiteral(token).literal;
        return this._readPredicateOrNamedGraph;
    }
    // Completes a literal in object position
    _completeObjectLiteral(token, listItem) {
        const completed = this._completeLiteral(token);
        if (!completed) return;
        this._object = completed.literal;
        // If this literal was part of a list, write the item
        // (we could also check the context stack, but passing in a flag is faster)
        if (listItem) this._emit(this._subject, this.RDF_FIRST, this._object, this._graph);
        // If the token was consumed, continue with the rest of the input
        if (completed.token === null) return this._getContextEndReader();
        else {
            this._readCallback = this._getContextEndReader();
            return this._readCallback(completed.token);
        }
    }
    // ### `_readFormulaTail` reads the end of a formula
    _readFormulaTail(token) {
        if (token.type !== "}") return this._readPunctuation(token);
        // Store the last quad of the formula
        if (this._subject !== null) this._emit(this._subject, this._predicate, this._object, this._graph);
        // Restore the parent context containing this formula
        this._restoreContext("formula", token);
        // If the formula was the subject, continue reading the predicate.
        // If the formula was the object, read punctuation.
        return this._object === null ? this._readPredicate : this._getContextEndReader();
    }
    // ### `_readPunctuation` reads punctuation between quads or quad parts
    _readPunctuation(token) {
        let next, graph = this._graph;
        const subject = this._subject, inversePredicate = this._inversePredicate;
        switch(token.type){
            // A closing brace ends a graph
            case "}":
                if (this._graph === null) return this._error("Unexpected graph closing", token);
                if (this._n3Mode) return this._readFormulaTail(token);
                this._graph = null;
            // A dot just ends the statement, without sharing anything with the next
            case ".":
                this._subject = null;
                next = this._contextStack.length ? this._readSubject : this._readInTopContext;
                if (inversePredicate) this._inversePredicate = false;
                break;
            // Semicolon means the subject is shared; predicate and object are different
            case ";":
                next = this._readPredicate;
                break;
            // Comma means both the subject and predicate are shared; the object is different
            case ",":
                next = this._readObject;
                break;
            // {| means that the current triple is annotated with predicate-object pairs.
            case "{|":
                if (!this._supportsRDFStar) return this._error("Unexpected RDF* syntax", token);
                // Continue using the last triple as quoted triple subject for the predicate-object pairs.
                const predicate = this._predicate, object = this._object;
                this._subject = this._quad(subject, predicate, object, this.DEFAULTGRAPH);
                next = this._readPredicate;
                break;
            // |} means that the current quoted triple in annotation syntax is finalized.
            case "|}":
                if (this._subject.termType !== "Quad") return this._error("Unexpected asserted triple closing", token);
                this._subject = null;
                next = this._readPunctuation;
                break;
            default:
                // An entity means this is a quad (only allowed if not already inside a graph)
                if (this._supportsQuads && this._graph === null && (graph = this._readEntity(token)) !== undefined) {
                    next = this._readQuadPunctuation;
                    break;
                }
                return this._error(`Expected punctuation to follow "${this._object.id}"`, token);
        }
        // A quad has been completed now, so return it
        if (subject !== null) {
            const predicate = this._predicate, object = this._object;
            if (!inversePredicate) this._emit(subject, predicate, object, graph);
            else this._emit(object, predicate, subject, graph);
        }
        return next;
    }
    // ### `_readBlankNodePunctuation` reads punctuation in a blank node
    _readBlankNodePunctuation(token) {
        let next;
        switch(token.type){
            // Semicolon means the subject is shared; predicate and object are different
            case ";":
                next = this._readPredicate;
                break;
            // Comma means both the subject and predicate are shared; the object is different
            case ",":
                next = this._readObject;
                break;
            default:
                return this._error(`Expected punctuation to follow "${this._object.id}"`, token);
        }
        // A quad has been completed now, so return it
        this._emit(this._subject, this._predicate, this._object, this._graph);
        return next;
    }
    // ### `_readQuadPunctuation` reads punctuation after a quad
    _readQuadPunctuation(token) {
        if (token.type !== ".") return this._error("Expected dot to follow quad", token);
        return this._readInTopContext;
    }
    // ### `_readPrefix` reads the prefix of a prefix declaration
    _readPrefix(token) {
        if (token.type !== "prefix") return this._error("Expected prefix to follow @prefix", token);
        this._prefix = token.value;
        return this._readPrefixIRI;
    }
    // ### `_readPrefixIRI` reads the IRI of a prefix declaration
    _readPrefixIRI(token) {
        if (token.type !== "IRI") return this._error(`Expected IRI to follow prefix "${this._prefix}:"`, token);
        const prefixNode = this._readEntity(token);
        this._prefixes[this._prefix] = prefixNode.value;
        this._prefixCallback(this._prefix, prefixNode);
        return this._readDeclarationPunctuation;
    }
    // ### `_readBaseIRI` reads the IRI of a base declaration
    _readBaseIRI(token) {
        const iri = token.type === "IRI" && this._resolveIRI(token.value);
        if (!iri) return this._error("Expected valid IRI to follow base declaration", token);
        this._setBase(iri);
        return this._readDeclarationPunctuation;
    }
    // ### `_readNamedGraphLabel` reads the label of a named graph
    _readNamedGraphLabel(token) {
        switch(token.type){
            case "IRI":
            case "blank":
            case "prefixed":
                return this._readSubject(token), this._readGraph;
            case "[":
                return this._readNamedGraphBlankLabel;
            default:
                return this._error("Invalid graph label", token);
        }
    }
    // ### `_readNamedGraphLabel` reads a blank node label of a named graph
    _readNamedGraphBlankLabel(token) {
        if (token.type !== "]") return this._error("Invalid graph label", token);
        this._subject = this._blankNode();
        return this._readGraph;
    }
    // ### `_readDeclarationPunctuation` reads the punctuation of a declaration
    _readDeclarationPunctuation(token) {
        // SPARQL-style declarations don't have punctuation
        if (this._sparqlStyle) {
            this._sparqlStyle = false;
            return this._readInTopContext(token);
        }
        if (token.type !== ".") return this._error("Expected declaration to end with a dot", token);
        return this._readInTopContext;
    }
    // Reads a list of quantified symbols from a @forSome or @forAll statement
    _readQuantifierList(token) {
        let entity;
        switch(token.type){
            case "IRI":
            case "prefixed":
                if ((entity = this._readEntity(token, true)) !== undefined) break;
            default:
                return this._error(`Unexpected ${token.type}`, token);
        }
        // Without explicit quantifiers, map entities to a quantified entity
        if (!this._explicitQuantifiers) this._quantified[entity.id] = this._quantifier(this._blankNode().value);
        else {
            // If this is the first item, start a new quantifier list
            if (this._subject === null) this._emit(this._graph || this.DEFAULTGRAPH, this._predicate, this._subject = this._blankNode(), this.QUANTIFIERS_GRAPH);
            else this._emit(this._subject, this.RDF_REST, this._subject = this._blankNode(), this.QUANTIFIERS_GRAPH);
            // Output the list item
            this._emit(this._subject, this.RDF_FIRST, entity, this.QUANTIFIERS_GRAPH);
        }
        return this._readQuantifierPunctuation;
    }
    // Reads punctuation from a @forSome or @forAll statement
    _readQuantifierPunctuation(token) {
        // Read more quantifiers
        if (token.type === ",") return this._readQuantifierList;
        else {
            // With explicit quantifiers, close the quantifier list
            if (this._explicitQuantifiers) {
                this._emit(this._subject, this.RDF_REST, this.RDF_NIL, this.QUANTIFIERS_GRAPH);
                this._subject = null;
            }
            // Read a dot
            this._readCallback = this._getContextEndReader();
            return this._readCallback(token);
        }
    }
    // ### `_getPathReader` reads a potential path and then resumes with the given function
    _getPathReader(afterPath) {
        this._afterPath = afterPath;
        return this._readPath;
    }
    // ### `_readPath` reads a potential path
    _readPath(token) {
        switch(token.type){
            // Forward path
            case "!":
                return this._readForwardPath;
            // Backward path
            case "^":
                return this._readBackwardPath;
            // Not a path; resume reading where we left off
            default:
                const stack = this._contextStack, parent = stack.length && stack[stack.length - 1];
                // If we were reading a list item, we still need to output it
                if (parent && parent.type === "item") {
                    // The list item is the remaining subejct after reading the path
                    const item = this._subject;
                    // Switch back to the context of the list
                    this._restoreContext("item", token);
                    // Output the list item
                    this._emit(this._subject, this.RDF_FIRST, item, this._graph);
                }
                return this._afterPath(token);
        }
    }
    // ### `_readForwardPath` reads a '!' path
    _readForwardPath(token) {
        let subject, predicate;
        const object = this._blankNode();
        // The next token is the predicate
        if ((predicate = this._readEntity(token)) === undefined) return;
        // If we were reading a subject, replace the subject by the path's object
        if (this._predicate === null) subject = this._subject, this._subject = object;
        else subject = this._object, this._object = object;
        // Emit the path's current quad and read its next section
        this._emit(subject, predicate, object, this._graph);
        return this._readPath;
    }
    // ### `_readBackwardPath` reads a '^' path
    _readBackwardPath(token) {
        const subject = this._blankNode();
        let predicate, object;
        // The next token is the predicate
        if ((predicate = this._readEntity(token)) === undefined) return;
        // If we were reading a subject, replace the subject by the path's subject
        if (this._predicate === null) object = this._subject, this._subject = subject;
        else object = this._object, this._object = subject;
        // Emit the path's current quad and read its next section
        this._emit(subject, predicate, object, this._graph);
        return this._readPath;
    }
    // ### `_readRDFStarTailOrGraph` reads the graph of a nested RDF* quad or the end of a nested RDF* triple
    _readRDFStarTailOrGraph(token) {
        if (token.type !== ">>") {
            // An entity means this is a quad (only allowed if not already inside a graph)
            if (this._supportsQuads && this._graph === null && (this._graph = this._readEntity(token)) !== undefined) return this._readRDFStarTail;
            return this._error(`Expected >> to follow "${this._object.id}"`, token);
        }
        return this._readRDFStarTail(token);
    }
    // ### `_readRDFStarTail` reads the end of a nested RDF* triple
    _readRDFStarTail(token) {
        if (token.type !== ">>") return this._error(`Expected >> but got ${token.type}`, token);
        // Read the quad and restore the previous context
        const quad = this._quad(this._subject, this._predicate, this._object, this._graph || this.DEFAULTGRAPH);
        this._restoreContext("<<", token);
        // If the triple was the subject, continue by reading the predicate.
        if (this._subject === null) {
            this._subject = quad;
            return this._readPredicate;
        } else {
            this._object = quad;
            return this._getContextEndReader();
        }
    }
    // ### `_getContextEndReader` gets the next reader function at the end of a context
    _getContextEndReader() {
        const contextStack = this._contextStack;
        if (!contextStack.length) return this._readPunctuation;
        switch(contextStack[contextStack.length - 1].type){
            case "blank":
                return this._readBlankNodeTail;
            case "list":
                return this._readListItem;
            case "formula":
                return this._readFormulaTail;
            case "<<":
                return this._readRDFStarTailOrGraph;
        }
    }
    // ### `_emit` sends a quad through the callback
    _emit(subject, predicate, object, graph) {
        this._callback(null, this._quad(subject, predicate, object, graph || this.DEFAULTGRAPH));
    }
    // ### `_error` emits an error message through the callback
    _error(message, token) {
        const err = new Error(`${message} on line ${token.line}.`);
        err.context = {
            token: token,
            line: token.line,
            previousToken: this._lexer.previousToken
        };
        this._callback(err);
        this._callback = $37274793fe7a5937$var$noop;
    }
    // ### `_resolveIRI` resolves an IRI against the base path
    _resolveIRI(iri) {
        return /^[a-z][a-z0-9+.-]*:/i.test(iri) ? iri : this._resolveRelativeIRI(iri);
    }
    // ### `_resolveRelativeIRI` resolves an IRI against the base path,
    // assuming that a base path has been set and that the IRI is indeed relative
    _resolveRelativeIRI(iri) {
        // An empty relative IRI indicates the base IRI
        if (!iri.length) return this._base;
        // Decide resolving strategy based in the first character
        switch(iri[0]){
            // Resolve relative fragment IRIs against the base IRI
            case "#":
                return this._base + iri;
            // Resolve relative query string IRIs by replacing the query string
            case "?":
                return this._base.replace(/(?:\?.*)?$/, iri);
            // Resolve root-relative IRIs at the root of the base IRI
            case "/":
                // Resolve scheme-relative IRIs to the scheme
                return (iri[1] === "/" ? this._baseScheme : this._baseRoot) + this._removeDotSegments(iri);
            // Resolve all other IRIs at the base IRI's path
            default:
                // Relative IRIs cannot contain a colon in the first path segment
                return /^[^/:]*:/.test(iri) ? null : this._removeDotSegments(this._basePath + iri);
        }
    }
    // ### `_removeDotSegments` resolves './' and '../' path segments in an IRI as per RFC3986
    _removeDotSegments(iri) {
        // Don't modify the IRI if it does not contain any dot segments
        if (!/(^|\/)\.\.?($|[/#?])/.test(iri)) return iri;
        // Start with an imaginary slash before the IRI in order to resolve trailing './' and '../'
        const length = iri.length;
        let result = "", i = -1, pathStart = -1, segmentStart = 0, next = "/";
        while(i < length){
            switch(next){
                // The path starts with the first slash after the authority
                case ":":
                    if (pathStart < 0) {
                        // Skip two slashes before the authority
                        if (iri[++i] === "/" && iri[++i] === "/") // Skip to slash after the authority
                        while((pathStart = i + 1) < length && iri[pathStart] !== "/")i = pathStart;
                    }
                    break;
                // Don't modify a query string or fragment
                case "?":
                case "#":
                    i = length;
                    break;
                // Handle '/.' or '/..' path segments
                case "/":
                    if (iri[i + 1] === ".") {
                        next = iri[++i + 1];
                        switch(next){
                            // Remove a '/.' segment
                            case "/":
                                result += iri.substring(segmentStart, i - 1);
                                segmentStart = i + 1;
                                break;
                            // Remove a trailing '/.' segment
                            case undefined:
                            case "?":
                            case "#":
                                return result + iri.substring(segmentStart, i) + iri.substr(i + 1);
                            // Remove a '/..' segment
                            case ".":
                                next = iri[++i + 1];
                                if (next === undefined || next === "/" || next === "?" || next === "#") {
                                    result += iri.substring(segmentStart, i - 2);
                                    // Try to remove the parent path from result
                                    if ((segmentStart = result.lastIndexOf("/")) >= pathStart) result = result.substr(0, segmentStart);
                                    // Remove a trailing '/..' segment
                                    if (next !== "/") return `${result}/${iri.substr(i + 1)}`;
                                    segmentStart = i + 1;
                                }
                        }
                    }
            }
            next = iri[++i];
        }
        return result + iri.substring(segmentStart);
    }
    // ## Public methods
    // ### `parse` parses the N3 input and emits each parsed quad through the callback
    parse(input, quadCallback, prefixCallback) {
        // The read callback is the next function to be executed when a token arrives.
        // We start reading in the top context.
        this._readCallback = this._readInTopContext;
        this._sparqlStyle = false;
        this._prefixes = Object.create(null);
        this._prefixes._ = this._blankNodePrefix ? this._blankNodePrefix.substr(2) : `b${$37274793fe7a5937$var$blankNodePrefix++}_`;
        this._prefixCallback = prefixCallback || $37274793fe7a5937$var$noop;
        this._inversePredicate = false;
        this._quantified = Object.create(null);
        // Parse synchronously if no quad callback is given
        if (!quadCallback) {
            const quads = [];
            let error;
            this._callback = (e, t)=>{
                e ? error = e : t && quads.push(t);
            };
            this._lexer.tokenize(input).every((token)=>{
                return this._readCallback = this._readCallback(token);
            });
            if (error) throw error;
            return quads;
        }
        // Parse asynchronously otherwise, executing the read callback when a token arrives
        this._callback = quadCallback;
        this._lexer.tokenize(input, (error, token)=>{
            if (error !== null) this._callback(error), this._callback = $37274793fe7a5937$var$noop;
            else if (this._readCallback) this._readCallback = this._readCallback(token);
        });
    }
}
// The empty function
function $37274793fe7a5937$var$noop() {}
// Initializes the parser with the given data factory
function $37274793fe7a5937$var$initDataFactory(parser, factory) {
    // Set factory methods
    const namedNode = factory.namedNode;
    parser._namedNode = namedNode;
    parser._blankNode = factory.blankNode;
    parser._literal = factory.literal;
    parser._variable = factory.variable;
    parser._quad = factory.quad;
    parser.DEFAULTGRAPH = factory.defaultGraph();
    // Set common named nodes
    parser.RDF_FIRST = namedNode((0, $9b58994fe65d4758$export$2e2bcd8739ae039).rdf.first);
    parser.RDF_REST = namedNode((0, $9b58994fe65d4758$export$2e2bcd8739ae039).rdf.rest);
    parser.RDF_NIL = namedNode((0, $9b58994fe65d4758$export$2e2bcd8739ae039).rdf.nil);
    parser.N3_FORALL = namedNode((0, $9b58994fe65d4758$export$2e2bcd8739ae039).r.forAll);
    parser.N3_FORSOME = namedNode((0, $9b58994fe65d4758$export$2e2bcd8739ae039).r.forSome);
    parser.ABBREVIATIONS = {
        "a": namedNode((0, $9b58994fe65d4758$export$2e2bcd8739ae039).rdf.type),
        "=": namedNode((0, $9b58994fe65d4758$export$2e2bcd8739ae039).owl.sameAs),
        ">": namedNode((0, $9b58994fe65d4758$export$2e2bcd8739ae039).log.implies)
    };
    parser.QUANTIFIERS_GRAPH = namedNode("urn:n3:quantifiers");
}
$37274793fe7a5937$var$initDataFactory($37274793fe7a5937$export$2e2bcd8739ae039.prototype, (0, $555d89d857a9ecd3$export$2e2bcd8739ae039));


// **N3Writer** writes N3 documents.



const $32dfb6bd0d0c03b1$var$DEFAULTGRAPH = (0, $555d89d857a9ecd3$export$2e2bcd8739ae039).defaultGraph();
const { rdf: $32dfb6bd0d0c03b1$var$rdf, xsd: $32dfb6bd0d0c03b1$var$xsd } = (0, $9b58994fe65d4758$export$2e2bcd8739ae039);
// Characters in literals that require escaping
const $32dfb6bd0d0c03b1$var$escape = /["\\\t\n\r\b\f\u0000-\u0019\ud800-\udbff]/, $32dfb6bd0d0c03b1$var$escapeAll = /["\\\t\n\r\b\f\u0000-\u0019]|[\ud800-\udbff][\udc00-\udfff]/g, $32dfb6bd0d0c03b1$var$escapedCharacters = {
    "\\": "\\\\",
    '"': '\\"',
    "	": "\\t",
    "\n": "\\n",
    "\r": "\\r",
    "\b": "\\b",
    "\f": "\\f"
};
// ## Placeholder class to represent already pretty-printed terms
class $32dfb6bd0d0c03b1$var$SerializedTerm extends (0, $555d89d857a9ecd3$export$656c1e606ad06131) {
    // Pretty-printed nodes are not equal to any other node
    // (e.g., [] does not equal [])
    equals(other) {
        return other === this;
    }
}
class $32dfb6bd0d0c03b1$export$2e2bcd8739ae039 {
    constructor(outputStream, options){
        // ### `_prefixRegex` matches a prefixed name or IRI that begins with one of the added prefixes
        this._prefixRegex = /$0^/;
        // Shift arguments if the first argument is not a stream
        if (outputStream && typeof outputStream.write !== "function") options = outputStream, outputStream = null;
        options = options || {};
        this._lists = options.lists;
        // If no output stream given, send the output as string through the end callback
        if (!outputStream) {
            let output = "";
            this._outputStream = {
                write (chunk, encoding, done) {
                    output += chunk;
                    done && done();
                },
                end: (done)=>{
                    done && done(null, output);
                }
            };
            this._endStream = true;
        } else {
            this._outputStream = outputStream;
            this._endStream = options.end === undefined ? true : !!options.end;
        }
        // Initialize writer, depending on the format
        this._subject = null;
        if (!/triple|quad/i.test(options.format)) {
            this._lineMode = false;
            this._graph = $32dfb6bd0d0c03b1$var$DEFAULTGRAPH;
            this._prefixIRIs = Object.create(null);
            options.prefixes && this.addPrefixes(options.prefixes);
            if (options.baseIRI) {
                this._baseMatcher = new RegExp(`^${$32dfb6bd0d0c03b1$var$escapeRegex(options.baseIRI)}${options.baseIRI.endsWith("/") ? "" : "[#?]"}`);
                this._baseLength = options.baseIRI.length;
            }
        } else {
            this._lineMode = true;
            this._writeQuad = this._writeQuadLine;
        }
    }
    // ## Private methods
    // ### Whether the current graph is the default graph
    get _inDefaultGraph() {
        return $32dfb6bd0d0c03b1$var$DEFAULTGRAPH.equals(this._graph);
    }
    // ### `_write` writes the argument to the output stream
    _write(string, callback) {
        this._outputStream.write(string, "utf8", callback);
    }
    // ### `_writeQuad` writes the quad to the output stream
    _writeQuad(subject, predicate, object, graph, done) {
        try {
            // Write the graph's label if it has changed
            if (!graph.equals(this._graph)) {
                // Close the previous graph and start the new one
                this._write((this._subject === null ? "" : this._inDefaultGraph ? ".\n" : "\n}\n") + ($32dfb6bd0d0c03b1$var$DEFAULTGRAPH.equals(graph) ? "" : `${this._encodeIriOrBlank(graph)} {\n`));
                this._graph = graph;
                this._subject = null;
            }
            // Don't repeat the subject if it's the same
            if (subject.equals(this._subject)) {
                // Don't repeat the predicate if it's the same
                if (predicate.equals(this._predicate)) this._write(`, ${this._encodeObject(object)}`, done);
                else this._write(`;\n    ${this._encodePredicate(this._predicate = predicate)} ${this._encodeObject(object)}`, done);
            } else this._write(`${(this._subject === null ? "" : ".\n") + this._encodeSubject(this._subject = subject)} ${this._encodePredicate(this._predicate = predicate)} ${this._encodeObject(object)}`, done);
        } catch (error) {
            done && done(error);
        }
    }
    // ### `_writeQuadLine` writes the quad to the output stream as a single line
    _writeQuadLine(subject, predicate, object, graph, done) {
        // Write the quad without prefixes
        delete this._prefixMatch;
        this._write(this.quadToString(subject, predicate, object, graph), done);
    }
    // ### `quadToString` serializes a quad as a string
    quadToString(subject, predicate, object, graph) {
        return `${this._encodeSubject(subject)} ${this._encodeIriOrBlank(predicate)} ${this._encodeObject(object)}${graph && graph.value ? ` ${this._encodeIriOrBlank(graph)} .\n` : " .\n"}`;
    }
    // ### `quadsToString` serializes an array of quads as a string
    quadsToString(quads) {
        return quads.map((t)=>{
            return this.quadToString(t.subject, t.predicate, t.object, t.graph);
        }).join("");
    }
    // ### `_encodeSubject` represents a subject
    _encodeSubject(entity) {
        return entity.termType === "Quad" ? this._encodeQuad(entity) : this._encodeIriOrBlank(entity);
    }
    // ### `_encodeIriOrBlank` represents an IRI or blank node
    _encodeIriOrBlank(entity) {
        // A blank node or list is represented as-is
        if (entity.termType !== "NamedNode") {
            // If it is a list head, pretty-print it
            if (this._lists && entity.value in this._lists) entity = this.list(this._lists[entity.value]);
            return "id" in entity ? entity.id : `_:${entity.value}`;
        }
        let iri = entity.value;
        // Use relative IRIs if requested and possible
        if (this._baseMatcher && this._baseMatcher.test(iri)) iri = iri.substr(this._baseLength);
        // Escape special characters
        if ($32dfb6bd0d0c03b1$var$escape.test(iri)) iri = iri.replace($32dfb6bd0d0c03b1$var$escapeAll, $32dfb6bd0d0c03b1$var$characterReplacer);
        // Try to represent the IRI as prefixed name
        const prefixMatch = this._prefixRegex.exec(iri);
        return !prefixMatch ? `<${iri}>` : !prefixMatch[1] ? iri : this._prefixIRIs[prefixMatch[1]] + prefixMatch[2];
    }
    // ### `_encodeLiteral` represents a literal
    _encodeLiteral(literal) {
        // Escape special characters
        let value = literal.value;
        if ($32dfb6bd0d0c03b1$var$escape.test(value)) value = value.replace($32dfb6bd0d0c03b1$var$escapeAll, $32dfb6bd0d0c03b1$var$characterReplacer);
        // Write a language-tagged literal
        if (literal.language) return `"${value}"@${literal.language}`;
        // Write dedicated literals per data type
        if (this._lineMode) {
            // Only abbreviate strings in N-Triples or N-Quads
            if (literal.datatype.value === $32dfb6bd0d0c03b1$var$xsd.string) return `"${value}"`;
        } else // Use common datatype abbreviations in Turtle or TriG
        switch(literal.datatype.value){
            case $32dfb6bd0d0c03b1$var$xsd.string:
                return `"${value}"`;
            case $32dfb6bd0d0c03b1$var$xsd.boolean:
                if (value === "true" || value === "false") return value;
                break;
            case $32dfb6bd0d0c03b1$var$xsd.integer:
                if (/^[+-]?\d+$/.test(value)) return value;
                break;
            case $32dfb6bd0d0c03b1$var$xsd.decimal:
                if (/^[+-]?\d*\.\d+$/.test(value)) return value;
                break;
            case $32dfb6bd0d0c03b1$var$xsd.double:
                if (/^[+-]?(?:\d+\.\d*|\.?\d+)[eE][+-]?\d+$/.test(value)) return value;
                break;
        }
        // Write a regular datatyped literal
        return `"${value}"^^${this._encodeIriOrBlank(literal.datatype)}`;
    }
    // ### `_encodePredicate` represents a predicate
    _encodePredicate(predicate) {
        return predicate.value === $32dfb6bd0d0c03b1$var$rdf.type ? "a" : this._encodeIriOrBlank(predicate);
    }
    // ### `_encodeObject` represents an object
    _encodeObject(object) {
        switch(object.termType){
            case "Quad":
                return this._encodeQuad(object);
            case "Literal":
                return this._encodeLiteral(object);
            default:
                return this._encodeIriOrBlank(object);
        }
    }
    // ### `_encodeQuad` encodes an RDF* quad
    _encodeQuad({ subject: subject, predicate: predicate, object: object, graph: graph }) {
        return `<<${this._encodeSubject(subject)} ${this._encodePredicate(predicate)} ${this._encodeObject(object)}${(0, $d6df86e8a0a82242$export$1a29e0fa6b36b0c8)(graph) ? "" : ` ${this._encodeIriOrBlank(graph)}`}>>`;
    }
    // ### `_blockedWrite` replaces `_write` after the writer has been closed
    _blockedWrite() {
        throw new Error("Cannot write because the writer has been closed.");
    }
    // ### `addQuad` adds the quad to the output stream
    addQuad(subject, predicate, object, graph, done) {
        // The quad was given as an object, so shift parameters
        if (object === undefined) this._writeQuad(subject.subject, subject.predicate, subject.object, subject.graph, predicate);
        else if (typeof graph === "function") this._writeQuad(subject, predicate, object, $32dfb6bd0d0c03b1$var$DEFAULTGRAPH, graph);
        else this._writeQuad(subject, predicate, object, graph || $32dfb6bd0d0c03b1$var$DEFAULTGRAPH, done);
    }
    // ### `addQuads` adds the quads to the output stream
    addQuads(quads) {
        for(let i = 0; i < quads.length; i++)this.addQuad(quads[i]);
    }
    // ### `addPrefix` adds the prefix to the output stream
    addPrefix(prefix, iri, done) {
        const prefixes = {};
        prefixes[prefix] = iri;
        this.addPrefixes(prefixes, done);
    }
    // ### `addPrefixes` adds the prefixes to the output stream
    addPrefixes(prefixes, done) {
        // Ignore prefixes if not supported by the serialization
        if (!this._prefixIRIs) return done && done();
        // Write all new prefixes
        let hasPrefixes = false;
        for(let prefix in prefixes){
            let iri = prefixes[prefix];
            if (typeof iri !== "string") iri = iri.value;
            hasPrefixes = true;
            // Finish a possible pending quad
            if (this._subject !== null) {
                this._write(this._inDefaultGraph ? ".\n" : "\n}\n");
                this._subject = null, this._graph = "";
            }
            // Store and write the prefix
            this._prefixIRIs[iri] = prefix += ":";
            this._write(`@prefix ${prefix} <${iri}>.\n`);
        }
        // Recreate the prefix matcher
        if (hasPrefixes) {
            let IRIlist = "", prefixList = "";
            for(const prefixIRI in this._prefixIRIs){
                IRIlist += IRIlist ? `|${prefixIRI}` : prefixIRI;
                prefixList += (prefixList ? "|" : "") + this._prefixIRIs[prefixIRI];
            }
            IRIlist = $32dfb6bd0d0c03b1$var$escapeRegex(IRIlist, /[\]\/\(\)\*\+\?\.\\\$]/g, "\\$&");
            this._prefixRegex = new RegExp(`^(?:${prefixList})[^\/]*$|` + `^(${IRIlist})([_a-zA-Z][\\-_a-zA-Z0-9]*)$`);
        }
        // End a prefix block with a newline
        this._write(hasPrefixes ? "\n" : "", done);
    }
    // ### `blank` creates a blank node with the given content
    blank(predicate, object) {
        let children = predicate, child, length;
        // Empty blank node
        if (predicate === undefined) children = [];
        else if (predicate.termType) children = [
            {
                predicate: predicate,
                object: object
            }
        ];
        else if (!("length" in predicate)) children = [
            predicate
        ];
        switch(length = children.length){
            // Generate an empty blank node
            case 0:
                return new $32dfb6bd0d0c03b1$var$SerializedTerm("[]");
            // Generate a non-nested one-triple blank node
            case 1:
                child = children[0];
                if (!(child.object instanceof $32dfb6bd0d0c03b1$var$SerializedTerm)) return new $32dfb6bd0d0c03b1$var$SerializedTerm(`[ ${this._encodePredicate(child.predicate)} ${this._encodeObject(child.object)} ]`);
            // Generate a multi-triple or nested blank node
            default:
                let contents = "[";
                // Write all triples in order
                for(let i = 0; i < length; i++){
                    child = children[i];
                    // Write only the object is the predicate is the same as the previous
                    if (child.predicate.equals(predicate)) contents += `, ${this._encodeObject(child.object)}`;
                    else {
                        contents += `${(i ? ";\n  " : "\n  ") + this._encodePredicate(child.predicate)} ${this._encodeObject(child.object)}`;
                        predicate = child.predicate;
                    }
                }
                return new $32dfb6bd0d0c03b1$var$SerializedTerm(`${contents}\n]`);
        }
    }
    // ### `list` creates a list node with the given content
    list(elements) {
        const length = elements && elements.length || 0, contents = new Array(length);
        for(let i = 0; i < length; i++)contents[i] = this._encodeObject(elements[i]);
        return new $32dfb6bd0d0c03b1$var$SerializedTerm(`(${contents.join(" ")})`);
    }
    // ### `end` signals the end of the output stream
    end(done) {
        // Finish a possible pending quad
        if (this._subject !== null) {
            this._write(this._inDefaultGraph ? ".\n" : "\n}\n");
            this._subject = null;
        }
        // Disallow further writing
        this._write = this._blockedWrite;
        // Try to end the underlying stream, ensuring done is called exactly one time
        let singleDone = done && ((error, result)=>{
            singleDone = null, done(error, result);
        });
        if (this._endStream) try {
            return this._outputStream.end(singleDone);
        } catch (error) {}
        singleDone && singleDone();
    }
}
// Replaces a character by its escaped version
function $32dfb6bd0d0c03b1$var$characterReplacer(character) {
    // Replace a single character by its escaped version
    let result = $32dfb6bd0d0c03b1$var$escapedCharacters[character];
    if (result === undefined) {
        // Replace a single character with its 4-bit unicode escape sequence
        if (character.length === 1) {
            result = character.charCodeAt(0).toString(16);
            result = "\\u0000".substr(0, 6 - result.length) + result;
        } else {
            result = ((character.charCodeAt(0) - 0xD800) * 0x400 + character.charCodeAt(1) + 0x2400).toString(16);
            result = "\\U00000000".substr(0, 10 - result.length) + result;
        }
    }
    return result;
}
function $32dfb6bd0d0c03b1$var$escapeRegex(regex) {
    return regex.replace(/[\]\/\(\)\*\+\?\.\\\$]/g, "\\$&");
}


// **N3Store** objects store N3 quads by graph in memory.

var $511287080958fe02$exports = {};
"use strict";
var $783efb31b6997627$exports = {};
/* replacement start */ 
var $4mEhT = parcelRequire("4mEhT");
var $783efb31b6997627$require$Buffer = $4mEhT.Buffer;
"use strict";

var $hARba = parcelRequire("hARba");
var $783efb31b6997627$require$ObjectDefineProperty = $hARba.ObjectDefineProperty;
var $783efb31b6997627$require$ObjectKeys = $hARba.ObjectKeys;
var $783efb31b6997627$require$ReflectApply = $hARba.ReflectApply;

var $23YUm = parcelRequire("23YUm");
const { promisify: { custom: $783efb31b6997627$var$customPromisify } } = $23YUm;
var $2f933b59691fabad$export$42af8c323be37587;
var $2f933b59691fabad$export$f405f72c701dad87;
"use strict";

const $2f933b59691fabad$var$AbortController = globalThis.AbortController || (parcelRequire("lOmHN")).AbortController;

var $fDejL = parcelRequire("fDejL");
const { codes: { ERR_INVALID_ARG_VALUE: $2f933b59691fabad$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $2f933b59691fabad$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $2f933b59691fabad$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $2f933b59691fabad$var$ERR_OUT_OF_RANGE }, AbortError: $2f933b59691fabad$var$AbortError } = $fDejL;

var $dJ6QP = parcelRequire("dJ6QP");
var $2f933b59691fabad$require$validateAbortSignal = $dJ6QP.validateAbortSignal;
var $2f933b59691fabad$require$validateInteger = $dJ6QP.validateInteger;
var $2f933b59691fabad$require$validateObject = $dJ6QP.validateObject;

const $2f933b59691fabad$var$kWeakHandler = (parcelRequire("hARba")).Symbol("kWeak");

const $2f933b59691fabad$var$kResistStopPropagation = (parcelRequire("hARba")).Symbol("kResistStopPropagation");

var $2GdZi = parcelRequire("2GdZi");
var $2f933b59691fabad$require$finished = $2GdZi.finished;
var $9fde3ebbead14155$exports = {};
"use strict";
var $e73068a6eaab0343$exports = {};
/* replacement start */ 
var $6Q1U4 = parcelRequire("6Q1U4");
"use strict";

var $hARba = parcelRequire("hARba");
var $e73068a6eaab0343$require$ArrayIsArray = $hARba.ArrayIsArray;
var $e73068a6eaab0343$require$Promise = $hARba.Promise;
var $e73068a6eaab0343$require$SymbolAsyncIterator = $hARba.SymbolAsyncIterator;
var $e73068a6eaab0343$require$SymbolDispose = $hARba.SymbolDispose;

var $2GdZi = parcelRequire("2GdZi");

var $e73068a6eaab0343$require$once = (parcelRequire("23YUm")).once;

var $eDzoI = parcelRequire("eDzoI");

var $1DMM6 = parcelRequire("1DMM6");

var $fDejL = parcelRequire("fDejL");
const { aggregateTwoErrors: $e73068a6eaab0343$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $e73068a6eaab0343$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $e73068a6eaab0343$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $e73068a6eaab0343$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $e73068a6eaab0343$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $e73068a6eaab0343$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $e73068a6eaab0343$var$AbortError } = $fDejL;

var $dJ6QP = parcelRequire("dJ6QP");
var $e73068a6eaab0343$require$validateFunction = $dJ6QP.validateFunction;
var $e73068a6eaab0343$require$validateAbortSignal = $dJ6QP.validateAbortSignal;

var $jTHeA = parcelRequire("jTHeA");
var $e73068a6eaab0343$require$isIterable = $jTHeA.isIterable;
var $e73068a6eaab0343$require$isReadable = $jTHeA.isReadable;
var $e73068a6eaab0343$require$isReadableNodeStream = $jTHeA.isReadableNodeStream;
var $e73068a6eaab0343$require$isNodeStream = $jTHeA.isNodeStream;
var $e73068a6eaab0343$require$isTransformStream = $jTHeA.isTransformStream;
var $e73068a6eaab0343$require$isWebStream = $jTHeA.isWebStream;
var $e73068a6eaab0343$require$isReadableStream = $jTHeA.isReadableStream;
var $e73068a6eaab0343$require$isReadableFinished = $jTHeA.isReadableFinished;

const $e73068a6eaab0343$var$AbortController = globalThis.AbortController || (parcelRequire("lOmHN")).AbortController;
let $e73068a6eaab0343$var$PassThrough;
let $e73068a6eaab0343$var$Readable;
let $e73068a6eaab0343$var$addAbortListener;
function $e73068a6eaab0343$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on("close", ()=>{
        finished = true;
    });
    const cleanup = $2GdZi(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $eDzoI.destroyer(stream, err || new $e73068a6eaab0343$var$ERR_STREAM_DESTROYED("pipe"));
        },
        cleanup: cleanup
    };
}
function $e73068a6eaab0343$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $e73068a6eaab0343$require$validateFunction(streams[streams.length - 1], "streams[stream.length - 1]");
    return streams.pop();
}
function $e73068a6eaab0343$var$makeAsyncIterable(val) {
    if ($e73068a6eaab0343$require$isIterable(val)) return val;
    else if ($e73068a6eaab0343$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $e73068a6eaab0343$var$fromReadable(val);
    throw new $e73068a6eaab0343$var$ERR_INVALID_ARG_TYPE("val", [
        "Readable",
        "Iterable",
        "AsyncIterable"
    ], val);
}

async function* $e73068a6eaab0343$var$fromReadable(val) {
    if (!$e73068a6eaab0343$var$Readable) $e73068a6eaab0343$var$Readable = (parcelRequire("6t7Uw"));
    yield* $e73068a6eaab0343$var$Readable.prototype[$e73068a6eaab0343$require$SymbolAsyncIterator].call(val);
}
async function $e73068a6eaab0343$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $e73068a6eaab0343$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on("drain", resume);
    const cleanup = $2GdZi(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $e73068a6eaab0343$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off("drain", resume);
    }
}
async function $e73068a6eaab0343$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($e73068a6eaab0343$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $e73068a6eaab0343$var$pipeline(...streams) {
    return $e73068a6eaab0343$var$pipelineImpl(streams, $e73068a6eaab0343$require$once($e73068a6eaab0343$var$popCallback(streams)));
}


function $e73068a6eaab0343$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $e73068a6eaab0343$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $e73068a6eaab0343$var$ERR_MISSING_ARGS("streams");
    const ac = new $e73068a6eaab0343$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $e73068a6eaab0343$require$validateAbortSignal(outerSignal, "options.signal");
    function abort() {
        finishImpl(new $e73068a6eaab0343$var$AbortError());
    }
    $e73068a6eaab0343$var$addAbortListener = $e73068a6eaab0343$var$addAbortListener || (parcelRequire("23YUm")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $e73068a6eaab0343$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === "ERR_STREAM_PREMATURE_CLOSE")) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$e73068a6eaab0343$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $6Q1U4.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($e73068a6eaab0343$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $e73068a6eaab0343$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($e73068a6eaab0343$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== "AbortError" && err.code !== "ERR_STREAM_PREMATURE_CLOSE") finish(err);
            }
            stream.on("error", onError);
            if ($e73068a6eaab0343$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener("error", onError);
            });
        }
        if (i === 0) {
            if (typeof stream === "function") {
                ret = stream({
                    signal: signal
                });
                if (!$e73068a6eaab0343$require$isIterable(ret)) throw new $e73068a6eaab0343$var$ERR_INVALID_RETURN_VALUE("Iterable, AsyncIterable or Stream", "source", ret);
            } else if ($e73068a6eaab0343$require$isIterable(stream) || $e73068a6eaab0343$require$isReadableNodeStream(stream) || $e73068a6eaab0343$require$isTransformStream(stream)) ret = stream;
            else ret = $1DMM6.from(stream);
        } else if (typeof stream === "function") {
            if ($e73068a6eaab0343$require$isTransformStream(ret)) {
                var _ret;
                ret = $e73068a6eaab0343$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $e73068a6eaab0343$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$e73068a6eaab0343$require$isIterable(ret, true)) throw new $e73068a6eaab0343$var$ERR_INVALID_RETURN_VALUE("AsyncIterable", `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$e73068a6eaab0343$var$PassThrough) $e73068a6eaab0343$var$PassThrough = (parcelRequire("a9qV7"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $e73068a6eaab0343$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === "function") {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $6Q1U4.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $6Q1U4.nextTick(finish, err);
                    });
                } else if ($e73068a6eaab0343$require$isIterable(ret, true)) {
                    finishCount++;
                    $e73068a6eaab0343$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($e73068a6eaab0343$require$isReadableStream(ret) || $e73068a6eaab0343$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $e73068a6eaab0343$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $e73068a6eaab0343$var$ERR_INVALID_RETURN_VALUE("AsyncIterable or Promise", "destination", ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $e73068a6eaab0343$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($e73068a6eaab0343$require$isNodeStream(stream)) {
            if ($e73068a6eaab0343$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $e73068a6eaab0343$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($e73068a6eaab0343$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($e73068a6eaab0343$require$isTransformStream(ret) || $e73068a6eaab0343$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $e73068a6eaab0343$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($e73068a6eaab0343$require$isIterable(ret)) {
                finishCount++;
                $e73068a6eaab0343$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $e73068a6eaab0343$var$ERR_INVALID_ARG_TYPE("val", [
                "Readable",
                "Iterable",
                "AsyncIterable",
                "ReadableStream",
                "TransformStream"
            ], ret);
            ret = stream;
        } else if ($e73068a6eaab0343$require$isWebStream(stream)) {
            if ($e73068a6eaab0343$require$isReadableNodeStream(ret)) {
                finishCount++;
                $e73068a6eaab0343$var$pumpToWeb($e73068a6eaab0343$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($e73068a6eaab0343$require$isReadableStream(ret) || $e73068a6eaab0343$require$isIterable(ret)) {
                finishCount++;
                $e73068a6eaab0343$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($e73068a6eaab0343$require$isTransformStream(ret)) {
                finishCount++;
                $e73068a6eaab0343$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $e73068a6eaab0343$var$ERR_INVALID_ARG_TYPE("val", [
                "Readable",
                "Iterable",
                "AsyncIterable",
                "ReadableStream",
                "TransformStream"
            ], ret);
            ret = stream;
        } else ret = $1DMM6.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $6Q1U4.nextTick(abort);
    return ret;
}
function $e73068a6eaab0343$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on("close", ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $e73068a6eaab0343$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($e73068a6eaab0343$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $6Q1U4.nextTick(endFn);
        else src.once("end", endFn);
    } else finish();
    $2GdZi(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === "ERR_STREAM_PREMATURE_CLOSE" && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once("end", finish).once("error", finish);
        else finish(err);
    });
    return $2GdZi(dst, {
        readable: false,
        writable: true
    }, finish);
}
$e73068a6eaab0343$exports = {
    pipelineImpl: $e73068a6eaab0343$var$pipelineImpl,
    pipeline: $e73068a6eaab0343$var$pipeline
};


var $9fde3ebbead14155$require$pipeline = $e73068a6eaab0343$exports.pipeline;

var $1DMM6 = parcelRequire("1DMM6");

var $eDzoI = parcelRequire("eDzoI");
var $9fde3ebbead14155$require$destroyer = $eDzoI.destroyer;

var $jTHeA = parcelRequire("jTHeA");
var $9fde3ebbead14155$require$isNodeStream = $jTHeA.isNodeStream;
var $9fde3ebbead14155$require$isReadable = $jTHeA.isReadable;
var $9fde3ebbead14155$require$isWritable = $jTHeA.isWritable;
var $9fde3ebbead14155$require$isWebStream = $jTHeA.isWebStream;
var $9fde3ebbead14155$require$isTransformStream = $jTHeA.isTransformStream;
var $9fde3ebbead14155$require$isWritableStream = $jTHeA.isWritableStream;
var $9fde3ebbead14155$require$isReadableStream = $jTHeA.isReadableStream;

var $fDejL = parcelRequire("fDejL");
const { AbortError: $9fde3ebbead14155$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $9fde3ebbead14155$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $9fde3ebbead14155$var$ERR_MISSING_ARGS } } = $fDejL;

var $2GdZi = parcelRequire("2GdZi");
$9fde3ebbead14155$exports = function compose(...streams) {
    if (streams.length === 0) throw new $9fde3ebbead14155$var$ERR_MISSING_ARGS("streams");
    if (streams.length === 1) return $1DMM6.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === "function") streams[0] = $1DMM6.from(streams[0]);
    if (typeof streams[streams.length - 1] === "function") {
        const idx = streams.length - 1;
        streams[idx] = $1DMM6.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$9fde3ebbead14155$require$isNodeStream(streams[n]) && !$9fde3ebbead14155$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($9fde3ebbead14155$require$isReadable(streams[n]) || $9fde3ebbead14155$require$isReadableStream(streams[n]) || $9fde3ebbead14155$require$isTransformStream(streams[n]))) throw new $9fde3ebbead14155$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], "must be readable");
        if (n > 0 && !($9fde3ebbead14155$require$isWritable(streams[n]) || $9fde3ebbead14155$require$isWritableStream(streams[n]) || $9fde3ebbead14155$require$isTransformStream(streams[n]))) throw new $9fde3ebbead14155$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], "must be writable");
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $9fde3ebbead14155$require$pipeline(streams, onfinished);
    const writable = !!($9fde3ebbead14155$require$isWritable(head) || $9fde3ebbead14155$require$isWritableStream(head) || $9fde3ebbead14155$require$isTransformStream(head));
    const readable = !!($9fde3ebbead14155$require$isReadable(tail) || $9fde3ebbead14155$require$isReadableStream(tail) || $9fde3ebbead14155$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $1DMM6({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($9fde3ebbead14155$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on("drain", function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($9fde3ebbead14155$require$isWebStream(head)) {
            const writable = $9fde3ebbead14155$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $9fde3ebbead14155$require$isTransformStream(tail) ? tail.readable : tail;
        $2GdZi(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($9fde3ebbead14155$require$isNodeStream(tail)) {
            tail.on("readable", function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on("end", function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($9fde3ebbead14155$require$isWebStream(tail)) {
            const readable = $9fde3ebbead14155$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch  {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $9fde3ebbead14155$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($9fde3ebbead14155$require$isNodeStream(tail)) $9fde3ebbead14155$require$destroyer(tail, err);
        }
    };
    return d;
};



var $5VHEs = parcelRequire("5VHEs");
var $2f933b59691fabad$require$addAbortSignalNoValidate = $5VHEs.addAbortSignalNoValidate;

var $jTHeA = parcelRequire("jTHeA");
var $2f933b59691fabad$require$isWritable = $jTHeA.isWritable;
var $2f933b59691fabad$require$isNodeStream = $jTHeA.isNodeStream;

var $2f933b59691fabad$require$deprecate = (parcelRequire("23YUm")).deprecate;

var $2f933b59691fabad$require$ArrayPrototypePush = (parcelRequire("hARba")).ArrayPrototypePush;
var $2f933b59691fabad$require$Boolean = (parcelRequire("hARba")).Boolean;
var $2f933b59691fabad$require$MathFloor = (parcelRequire("hARba")).MathFloor;
var $2f933b59691fabad$require$Number = (parcelRequire("hARba")).Number;
var $2f933b59691fabad$require$NumberIsNaN = (parcelRequire("hARba")).NumberIsNaN;
var $2f933b59691fabad$require$Promise = (parcelRequire("hARba")).Promise;
var $2f933b59691fabad$require$PromiseReject = (parcelRequire("hARba")).PromiseReject;
var $2f933b59691fabad$require$PromiseResolve = (parcelRequire("hARba")).PromiseResolve;
var $2f933b59691fabad$require$PromisePrototypeThen = (parcelRequire("hARba")).PromisePrototypeThen;
var $2f933b59691fabad$require$Symbol = (parcelRequire("hARba")).Symbol;
const $2f933b59691fabad$var$kEmpty = $2f933b59691fabad$require$Symbol("kEmpty");
const $2f933b59691fabad$var$kEof = $2f933b59691fabad$require$Symbol("kEof");
function $2f933b59691fabad$var$compose(stream, options) {
    if (options != null) $2f933b59691fabad$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $2f933b59691fabad$require$validateAbortSignal(options.signal, "options.signal");
    if ($2f933b59691fabad$require$isNodeStream(stream) && !$2f933b59691fabad$require$isWritable(stream)) throw new $2f933b59691fabad$var$ERR_INVALID_ARG_VALUE("stream", stream, "must be writable");
    const composedStream = $9fde3ebbead14155$exports(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $2f933b59691fabad$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $2f933b59691fabad$var$map(fn, options) {
    if (typeof fn !== "function") throw new $2f933b59691fabad$var$ERR_INVALID_ARG_TYPE("fn", [
        "Function",
        "AsyncFunction"
    ], fn);
    if (options != null) $2f933b59691fabad$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $2f933b59691fabad$require$validateAbortSignal(options.signal, "options.signal");
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $2f933b59691fabad$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $2f933b59691fabad$require$MathFloor(options.highWaterMark);
    $2f933b59691fabad$require$validateInteger(concurrency, "options.concurrency", 1);
    $2f933b59691fabad$require$validateInteger(highWaterMark, "options.highWaterMark", 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("23YUm")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($2f933b59691fabad$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $2f933b59691fabad$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $2f933b59691fabad$var$kEmpty) continue;
                        val = $2f933b59691fabad$require$PromiseResolve(val);
                    } catch (err) {
                        val = $2f933b59691fabad$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $2f933b59691fabad$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $2f933b59691fabad$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($2f933b59691fabad$var$kEof);
            } catch (err) {
                const val = $2f933b59691fabad$require$PromiseReject(err);
                $2f933b59691fabad$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $2f933b59691fabad$var$kEof) return;
                    if (signal.aborted) throw new $2f933b59691fabad$var$AbortError();
                    if (val !== $2f933b59691fabad$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $2f933b59691fabad$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $2f933b59691fabad$var$asIndexedPairs(options) {
    if (options != null) $2f933b59691fabad$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $2f933b59691fabad$require$validateAbortSignal(options.signal, "options.signal");
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $2f933b59691fabad$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $2f933b59691fabad$var$some(fn, options) {
    for await (const unused of $2f933b59691fabad$var$filter.call(this, fn, options))return true;
    return false;
}
async function $2f933b59691fabad$var$every(fn, options) {
    if (typeof fn !== "function") throw new $2f933b59691fabad$var$ERR_INVALID_ARG_TYPE("fn", [
        "Function",
        "AsyncFunction"
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $2f933b59691fabad$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $2f933b59691fabad$var$find(fn, options) {
    for await (const result of $2f933b59691fabad$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $2f933b59691fabad$var$forEach(fn, options) {
    if (typeof fn !== "function") throw new $2f933b59691fabad$var$ERR_INVALID_ARG_TYPE("fn", [
        "Function",
        "AsyncFunction"
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $2f933b59691fabad$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $2f933b59691fabad$var$map.call(this, forEachFn, options));
}
function $2f933b59691fabad$var$filter(fn, options) {
    if (typeof fn !== "function") throw new $2f933b59691fabad$var$ERR_INVALID_ARG_TYPE("fn", [
        "Function",
        "AsyncFunction"
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $2f933b59691fabad$var$kEmpty;
    }
    return $2f933b59691fabad$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $2f933b59691fabad$var$ReduceAwareErrMissingArgs extends $2f933b59691fabad$var$ERR_MISSING_ARGS {
    constructor(){
        super("reduce");
        this.message = "Reduce of an empty stream requires an initial value";
    }
}
async function $2f933b59691fabad$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== "function") throw new $2f933b59691fabad$var$ERR_INVALID_ARG_TYPE("reducer", [
        "Function",
        "AsyncFunction"
    ], reducer);
    if (options != null) $2f933b59691fabad$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $2f933b59691fabad$require$validateAbortSignal(options.signal, "options.signal");
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $2f933b59691fabad$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once("error", ()=>{}) // The error is already propagated
        ;
        await $2f933b59691fabad$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $2f933b59691fabad$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$2f933b59691fabad$var$kWeakHandler]: this,
            [$2f933b59691fabad$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener("abort", ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $2f933b59691fabad$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $2f933b59691fabad$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $2f933b59691fabad$var$toArray(options) {
    if (options != null) $2f933b59691fabad$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $2f933b59691fabad$require$validateAbortSignal(options.signal, "options.signal");
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $2f933b59691fabad$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $2f933b59691fabad$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $2f933b59691fabad$var$flatMap(fn, options) {
    const values = $2f933b59691fabad$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $2f933b59691fabad$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $2f933b59691fabad$require$Number(number);
    if ($2f933b59691fabad$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $2f933b59691fabad$var$ERR_OUT_OF_RANGE("number", ">= 0", number);
    return number;
}
function $2f933b59691fabad$var$drop(number, options) {
    if (options != null) $2f933b59691fabad$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $2f933b59691fabad$require$validateAbortSignal(options.signal, "options.signal");
    number = $2f933b59691fabad$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $2f933b59691fabad$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $2f933b59691fabad$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $2f933b59691fabad$var$take(number, options) {
    if (options != null) $2f933b59691fabad$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $2f933b59691fabad$require$validateAbortSignal(options.signal, "options.signal");
    number = $2f933b59691fabad$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $2f933b59691fabad$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $2f933b59691fabad$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$2f933b59691fabad$export$42af8c323be37587 = {
    asIndexedPairs: $2f933b59691fabad$require$deprecate($2f933b59691fabad$var$asIndexedPairs, "readable.asIndexedPairs will be removed in a future version."),
    drop: $2f933b59691fabad$var$drop,
    filter: $2f933b59691fabad$var$filter,
    flatMap: $2f933b59691fabad$var$flatMap,
    map: $2f933b59691fabad$var$map,
    take: $2f933b59691fabad$var$take,
    compose: $2f933b59691fabad$var$compose
};
$2f933b59691fabad$export$f405f72c701dad87 = {
    every: $2f933b59691fabad$var$every,
    forEach: $2f933b59691fabad$var$forEach,
    reduce: $2f933b59691fabad$var$reduce,
    toArray: $2f933b59691fabad$var$toArray,
    some: $2f933b59691fabad$var$some,
    find: $2f933b59691fabad$var$find
};


var $783efb31b6997627$require$streamReturningOperators = $2f933b59691fabad$export$42af8c323be37587;
var $783efb31b6997627$require$promiseReturningOperators = $2f933b59691fabad$export$f405f72c701dad87;

var $fDejL = parcelRequire("fDejL");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $783efb31b6997627$var$ERR_ILLEGAL_CONSTRUCTOR } } = $fDejL;


var $2yl2j = parcelRequire("2yl2j");
var $783efb31b6997627$require$setDefaultHighWaterMark = $2yl2j.setDefaultHighWaterMark;
var $783efb31b6997627$require$getDefaultHighWaterMark = $2yl2j.getDefaultHighWaterMark;

var $783efb31b6997627$require$pipeline = $e73068a6eaab0343$exports.pipeline;

var $eDzoI = parcelRequire("eDzoI");
var $783efb31b6997627$require$destroyer = $eDzoI.destroyer;

var $2GdZi = parcelRequire("2GdZi");
const $783efb31b6997627$var$internalBuffer = {};
var $1810f5fadabb55f3$exports = {};
"use strict";

var $hARba = parcelRequire("hARba");
var $1810f5fadabb55f3$require$ArrayPrototypePop = $hARba.ArrayPrototypePop;
var $1810f5fadabb55f3$require$Promise = $hARba.Promise;

var $jTHeA = parcelRequire("jTHeA");
var $1810f5fadabb55f3$require$isIterable = $jTHeA.isIterable;
var $1810f5fadabb55f3$require$isNodeStream = $jTHeA.isNodeStream;
var $1810f5fadabb55f3$require$isWebStream = $jTHeA.isWebStream;

var $1810f5fadabb55f3$require$pl = $e73068a6eaab0343$exports.pipelineImpl;

var $2GdZi = parcelRequire("2GdZi");
var $1810f5fadabb55f3$require$finished = $2GdZi.finished;

function $1810f5fadabb55f3$var$pipeline(...streams) {
    return new $1810f5fadabb55f3$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === "object" && !$1810f5fadabb55f3$require$isNodeStream(lastArg) && !$1810f5fadabb55f3$require$isIterable(lastArg) && !$1810f5fadabb55f3$require$isWebStream(lastArg)) {
            const options = $1810f5fadabb55f3$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $1810f5fadabb55f3$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
$1810f5fadabb55f3$exports = {
    finished: $1810f5fadabb55f3$require$finished,
    pipeline: $1810f5fadabb55f3$var$pipeline
};



var $jTHeA = parcelRequire("jTHeA");

const $783efb31b6997627$var$Stream = $783efb31b6997627$exports = (parcelRequire("8tftx")).Stream;
$783efb31b6997627$var$Stream.isDestroyed = $jTHeA.isDestroyed;
$783efb31b6997627$var$Stream.isDisturbed = $jTHeA.isDisturbed;
$783efb31b6997627$var$Stream.isErrored = $jTHeA.isErrored;
$783efb31b6997627$var$Stream.isReadable = $jTHeA.isReadable;
$783efb31b6997627$var$Stream.isWritable = $jTHeA.isWritable;

$783efb31b6997627$var$Stream.Readable = (parcelRequire("6t7Uw"));
for (const key of $783efb31b6997627$require$ObjectKeys($783efb31b6997627$require$streamReturningOperators)){
    const op = $783efb31b6997627$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $783efb31b6997627$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $783efb31b6997627$var$Stream.Readable.from($783efb31b6997627$require$ReflectApply(op, this, args));
    }
    $783efb31b6997627$require$ObjectDefineProperty(fn, "name", {
        __proto__: null,
        value: op.name
    });
    $783efb31b6997627$require$ObjectDefineProperty(fn, "length", {
        __proto__: null,
        value: op.length
    });
    $783efb31b6997627$require$ObjectDefineProperty($783efb31b6997627$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $783efb31b6997627$require$ObjectKeys($783efb31b6997627$require$promiseReturningOperators)){
    const op = $783efb31b6997627$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $783efb31b6997627$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $783efb31b6997627$require$ReflectApply(op, this, args);
    }
    $783efb31b6997627$require$ObjectDefineProperty(fn1, "name", {
        __proto__: null,
        value: op.name
    });
    $783efb31b6997627$require$ObjectDefineProperty(fn1, "length", {
        __proto__: null,
        value: op.length
    });
    $783efb31b6997627$require$ObjectDefineProperty($783efb31b6997627$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$783efb31b6997627$var$Stream.Writable = (parcelRequire("bhyec"));

$783efb31b6997627$var$Stream.Duplex = (parcelRequire("1DMM6"));

$783efb31b6997627$var$Stream.Transform = (parcelRequire("6ch13"));

$783efb31b6997627$var$Stream.PassThrough = (parcelRequire("a9qV7"));
$783efb31b6997627$var$Stream.pipeline = $783efb31b6997627$require$pipeline;

var $5VHEs = parcelRequire("5VHEs");
var $783efb31b6997627$require$addAbortSignal = $5VHEs.addAbortSignal;
$783efb31b6997627$var$Stream.addAbortSignal = $783efb31b6997627$require$addAbortSignal;
$783efb31b6997627$var$Stream.finished = $2GdZi;
$783efb31b6997627$var$Stream.destroy = $783efb31b6997627$require$destroyer;
$783efb31b6997627$var$Stream.compose = $9fde3ebbead14155$exports;
$783efb31b6997627$var$Stream.setDefaultHighWaterMark = $783efb31b6997627$require$setDefaultHighWaterMark;
$783efb31b6997627$var$Stream.getDefaultHighWaterMark = $783efb31b6997627$require$getDefaultHighWaterMark;
$783efb31b6997627$require$ObjectDefineProperty($783efb31b6997627$var$Stream, "promises", {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $1810f5fadabb55f3$exports;
    }
});
$783efb31b6997627$require$ObjectDefineProperty($783efb31b6997627$require$pipeline, $783efb31b6997627$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $1810f5fadabb55f3$exports.pipeline;
    }
});
$783efb31b6997627$require$ObjectDefineProperty($2GdZi, $783efb31b6997627$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $1810f5fadabb55f3$exports.finished;
    }
});
// Backwards-compat with node 0.4.x
$783efb31b6997627$var$Stream.Stream = $783efb31b6997627$var$Stream;
$783efb31b6997627$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$783efb31b6997627$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $783efb31b6997627$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};



const $511287080958fe02$var$originalDestroy = $783efb31b6997627$exports.Readable.destroy;
$511287080958fe02$exports = $783efb31b6997627$exports.Readable;
// Explicit export naming is needed for ESM
$511287080958fe02$exports._uint8ArrayToBuffer = $783efb31b6997627$exports._uint8ArrayToBuffer;
$511287080958fe02$exports._isUint8Array = $783efb31b6997627$exports._isUint8Array;
$511287080958fe02$exports.isDisturbed = $783efb31b6997627$exports.isDisturbed;
$511287080958fe02$exports.isErrored = $783efb31b6997627$exports.isErrored;
$511287080958fe02$exports.isReadable = $783efb31b6997627$exports.isReadable;
$511287080958fe02$exports.Readable = $783efb31b6997627$exports.Readable;
$511287080958fe02$exports.Writable = $783efb31b6997627$exports.Writable;
$511287080958fe02$exports.Duplex = $783efb31b6997627$exports.Duplex;
$511287080958fe02$exports.Transform = $783efb31b6997627$exports.Transform;
$511287080958fe02$exports.PassThrough = $783efb31b6997627$exports.PassThrough;
$511287080958fe02$exports.addAbortSignal = $783efb31b6997627$exports.addAbortSignal;
$511287080958fe02$exports.finished = $783efb31b6997627$exports.finished;
$511287080958fe02$exports.destroy = $783efb31b6997627$exports.destroy;
$511287080958fe02$exports.destroy = $511287080958fe02$var$originalDestroy;
$511287080958fe02$exports.pipeline = $783efb31b6997627$exports.pipeline;
$511287080958fe02$exports.compose = $783efb31b6997627$exports.compose;
Object.defineProperty($783efb31b6997627$exports, "promises", {
    configurable: true,
    enumerable: true,
    get () {
        return $1810f5fadabb55f3$exports;
    }
});
$511287080958fe02$exports.Stream = $783efb31b6997627$exports.Stream;
// Allow default importing
$511287080958fe02$exports.default = $511287080958fe02$exports;




class $5921901579fafa81$export$2e2bcd8739ae039 {
    constructor(quads, options){
        // The number of quads is initially zero
        this._size = 0;
        // `_graphs` contains subject, predicate, and object indexes per graph
        this._graphs = Object.create(null);
        // `_ids` maps entities such as `http://xmlns.com/foaf/0.1/name` to numbers,
        // saving memory by using only numbers as keys in `_graphs`
        this._id = 0;
        this._ids = Object.create(null);
        this._entities = Object.create(null); // inverse of `_ids`
        // `_blankNodeIndex` is the index of the last automatically named blank node
        this._blankNodeIndex = 0;
        // Shift parameters if `quads` is not given
        if (!options && quads && !quads[0]) options = quads, quads = null;
        options = options || {};
        this._factory = options.factory || (0, $555d89d857a9ecd3$export$2e2bcd8739ae039);
        // Add quads if passed
        if (quads) this.addQuads(quads);
    }
    _termFromId(id, factory) {
        if (id[0] === ".") {
            const entities = this._entities;
            const terms = id.split(".");
            const q = this._factory.quad(this._termFromId(entities[terms[1]]), this._termFromId(entities[terms[2]]), this._termFromId(entities[terms[3]]), terms[4] && this._termFromId(entities[terms[4]]));
            return q;
        }
        return (0, $555d89d857a9ecd3$export$85285e91bbd99cf)(id, factory);
    }
    _termToNumericId(term) {
        if (term.termType === "Quad") {
            const s = this._termToNumericId(term.subject), p = this._termToNumericId(term.predicate), o = this._termToNumericId(term.object);
            let g;
            return s && p && o && ((0, $d6df86e8a0a82242$export$1a29e0fa6b36b0c8)(term.graph) || (g = this._termToNumericId(term.graph))) && this._ids[g ? `.${s}.${p}.${o}.${g}` : `.${s}.${p}.${o}`];
        }
        return this._ids[(0, $555d89d857a9ecd3$export$fbf03d1179c9227e)(term)];
    }
    _termToNewNumericId(term) {
        // This assumes that no graph term is present - we may wish to error if there is one
        const str = term && term.termType === "Quad" ? `.${this._termToNewNumericId(term.subject)}.${this._termToNewNumericId(term.predicate)}.${this._termToNewNumericId(term.object)}${(0, $d6df86e8a0a82242$export$1a29e0fa6b36b0c8)(term.graph) ? "" : `.${this._termToNewNumericId(term.graph)}`}` : (0, $555d89d857a9ecd3$export$fbf03d1179c9227e)(term);
        return this._ids[str] || (this._ids[this._entities[++this._id] = str] = this._id);
    }
    // ## Public properties
    // ### `size` returns the number of quads in the store
    get size() {
        // Return the quad count if if was cached
        let size = this._size;
        if (size !== null) return size;
        // Calculate the number of quads by counting to the deepest level
        size = 0;
        const graphs = this._graphs;
        let subjects, subject;
        for(const graphKey in graphs)for(const subjectKey in subjects = graphs[graphKey].subjects)for(const predicateKey in subject = subjects[subjectKey])size += Object.keys(subject[predicateKey]).length;
        return this._size = size;
    }
    // ## Private methods
    // ### `_addToIndex` adds a quad to a three-layered index.
    // Returns if the index has changed, if the entry did not already exist.
    _addToIndex(index0, key0, key1, key2) {
        // Create layers as necessary
        const index1 = index0[key0] || (index0[key0] = {});
        const index2 = index1[key1] || (index1[key1] = {});
        // Setting the key to _any_ value signals the presence of the quad
        const existed = key2 in index2;
        if (!existed) index2[key2] = null;
        return !existed;
    }
    // ### `_removeFromIndex` removes a quad from a three-layered index
    _removeFromIndex(index0, key0, key1, key2) {
        // Remove the quad from the index
        const index1 = index0[key0], index2 = index1[key1];
        delete index2[key2];
        // Remove intermediary index layers if they are empty
        for(const key in index2)return;
        delete index1[key1];
        for(const key in index1)return;
        delete index0[key0];
    }
    // ### `_findInIndex` finds a set of quads in a three-layered index.
    // The index base is `index0` and the keys at each level are `key0`, `key1`, and `key2`.
    // Any of these keys can be undefined, which is interpreted as a wildcard.
    // `name0`, `name1`, and `name2` are the names of the keys at each level,
    // used when reconstructing the resulting quad
    // (for instance: _subject_, _predicate_, and _object_).
    // Finally, `graphId` will be the graph of the created quads.
    *_findInIndex(index0, key0, key1, key2, name0, name1, name2, graphId) {
        let tmp, index1, index2;
        const entityKeys = this._entities;
        const graph = this._termFromId(graphId, this._factory);
        const parts = {
            subject: null,
            predicate: null,
            object: null
        };
        // If a key is specified, use only that part of index 0.
        if (key0) (tmp = index0, index0 = {})[key0] = tmp[key0];
        for(const value0 in index0)if (index1 = index0[value0]) {
            parts[name0] = this._termFromId(entityKeys[value0], this._factory);
            // If a key is specified, use only that part of index 1.
            if (key1) (tmp = index1, index1 = {})[key1] = tmp[key1];
            for(const value1 in index1)if (index2 = index1[value1]) {
                parts[name1] = this._termFromId(entityKeys[value1], this._factory);
                // If a key is specified, use only that part of index 2, if it exists.
                const values = key2 ? key2 in index2 ? [
                    key2
                ] : [] : Object.keys(index2);
                // Create quads for all items found in index 2.
                for(let l = 0; l < values.length; l++){
                    parts[name2] = this._termFromId(entityKeys[values[l]], this._factory);
                    yield this._factory.quad(parts.subject, parts.predicate, parts.object, graph);
                }
            }
        }
    }
    // ### `_loop` executes the callback on all keys of index 0
    _loop(index0, callback) {
        for(const key0 in index0)callback(key0);
    }
    // ### `_loopByKey0` executes the callback on all keys of a certain entry in index 0
    _loopByKey0(index0, key0, callback) {
        let index1, key1;
        if (index1 = index0[key0]) for(key1 in index1)callback(key1);
    }
    // ### `_loopByKey1` executes the callback on given keys of all entries in index 0
    _loopByKey1(index0, key1, callback) {
        let key0, index1;
        for(key0 in index0){
            index1 = index0[key0];
            if (index1[key1]) callback(key0);
        }
    }
    // ### `_loopBy2Keys` executes the callback on given keys of certain entries in index 2
    _loopBy2Keys(index0, key0, key1, callback) {
        let index1, index2, key2;
        if ((index1 = index0[key0]) && (index2 = index1[key1])) for(key2 in index2)callback(key2);
    }
    // ### `_countInIndex` counts matching quads in a three-layered index.
    // The index base is `index0` and the keys at each level are `key0`, `key1`, and `key2`.
    // Any of these keys can be undefined, which is interpreted as a wildcard.
    _countInIndex(index0, key0, key1, key2) {
        let count = 0, tmp, index1, index2;
        // If a key is specified, count only that part of index 0
        if (key0) (tmp = index0, index0 = {})[key0] = tmp[key0];
        for(const value0 in index0)if (index1 = index0[value0]) {
            // If a key is specified, count only that part of index 1
            if (key1) (tmp = index1, index1 = {})[key1] = tmp[key1];
            for(const value1 in index1)if (index2 = index1[value1]) {
                // If a key is specified, count the quad if it exists
                if (key2) key2 in index2 && count++;
                else count += Object.keys(index2).length;
            }
        }
        return count;
    }
    // ### `_getGraphs` returns an array with the given graph,
    // or all graphs if the argument is null or undefined.
    _getGraphs(graph) {
        if (!$5921901579fafa81$var$isString(graph)) return this._graphs;
        const graphs = {};
        graphs[graph] = this._graphs[graph];
        return graphs;
    }
    // ### `_uniqueEntities` returns a function that accepts an entity ID
    // and passes the corresponding entity to callback if it hasn't occurred before.
    _uniqueEntities(callback) {
        const uniqueIds = Object.create(null);
        return (id)=>{
            if (!(id in uniqueIds)) {
                uniqueIds[id] = true;
                callback(this._termFromId(this._entities[id], this._factory));
            }
        };
    }
    // ## Public methods
    // ### `add` adds the specified quad to the dataset.
    // Returns the dataset instance it was called on.
    // Existing quads, as defined in Quad.equals, will be ignored.
    add(quad) {
        this.addQuad(quad);
        return this;
    }
    // ### `addQuad` adds a new quad to the store.
    // Returns if the quad index has changed, if the quad did not already exist.
    addQuad(subject, predicate, object, graph) {
        // Shift arguments if a quad object is given instead of components
        if (!predicate) graph = subject.graph, object = subject.object, predicate = subject.predicate, subject = subject.subject;
        // Convert terms to internal string representation
        graph = (0, $555d89d857a9ecd3$export$fbf03d1179c9227e)(graph);
        // Find the graph that will contain the triple
        let graphItem = this._graphs[graph];
        // Create the graph if it doesn't exist yet
        if (!graphItem) {
            graphItem = this._graphs[graph] = {
                subjects: {},
                predicates: {},
                objects: {}
            };
            // Freezing a graph helps subsequent `add` performance,
            // and properties will never be modified anyway
            Object.freeze(graphItem);
        }
        // Since entities can often be long IRIs, we avoid storing them in every index.
        // Instead, we have a separate index that maps entities to numbers,
        // which are then used as keys in the other indexes.
        subject = this._termToNewNumericId(subject);
        predicate = this._termToNewNumericId(predicate);
        object = this._termToNewNumericId(object);
        const changed = this._addToIndex(graphItem.subjects, subject, predicate, object);
        this._addToIndex(graphItem.predicates, predicate, object, subject);
        this._addToIndex(graphItem.objects, object, subject, predicate);
        // The cached quad count is now invalid
        this._size = null;
        return changed;
    }
    // ### `addQuads` adds multiple quads to the store
    addQuads(quads) {
        for(let i = 0; i < quads.length; i++)this.addQuad(quads[i]);
    }
    // ### `delete` removes the specified quad from the dataset.
    // Returns the dataset instance it was called on.
    delete(quad) {
        this.removeQuad(quad);
        return this;
    }
    // ### `has` determines whether a dataset includes a certain quad or quad pattern.
    has(subjectOrQuad, predicate, object, graph) {
        if (subjectOrQuad && subjectOrQuad.subject) ({ subject: subjectOrQuad, predicate: predicate, object: object, graph: graph } = subjectOrQuad);
        return !this.readQuads(subjectOrQuad, predicate, object, graph).next().done;
    }
    // ### `import` adds a stream of quads to the store
    import(stream) {
        stream.on("data", (quad)=>{
            this.addQuad(quad);
        });
        return stream;
    }
    // ### `removeQuad` removes a quad from the store if it exists
    removeQuad(subject, predicate, object, graph) {
        // Shift arguments if a quad object is given instead of components
        if (!predicate) graph = subject.graph, object = subject.object, predicate = subject.predicate, subject = subject.subject;
        // Convert terms to internal string representation
        graph = (0, $555d89d857a9ecd3$export$fbf03d1179c9227e)(graph);
        // Find internal identifiers for all components
        // and verify the quad exists.
        const graphs = this._graphs;
        let graphItem, subjects, predicates;
        if (!(subject = subject && this._termToNumericId(subject)) || !(predicate = predicate && this._termToNumericId(predicate)) || !(object = object && this._termToNumericId(object)) || !(graphItem = graphs[graph]) || !(subjects = graphItem.subjects[subject]) || !(predicates = subjects[predicate]) || !(object in predicates)) return false;
        // Remove it from all indexes
        this._removeFromIndex(graphItem.subjects, subject, predicate, object);
        this._removeFromIndex(graphItem.predicates, predicate, object, subject);
        this._removeFromIndex(graphItem.objects, object, subject, predicate);
        if (this._size !== null) this._size--;
        // Remove the graph if it is empty
        for(subject in graphItem.subjects)return true;
        delete graphs[graph];
        return true;
    }
    // ### `removeQuads` removes multiple quads from the store
    removeQuads(quads) {
        for(let i = 0; i < quads.length; i++)this.removeQuad(quads[i]);
    }
    // ### `remove` removes a stream of quads from the store
    remove(stream) {
        stream.on("data", (quad)=>{
            this.removeQuad(quad);
        });
        return stream;
    }
    // ### `removeMatches` removes all matching quads from the store
    // Setting any field to `undefined` or `null` indicates a wildcard.
    removeMatches(subject, predicate, object, graph) {
        const stream = new (0, $511287080958fe02$exports.Readable)({
            objectMode: true
        });
        stream._read = ()=>{
            for (const quad of this.readQuads(subject, predicate, object, graph))stream.push(quad);
            stream.push(null);
        };
        return this.remove(stream);
    }
    // ### `deleteGraph` removes all triples with the given graph from the store
    deleteGraph(graph) {
        return this.removeMatches(null, null, null, graph);
    }
    // ### `getQuads` returns an array of quads matching a pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getQuads(subject, predicate, object, graph) {
        return [
            ...this.readQuads(subject, predicate, object, graph)
        ];
    }
    // ### `readQuads` returns an generator of quads matching a pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    *readQuads(subject, predicate, object, graph) {
        // Convert terms to internal string representation
        graph = graph && (0, $555d89d857a9ecd3$export$fbf03d1179c9227e)(graph);
        const graphs = this._getGraphs(graph);
        let content, subjectId, predicateId, objectId;
        // Translate IRIs to internal index keys.
        if (subject && !(subjectId = this._termToNumericId(subject)) || predicate && !(predicateId = this._termToNumericId(predicate)) || object && !(objectId = this._termToNumericId(object))) return;
        for(const graphId in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graphId]) {
            // Choose the optimal index, based on what fields are present
            if (subjectId) {
                if (objectId) // If subject and object are given, the object index will be the fastest
                yield* this._findInIndex(content.objects, objectId, subjectId, predicateId, "object", "subject", "predicate", graphId);
                else // If only subject and possibly predicate are given, the subject index will be the fastest
                yield* this._findInIndex(content.subjects, subjectId, predicateId, null, "subject", "predicate", "object", graphId);
            } else if (predicateId) // If only predicate and possibly object are given, the predicate index will be the fastest
            yield* this._findInIndex(content.predicates, predicateId, objectId, null, "predicate", "object", "subject", graphId);
            else if (objectId) // If only object is given, the object index will be the fastest
            yield* this._findInIndex(content.objects, objectId, null, null, "object", "subject", "predicate", graphId);
            else // If nothing is given, iterate subjects and predicates first
            yield* this._findInIndex(content.subjects, null, null, null, "subject", "predicate", "object", graphId);
        }
    }
    // ### `match` returns a new dataset that is comprised of all quads in the current instance matching the given arguments.
    // The logic described in Quad Matching is applied for each quad in this dataset to check if it should be included in the output dataset.
    // Note: This method always returns a new DatasetCore, even if that dataset contains no quads.
    // Note: Since a DatasetCore is an unordered set, the order of the quads within the returned sequence is arbitrary.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    // For backwards compatibility, the object return also implements the Readable stream interface.
    match(subject, predicate, object, graph) {
        return new $5921901579fafa81$var$DatasetCoreAndReadableStream(this, subject, predicate, object, graph);
    }
    // ### `countQuads` returns the number of quads matching a pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    countQuads(subject, predicate, object, graph) {
        // Convert terms to internal string representation
        graph = graph && (0, $555d89d857a9ecd3$export$fbf03d1179c9227e)(graph);
        const graphs = this._getGraphs(graph);
        let count = 0, content, subjectId, predicateId, objectId;
        // Translate IRIs to internal index keys.
        if (subject && !(subjectId = this._termToNumericId(subject)) || predicate && !(predicateId = this._termToNumericId(predicate)) || object && !(objectId = this._termToNumericId(object))) return 0;
        for(const graphId in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graphId]) {
            // Choose the optimal index, based on what fields are present
            if (subject) {
                if (object) // If subject and object are given, the object index will be the fastest
                count += this._countInIndex(content.objects, objectId, subjectId, predicateId);
                else // If only subject and possibly predicate are given, the subject index will be the fastest
                count += this._countInIndex(content.subjects, subjectId, predicateId, objectId);
            } else if (predicate) // If only predicate and possibly object are given, the predicate index will be the fastest
            count += this._countInIndex(content.predicates, predicateId, objectId, subjectId);
            else // If only object is possibly given, the object index will be the fastest
            count += this._countInIndex(content.objects, objectId, subjectId, predicateId);
        }
        return count;
    }
    // ### `forEach` executes the callback on all quads.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forEach(callback, subject, predicate, object, graph) {
        this.some((quad)=>{
            callback(quad);
            return false;
        }, subject, predicate, object, graph);
    }
    // ### `every` executes the callback on all quads,
    // and returns `true` if it returns truthy for all them.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    every(callback, subject, predicate, object, graph) {
        let some = false;
        const every = !this.some((quad)=>{
            some = true;
            return !callback(quad);
        }, subject, predicate, object, graph);
        return some && every;
    }
    // ### `some` executes the callback on all quads,
    // and returns `true` if it returns truthy for any of them.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    some(callback, subject, predicate, object, graph) {
        for (const quad of this.readQuads(subject, predicate, object, graph))if (callback(quad)) return true;
        return false;
    }
    // ### `getSubjects` returns all subjects that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getSubjects(predicate, object, graph) {
        const results = [];
        this.forSubjects((s)=>{
            results.push(s);
        }, predicate, object, graph);
        return results;
    }
    // ### `forSubjects` executes the callback on all subjects that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forSubjects(callback, predicate, object, graph) {
        // Convert terms to internal string representation
        graph = graph && (0, $555d89d857a9ecd3$export$fbf03d1179c9227e)(graph);
        const graphs = this._getGraphs(graph);
        let content, predicateId, objectId;
        callback = this._uniqueEntities(callback);
        // Translate IRIs to internal index keys.
        if (predicate && !(predicateId = this._termToNumericId(predicate)) || object && !(objectId = this._termToNumericId(object))) return;
        for(graph in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graph]) {
            // Choose optimal index based on which fields are wildcards
            if (predicateId) {
                if (objectId) // If predicate and object are given, the POS index is best.
                this._loopBy2Keys(content.predicates, predicateId, objectId, callback);
                else // If only predicate is given, the SPO index is best.
                this._loopByKey1(content.subjects, predicateId, callback);
            } else if (objectId) // If only object is given, the OSP index is best.
            this._loopByKey0(content.objects, objectId, callback);
            else // If no params given, iterate all the subjects
            this._loop(content.subjects, callback);
        }
    }
    // ### `getPredicates` returns all predicates that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getPredicates(subject, object, graph) {
        const results = [];
        this.forPredicates((p)=>{
            results.push(p);
        }, subject, object, graph);
        return results;
    }
    // ### `forPredicates` executes the callback on all predicates that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forPredicates(callback, subject, object, graph) {
        // Convert terms to internal string representation
        graph = graph && (0, $555d89d857a9ecd3$export$fbf03d1179c9227e)(graph);
        const graphs = this._getGraphs(graph);
        let content, subjectId, objectId;
        callback = this._uniqueEntities(callback);
        // Translate IRIs to internal index keys.
        if (subject && !(subjectId = this._termToNumericId(subject)) || object && !(objectId = this._termToNumericId(object))) return;
        for(graph in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graph]) {
            // Choose optimal index based on which fields are wildcards
            if (subjectId) {
                if (objectId) // If subject and object are given, the OSP index is best.
                this._loopBy2Keys(content.objects, objectId, subjectId, callback);
                else // If only subject is given, the SPO index is best.
                this._loopByKey0(content.subjects, subjectId, callback);
            } else if (objectId) // If only object is given, the POS index is best.
            this._loopByKey1(content.predicates, objectId, callback);
            else // If no params given, iterate all the predicates.
            this._loop(content.predicates, callback);
        }
    }
    // ### `getObjects` returns all objects that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getObjects(subject, predicate, graph) {
        const results = [];
        this.forObjects((o)=>{
            results.push(o);
        }, subject, predicate, graph);
        return results;
    }
    // ### `forObjects` executes the callback on all objects that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forObjects(callback, subject, predicate, graph) {
        // Convert terms to internal string representation
        graph = graph && (0, $555d89d857a9ecd3$export$fbf03d1179c9227e)(graph);
        const graphs = this._getGraphs(graph);
        let content, subjectId, predicateId;
        callback = this._uniqueEntities(callback);
        // Translate IRIs to internal index keys.
        if (subject && !(subjectId = this._termToNumericId(subject)) || predicate && !(predicateId = this._termToNumericId(predicate))) return;
        for(graph in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graph]) {
            // Choose optimal index based on which fields are wildcards
            if (subjectId) {
                if (predicateId) // If subject and predicate are given, the SPO index is best.
                this._loopBy2Keys(content.subjects, subjectId, predicateId, callback);
                else // If only subject is given, the OSP index is best.
                this._loopByKey1(content.objects, subjectId, callback);
            } else if (predicateId) // If only predicate is given, the POS index is best.
            this._loopByKey0(content.predicates, predicateId, callback);
            else // If no params given, iterate all the objects.
            this._loop(content.objects, callback);
        }
    }
    // ### `getGraphs` returns all graphs that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getGraphs(subject, predicate, object) {
        const results = [];
        this.forGraphs((g)=>{
            results.push(g);
        }, subject, predicate, object);
        return results;
    }
    // ### `forGraphs` executes the callback on all graphs that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forGraphs(callback, subject, predicate, object) {
        for(const graph in this._graphs)this.some((quad)=>{
            callback(quad.graph);
            return true; // Halt iteration of some()
        }, subject, predicate, object, graph);
    }
    // ### `createBlankNode` creates a new blank node, returning its name
    createBlankNode(suggestedName) {
        let name, index;
        // Generate a name based on the suggested name
        if (suggestedName) {
            name = suggestedName = `_:${suggestedName}`, index = 1;
            while(this._ids[name])name = suggestedName + index++;
        } else do name = `_:b${this._blankNodeIndex++}`;
        while (this._ids[name]);
        // Add the blank node to the entities, avoiding the generation of duplicates
        this._ids[name] = ++this._id;
        this._entities[this._id] = name;
        return this._factory.blankNode(name.substr(2));
    }
    // ### `extractLists` finds and removes all list triples
    // and returns the items per list.
    extractLists({ remove: remove = false, ignoreErrors: ignoreErrors = false } = {}) {
        const lists = {}; // has scalar keys so could be a simple Object
        const onError = ignoreErrors ? ()=>true : (node, message)=>{
            throw new Error(`${node.value} ${message}`);
        };
        // Traverse each list from its tail
        const tails = this.getQuads(null, (0, $9b58994fe65d4758$export$2e2bcd8739ae039).rdf.rest, (0, $9b58994fe65d4758$export$2e2bcd8739ae039).rdf.nil, null);
        const toRemove = remove ? [
            ...tails
        ] : [];
        tails.forEach((tailQuad)=>{
            const items = []; // the members found as objects of rdf:first quads
            let malformed = false; // signals whether the current list is malformed
            let head; // the head of the list (_:b1 in above example)
            let headPos; // set to subject or object when head is set
            const graph = tailQuad.graph; // make sure list is in exactly one graph
            // Traverse the list from tail to end
            let current = tailQuad.subject;
            while(current && !malformed){
                const objectQuads = this.getQuads(null, null, current, null);
                const subjectQuads = this.getQuads(current, null, null, null);
                let quad, first = null, rest = null, parent = null;
                // Find the first and rest of this list node
                for(let i = 0; i < subjectQuads.length && !malformed; i++){
                    quad = subjectQuads[i];
                    if (!quad.graph.equals(graph)) malformed = onError(current, "not confined to single graph");
                    else if (head) malformed = onError(current, "has non-list arcs out");
                    else if (quad.predicate.value === (0, $9b58994fe65d4758$export$2e2bcd8739ae039).rdf.first) {
                        if (first) malformed = onError(current, "has multiple rdf:first arcs");
                        else toRemove.push(first = quad);
                    } else if (quad.predicate.value === (0, $9b58994fe65d4758$export$2e2bcd8739ae039).rdf.rest) {
                        if (rest) malformed = onError(current, "has multiple rdf:rest arcs");
                        else toRemove.push(rest = quad);
                    } else if (objectQuads.length) malformed = onError(current, "can't be subject and object");
                    else {
                        head = quad; // e.g. { (1 2 3) :p :o }
                        headPos = "subject";
                    }
                }
                // { :s :p (1 2) } arrives here with no head
                // { (1 2) :p :o } arrives here with head set to the list.
                for(let i = 0; i < objectQuads.length && !malformed; ++i){
                    quad = objectQuads[i];
                    if (head) malformed = onError(current, "can't have coreferences");
                    else if (quad.predicate.value === (0, $9b58994fe65d4758$export$2e2bcd8739ae039).rdf.rest) {
                        if (parent) malformed = onError(current, "has incoming rdf:rest arcs");
                        else parent = quad;
                    } else {
                        head = quad; // e.g. { :s :p (1 2) }
                        headPos = "object";
                    }
                }
                // Store the list item and continue with parent
                if (!first) malformed = onError(current, "has no list head");
                else items.unshift(first.object);
                current = parent && parent.subject;
            }
            // Don't remove any quads if the list is malformed
            if (malformed) remove = false;
            else if (head) lists[head[headPos].value] = items;
        });
        // Remove list quads if requested
        if (remove) this.removeQuads(toRemove);
        return lists;
    }
    // ### Store is an iterable.
    // Can be used where iterables are expected: for...of loops, array spread operator,
    // `yield*`, and destructuring assignment (order is not guaranteed).
    *[Symbol.iterator]() {
        yield* this.readQuads();
    }
}
// Determines whether the argument is a string
function $5921901579fafa81$var$isString(s) {
    return typeof s === "string" || s instanceof String;
}
/**
 * A class that implements both DatasetCore and Readable.
 */ class $5921901579fafa81$var$DatasetCoreAndReadableStream extends (0, $511287080958fe02$exports.Readable) {
    constructor(n3Store, subject, predicate, object, graph){
        super({
            objectMode: true
        });
        Object.assign(this, {
            n3Store: n3Store,
            subject: subject,
            predicate: predicate,
            object: object,
            graph: graph
        });
    }
    get filtered() {
        if (!this._filtered) {
            const { n3Store: n3Store, graph: graph, object: object, predicate: predicate, subject: subject } = this;
            const newStore = this._filtered = new $5921901579fafa81$export$2e2bcd8739ae039({
                factory: n3Store._factory
            });
            for (const quad of n3Store.readQuads(subject, predicate, object, graph))newStore.addQuad(quad);
        }
        return this._filtered;
    }
    get size() {
        return this.filtered.size;
    }
    _read() {
        for (const quad of this)this.push(quad);
        this.push(null);
    }
    add(quad) {
        return this.filtered.add(quad);
    }
    delete(quad) {
        return this.filtered.delete(quad);
    }
    has(quad) {
        return this.filtered.has(quad);
    }
    match(subject, predicate, object, graph) {
        return new $5921901579fafa81$var$DatasetCoreAndReadableStream(this.filtered, subject, predicate, object, graph);
    }
    *[Symbol.iterator]() {
        yield* this._filtered || this.n3Store.readQuads(this.subject, this.predicate, this.object, this.graph);
    }
}


// **N3StreamParser** parses a text stream into a quad stream.


class $30f8467a05727ec7$export$2e2bcd8739ae039 extends (0, $511287080958fe02$exports.Transform) {
    constructor(options){
        super({
            decodeStrings: true
        });
        this._readableState.objectMode = true;
        // Set up parser with dummy stream to obtain `data` and `end` callbacks
        const parser = new (0, $37274793fe7a5937$export$2e2bcd8739ae039)(options);
        let onData, onEnd;
        parser.parse({
            on: (event, callback)=>{
                switch(event){
                    case "data":
                        onData = callback;
                        break;
                    case "end":
                        onEnd = callback;
                        break;
                }
            }
        }, // Handle quads by pushing them down the pipeline
        (error, quad)=>{
            error && this.emit("error", error) || quad && this.push(quad);
        }, // Emit prefixes through the `prefix` event
        (prefix, uri)=>{
            this.emit("prefix", prefix, uri);
        });
        // Implement Transform methods through parser callbacks
        this._transform = (chunk, encoding, done)=>{
            onData(chunk);
            done();
        };
        this._flush = (done)=>{
            onEnd();
            done();
        };
    }
    // ### Parses a stream of strings
    import(stream) {
        stream.on("data", (chunk)=>{
            this.write(chunk);
        });
        stream.on("end", ()=>{
            this.end();
        });
        stream.on("error", (error)=>{
            this.emit("error", error);
        });
        return this;
    }
}


// **N3StreamWriter** serializes a quad stream into a text stream.


class $945bfdad0537ff7f$export$2e2bcd8739ae039 extends (0, $511287080958fe02$exports.Transform) {
    constructor(options){
        super({
            encoding: "utf8",
            writableObjectMode: true
        });
        // Set up writer with a dummy stream object
        const writer = this._writer = new (0, $32dfb6bd0d0c03b1$export$2e2bcd8739ae039)({
            write: (quad, encoding, callback)=>{
                this.push(quad);
                callback && callback();
            },
            end: (callback)=>{
                this.push(null);
                callback && callback();
            }
        }, options);
        // Implement Transform methods on top of writer
        this._transform = (quad, encoding, done)=>{
            writer.addQuad(quad, done);
        };
        this._flush = (done)=>{
            writer.end(done);
        };
    }
    // ### Serializes a stream of quads
    import(stream) {
        stream.on("data", (quad)=>{
            this.write(quad);
        });
        stream.on("end", ()=>{
            this.end();
        });
        stream.on("error", (error)=>{
            this.emit("error", error);
        });
        stream.on("prefix", (prefix, iri)=>{
            this._writer.addPrefix(prefix, iri);
        });
        return this;
    }
}




var // Export all named exports as a default object for backward compatibility
$beeff8e941219219$export$2e2bcd8739ae039 = {
    Lexer: $06829f691c650db7$export$2e2bcd8739ae039,
    Parser: $37274793fe7a5937$export$2e2bcd8739ae039,
    Writer: $32dfb6bd0d0c03b1$export$2e2bcd8739ae039,
    Store: $5921901579fafa81$export$2e2bcd8739ae039,
    StreamParser: $30f8467a05727ec7$export$2e2bcd8739ae039,
    StreamWriter: $945bfdad0537ff7f$export$2e2bcd8739ae039,
    Util: $d6df86e8a0a82242$exports,
    DataFactory: $555d89d857a9ecd3$export$2e2bcd8739ae039,
    Term: $555d89d857a9ecd3$export$656c1e606ad06131,
    NamedNode: $555d89d857a9ecd3$export$e55689a56c4c92c2,
    Literal: $555d89d857a9ecd3$export$e175ae9e414693bc,
    BlankNode: $555d89d857a9ecd3$export$1a8019c085269883,
    Variable: $555d89d857a9ecd3$export$c867a5c9595a1350,
    DefaultGraph: $555d89d857a9ecd3$export$4383f89a7161b240,
    Quad: $555d89d857a9ecd3$export$7005c9eb6671414d,
    Triple: $555d89d857a9ecd3$export$7005c9eb6671414d,
    termFromId: $555d89d857a9ecd3$export$85285e91bbd99cf,
    termToId: $555d89d857a9ecd3$export$fbf03d1179c9227e
};



var $jTfnt = parcelRequire("jTfnt");
var $71fca04c4b8b5491$exports = {};
"use strict";
function $71fca04c4b8b5491$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($71fca04c4b8b5491$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$71fca04c4b8b5491$var$checkDCE();

$71fca04c4b8b5491$exports = (parcelRequire("giKfk"));


var $c2752f4da8d4eb23$exports = {};
/**
 * LiquidMetal, version: 1.3.0 (2014-08-19)
 *
 * A mimetic poly-alloy of Quicksilver's scoring algorithm, essentially
 * LiquidMetal.
 *
 * For usage and examples, visit:
 * http://github.com/rmm5t/liquidmetal
 *
 * Licensed under the MIT:
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright (c) 2009-2014, Ryan McGeary (ryan -[at]- mcgeary [*dot*] org)
 */ (function(global) {
    var SCORE_NO_MATCH = 0.0;
    var SCORE_MATCH = 1.0;
    var SCORE_TRAILING = 0.8;
    var SCORE_TRAILING_BUT_STARTED = 0.9;
    var SCORE_BUFFER = 0.85;
    var WORD_SEPARATORS = " 	_-";
    var LiquidMetal = {
        lastScore: null,
        lastScoreArray: null,
        score: function(string, abbrev) {
            // short circuits
            if (abbrev.length === 0) return SCORE_TRAILING;
            if (abbrev.length > string.length) return SCORE_NO_MATCH;
            // match & score all
            var allScores = [];
            var search = string.toLowerCase();
            abbrev = abbrev.toLowerCase();
            this._scoreAll(string, search, abbrev, -1, 0, [], allScores);
            // complete miss
            if (allScores.length == 0) return 0;
            // sum per-character scores into overall scores,
            // selecting the maximum score
            var maxScore = 0.0, maxArray = [];
            for(var i = 0; i < allScores.length; i++){
                var scores = allScores[i];
                var scoreSum = 0.0;
                for(var j = 0; j < string.length; j++)scoreSum += scores[j];
                if (scoreSum > maxScore) {
                    maxScore = scoreSum;
                    maxArray = scores;
                }
            }
            // normalize max score by string length
            // s. t. the perfect match score = 1
            maxScore /= string.length;
            // record maximum score & score array, return
            this.lastScore = maxScore;
            this.lastScoreArray = maxArray;
            return maxScore;
        },
        _scoreAll: function(string, search, abbrev, searchIndex, abbrIndex, scores, allScores) {
            // save completed match scores at end of search
            if (abbrIndex == abbrev.length) {
                // add trailing score for the remainder of the match
                var started = search.charAt(0) == abbrev.charAt(0);
                var trailScore = started ? SCORE_TRAILING_BUT_STARTED : SCORE_TRAILING;
                fillArray(scores, trailScore, scores.length, string.length);
                // save score clone (since reference is persisted in scores)
                allScores.push(scores.slice(0));
                return;
            }
            // consume current char to match
            var c = abbrev.charAt(abbrIndex);
            abbrIndex++;
            // cancel match if a character is missing
            var index = search.indexOf(c, searchIndex);
            if (index == -1) return;
            // match all instances of the abbreviaton char
            var scoreIndex = searchIndex; // score section to update
            while((index = search.indexOf(c, searchIndex + 1)) != -1){
                // score this match according to context
                if (isNewWord(string, index)) {
                    scores[index - 1] = 1;
                    fillArray(scores, SCORE_BUFFER, scoreIndex + 1, index - 1);
                } else if (isUpperCase(string, index)) fillArray(scores, SCORE_BUFFER, scoreIndex + 1, index);
                else fillArray(scores, SCORE_NO_MATCH, scoreIndex + 1, index);
                scores[index] = SCORE_MATCH;
                // consume matched string and continue search
                searchIndex = index;
                this._scoreAll(string, search, abbrev, searchIndex, abbrIndex, scores, allScores);
            }
        }
    };
    function isUpperCase(string, index) {
        var c = string.charAt(index);
        return "A" <= c && c <= "Z";
    }
    function isNewWord(string, index) {
        var c = string.charAt(index - 1);
        return WORD_SEPARATORS.indexOf(c) != -1;
    }
    function fillArray(array, value, from, to) {
        for(var i = from; i < to; i++)array[i] = value;
        return array;
    }
    // Export as AMD...
    if (typeof define === "function" && define.amd) define(function() {
        return LiquidMetal;
    });
    else if (0, $c2752f4da8d4eb23$exports) $c2752f4da8d4eb23$exports = LiquidMetal;
    else global.LiquidMetal = LiquidMetal;
})(typeof window !== "undefined" ? window : $c2752f4da8d4eb23$exports);


const { namedNode: $79b3812887d80d22$var$namedNode } = (0, $555d89d857a9ecd3$export$2e2bcd8739ae039);
var $4faee1a89bbdf66d$exports = {};
$4faee1a89bbdf66d$exports = new URL("devices.ed433e15.ttl", import.meta.url).toString();


const $79b3812887d80d22$var$DEVICES_URI = new URL($4faee1a89bbdf66d$exports);
window.setImmediate = (func, ...rest)=>setTimeout(func, 0, ...rest);
async function $79b3812887d80d22$var$fetchStore(callback) {
    let devices = await (await fetch($79b3812887d80d22$var$DEVICES_URI)).text();
    let _store = new (0, $5921901579fafa81$export$2e2bcd8739ae039)();
    const parser = new (0, $37274793fe7a5937$export$2e2bcd8739ae039)();
    parser.parse(devices, async (error, quad, prefixes)=>quad ? _store.addQuad(quad) : callback(_store));
}
const $79b3812887d80d22$var$plural = (string, count)=>`${string}${count > 1 ? "s" : ""}`;
// hack: convert stringy boolean to true/false
const $79b3812887d80d22$var$convertTypes = (literal)=>literal && literal.datatypeString && literal.datatypeString === "http://www.w3.org/2001/XMLSchema#boolean" ? literal.value === "true" ? true : false : literal.value;
const $79b3812887d80d22$var$App = ()=>{
    const [terms, setTerms] = (0, $jTfnt.useState)();
    const [store, setStore] = (0, $jTfnt.useState)();
    (0, $jTfnt.useEffect)(()=>{
        $79b3812887d80d22$var$fetchStore(setStore);
    }, []);
    const onChange = (0, $jTfnt.useCallback)((event)=>{
        setTerms(event.target.value);
    });
    const getObjects = (subject, v)=>store.getObjects(subject, $79b3812887d80d22$var$namedNode(`http://example.org/vocab/device/${v}`)).length ? $79b3812887d80d22$var$convertTypes(store.getObjects(subject, $79b3812887d80d22$var$namedNode(`http://example.org/vocab/device/${v}`))[0]) : null;
    const results = store ? store.getSubjects().sort((a, b)=>{
        let nameA = (getObjects(a, "make") + " " + getObjects(a, "model")).toLowerCase();
        let nameB = (getObjects(b, "make") + " " + getObjects(a, "model")).toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
    }).filter((subject)=>{
        let make = getObjects(subject, "make");
        let model = getObjects(subject, "model");
        if (terms && terms != "") {
            let query = terms.replace(/\s+/g, "");
            return (0, (/*@__PURE__*/$parcel$interopDefault($c2752f4da8d4eb23$exports))).score(make + model, query) > 0.6;
        } else return true;
    }) : [];
    let inputRef = (0, $jTfnt.useRef)();
    let keydown = (event)=>{
        if (event.target == document.body) {
            if (event.key == "/") {
                event.preventDefault();
                inputRef.current.focus();
            }
        }
        if (event.target == inputRef.current) {
            if (event.key == "Escape") {
                if (event.target.value == "") {
                    event.preventDefault();
                    inputRef.current.blur();
                }
            }
        }
    };
    (0, $jTfnt.useEffect)(()=>{
        document.addEventListener("keydown", keydown);
        return function unmount() {
            document.removeEventListener("keydown", keydown);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
        className: "lh-copy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("form", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("input", {
        ref: inputRef,
        className: "input-reset ba b--black-20 pa2 mb2 db w-100 helvetica",
        style: {
            fontSize: 16
        },
        type: "search",
        placeholder: "Filter by Make or Model",
        onChange: onChange,
        // autoFocus={true}
        "aria-label": "Filter by Make or Model to find a device with minijack TRS MIDI support"
    })), store && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
        style: {
            height: 300
        },
        className: "results-listing flex flex-column helvetica pb5 overflow-scroll"
    }, results.length < 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
        className: "pa3 mr2 pb0 pb3-ns lh-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("span", {
        className: "f7"
    }, "No matches found."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("span", {
        className: "f7 gray"
    }, "Are we missing a device? Please ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("a", {
        className: "blue link",
        href: "https://github.com/audionerd/minimidi-data/issues"
    }, "let us know"), ".")) : results.map((subject, n)=>{
        let get = (v)=>getObjects(subject, v);
        let make = get("make");
        let model = get("model");
        let typeA = get("typeA");
        let typeB = get("typeB");
        let typeTS = get("typeTS");
        let inputs = get("inputs");
        let outputs = get("outputs");
        let thrus = get("thrus");
        let uri = get("uri");
        let notes = get("notes");
        let details = get("details");
        let zebra = n % 2 === 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            key: subject.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            style: {
                background: zebra ? "#f8f8f8" : "transparent"
            },
            className: `flex flex-wrap items-start`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "flex flex-column items-start w-100 w-30-ns"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "pa3 mr2 pb0 pb3-ns"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "black-60 ttu tracked f7"
        }, make), uri ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "f6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("a", {
            className: "no-underline blue link",
            href: uri
        }, model)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", null, model))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "f7 w-20-ns"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "midi-pill"
        }, typeA && typeB && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "ma3 mv2 mv3-ns ph2 pv1 lh-title br-pill washed-blue bg-blue dib"
        }, "Types A ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("span", {
            className: "avenir"
        }, "&"), " B"), typeA && !typeB && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "ma3 mv2 mv3-ns ph2 pv1 lh-title br-pill washed-blue bg-blue dib"
        }, "Type A"), typeB && !typeA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "ma3 mv2 mv3-ns ph2 pv1 lh-title br-pill washed-blue bg-blue dib"
        }, "Type B"), typeTS && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "ma3 mv2 mv3-ns ph2 pv1 lh-title br-pill washed-blue bg-blue dib"
        }, "TS"), !typeA && !typeB && !typeTS && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "ma3 mv2 mv3-ns pv1 lh-title gray dib"
        }, "Unknown Type"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "f7 w-20-ns"
        }, inputs != null && inputs > 0 && outputs != null && outputs > 0 && thrus !== null & thrus > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "ma3 mv2 mv3-ns pt1 pt0-ns"
        }, "MIDI IN/OUT/Thru") : inputs != null && inputs > 0 && outputs != null && outputs > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "ma3 mv2 mv3-ns pt1 pt0-ns"
        }, "MIDI IN/OUT") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", null, inputs != null && inputs > 0 && thrus != null && thrus > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "ma3 mv2 mv3-ns pt1 pt0-ns"
        }, "MIDI IN/THRU"), inputs != null && inputs > 0 && (thrus == null || thrus == 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "ma3 mv2 mv3-ns pt1 pt0-ns"
        }, "MIDI IN"), outputs != null && outputs > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "ma3 mv2 mv3-ns pt1 pt0-ns"
        }, "MIDI OUT"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("div", {
            className: "f7 w-100 w-30-ns ph3 pa3-ns black-70 overflow-scroll"
        }, notes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("p", {
            className: "mt0"
        }, notes), details && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement("p", {
            className: "mt0"
        }, details))));
    })));
};
(0, (/*@__PURE__*/$parcel$interopDefault($71fca04c4b8b5491$exports))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTfnt))).createElement($79b3812887d80d22$var$App, null), document.getElementById("app"));


//# sourceMappingURL=index.37d3c0f7.js.map
